// GENERATED by tools/translation/generateFeatureUsage.mjs - do not edit.
// FeatureCode -> app surface(s) where it is USED (whole-token source scan
// of apps/frontends + libs/frontends; defining file as fallback). `files`
// lists up to five component files behind each link, for the tooltip.
export type FeatureUsageLink = { label: string; url: string; files: string[] }

export const FEATURE_USAGE: Record<string, FeatureUsageLink[]> = {
  CompanyOwnershipTransactions_About: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_Change: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useColumns.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  CompanyOwnershipTransactions_Company: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useColumns.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useFilterableConfig.ts",
        "v2-console/src/company/transactions/CompanyTransactionsTable.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/transactions/PersonTransactionsTable.tsx"],
    },
  ],
  CompanyOwnershipTransactions_CompanyShares: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.text.ts",
      ],
    },
  ],
  CompanyOwnershipTransactions_InvestmentTabHeader: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsTable.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/transactions/PersonTransactionsTable.tsx"],
    },
  ],
  CompanyOwnershipTransactions_OrganizationNumber: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_Owner: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useColumns.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useFilterableConfig.ts",
        "v2-console/src/company/transactions/CompanyTransactionsTable.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_OwnerPercentage: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useColumns.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  CompanyOwnershipTransactions_OwnerPercentageDelta: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useColumns.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  CompanyOwnershipTransactions_OwnerTabHeader: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsTable.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_ParentChainNow: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_ParentChainTransactionYear: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_SearchPlaceholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  CompanyOwnershipTransactions_Shares: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useColumns.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_UltimateOwner: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/CompanyOwnershipTransactionsTableExpand.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useColumns.tsx",
      ],
    },
  ],
  CompanyOwnershipTransactions_Year: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useColumns.tsx",
        "v2-console/src/company/ownershipTransactions/companyOwnershipTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Documents_AnnualAccounts: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/documents/CompanyModuleDocuments.tsx",
      ],
    },
  ],
  Company_Documents_AnnualReport: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/documents/CompanyModuleDocuments.tsx",
      ],
    },
  ],
  Company_Documents_Download: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/documents/CompanyModuleDocuments.tsx",
      ],
    },
  ],
  Company_Documents_Latest: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/documents/CompanyModuleDocuments.tsx",
      ],
    },
  ],
  Company_Documents_MissingUrl: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/documents/CompanyModuleDocuments.tsx",
      ],
    },
  ],
  Company_Financials_AccountsTitle: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancials.tsx",
      ],
    },
  ],
  Company_Financials_AnnualReport: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsAnnualReports.tsx",
      ],
    },
  ],
  Company_Financials_AnnualReport_Download: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsAnnualReports.tsx",
      ],
    },
  ],
  Company_Financials_AnnualReport_Latest: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsAnnualReports.tsx",
      ],
    },
  ],
  Company_Financials_AnnualReport_MissingUrl: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsAnnualReports.tsx",
      ],
    },
  ],
  Company_Financials_AnnualReport_SearchPlaceholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsTabs.tsx",
      ],
    },
  ],
  Company_Financials_EBITDA: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsKeyMetrics.tsx",
      ],
    },
  ],
  Company_Financials_Employees: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsEmployeesChart.tsx",
        "v2-console/src/company/module/financials/CompanyModuleFinancialsKeyMetrics.tsx",
        "v2-console/src/company/module/financials/CompanyModuleFinancialsResultsTable.tsx",
      ],
    },
  ],
  Company_Financials_EmployeesAccumulated: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsEmployeesChart.tsx",
      ],
    },
  ],
  Company_Financials_EmployeesPerLocation: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsEmployeesPerLocationChart.tsx",
      ],
    },
  ],
  Company_Financials_EmployeesWithLocations: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsKeyMetrics.tsx",
      ],
    },
  ],
  Company_Financials_Employees_Current: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsEmployees.tsx",
      ],
    },
  ],
  Company_Financials_Employees_CurrentWithLocations: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsEmployees.tsx",
      ],
    },
  ],
  Company_Financials_Employees_GrowthCompare: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsEmployees.tsx",
      ],
    },
  ],
  Company_Financials_KeyMetrics: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsKeyMetrics.tsx",
      ],
    },
  ],
  Company_Financials_NetResult: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsKeyMetrics.tsx",
        "v2-console/src/company/module/financials/CompanyModuleFinancialsResultsTable.tsx",
      ],
    },
  ],
  Company_Financials_ProfitMargin: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsResultsTable.tsx",
      ],
    },
  ],
  Company_Financials_Revenue: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsKeyMetrics.tsx",
        "v2-console/src/company/module/financials/CompanyModuleFinancialsResultsTable.tsx",
      ],
    },
  ],
  Company_Financials_TabAnnualReport: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsTabs.tsx",
      ],
    },
  ],
  Company_Financials_TabEmployees: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsTabs.tsx",
      ],
    },
  ],
  Company_Financials_TabResults: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsTabs.tsx",
      ],
    },
  ],
  Company_Financials_Year: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsResultsTable.tsx",
      ],
    },
  ],
  Company_Financials_YoY: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/module/financials/CompanyModuleFinancialsKeyMetrics.tsx",
      ],
    },
  ],
  Company_Hierarchy_CollapseAll: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyActions.tsx"],
    },
  ],
  Company_Hierarchy_Companies: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/hierarchy/CompanyHierarchyView.tsx",
        "v2-console/src/company/hierarchy/company.hierarchy.types.ts",
      ],
    },
  ],
  Company_Hierarchy_CompaniesSingular: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/company.hierarchy.text.ts"],
    },
  ],
  Company_Hierarchy_CurrentCompany: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyTree.tsx"],
    },
  ],
  Company_Hierarchy_Disagreement: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyTree.tsx"],
    },
  ],
  Company_Hierarchy_EmptyState: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyView.tsx"],
    },
  ],
  Company_Hierarchy_ExpandAll: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyActions.tsx"],
    },
  ],
  Company_Hierarchy_KnownLandlord: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyTree.tsx"],
    },
  ],
  Company_Hierarchy_Levels: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/hierarchy/CompanyHierarchyView.tsx",
        "v2-console/src/company/hierarchy/company.hierarchy.types.ts",
      ],
    },
  ],
  Company_Hierarchy_LevelsSingular: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/company.hierarchy.text.ts"],
    },
  ],
  Company_Hierarchy_Share_Majority: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyTree.tsx"],
    },
  ],
  Company_Hierarchy_Subsidiaries: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/hierarchy/CompanyHierarchyTree.tsx",
        "v2-console/src/company/hierarchy/company.hierarchy.types.ts",
      ],
    },
  ],
  Company_Hierarchy_SubsidiariesSingular: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyTree.tsx"],
    },
  ],
  Company_Hierarchy_Tooltip_SingleParentControl: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/hierarchy/company.hierarchy.evidence.constants.ts",
      ],
    },
  ],
  Company_Hierarchy_Tooltip_StatedShare: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/hierarchy/company.hierarchy.evidence.constants.ts",
      ],
    },
  ],
  Company_Hierarchy_Tooltip_StatedText: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/hierarchy/company.hierarchy.evidence.constants.ts",
      ],
    },
  ],
  Company_Hierarchy_Tooltip_VotingShare: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/hierarchy/CompanyHierarchyTree.tsx"],
    },
  ],
  Company_Hierarchy_Tooltip_WhollyOwnedText: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/hierarchy/company.hierarchy.evidence.constants.ts",
      ],
    },
  ],
  Company_MoveHistory_AddressSection: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/moveHistory/CompanyMoveHistoryTableExpand.tsx",
      ],
    },
  ],
  Company_MoveHistory_Header: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/company.offices.text.ts"],
    },
  ],
  Company_MoveHistory_TabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/CompanyOfficesTabs.tsx"],
    },
  ],
  Company_MoveHistory_TableHeaderAddress: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/moveHistory/CompanyMoveHistoryTableExpand.tsx",
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useColumns.tsx",
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useFilterableConfig.ts",
      ],
    },
  ],
  Company_MoveHistory_TableHeaderCity: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/moveHistory/CompanyMoveHistoryTableExpand.tsx",
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useColumns.tsx",
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useFilterableConfig.ts",
      ],
    },
  ],
  Company_MoveHistory_TableHeaderMovedToLocationAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/moveHistory/CompanyMoveHistoryTableExpand.tsx",
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useColumns.tsx",
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useFilterableConfig.ts",
      ],
    },
  ],
  Company_MoveHistory_TableHeaderPostalCode: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/moveHistory/CompanyMoveHistoryTableExpand.tsx",
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useColumns.tsx",
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useFilterableConfig.ts",
      ],
    },
  ],
  Company_MoveHistory_TableSearchPlaceholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/moveHistory/company.moveHistory.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Offices_AddressSection: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/table/CompanyOfficesTableExpand.tsx",
      ],
    },
  ],
  Company_Offices_AddressType_LOC: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/company.offices.text.ts"],
    },
  ],
  Company_Offices_AddressType_POST: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/company.offices.text.ts"],
    },
  ],
  Company_Offices_BusinessActivity: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/company.offices.text.ts"],
    },
  ],
  Company_Offices_ClickToZoomTo: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/CompanyOfficesMapZoomLabel.tsx"],
    },
  ],
  Company_Offices_Header: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/insight/company.offices.insight.useStackedSummaryData.ts",
        "v2-console/src/company/offices/tree/CompanyOfficesTree.tsx",
      ],
    },
  ],
  Company_Offices_NumberOfEmployees: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/company.offices.text.ts"],
    },
  ],
  Company_Offices_RegisteredPurpose: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/company.offices.text.ts"],
    },
  ],
  Company_Offices_StackedSummaryOfAllOffices: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/insight/CompanyOfficesInsightCards.tsx",
      ],
    },
  ],
  Company_Offices_StackedSummaryOthersName: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/insight/company.offices.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Offices_StackedSummaryTitle: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/insight/CompanyOfficesInsightCards.tsx",
      ],
    },
  ],
  Company_Offices_TabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/CompanyOfficesTabs.tsx"],
    },
  ],
  Company_Offices_TableHeaderAddress: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/table/CompanyOfficesTableExpand.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useColumns.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Offices_TableHeaderCity: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/insight/CompanyOfficesInsightCards.tsx",
        "v2-console/src/company/offices/table/CompanyOfficesTableExpand.tsx",
        "v2-console/src/company/offices/table/CompanyOfficesTableFilterBody.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useColumns.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Offices_TableHeaderCompany: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/table/CompanyOfficesTableExpand.tsx",
        "v2-console/src/company/offices/table/CompanyOfficesTableFilterBody.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useColumns.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Offices_TableHeaderOwnership: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/table/company.offices.table.useColumns.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Offices_TableHeaderPostalCode: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/table/CompanyOfficesTableExpand.tsx",
        "v2-console/src/company/offices/table/CompanyOfficesTableFilterBody.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useColumns.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Offices_TableHeaderUsage: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/insight/CompanyOfficesInsightCards.tsx",
        "v2-console/src/company/offices/table/CompanyOfficesTableExpand.tsx",
        "v2-console/src/company/offices/table/CompanyOfficesTableFilterBody.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useColumns.tsx",
        "v2-console/src/company/offices/table/company.offices.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Offices_TableSearchPlaceholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/table/company.offices.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Offices_Tree_CollapseAll: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/CompanyOfficesTabs.tsx"],
    },
  ],
  Company_Offices_Tree_EmptyState: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/tree/CompanyOfficesTree.tsx"],
    },
  ],
  Company_Offices_Tree_ExpandAll: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/CompanyOfficesTabs.tsx"],
    },
  ],
  Company_Offices_Tree_Header: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/company.offices.text.ts"],
    },
  ],
  Company_Offices_Tree_TabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/offices/CompanyOfficesTabs.tsx"],
    },
  ],
  Company_Offices_UnknownCity: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/insight/company.offices.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Offices_UnknownCompany: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/table/CompanyOfficesTableCompanyCell.tsx",
        "v2-console/src/company/offices/tree/CompanyOfficesTree.tsx",
      ],
    },
  ],
  Company_Offices_UnknownUsage: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/insight/company.offices.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Offices_UsageMixed: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/offices/company.offices.useData.ts",
        "v2-console/src/company/offices/tree/company.offices.tree.useTreeData.ts",
      ],
    },
  ],
  Company_Ownership_Header: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/company.ownership.text.ts"],
    },
  ],
  Company_Ownership_HierarchySearchPlaceholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/hierarchy/company.hierarchy.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Ownership_HierarchyTabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnership.tsx",
        "v2-console/src/company/ownership/CompanyOwnershipTable.tsx",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  Company_Ownership_KonsernTabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/CompanyOwnershipTable.tsx"],
    },
  ],
  Company_Ownership_Konsern_CurrentCompany: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/CompanyOwnershipTable.tsx"],
    },
  ],
  Company_Ownership_Konsern_EmptyState: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/CompanyOwnershipTable.tsx"],
    },
  ],
  Company_Ownership_LargestOwner: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
      ],
    },
  ],
  Company_Ownership_OthersDetailSection: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersOthersExpand.tsx",
      ],
    },
  ],
  Company_Ownership_OthersExpandBody: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersOthersExpand.tsx",
      ],
    },
  ],
  Company_Ownership_OthersRowHoldersLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
      ],
    },
  ],
  Company_Ownership_OthersRowName: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
      ],
    },
  ],
  Company_Ownership_Overview: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
      ],
    },
  ],
  Company_Ownership_OwnerTypeCompany: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Ownership_OwnerTypePerson: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Ownership_OwnershipYear: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
        "v2-console/src/company/ownership/CompanyOwnershipYearSelect.tsx",
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_PrivatePerson_Fallback: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholderOwnerName.tsx",
      ],
    },
  ],
  Company_Ownership_ShareholderDetailSection: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_ShareholdersTabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/CompanyOwnershipTable.tsx"],
    },
  ],
  Company_Ownership_StackedSummaryGroupByOwner: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
      ],
    },
  ],
  Company_Ownership_StackedSummaryGroupByOwnerType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
      ],
    },
  ],
  Company_Ownership_StackedSummaryGroupByShareClass: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
      ],
    },
  ],
  Company_Ownership_StackedSummaryOfOwnership: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
      ],
    },
  ],
  Company_Ownership_StackedSummaryOthersName: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Ownership_StackedSummaryShare: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Ownership_StackedSummaryTitle: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
      ],
    },
  ],
  Company_Ownership_TableHeaderActive: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_TableHeaderCountry: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Ownership_TableHeaderEffectiveOwnership: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/ultimateOwners/CompanyUltimateOwnersTableExpand.tsx",
        "v2-console/src/company/ownership/ultimateOwners/company.ownership.ultimateOwners.useColumns.tsx",
        "v2-console/src/company/ownership/ultimateOwners/company.ownership.ultimateOwners.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Ownership_TableHeaderIsin: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_TableHeaderNationalId: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_TableHeaderOrganizationNumber: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/ultimateOwners/CompanyUltimateOwnersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_TableHeaderOwner: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useFilterableConfig.ts",
        "v2-console/src/company/ownership/ultimateOwners/CompanyUltimateOwnersTableExpand.tsx",
        "v2-console/src/company/ownership/ultimateOwners/company.ownership.ultimateOwners.useColumns.tsx",
      ],
    },
  ],
  Company_Ownership_TableHeaderOwnerType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Ownership_TableHeaderOwnership: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Ownership_TableHeaderShareClass: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Ownership_TableHeaderShareClassCode: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_TableHeaderShares: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useColumns.tsx",
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Ownership_TableHeaderSource: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/company.ownership.text.ts"],
    },
  ],
  Company_Ownership_TableHeaderSourceDate: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_TableHeaderStructureType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/ultimateOwners/CompanyUltimateOwnersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_TableSearchPlaceholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useFilterableConfig.ts",
        "v2-console/src/company/ownership/ultimateOwners/company.ownership.ultimateOwners.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Ownership_TotalShareholders: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
      ],
    },
  ],
  Company_Ownership_TotalShares: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/CompanyOwnershipInsightCards.tsx",
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_TreeTabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/CompanyOwnershipTable.tsx"],
    },
  ],
  Company_Ownership_Tree_CollapseAll: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/CompanyOwnershipTable.tsx"],
    },
  ],
  Company_Ownership_Tree_EmptyState: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/tree/CompanyOwnershipTree.tsx"],
    },
  ],
  Company_Ownership_Tree_ExpandAll: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/CompanyOwnershipTable.tsx"],
    },
  ],
  Company_Ownership_Tree_SearchPlaceholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/company.ownership.text.ts"],
    },
  ],
  Company_Ownership_Tree_Subsidiaries: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/tree/CompanyOwnershipTree.tsx"],
    },
  ],
  Company_Ownership_UltimateOwnerDetailSection: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/ultimateOwners/CompanyUltimateOwnersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_UltimateOwnerHierarchyLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/CompanyShareholdersTableExpand.tsx",
        "v2-console/src/company/ownership/ultimateOwners/CompanyUltimateOwnersTableExpand.tsx",
      ],
    },
  ],
  Company_Ownership_UltimateOwnersTabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/CompanyOwnershipTable.tsx"],
    },
  ],
  Company_Ownership_UnknownCountry: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/ownership/company.ownership.text.ts"],
    },
  ],
  Company_Ownership_UnknownOwner: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useStackedSummaryData.ts",
        "v2-console/src/company/ownership/tree/CompanyOwnershipTree.tsx",
      ],
    },
  ],
  Company_Ownership_UnknownShareClass: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/ownership/shareholders/company.ownership.shareholders.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Properties_AboutProperty: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
      ],
    },
  ],
  Company_Properties_AllOwnersSection: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
      ],
    },
  ],
  Company_Properties_Header: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/legend/CompanyPropertiesLegend.tsx",
      ],
    },
  ],
  Company_Properties_KnownLandlords: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
      ],
    },
  ],
  Company_Properties_Legend_Parcel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/legend/CompanyPropertiesLegend.tsx",
      ],
    },
  ],
  Company_Properties_Legend_Point: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/legend/CompanyPropertiesLegend.tsx",
      ],
    },
  ],
  Company_Properties_Legend_WithoutPoint: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/legend/CompanyPropertiesLegend.tsx",
      ],
    },
  ],
  Company_Properties_Map_ShowOnMap: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/layer/CompanyPropertiesMapBlock.tsx",
      ],
    },
  ],
  Company_Properties_Map_ZoomTo: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/layer/CompanyPropertiesMapBlock.tsx",
      ],
    },
  ],
  Company_Properties_MaxDepth: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
      ],
    },
  ],
  Company_Properties_Overview: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
      ],
    },
  ],
  Company_Properties_OwnedPropertiesTabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTable.tsx",
      ],
    },
  ],
  Company_Properties_OwnedPropertiesTreeTabLabel: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTable.tsx",
      ],
    },
  ],
  Company_Properties_OwnerHierarchySection: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
      ],
    },
  ],
  Company_Properties_PrimaryOwnerSection: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
      ],
    },
  ],
  Company_Properties_StackedSummaryOfAllProperties: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
      ],
    },
  ],
  Company_Properties_StackedSummaryOthersName: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/company.properties.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Properties_StackedSummaryProperties: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/company.properties.insight.useStackedSummaryData.ts",
        "v2-console/src/company/properties/tree/CompanyPropertiesTree.tsx",
      ],
    },
  ],
  Company_Properties_StackedSummaryTitle: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
      ],
    },
  ],
  Company_Properties_TableHeaderAddress: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
      ],
    },
  ],
  Company_Properties_TableHeaderCadastre: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderContactRole: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
      ],
    },
  ],
  Company_Properties_TableHeaderDepth: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
      ],
    },
  ],
  Company_Properties_TableHeaderEffectiveOwnershipPct: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderFloorSpace: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderInterestType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
      ],
    },
  ],
  Company_Properties_TableHeaderMunicipality: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableFilterBody.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderOwnersCount: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderPartyType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
      ],
    },
  ],
  Company_Properties_TableHeaderPlotArea: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderPrimaryOwner: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableFilterBody.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderRecordType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableFilterBody.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderShare: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
      ],
    },
  ],
  Company_Properties_TableHeaderStructureType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableHeaderUsage: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableFilterBody.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useColumns.tsx",
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TableSearchPlaceholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/company.properties.table.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Properties_TotalOwners: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
      ],
    },
  ],
  Company_Properties_TotalProperties: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/CompanyPropertiesInsightCards.tsx",
      ],
    },
  ],
  Company_Properties_Tree_CollapseAll: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTable.tsx",
      ],
    },
  ],
  Company_Properties_Tree_EmptyState: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/tree/CompanyPropertiesTree.tsx",
      ],
    },
  ],
  Company_Properties_Tree_ExpandAll: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTable.tsx",
      ],
    },
  ],
  Company_Properties_Tree_PercentageType_Label: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/properties/company.properties.text.ts"],
    },
  ],
  Company_Properties_Tree_PercentageType_Show: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/properties/company.properties.text.ts"],
    },
  ],
  Company_Properties_Tree_PercentageType_effective: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/properties/company.properties.text.ts"],
    },
  ],
  Company_Properties_Tree_PercentageType_share: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/properties/company.properties.text.ts"],
    },
  ],
  Company_Properties_UnknownMunicipality: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/company.properties.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Properties_UnknownOwner: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/company.properties.insight.useStackedSummaryData.ts",
        "v2-console/src/company/properties/table/CompanyPropertiesTableExpand.tsx",
        "v2-console/src/company/properties/tree/CompanyPropertiesTree.tsx",
      ],
    },
  ],
  Company_Properties_UnknownRecordType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/company.properties.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Properties_UnknownUsage: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/insight/company.properties.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Company_Properties_UsageMixed: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/company.properties.useData.ts",
      ],
    },
  ],
  Company_Roles_BoardOfDirectors: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTable.tsx"],
    },
  ],
  Company_Roles_Board_Column_BornYear: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
  ],
  Company_Roles_Board_Column_Description: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
  ],
  Company_Roles_Board_Column_Name: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/roles/company.roles.useColumns.tsx",
        "v2-console/src/company/roles/company.roles.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Roles_Board_Column_RoleGroup: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/company.roles.text.ts"],
    },
  ],
  Company_Roles_Board_Column_RoleTitle: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/roles/CompanyRolesTableExpand.tsx",
        "v2-console/src/company/roles/company.roles.useColumns.tsx",
        "v2-console/src/company/roles/company.roles.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Roles_Board_Search_Placeholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/roles/company.roles.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Roles_ChairOfTheBoard: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Current: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTable.tsx"],
    },
  ],
  Company_Roles_EndAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
  ],
  Company_Roles_GeneralManager: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_HasResigned: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
  ],
  Company_Roles_Historic: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTable.tsx"],
    },
  ],
  Company_Roles_Insight_Appointed: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Insight_BoardComposition: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Insight_BoardDeputies: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Insight_BoardMembers: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Insight_BoardSize: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Insight_Departed: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Insight_LastChange: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Insight_WhatChanged: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_IsActive: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/company.roles.text.ts"],
    },
  ],
  Company_Roles_Others: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTable.tsx"],
    },
  ],
  Company_Roles_Others_Column_BornYear: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/company.roles.text.ts"],
    },
  ],
  Company_Roles_Others_Column_Description: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
  ],
  Company_Roles_Others_Column_Name: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/roles/company.roles.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Roles_Others_Column_RoleGroup: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
  ],
  Company_Roles_Others_Column_RoleTitle: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/roles/company.roles.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Roles_Others_Search_Placeholder: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/roles/company.roles.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Roles_Overview: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesInsightCards.tsx"],
    },
  ],
  Company_Roles_Period: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/roles/company.roles.useColumns.tsx",
        "v2-console/src/company/roles/company.roles.useFilterableConfig.ts",
      ],
    },
  ],
  Company_Roles_PowerOfAttorney: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/company.roles.text.ts"],
    },
  ],
  Company_Roles_SignaturProkura: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/company.roles.text.ts"],
    },
  ],
  Company_Roles_Signature: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/company.roles.text.ts"],
    },
  ],
  Company_Roles_StartAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
  ],
  Company_Roles_Today: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/roles/CompanyRolesTableExpand.tsx",
        "v2-console/src/company/roles/company.roles.useColumns.tsx",
      ],
    },
  ],
  Industry_Company_Count: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/hoverCard/cadastre/CadastreHoverCardLazy.tsx",
        "v2-console/src/object/hoverCard/section/SectionHoverCardLazy.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/industry/CadastreIndustry.tsx"],
    },
  ],
  Industry_Company_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/industry/CadastreIndustry.tsx"],
    },
  ],
  Industry_Company_NumberOfEmployees: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/hoverCard/cadastre/CadastreHoverCardLazy.tsx",
        "v2-console/src/object/hoverCard/section/SectionHoverCardLazy.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/industry/CadastreIndustry.tsx"],
    },
  ],
  Industry_Company_WithEmployeesCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/industry/CadastreIndustry.tsx"],
    },
  ],
  Legal_Email_Availability_Cta: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Availability_Heading: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Availability_Intro: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Availability_Subject: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Availability_Total: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_DocType_MortgageRegister: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_DocType_RealProperty: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Failure_Heading: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Failure_Intro: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Failure_ReasonAlreadyOrdered: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Failure_ReasonBefore1951: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Failure_ReasonNotFound: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Failure_ReasonUnknown: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Failure_Subject: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Order_Reference: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Receipt_Heading: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Receipt_Intro: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Receipt_NotCharged: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Receipt_Subject: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Email_Receipt_Total: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: [
        "apps/backends/v2-legal-service/src/landregisternotify/landregisternotify.text.go",
      ],
    },
  ],
  Legal_Report_File_AssessmentReportsFolder: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_File_NoPdfPlaceholder: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_File_PropertyReportsFolder: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Address: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_AmountNok: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BaseData: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BuildingCategory: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BuildingKey: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BuildingStatus: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BuildingType: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Buildings: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BurdenedCadastre: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BurdenedCadastres: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BusinessAddress: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BusinessTypeCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_BusinessTypeText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CadastralUnitNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CadastreLevelCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CadastreLevelRegisterCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CadastreLevelText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CadastreNumber: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CoOwnershipShare: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CoOwnershipShareholders: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CoOwnershipShares: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CompanyAddress: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CompanyId: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CompanyName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CompanyType: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CompulsoryLien: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ContainsBuilding: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ConveyanceTypeActive: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ConveyanceTypeCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ConveyanceTypeText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CoordinatesLatLong: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CounterpartCadastre: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_CulturalHeritage: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Currency: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Date: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_DisposalRestrictions: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_DocumentStatusActive: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_DocumentTypeText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_DwellingTypeActive: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_DwellingTypeCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_DwellingTypeText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Easements: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Encumbrances: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Established: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FeeBasisNok: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FeeCauseActive: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FeeCauseCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FeeCauseText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FoundationYear: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FractionDenominator: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FractionNumerator: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FromCadastre: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FromCadastreActive: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_FromCadastreLevel: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_GroundPollution: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_GroundPollutionId: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_HasMarketValue: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_HasProperty: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_History: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_HoldingNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_IdentifierPresentationFormatted: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_IndustrialClassificationCodes: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_IndustrialClassificationTexts: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_IsActive: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_IsRegistered: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_IsUseOfCadastreActive: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Key: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_LeaseAgreements: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_LeaseNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_LeaseholdAgreements: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_LeaseholdPlots: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_LeaseholdRight: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_MainUnitNumber: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Map: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_MortgageAmountNok: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Municipality: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_MunicipalityNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_NoOfCreationOfRights: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_NoOfRealties: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_NumberOfEmployees: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_NumberOfRealties: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_NumberOfRightsHolders: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_OfficeName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_OfficeNumber: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_OwnerLevel: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_OwnerTypeCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_OwnerTypeText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PersonIndustrialClassificationCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PersonIndustrialClassificationText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PersonKey: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PersonName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PersonOrgNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PersonalNumberTypeCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PersonalNumberTypeText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PlotArea: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PointLeasehold: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PostalAddress: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PostalCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Profit: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PropertyRights: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_PurchasePrice: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Registered: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_RegisteredForVat: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_RegisteredIn: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Remarks: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Revenue: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_RightsHolderCadastres: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_RightsHolderMortgagee: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_RightsHolderName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_RightsHolderOrgNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_RoleText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_SectionNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_SectionType: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Sectioned: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_SellerCadastre: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_SellerName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_SellerOrgNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ShareDenominator: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ShareFraction: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ShareNumerator: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ShareholderName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ShareholderOrgNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Tenants: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Text: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Title: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TitleholderName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TitleholderOrgNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TitleholderRevenueKNok: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TitleholdersShareholderName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TitleholdersShareholderOrgNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TitleholdersShareholderShare: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ToCadastre: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ToCadastreActive: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_ToCadastreLevel: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TopOwnerName: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TopOwnerOrgNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TopOwnerRevenueKNok: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_Type: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_TypeCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_UseOfCadastreCode: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_UseOfCadastreText: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Header_VoluntaryMortgage: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_AppliesTo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_Buildings: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_CoOwnershipShareholders: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_CoOwnershipShares: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_DisposalRestrictions: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_EncumbranceTransfers: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_Encumbrances: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_GroundData: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_History: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_LandDataFromCadastre: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_LandDataToCadastre: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_LeaseAgreements: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_LeaseholdAgreement: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_Main: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_Mortgage: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_Office: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_PropertyRights: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_Remarks: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_Tenants: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_Title: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_TitleBusinessCadastreSellers: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Tab_TitlePersonCadastreSellers: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_BooleanNo: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_BooleanYes: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_EncumbranceTypeLeaseAgreement: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_EncumbranceTypeLeaseholdAgreement: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_EncumbranceTypeServitude: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_EncumbranceTypeVoluntaryMortgage: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_OwnerLevelLeasehold: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_OwnerLevelTitleholder: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_RegisteredInLeaseRight: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_RegisteredInLeaseholdRight: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  Legal_Report_Value_RegisteredInOwnershipRight: [
    {
      label: "Legal report (Excel)",
      url: "https://app.placepoint.no/map/legal-reports",
      files: ["libs/backends/v2-legal-excel/src/legalexcel.text.go"],
    },
  ],
  NavLayer_NO_Buildings_Root: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/map.layer.navLayer.constants.ts",
      ],
    },
  ],
  NavLayer_NO_Cadastre_MissingNumber_Root: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/map.layer.navLayer.clickHandlers.ts",
      ],
    },
  ],
  NavLayer_NO_Cadastre_Root: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/map.layer.navLayer.constants.ts",
      ],
    },
  ],
  Property_BuiltArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/property/CadastreProperty.tsx"],
    },
  ],
  Property_Cadastre_Border_Area: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/plotValuation/landTransactions/CadastreModulePlotValuationLandTransactions.tsx",
        "v2-console/src/cadastre/module/plotValuation/newBuildsValueEstimator/CadastreModulePlotValuationNewBuildsValueEstimator.tsx",
        "v2-console/src/cadastre/module/plotValuation/plotAds/CadastreModulePlotValuationPlotAds.tsx",
        "v2-console/src/cadastre/module/plotValuation/plots/CadastreModulePlotValuationPlots.tsx",
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/company.properties.useData.ts",
      ],
    },
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/hoverCard/cadastre/CadastreHoverCardLazy.tsx",
        "v2-console/src/object/hoverCard/section/SectionHoverCardLazy.tsx",
      ],
    },
  ],
  Property_Cadastre_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/property/CadastreProperty.tsx"],
    },
  ],
  Property_Cadastre_Number: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/panel/BuildingPanel.tsx",
        "v2-console/src/building/panel/BuildingPanelHeaderTop.tsx",
        "v2-console/src/building/panel/building.panel.headerDisplay.utils.ts",
        "v2-console/src/building/property/hierarchy/BuildingPropertyHierarchyContent.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/cadastre.utils.ts",
        "v2-console/src/cadastre/hierarchyV2/cadastre.hierarchyV2.useData.ts",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.utils.ts",
        "v2-console/src/cadastre/overview/contextBanner/CadastreOverviewContextBanner.tsx",
        "v2-console/src/cadastre/overview/insight/CadastreOverviewInsight.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/company.properties.useData.ts",
        "v2-console/src/company/properties/tree/company.properties.tree.useTreeData.ts",
      ],
    },
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/cadastre/DatasetTableCadastre.tsx",
        "v2-console/src/dataset/table/sheets/dataset.table.sheets.constants.ts",
      ],
    },
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/energyLabel/esg.energyLabel.belongsTo.utils.ts",
      ],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/panel/HousingUnitPanel.tsx",
        "v2-console/src/housingUnit/panel/HousingUnitPanelHeaderTop.tsx",
        "v2-console/src/housingUnit/panel/housingUnit.panel.headerDisplay.utils.ts",
      ],
    },
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/hoverCard/cadastre/CadastreHoverCardLazy.tsx",
        "v2-console/src/object/hoverCard/housingUnit/HousingUnitHoverCardLazy.tsx",
        "v2-console/src/object/hoverCard/section/SectionHoverCardLazy.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/portfolio/person.portfolio.tree.useTreeData.ts",
      ],
    },
    {
      label: "Formatters",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/formatters/formatters.ts"],
    },
  ],
  Property_Cadastre_StoryCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
        "v2-console-ui/src/cadastre/property/CadastreProperty.tsx",
      ],
    },
  ],
  Property_ESG_AboutAttest: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/expand/EsgCertificationBreeamExpand.tsx",
        "v2-console/src/esg/certifications/expand/EsgCertificationLeedExpand.tsx",
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
        "v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx",
      ],
    },
  ],
  Property_ESG_AttestNumber: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx"],
    },
  ],
  Property_ESG_Certifications_KindBreeamCommunities: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.constants.ts",
      ],
    },
  ],
  Property_ESG_Certifications_KindBreeamInUse: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.constants.ts",
      ],
    },
  ],
  Property_ESG_Certifications_KindBreeamNor: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.constants.ts",
      ],
    },
  ],
  Property_ESG_Certifications_KindLeed: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.constants.ts",
      ],
    },
  ],
  Property_ESG_Certifications_KindSvanemerket: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.constants.ts",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderAddress: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderBrand: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderCertBody: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderCertificationDate: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderLicenseNumber: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderName: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.useColumns.tsx",
        "v2-console/src/esg/certifications/esg.certifications.useFilterableConfig.ts",
        "v2-console/src/esg/certifications/expand/EsgCertificationBreeamExpand.tsx",
        "v2-console/src/esg/certifications/expand/EsgCertificationLeedExpand.tsx",
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderProjectType: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderRating: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.useColumns.tsx",
        "v2-console/src/esg/certifications/esg.certifications.useFilterableConfig.ts",
        "v2-console/src/esg/certifications/expand/EsgCertificationBreeamExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderScore: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/EsgCertificationsFilterFields.tsx",
        "v2-console/src/esg/certifications/esg.certifications.useColumns.tsx",
        "v2-console/src/esg/certifications/esg.certifications.useFilterableConfig.ts",
        "v2-console/src/esg/certifications/expand/EsgCertificationBreeamExpand.tsx",
        "v2-console/src/esg/certifications/expand/EsgCertificationLeedExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderType: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/EsgCertificationsFilterFields.tsx",
        "v2-console/src/esg/certifications/esg.certifications.useColumns.tsx",
        "v2-console/src/esg/certifications/esg.certifications.useFilterableConfig.ts",
        "v2-console/src/esg/certifications/expand/EsgCertificationBreeamExpand.tsx",
        "v2-console/src/esg/certifications/expand/EsgCertificationLeedExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderValidUntil: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_Certifications_TableHeaderYear: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.useColumns.tsx",
        "v2-console/src/esg/certifications/esg.certifications.useFilterableConfig.ts",
        "v2-console/src/esg/certifications/expand/EsgCertificationSvanemerketExpand.tsx",
      ],
    },
  ],
  Property_ESG_EnergyLabels: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/summary/EsgSummaryCard.tsx",
        "v2-console/src/esg/summary/EsgSummaryCardSkeleton.tsx",
      ],
    },
  ],
  Property_ESG_Enova_BelongsToUnknown: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/energyLabel/EsgEnergyLabelBelongsToCell.tsx"],
    },
  ],
  Property_ESG_Enova_Outdated: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useColumns.tsx",
      ],
    },
  ],
  Property_ESG_Enova_OutdatedLabel: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx"],
    },
  ],
  Property_ESG_Enova_TableHeaderBelongsTo: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useColumns.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Enova_TableHeaderBuildingCategories: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/energyLabel/EsgEnergyLabelFilterFields.tsx",
        "v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useColumns.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Enova_TableHeaderEnergyRating: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/energyLabel/EsgEnergyLabelFilterFields.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useColumns.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Enova_TableHeaderHeatingRating: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx"],
    },
  ],
  Property_ESG_Enova_TableHeaderIssueDate: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/energyLabel/EsgEnergyLabelFilterFields.tsx",
        "v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useColumns.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Enova_TableHeaderTotal: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useColumns.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Enova_TableHeaderYearOfConstruction: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/energyLabel/EsgEnergyLabelTableExpand.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useColumns.tsx",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_SummaryFound: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/esg/summary/CadastreESGSummaryCard.tsx"],
    },
  ],
  Property_ESG_SummaryFoundEnergyOnly: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/esg/summary/BuildingESGSummaryCard.tsx"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/esg/summary/HousingUnitESGSummaryCard.tsx",
      ],
    },
  ],
  Property_ESG_TabCertifications: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/esg/CadastreESGTable.tsx"],
    },
  ],
  Property_ESG_TabEnova: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/esg/BuildingESGTable.tsx"],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/esg/CadastreESGTable.tsx"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/esg/HousingUnitESGTable.tsx"],
    },
  ],
  Property_ESG_TabTek: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/esg/BuildingESGTable.tsx"],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/esg/CadastreESGTable.tsx"],
    },
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/tek/esg.tek.useColumns.tsx"],
    },
  ],
  Property_ESG_TableSearchPlaceholder: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/esg.certifications.useFilterableConfig.ts",
        "v2-console/src/esg/energyLabel/esg.energyLabel.useFilterableConfig.ts",
        "v2-console/src/esg/tek/esg.tek.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Tek_AboutTitle: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/tek/EsgTekExpand.tsx"],
    },
  ],
  Property_ESG_Tek_BuildingPrefix: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/tek/esg.tek.useColumns.tsx"],
    },
  ],
  Property_ESG_Tek_ReadMore: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/tek/EsgTekExpand.tsx"],
    },
  ],
  Property_ESG_Tek_TableHeaderBuilding: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/tek/esg.tek.useColumns.tsx",
        "v2-console/src/esg/tek/esg.tek.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Tek_TableHeaderBuildingName: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/tek/EsgTekExpand.tsx"],
    },
  ],
  Property_ESG_Tek_TableHeaderBuildingNumber: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/tek/EsgTekExpand.tsx"],
    },
  ],
  Property_ESG_Tek_TableHeaderCode: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/tek/EsgTekExpand.tsx"],
    },
  ],
  Property_ESG_Tek_TableHeaderLevel: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/tek/EsgTekExpand.tsx",
        "v2-console/src/esg/tek/EsgTekFilterFields.tsx",
        "v2-console/src/esg/tek/esg.tek.useColumns.tsx",
        "v2-console/src/esg/tek/esg.tek.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Tek_TableHeaderPermitDate: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/tek/EsgTekExpand.tsx",
        "v2-console/src/esg/tek/esg.tek.useColumns.tsx",
        "v2-console/src/esg/tek/esg.tek.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_Tek_TableHeaderType: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/tek/EsgTekExpand.tsx",
        "v2-console/src/esg/tek/esg.tek.useColumns.tsx",
        "v2-console/src/esg/tek/esg.tek.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ESG_ToggleMapLayersOn: [
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/summary/EsgSummaryCard.tsx"],
    },
  ],
  Property_GovernmentCases_AllCases: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/CadastreGovernmentCasesHeader.tsx",
      ],
    },
  ],
  Property_GovernmentCases_AllCasesBreadcrumb: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/CadastreGovernmentCasesHeader.tsx",
        "v2-console/src/cadastre/governmentCases/CadastreGovernmentCasesTable.tsx",
      ],
    },
  ],
  Property_GovernmentCases_AreaFilterLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/CadastreGovernmentCasesFilter.tsx",
      ],
    },
  ],
  Property_GovernmentCases_AreaFilter_basicstatisticalunit: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cadastre.governmentCases.text.ts",
      ],
    },
  ],
  Property_GovernmentCases_AreaFilter_cadastre: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cadastre.governmentCases.text.ts",
      ],
    },
  ],
  Property_GovernmentCases_AreaFilter_neighbors: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cadastre.governmentCases.text.ts",
      ],
    },
  ],
  Property_GovernmentCases_AreaFilter_road: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cadastre.governmentCases.text.ts",
      ],
    },
  ],
  Property_GovernmentCases_DocumentsBreadcrumb: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/CadastreGovernmentCasesTable.tsx",
      ],
    },
  ],
  Property_GovernmentCases_FieldCaseNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCasesDocumentsTableExpand.tsx",
      ],
    },
  ],
  Property_GovernmentCases_FieldDocumentDate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCasesDocumentsTableExpand.tsx",
      ],
    },
  ],
  Property_GovernmentCases_FieldDocumentNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCasesDocumentsTableExpand.tsx",
      ],
    },
  ],
  Property_GovernmentCases_FieldFrom: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCasesDocumentsTableExpand.tsx",
      ],
    },
  ],
  Property_GovernmentCases_FieldSource: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCasesDocumentsTableExpand.tsx",
      ],
    },
  ],
  Property_GovernmentCases_FieldTo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCasesDocumentsTableExpand.tsx",
      ],
    },
  ],
  Property_GovernmentCases_GroupByYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cases/cadastre.governmentCases.cases.useFilterableConfig.ts",
        "v2-console/src/cadastre/governmentCases/documents/cadastre.governmentCases.documents.useFilterableConfig.ts",
      ],
    },
  ],
  Property_GovernmentCases_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/CadastreGovernmentCasesHeader.tsx",
      ],
    },
  ],
  Property_GovernmentCases_SearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cases/cadastre.governmentCases.cases.useFilterableConfig.ts",
        "v2-console/src/cadastre/governmentCases/documents/cadastre.governmentCases.documents.useFilterableConfig.ts",
      ],
    },
  ],
  Property_GovernmentCases_SummaryFor: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/CadastreGovernmentCasesFilter.tsx",
      ],
    },
  ],
  Property_GovernmentCases_TableHeaderDate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cases/CadastreGovernmentCasesTableContent.tsx",
        "v2-console/src/cadastre/governmentCases/cases/cadastre.governmentCases.cases.useColumns.tsx",
        "v2-console/src/cadastre/governmentCases/cases/cadastre.governmentCases.cases.useFilterableConfig.ts",
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCaseDocumentsTableContent.tsx",
        "v2-console/src/cadastre/governmentCases/documents/cadastre.governmentCases.documents.useColumns.tsx",
      ],
    },
  ],
  Property_GovernmentCases_TableHeaderDocumentCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cases/cadastre.governmentCases.cases.useColumns.tsx",
        "v2-console/src/cadastre/governmentCases/cases/cadastre.governmentCases.cases.useFilterableConfig.ts",
      ],
    },
  ],
  Property_GovernmentCases_TableHeaderFileCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCasesDocumentFiles.tsx",
        "v2-console/src/cadastre/governmentCases/documents/cadastre.governmentCases.documents.useColumns.tsx",
        "v2-console/src/cadastre/governmentCases/documents/cadastre.governmentCases.documents.useFilterableConfig.ts",
      ],
    },
  ],
  Property_GovernmentCases_TableHeaderTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cases/cadastre.governmentCases.cases.useColumns.tsx",
        "v2-console/src/cadastre/governmentCases/documents/cadastre.governmentCases.documents.useColumns.tsx",
      ],
    },
  ],
  Property_MarketTransactions_AboutDeal: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_Advisor: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_Amount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableContent.tsx",
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_AmountPerSquareMeter: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_BuildingArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_Buyers: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
      ],
    },
  ],
  Property_MarketTransactions_LeasePeriod: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_NameMatchHint: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsPartyList.tsx",
      ],
    },
  ],
  Property_MarketTransactions_Note: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_OpenSource: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
      ],
    },
  ],
  Property_MarketTransactions_OwnedCompany: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/marketTransactions/CompanyMarketTransactionsTableContent.tsx",
        "v2-console/src/company/marketTransactions/company.marketTransactions.useColumns.tsx",
        "v2-console/src/company/marketTransactions/company.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_Period: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_PlotArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_Properties: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_PropertyName: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_PropertyType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_Role: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/marketTransactions/CompanyMarketTransactionsTableContent.tsx",
        "v2-console/src/company/marketTransactions/company.marketTransactions.useColumns.tsx",
        "v2-console/src/company/marketTransactions/company.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_RoleBuyer: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/marketTransactions/company.marketTransactions.useData.ts",
      ],
    },
  ],
  Property_MarketTransactions_RoleSeller: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/marketTransactions/company.marketTransactions.useData.ts",
      ],
    },
  ],
  Property_MarketTransactions_Sellers: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
      ],
    },
  ],
  Property_MarketTransactions_ShowAllProperties: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsPropertyList.tsx",
      ],
    },
  ],
  Property_MarketTransactions_ShowLessProperties: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsPropertyList.tsx",
      ],
    },
  ],
  Property_MarketTransactions_ShowOnMap: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_Source: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableContent.tsx",
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_SourceLink: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
      ],
    },
  ],
  Property_MarketTransactions_SquareMeters: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useColumns.tsx",
      ],
    },
  ],
  Property_MarketTransactions_TableSearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/marketTransactions/company.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_MarketTransactions_Title: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_Week: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_MarketTransactions_Year: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableContent.tsx",
        "v2-console/src/cadastre/marketTransactions/cadastre.marketTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Owners_CompanyOwnership_Error_CouldNotLoadOwners: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx"],
    },
  ],
  Property_Owners_CompanyOwnership_Error_SomeOwnersCouldNotBeLoaded: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/cadastre.owners.text.ts"],
    },
  ],
  Property_Owners_ContactRole: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
        "v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx",
      ],
    },
  ],
  Property_Owners_DateFrom: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
        "v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx",
      ],
    },
  ],
  Property_Owners_DateTo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
        "v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx",
      ],
    },
  ],
  Property_Owners_EmptyState: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/tree/CadastreOwnersTreeView.tsx"],
    },
  ],
  Property_Owners_Expand_OwnedSection: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
      ],
    },
  ],
  Property_Owners_Expand_SectionWeight: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
      ],
    },
  ],
  Property_Owners_Expand_ShareInSection: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
      ],
    },
  ],
  Property_Owners_Expand_WeightedShare: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
      ],
    },
  ],
  Property_Owners_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/cadastre.owners.text.ts"],
    },
  ],
  Property_Owners_HolderType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Owners_HolderTypeCompany: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableContent.tsx",
      ],
    },
  ],
  Property_Owners_HolderTypeOther: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableContent.tsx",
      ],
    },
  ],
  Property_Owners_HolderTypePerson: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableContent.tsx",
      ],
    },
  ],
  Property_Owners_HolderTypeSection: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableContent.tsx",
      ],
    },
  ],
  Property_Owners_Insight_ActualOwners: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/actualOwners/CadastreActualOwners.tsx",
      ],
    },
  ],
  Property_Owners_Insight_ActualOwners_Info: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/actualOwners/CadastreActualOwnersInfoButton.tsx",
      ],
    },
  ],
  Property_Owners_Insight_ActualOwners_Info_Docs: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/actualOwners/CadastreActualOwnersInfoButton.tsx",
      ],
    },
  ],
  Property_Owners_Insight_ActualOwners_OtherOwners: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/actualOwners/CadastreActualOwners.tsx",
      ],
    },
  ],
  Property_Owners_Insight_ActualOwners_OtherPersons: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/actualOwners/CadastreActualOwners.tsx",
      ],
    },
  ],
  Property_Owners_Insight_BreakdownOthers: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Owners_Insight_BreakdownOwnersSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Owners_Insight_BreakdownTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
      ],
    },
  ],
  Property_Owners_Insight_BreakdownTooltipShare: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
      ],
    },
  ],
  Property_Owners_Insight_BreakdownUnknown: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Owners_Insight_Festere: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/primaryOwners/CadastrePrimaryOwners.tsx",
      ],
    },
  ],
  Property_Owners_Insight_Gardeiere: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/primaryOwners/CadastrePrimaryOwners.tsx",
      ],
    },
  ],
  Property_Owners_Insight_Hjemmelshaver: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/primaryOwners/CadastrePrimaryOwners.tsx",
      ],
    },
  ],
  Property_Owners_Insight_NoHjemmelshaver: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/primaryOwners/CadastrePrimaryOwners.tsx",
      ],
    },
  ],
  Property_Owners_Insight_ShowLess: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/cadastre.owners.text.ts"],
    },
  ],
  Property_Owners_Insight_ShowMoreOthers: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/primaryOwners/CadastrePrimaryOwnerRows.tsx",
      ],
    },
  ],
  Property_Owners_Insight_ShowMoreOthersTooltip: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/actualOwners/CadastreActualOwners.tsx",
        "v2-console/src/cadastre/owners/primaryOwners/CadastrePrimaryOwnerRows.tsx",
      ],
    },
  ],
  Property_Owners_InterestType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useColumns.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useFilterableConfig.ts",
        "v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx",
      ],
    },
  ],
  Property_Owners_LandOwner: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
        "v2-console/src/cadastre/owners/tree/cadastre.owners.tree.useData.ts",
      ],
    },
  ],
  Property_Owners_Leaseholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
        "v2-console/src/cadastre/owners/tree/cadastre.owners.tree.useData.ts",
      ],
    },
  ],
  Property_Owners_ListTabLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/CadastreOwnersTabs.tsx",
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
      ],
    },
  ],
  Property_Owners_Owner: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useColumns.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Owners_PartyType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
        "v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx",
      ],
    },
  ],
  Property_Owners_Period: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/cadastre.owners.text.ts"],
    },
  ],
  Property_Owners_PrivatePerson_Fallback: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/primaryOwners/CadastrePrimaryOwnerRow.tsx",
      ],
    },
  ],
  Property_Owners_PurposeType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
      ],
    },
  ],
  Property_Owners_RecordType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useColumns.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useFilterableConfig.ts",
        "v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx",
      ],
    },
  ],
  Property_Owners_Role: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/CadastreOwnersInsightCards.tsx",
      ],
    },
  ],
  Property_Owners_Section: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
      ],
    },
  ],
  Property_Owners_Section_WithNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx"],
    },
  ],
  Property_Owners_Sections: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/cadastre.owners.text.ts"],
    },
  ],
  Property_Owners_SectionsCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/insight/cadastre.owners.insight.useStackedSummaryData.ts",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useColumns.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Owners_Share: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandOwnershipSummary.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useColumns.tsx",
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Owners_Table_About: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/cadastre.owners.text.ts"],
    },
  ],
  Property_Owners_Table_AboutOwnership: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandOwnershipSummary.tsx",
      ],
    },
  ],
  Property_Owners_Table_HoldingsTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/cadastre.owners.text.ts"],
    },
  ],
  Property_Owners_Table_SearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/cadastre.owners.table.useFilterableConfig.ts",
        "v2-console/src/cadastre/owners/tree/cadastre.owners.tree.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Owners_Table_WholeProperty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/table/CadastreOwnersTableExpandHoldingDetail.tsx",
      ],
    },
  ],
  Property_Owners_TreeTabLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/CadastreOwnersTabs.tsx"],
    },
  ],
  Property_Owners_Tree_CollapseAll: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/CadastreOwnersTabs.tsx"],
    },
  ],
  Property_Owners_Tree_ExpandAll: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/CadastreOwnersTabs.tsx"],
    },
  ],
  Property_Property_AboutBuilding: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_AboutHousingUnit: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_AboutPlot: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_AboutSection: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/sections/CadastrePropertySectionsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Address: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_AnimalsAllowed: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_ApartmentNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Area: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BAR: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BRA: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BRAB: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BRAE: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BRAForHousing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BRAForOther: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BRAI: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BTA: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BYA: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BYAForHousing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BYAForOther: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Bathrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Bedrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BuildingId: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BuildingNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BuildingStatus: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsFilterBody.tsx",
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_ExpandField_BuildingType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BuildingTypeAggregated: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_BuildingTypePrimary: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsFilterBody.tsx",
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_ExpandField_BuildingTypeSub: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsFilterBody.tsx",
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_ExpandField_BuiltYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_CadastreNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
        "v2-console/src/cadastre/property/sections/CadastrePropertySectionsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_ConfirmedOwners: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_DataCaptureDate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Dispute: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_EnergyLabels: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/cadastre.property.energyLabelExpand.utils.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_EnergySources: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Environment: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_ExtensionType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Floor: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
        "v2-console/src/cadastre/property/sections/CadastrePropertySectionsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_FloorPlanType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Floors: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_GrossArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_HasLift: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsFilterBody.tsx",
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_ExpandField_HeatingTypes: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_HousingUnitCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/sections/CadastrePropertySectionsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_HousingUnitNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_HousingUnitType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
        "v2-console/src/cadastre/property/sections/CadastrePropertySectionsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_HousingUnitTypeCode: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_HousingUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_IndustryGroup: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_IsAreaIncomplete: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_IsCulturalHeritage: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_IsSEFRAK: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_IsWithoutBuiltUpArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_KitchenAccessType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_LandArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_LeaseholdPlots: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/sections/CadastrePropertySectionsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_MultipleCadastralUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_OriginType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_PROM: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_PlotType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Rooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_SectionUseArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/sections/CadastrePropertySectionsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_SequenceNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_SewerType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_TBAArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_TekCode: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_TekLevel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_TekPermitDate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_TekType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_ToBeDiscontinued: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Toilets: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_UnitType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
        "v2-console/src/cadastre/property/sections/CadastrePropertySectionsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_UnregisteredCoOwnership: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_UseArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Valuation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_ValuationComingSoon: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/CadastrePropertyHousingUnitsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_Volume: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_ExpandField_WaterSupplyType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_HierarchyCollapseAll: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/CadastrePropertyTable.tsx"],
    },
  ],
  Property_Property_HierarchyExpandAll: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/CadastrePropertyTable.tsx"],
    },
  ],
  Property_Property_InfoAreaRemark: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoAreaRemarkAdditionalArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoAreaRemarkUnderMerger: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoCoordinates: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoCulturalHeritage: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoGroundPollution: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoHistoricalReportedArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoLandAcquisition: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoLandPartitioningRequired: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoLandRegistryName: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoLeaseholdPlots: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoMuf: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoMunicipality: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoPropertyRegistrationNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoPropertyRegistrationNumberSub: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoRegistryOfDeeds: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InfoSectioned: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/info/CadastrePropertyInfoContent.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_AreaUse: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_InsightRow_AverageFloors: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_InsightRow_AverageUseArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_BuildingCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_BuildingPerSection: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_BuiltUpArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_BuiltUpAreaRatio: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_BuiltYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_Commercial: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_CommercialVsHousing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_Disputes: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_InsightRow_Floors: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_FloorsAverageShort: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_FloorsMaxShort: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_FloorsMinShort: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_HighestFloors: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_InsightRow_Housing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_HousingUnitCount: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_MultipleCadastralUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_InsightRow_Other: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_InsightRow_PlotAreaTotal: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_PlotCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_PlotTotal: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_SectionCount: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_Total: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_InsightRow_TotalUseArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_UtilityFloorSpaceHousing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_UtilityFloorSpaceOther: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_UtilityFloorSpaceRate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_InsightRow_UtilityFloorSpaceTotal: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_Insight_BRA: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_Insight_BYA: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_Insight_Building: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_Insight_Buildings: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_Insight_Plots: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_Insight_SectionsUnits: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/CadastrePropertyInsightCards.tsx",
      ],
    },
  ],
  Property_Property_Kotehoyde_Bygghoyde: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/cadastre.property.kotehoyde.utils.tsx",
      ],
    },
  ],
  Property_Property_Kotehoyde_Feature: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/cadastre.property.kotehoyde.utils.tsx",
      ],
    },
  ],
  Property_Property_Kotehoyde_HeightAboveGround: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/cadastre.property.kotehoyde.utils.tsx",
      ],
    },
  ],
  Property_Property_Kotehoyde_Terrenghoyde: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/cadastre.property.kotehoyde.utils.tsx",
      ],
    },
  ],
  Property_Property_NoBuildings: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_PlotJumpTo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_PlotLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useData.ts",
      ],
    },
  ],
  Property_Property_PlotLandUse: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsTableExpand.tsx",
      ],
    },
  ],
  Property_Property_TabBuildings: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/CadastrePropertyTable.tsx"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/building/HousingUnitBuildingTable.tsx",
      ],
    },
  ],
  Property_Property_TabHierarchy: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/property/BuildingPropertyTable.tsx"],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/CadastrePropertyTable.tsx"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/building/HousingUnitBuildingTable.tsx",
      ],
    },
  ],
  Property_Property_TabHousingUnits: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/property/BuildingPropertyTable.tsx"],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/CadastrePropertyTable.tsx"],
    },
  ],
  Property_Property_TabInfo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/CadastrePropertyTable.tsx"],
    },
  ],
  Property_Property_TabPlots: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/CadastrePropertyTable.tsx"],
    },
  ],
  Property_Property_TabSections: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/property/BuildingPropertyTable.tsx"],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/CadastrePropertyTable.tsx"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/building/HousingUnitBuildingTable.tsx",
      ],
    },
  ],
  Property_Property_TableHeaderArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useColumns.tsx",
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderBRA: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useColumns.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderBYA: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/property/BuildingPropertyInsightCards.tsx",
      ],
    },
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useColumns.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderBathrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
      ],
    },
  ],
  Property_Property_TableHeaderBuilding: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useColumns.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderBuildingNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useColumns.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
      ],
    },
  ],
  Property_Property_TableHeaderBuildingType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsFilterBody.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderCadastreNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
      ],
    },
  ],
  Property_Property_TableHeaderConfirmedOwners: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_TableHeaderDataCaptureDate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_TableHeaderDispute: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_TableHeaderEnergyAndKotehoyde: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useColumns.tsx",
      ],
    },
  ],
  Property_Property_TableHeaderEnergyLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderEnvironment: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useColumns.tsx",
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderFlags: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useColumns.tsx",
      ],
    },
  ],
  Property_Property_TableHeaderFloor: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useColumns.tsx",
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderHousingUnit: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderHousingUnitType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useColumns.tsx",
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderHousingUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useColumns.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderIndustryGroup: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsFilterBody.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useColumns.tsx",
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderLeaseholdPlots: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useColumns.tsx",
      ],
    },
  ],
  Property_Property_TableHeaderMultipleCadastralUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_TableHeaderPlot: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useColumns.tsx",
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderPlotType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useColumns.tsx",
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderRooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderSection: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useColumns.tsx",
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderToilets: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_TableHeaderUnitCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useColumns.tsx",
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderUnregisteredCoOwnership: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/property/cadastre.property.text.ts"],
    },
  ],
  Property_Property_TableHeaderUseArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useColumns.tsx",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useColumns.tsx",
        "v2-console/src/cadastre/property/sections/cadastre.property.sections.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableHeaderVolume: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useColumns.tsx",
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Property_TableSearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/buildings/cadastre.property.buildings.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/hierarchy/cadastre.property.hierarchy.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/housingUnits/cadastre.property.housingUnits.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/info/cadastre.property.info.useFilterableConfig.ts",
        "v2-console/src/cadastre/property/plots/cadastre.property.plots.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Regulation_DocDownload: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.constants.ts"],
    },
  ],
  Property_Regulation_DocDownloadError: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanDocuments.tsx"],
    },
  ],
  Property_Regulation_DocMustRead: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanDocuments.tsx"],
    },
  ],
  Property_Regulation_DocNote_NotPdfExtension: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.utils.ts"],
    },
  ],
  Property_Regulation_DocNote_NotPdfMime: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.utils.ts"],
    },
  ],
  Property_Regulation_DocNote_RestrictedAccess: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.utils.ts"],
    },
  ],
  Property_Regulation_DocsBrowseAll: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanDocuments.tsx"],
    },
  ],
  Property_Regulation_DocsError: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanDocuments.tsx"],
    },
  ],
  Property_Regulation_DocsNote_NoDocumentsAtProvider: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.utils.ts"],
    },
  ],
  Property_Regulation_DocsNote_NoProviderCovers: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.utils.ts"],
    },
  ],
  Property_Regulation_DocsNote_NotFoundAtProvider: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.utils.ts"],
    },
  ],
  Property_Regulation_DocsNote_OsloNotCovered: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.utils.ts"],
    },
  ],
  Property_Regulation_DocsNote_ProviderError: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.utils.ts"],
    },
  ],
  Property_Regulation_LabelAnnounced: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelAreaName: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelAreaPurpose: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_LabelBaandlagt: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelBuildingProvision: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelCaseNumber: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelDataHost: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_LabelDecisionDate: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelDeclaredAt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_LabelDescription: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelFieldName: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.text.ts"],
    },
  ],
  Property_Regulation_LabelFinalizedAt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelInEffectAt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelLandUseStatus: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelLegalRef: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelMinUtilization: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelMunicipalityCode: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_LabelObjectType: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelOriginalPlanId: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelOutdoorArea: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelOwnershipForm: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelPlanId: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelPlanStatus: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelPlanTypeName: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.text.ts"],
    },
  ],
  Property_Regulation_LabelProposerSector: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelProvision: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelProvisionType: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelPurpose: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_LabelSuggester: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelUpdatedAt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_LabelUtilizationType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelUtilizationValue: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelValidUntil: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelVerticalLevel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_LabelZoneName: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.text.ts"],
    },
  ],
  Property_Regulation_MunicipalityPlansError: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_MunicipalityPlansHeader: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_NoCoordinate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_NoMunicipalityPlans: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_NoZoningPlans: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_OsloLimitedDescription: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanSourceBlock.tsx"],
    },
  ],
  Property_Regulation_OsloLimitedTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_OsloPlaninnsynLink: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanSourceBlock.tsx"],
    },
  ],
  Property_Regulation_PlanRowToggle: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/regulation/PlanExpandRowTrigger.tsx",
        "v2-console/src/regulation/regulation.constants.ts",
      ],
    },
  ],
  Property_Regulation_SectionAnnet: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanMatchRow.tsx"],
    },
  ],
  Property_Regulation_SectionBestemmelse: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanMatchRow.tsx"],
    },
  ],
  Property_Regulation_SectionDocuments: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/regulation/PlanDocuments.tsx",
        "v2-console/src/regulation/PlanoppstartRow.tsx",
      ],
    },
  ],
  Property_Regulation_SectionHensyn: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanMatchRow.tsx"],
    },
  ],
  Property_Regulation_SectionPlanoppstart: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.text.ts"],
    },
  ],
  Property_Regulation_SectionPurposes: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanMatchRow.tsx"],
    },
  ],
  Property_Regulation_SeePlanDetails: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanMatchRow.tsx"],
    },
  ],
  Property_Regulation_SourceHitsSuffix: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.usePlanDetailsData.ts"],
    },
  ],
  Property_Regulation_SourceInfo_Kommuneplan: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.constants.ts"],
    },
  ],
  Property_Regulation_SourceInfo_Kommuneplanforslag: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.constants.ts"],
    },
  ],
  Property_Regulation_SourceInfo_Planoppstart: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.constants.ts"],
    },
  ],
  Property_Regulation_SourceInfo_Reguleringsplan: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.constants.ts"],
    },
  ],
  Property_Regulation_SourceInfo_Reguleringsplanforslag: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.constants.ts"],
    },
  ],
  Property_Regulation_SourceNoHits: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.usePlanDetailsData.ts"],
    },
  ],
  Property_Regulation_SourceNoPlans: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/PlanSourceBlock.tsx"],
    },
  ],
  Property_Regulation_SourceUnavailable: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/regulation/PlanSourceBlock.tsx",
        "v2-console/src/regulation/RegulationSourceBadges.tsx",
        "v2-console/src/regulation/regulation.usePlanDetailsData.ts",
      ],
    },
  ],
  Property_Regulation_SummaryEnableMapLayer: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/RegulationLayerToggle.tsx"],
    },
  ],
  Property_Regulation_SummaryHitCountSuffix: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/regulation/RegulationLookupSummary.tsx",
        "v2-console/src/regulation/RegulationSummaryCard.tsx",
      ],
    },
  ],
  Property_Regulation_SummaryMunicipalityPlan: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/RegulationSummaryCard.tsx"],
    },
  ],
  Property_Regulation_SummarySeeDetails: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/RegulationSummaryCard.tsx"],
    },
  ],
  Property_Regulation_SummaryZoningPlan: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/RegulationSummaryCard.tsx"],
    },
  ],
  Property_Regulation_Unknown: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/regulation/regulation.planRows.utils.ts"],
    },
  ],
  Property_Regulation_UnknownWithCode: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_ZoningPlansError: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_ZoningPlansHeader: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/regulation/CadastreRegulation.tsx"],
    },
  ],
  Property_Regulation_ZoomToArea: [
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/regulation/PlanHoverRow.tsx",
        "v2-console/src/regulation/regulation.constants.ts",
      ],
    },
  ],
  Property_Risks_Column_MapLayer: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.useColumns.tsx"],
    },
  ],
  Property_Risks_Column_ShowInMap: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.useColumns.tsx"],
    },
  ],
  Property_Risks_Column_Status: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.useColumns.tsx"],
    },
  ],
  Property_Risks_CoverageProxyNote: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskPanel.tsx"],
    },
  ],
  Property_Risks_Details_Empty: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/risk/RiskLayerFeatures.tsx",
        "v2-console/src/risk/RiskPanel.tsx",
      ],
    },
  ],
  Property_Risks_Details_Expand: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.text.ts"],
    },
  ],
  Property_Risks_Details_Header: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.text.ts"],
    },
  ],
  Property_Risks_Details_LayerHits: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskPanel.tsx"],
    },
  ],
  Property_Risks_Details_SublayerHits: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskSublayerTree.tsx"],
    },
  ],
  Property_Risks_Details_ZoomTo: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.constants.ts"],
    },
  ],
  Property_Risks_DownloadReport: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.text.ts"],
    },
  ],
  Property_Risks_EmptyState: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskPanel.tsx"],
    },
  ],
  Property_Risks_FeatureRow_ToggleProperties: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskLayerHit.tsx"],
    },
  ],
  Property_Risks_Feature_HitHeader: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskLayerFeatures.tsx"],
    },
  ],
  Property_Risks_Feature_SeeMap: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskLayerFeatures.tsx"],
    },
  ],
  Property_Risks_Feature_ShowLess: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskLayerHit.tsx"],
    },
  ],
  Property_Risks_Feature_ShowMore: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskLayerHit.tsx"],
    },
  ],
  Property_Risks_Header: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.text.ts"],
    },
  ],
  Property_Risks_Note_NotChecked: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.utils.ts"],
    },
  ],
  Property_Risks_Note_TimedOut: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.utils.ts"],
    },
  ],
  Property_Risks_Progress: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskPanel.tsx"],
    },
  ],
  Property_Risks_ProgressNoHits: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskPanel.tsx"],
    },
  ],
  Property_Risks_Row_ToggleLayer: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/risk.useColumns.tsx"],
    },
  ],
  Property_Risks_Status_Hit: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/risk/risk.useColumns.tsx",
        "v2-console/src/risk/risk.useRisksData.ts",
      ],
    },
  ],
  Property_Risks_Status_NoHit: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/risk/risk.useColumns.tsx",
        "v2-console/src/risk/risk.useRisksData.ts",
      ],
    },
  ],
  Property_Risks_Status_Unavailable: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/risk/RiskPanel.tsx",
        "v2-console/src/risk/risk.useColumns.tsx",
      ],
    },
  ],
  Property_Risks_Status_Unknown: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/risk/risk.useColumns.tsx",
        "v2-console/src/risk/risk.useRisksData.ts",
      ],
    },
  ],
  Property_Risks_Summary_Detected: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskSummary.tsx"],
    },
  ],
  Property_Risks_Summary_ToggleAllLayers: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskSummary.tsx"],
    },
  ],
  Property_Risks_Summary_ToggleHitLayers: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskSummary.tsx"],
    },
  ],
  Property_Risks_Summary_ToggleLayers: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskSummary.tsx"],
    },
  ],
  Property_Risks_Table_Title: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskPanel.tsx"],
    },
  ],
  Property_Risks_Value: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskPanel.tsx"],
    },
  ],
  Property_Risks_ValueWithPeriod: [
    {
      label: "Risk",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/risk/RiskPanel.tsx"],
    },
  ],
  Property_ShareTransactions_AboutEvent: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_ShareTransactions_Change: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ShareTransactions_OwnedCompany: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useColumns.tsx",
      ],
    },
  ],
  Property_ShareTransactions_OwnerPercentage: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useColumns.tsx",
      ],
    },
  ],
  Property_ShareTransactions_OwnerShares: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useColumns.tsx",
      ],
    },
  ],
  Property_ShareTransactions_ParentChainNow: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_ShareTransactions_ParentChainTransactionYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_ShareTransactions_Party: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ShareTransactions_PropertyShare: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_ShareTransactions_PropertyShareDelta: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ShareTransactions_Source: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ShareTransactions_SourcePortfolio: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useData.ts",
      ],
    },
  ],
  Property_ShareTransactions_SourceShares: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useData.ts",
      ],
    },
  ],
  Property_ShareTransactions_TableSearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_ShareTransactions_UltimateOwner: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreShareTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_ShareTransactions_Year: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.shareTransactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Tenants_AboutTenancy: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/CadastreTenantsTableExpand.tsx"],
    },
  ],
  Property_Tenants_AboutTenant: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/CadastreTenantsTableExpand.tsx"],
    },
  ],
  Property_Tenants_AvgTenancyDurationCurrent: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
      ],
    },
  ],
  Property_Tenants_AvgTenancyDurationHistoric: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
      ],
    },
  ],
  Property_Tenants_Export: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsExportButton.tsx",
      ],
    },
  ],
  Property_Tenants_ExportConfirmAll: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsExportButton.tsx",
      ],
    },
  ],
  Property_Tenants_ExportConfirmCancel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsExportButton.tsx",
      ],
    },
  ],
  Property_Tenants_ExportConfirmDescription: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsExportButton.tsx",
      ],
    },
  ],
  Property_Tenants_ExportConfirmFiltered: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsExportButton.tsx",
      ],
    },
  ],
  Property_Tenants_ExportConfirmFlatGroupsNote: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsExportButton.tsx",
      ],
    },
  ],
  Property_Tenants_ExportConfirmTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsExportButton.tsx",
      ],
    },
  ],
  Property_Tenants_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsTable.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTable.tsx",
      ],
    },
  ],
  Property_Tenants_HistoricHeader: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/CadastreTenantsTable.tsx"],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/table/CompanyPropertiesTable.tsx",
      ],
    },
  ],
  Property_Tenants_IncludeShellCompanies: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx"],
    },
  ],
  Property_Tenants_NoTenants: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/cadastre.tenants.text.ts"],
    },
  ],
  Property_Tenants_NumberOfEmployees: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/cadastre.tenants.text.ts"],
    },
  ],
  Property_Tenants_Overview: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
      ],
    },
  ],
  Property_Tenants_Period: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Tenants_SingleEmployee: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/cadastre.tenants.text.ts"],
    },
  ],
  Property_Tenants_SizeBucketLarge: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Tenants_SizeBucketMedium: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Tenants_SizeBucketMicro: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Tenants_SizeBucketSmall: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Tenants_StackedSummaryOfAllTenants: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
      ],
    },
  ],
  Property_Tenants_StackedSummaryOthersName: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Tenants_StackedSummaryTenants: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Tenants_StackedSummaryTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
      ],
    },
  ],
  Property_Tenants_StackedSummaryTotalEmployees: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderAddress: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderCEOName: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderCompanyId: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/cadastre.tenants.text.ts"],
    },
  ],
  Property_Tenants_TableHeaderFoundedAt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts"],
    },
  ],
  Property_Tenants_TableHeaderIndustrialClassification: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderMovedFromLocationAt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderMovedToLocationAt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderName: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderNumberOfEmployees: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderOrganizationNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderPhone: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderProperty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
      ],
    },
  ],
  Property_Tenants_TableHeaderTenancyDurationYears: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Tenants_TableHeaderTenant: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
      ],
    },
  ],
  Property_Tenants_TableHeaderUrl: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useExport.ts",
      ],
    },
  ],
  Property_Tenants_TableSearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Tenants_TenantsWithEmployees: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
      ],
    },
  ],
  Property_Tenants_TenantsWithoutEmployees: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
      ],
    },
  ],
  Property_Tenants_Today: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.expand.utils.tsx",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useColumns.tsx",
      ],
    },
  ],
  Property_Tenants_TotalEmployees: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/CadastreTenantsInsightCards.tsx",
      ],
    },
  ],
  Property_Tenants_UnknownIndustry: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Transactions_AboutTransaction: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_Amount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Transactions_Buyers: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_CadastreNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Transactions_Document: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
      ],
    },
  ],
  Property_Transactions_ExpandAmount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_ExpandDocumentYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_ExpandRegistered: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_ExpandRightType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_ExpandTransferTax: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_ExpandTransferTaxReason: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_ExpandType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_HasFee: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Transactions_HasTransferTax: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsTable.tsx",
      ],
    },
  ],
  Property_Transactions_HousingCooperativeShare: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_HousingCooperativeShareLine: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_HousingCooperativeSharesPrice: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_LastTransaction: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_NoParties: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.text.ts",
      ],
    },
  ],
  Property_Transactions_OpenMarket: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Transactions_Overview: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_PartyShareFraction: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsPartyRow.tsx",
      ],
    },
  ],
  Property_Transactions_PrivatePerson_Fallback: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsPartyRow.tsx",
      ],
    },
  ],
  Property_Transactions_PropertyTabHeader: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/transactions/PersonTransactionsTable.tsx"],
    },
  ],
  Property_Transactions_Registered: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Transactions_RightType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_Sellers: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_ShareTransactionsComingSoon: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.text.ts",
      ],
    },
  ],
  Property_Transactions_ShareTransactionsHeader: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
      ],
    },
  ],
  Property_Transactions_ShowAllCadastres: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsCadastreList.tsx",
      ],
    },
  ],
  Property_Transactions_ShowLessCadastres: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsCadastreList.tsx",
      ],
    },
  ],
  Property_Transactions_StackedSummaryCountLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Transactions_StackedSummaryOthers: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Transactions_StackedSummaryShareLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_StackedSummaryTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_StackedSummaryTitleByRightType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_StackedSummaryTitleByType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_StackedSummaryTitleByUsage: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_StackedSummaryTitleByYear: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_StackedSummaryUnknown: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.useStackedSummaryData.ts",
      ],
    },
  ],
  Property_Transactions_TableSearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Transactions_Total: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_TotalAmount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_TransferTax: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useFilterableConfig.ts",
      ],
    },
  ],
  Property_Transactions_TransferTaxBasis: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  Property_Transactions_TransferTaxReason: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
      ],
    },
  ],
  Property_Transactions_Type: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useFilterableConfig.ts",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
        "v2-console/src/company/transactions/CompanyTransactionsTable.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
        "v2-console/src/person/transactions/PersonTransactionsTable.tsx",
      ],
    },
  ],
  Property_Transactions_UsageType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
        "v2-console/src/cadastre/transactions/cadastre.transactions.useColumns.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  Property_Transactions_Year: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsInsightCards.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/transactions/PersonTransactionsInsightCards.tsx",
      ],
    },
  ],
  UI_3DSettings_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemBackgroundSettings.tsx",
        "v2-console/src/map/toolbar/MapToolbarItemSceneViewSettings.tsx",
      ],
    },
  ],
  UI_About_Company: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoCompany.tsx"],
    },
  ],
  UI_About_Contact: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoContact.tsx"],
    },
  ],
  UI_About_ContactUsLink: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoContact.tsx"],
    },
  ],
  UI_About_DocsLink: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoResources.tsx"],
    },
  ],
  UI_About_Email: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoContact.tsx"],
    },
  ],
  UI_About_MenuItem: [
    {
      label: "Help",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/help/HelpMenuItems.tsx"],
    },
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/help/AboutDialog.tsx"],
    },
  ],
  UI_About_OrgNumber: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoCompany.tsx"],
    },
  ],
  UI_About_Resources: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoResources.tsx"],
    },
  ],
  UI_About_TermsLink: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoResources.tsx"],
    },
  ],
  UI_About_Title: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/about.text.ts"],
    },
  ],
  UI_About_VersionLabel: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoVersion.tsx"],
    },
  ],
  UI_About_WebsiteLink: [
    {
      label: "About",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/about/info/AboutInfoResources.tsx"],
    },
  ],
  UI_ActiveLayers_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/toolbar/MapToolbarItemActiveLayers.tsx"],
    },
  ],
  UI_Address_EntranceLabel: [
    {
      label: "Address",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/address/AddressInfo.tsx"],
    },
  ],
  UI_Address_NumberLabel: [
    {
      label: "Address",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/address/AddressInfo.tsx"],
    },
  ],
  UI_Address_PanelTitle: [
    {
      label: "Address",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/address/AddressPanel.tsx"],
    },
  ],
  UI_Agent_Answer: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Agent_Beta: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Cap_Ownership_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Cap_Plans_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Cap_Property_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Cap_Risk_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Capabilities_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Clear: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelContent.tsx"],
    },
  ],
  UI_Agent_Combify: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Agent_Connectors_Add: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorsSection.tsx"],
    },
  ],
  UI_Agent_Connectors_AdminOnly_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorAdminNotice.tsx"],
    },
  ],
  UI_Agent_Connectors_Admins_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorAdminNotice.tsx"],
    },
  ],
  UI_Agent_Connectors_Connected: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorList.tsx"],
    },
  ],
  UI_Agent_Connectors_Custom_Warning_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Disconnect: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorList.tsx"],
    },
  ],
  UI_Agent_Connectors_DisconnectConfirm_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorList.tsx"],
    },
  ],
  UI_Agent_Connectors_DisconnectConfirm_Yes: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorList.tsx"],
    },
  ],
  UI_Agent_Connectors_Docs: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorAdminNotice.tsx"],
    },
  ],
  UI_Agent_Connectors_Empty_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorList.tsx"],
    },
  ],
  UI_Agent_Connectors_Error_Failed_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/agent.connector.constants.ts"],
    },
  ],
  UI_Agent_Connectors_Error_Unreachable_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/agent.connector.constants.ts"],
    },
  ],
  UI_Agent_Connectors_Error_UrlNotAllowed_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/agent.connector.constants.ts"],
    },
  ],
  UI_Agent_Connectors_Form_Cancel: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/connector/AgentConnectorConnectForm.tsx",
        "v2-console/src/agent/connector/AgentConnectorList.tsx",
      ],
    },
  ],
  UI_Agent_Connectors_Form_Connect: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Form_Connector: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Form_DisplayName: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Form_OAuth: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Form_Test: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Form_Url: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Form_Url_Placeholder: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Grant_PerUser_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Grant_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Kind_Custom_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/agent.connector.utils.ts"],
    },
  ],
  UI_Agent_Connectors_Kind_Placepoint_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/agent.connector.utils.ts"],
    },
  ],
  UI_Agent_Connectors_Kind_Vendor_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/agent.connector.utils.ts"],
    },
  ],
  UI_Agent_Connectors_OAuth_Denied_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorsSection.tsx"],
    },
  ],
  UI_Agent_Connectors_OAuth_Failed_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/connector/AgentConnectorsSection.tsx",
        "v2-console/src/agent/connector/agent.connector.constants.ts",
      ],
    },
  ],
  UI_Agent_Connectors_OAuth_Ok_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorsSection.tsx"],
    },
  ],
  UI_Agent_Connectors_Probe_Detail_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Probe_Failed_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Probe_Ok_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorConnectForm.tsx"],
    },
  ],
  UI_Agent_Connectors_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorsSection.tsx"],
    },
  ],
  UI_Agent_Connectors_Verified_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/connector/AgentConnectorList.tsx"],
    },
  ],
  UI_Agent_DataAnswers: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/AgentChat.tsx",
        "v2-console/src/agent/AgentSeatNotice.tsx",
      ],
    },
  ],
  UI_Agent_Data_Link_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Data_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Dataset_Create: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_Created: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_Creating: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_Failed: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_NoProject: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_Offer: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_Open: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_Project: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_Rows: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Dataset_Skipped: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentDatasetOfferCard.tsx"],
    },
  ],
  UI_Agent_Datasets: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Docs: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_DocsAnswers: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_ElapsedSeconds_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/AgentChat.tsx",
        "v2-console/src/agent/AgentStepList.tsx",
      ],
    },
  ],
  UI_Agent_ErrorDetail_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Agent_ErrorRef_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Agent_ErrorStep_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Agent_Error_Auth_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Busy_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_DataSource_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Disconnected_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Empty_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.utils.ts",
        "v2-console/src/agent/agent.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Network_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_NoCredit_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Runtime_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Tool_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Unavailable_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Error_Upstream_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.errors.spec.ts",
        "v2-console/src/agent/agent.errors.utils.ts",
      ],
    },
  ],
  UI_Agent_Example_Ownership_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.constants.ts"],
    },
  ],
  UI_Agent_Example_Ownership_SE_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.constants.ts"],
    },
  ],
  UI_Agent_Example_Permits_SE_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.constants.ts"],
    },
  ],
  UI_Agent_Example_Plans_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.constants.ts"],
    },
  ],
  UI_Agent_Example_Plans_SE_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.constants.ts"],
    },
  ],
  UI_Agent_Example_Risk_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.constants.ts"],
    },
  ],
  UI_Agent_Example_Tenants_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.constants.ts"],
    },
  ],
  UI_Agent_Example_Tenants_SE_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.constants.ts"],
    },
  ],
  UI_Agent_Examples_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Export: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Export_Download: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentExportDownload.tsx"],
    },
  ],
  UI_Agent_Export_Expired: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentExportDownload.tsx"],
    },
  ],
  UI_Agent_Input: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Agent_MapAndPanels: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Map_Cadastre: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentMapProposalCard.tsx"],
    },
  ],
  UI_Agent_Map_Cadastres: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentMapProposalCard.tsx"],
    },
  ],
  UI_Agent_Map_Dismissed: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentMapProposalCard.tsx"],
    },
  ],
  UI_Agent_Map_Hide: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentMapProposalCard.tsx"],
    },
  ],
  UI_Agent_Map_Proposal: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentMapProposalCard.tsx"],
    },
  ],
  UI_Agent_Map_Show: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentMapProposalCard.tsx"],
    },
  ],
  UI_Agent_Map_Shown: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentMapProposalCard.tsx"],
    },
  ],
  UI_Agent_Panel_Open: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelProposalCard.tsx"],
    },
  ],
  UI_Agent_Panel_Opened: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelProposalCard.tsx"],
    },
  ],
  UI_Agent_Panel_Proposal: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelProposalCard.tsx"],
    },
  ],
  UI_Agent_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/AgentChat.tsx",
        "v2-console/src/agent/AgentPanelContent.tsx",
        "v2-console/src/agent/AgentSidebarItem.tsx",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_Agent_Seat: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentSeatNotice.tsx"],
    },
  ],
  UI_Agent_Seat_LearnMore: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentSeatNotice.tsx"],
    },
  ],
  UI_Agent_Send: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Agent_Sessions_Close: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.text.ts"],
    },
  ],
  UI_Agent_Sessions_Delete: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelContent.tsx"],
    },
  ],
  UI_Agent_Sessions_DeleteConfirm_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelContent.tsx"],
    },
  ],
  UI_Agent_Sessions_Empty_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelContent.tsx"],
    },
  ],
  UI_Agent_Sessions_New: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelContent.tsx"],
    },
  ],
  UI_Agent_Sessions_Trigger: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentPanelContent.tsx"],
    },
  ],
  UI_Agent_Steps_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentStepList.tsx"],
    },
  ],
  UI_Agent_Stop: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Agent_Tool_Accounts: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Addresses: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Check: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.tools.spec.ts",
        "v2-console/src/agent/agent.tools.utils.ts",
      ],
    },
  ],
  UI_Agent_Tool_Combify: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.tools.spec.ts",
        "v2-console/src/agent/agent.tools.utils.ts",
      ],
    },
  ],
  UI_Agent_Tool_Companies: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Dataset: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Docs: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.tools.spec.ts",
        "v2-console/src/agent/agent.tools.utils.ts",
      ],
    },
  ],
  UI_Agent_Tool_Export: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Geometry: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Guide: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_LandRegister: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Map: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.tools.spec.ts",
        "v2-console/src/agent/agent.tools.utils.ts",
      ],
    },
  ],
  UI_Agent_Tool_MapLayers: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Owners: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.tools.spec.ts",
        "v2-console/src/agent/agent.tools.utils.ts",
      ],
    },
  ],
  UI_Agent_Tool_Panel: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/agent/agent.tools.spec.ts",
        "v2-console/src/agent/agent.tools.utils.ts",
      ],
    },
  ],
  UI_Agent_Tool_Places: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Plans: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Properties: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Tenants: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Thinking: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Tool_Travel: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.tools.utils.ts"],
    },
  ],
  UI_Agent_Working_Root: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/AgentChat.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Area_Level_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/areaScore/AnalyzeAreaScore.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Grid_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/areaScore/AnalyzeAreaScore.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Legend_High: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/areaScore/AnalyzeAreaScore.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Legend_Low: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/areaScore/AnalyzeAreaScore.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Legend_Medium: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/areaScore/AnalyzeAreaScore.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Municipality_Level_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/areaScore/AnalyzeAreaScore.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Municipality_Level_Popup_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/areaScore/AnalyzeAreaScore.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Municipality_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/areaScore/AnalyzeAreaScore.tsx"],
    },
  ],
  UI_Analyze_Area_Score_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Column_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Column_BuildingNumber: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Column_BuildingStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Column_BuildingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Column_IndustryGroup: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Commercial_Leasing_Chart_PropertyType_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/analytics/AnalyzeCommercialLeasingAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Chart_PropertyType_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/chart/AnalyzeCommercialLeasingPropertyTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_BRA: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_ApartmentBuilding: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_CombinedPremises: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_CommercialPlot: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Dining: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Farm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Garage: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Hotel: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Industry: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Office: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Other: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Shop: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_ShoppingMall: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Teaching: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Warehouse: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_HousingType_Workshop: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_OfTheMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingMapPopupContent.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_OnTheMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingMapPopupContent.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Filter_TransactionType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Map_Layer_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/mapLayer/details/AnalyzeCommercialLeasingMapLayerDetails.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Map_Layer_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/mapLayer/AnalyzeCommercialLeasingMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Map_Popup_Field_AreaHigh: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Map_Popup_Field_AreaLow: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Map_Popup_Field_Count: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Map_Popup_Field_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Map_Popup_Field_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Map_Popup_Field_Type: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_MarketActivityTypeName_AD: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_MarketActivityTypeName_FOR_RENT: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_MarketActivityTypeName_OPM_TRANSACTION: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_MarketActivityTypeName_OTHER_TRANSACTION: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/analytics/AnalyzeCommercialLeasingAnalytics.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Panel_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingPanelContent.tsx",
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Footer_Result: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header_AreaHigh: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header_AreaLow: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header_MarketActivityTypeName: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Header_TransactionType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTable.tsx",
        "v2-console-ui/src/analyze/commercialLeasing/analyze.commercialLeasing.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Table_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_View_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Leasing_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialLeasing/AnalyzeCommercialLeasingPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Chart_Price_Per_Meter_Squared_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/analytics/AnalyzeCommercialTransactionAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Chart_PropertyType_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/analytics/AnalyzeCommercialTransactionAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Chart_PropertyType_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/chart/AnalyzeCommercialTransactionPropertyTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Chart_Transaction_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/analytics/AnalyzeCommercialTransactionAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Chart_Transaction_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/chart/AnalyzeCommercialTransactionTransactionChart.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_BRA: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_ApartmentBuilding: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_CombinedPremises: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_CommercialPlot: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Dining: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Farm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Garage: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Hotel: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Industry: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Office: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Other: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Shop: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_ShoppingMall: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Teaching: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Warehouse: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_HousingType_Workshop: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.constants.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_OfTheMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionMapPopupContent.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_OnTheMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionMapPopupContent.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Filter_TransactionType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Map_Layer_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/mapLayer/details/AnalyzeCommercialTransactionMapLayerDetails.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Map_Layer_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/mapLayer/AnalyzeCommercialTransactionMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Map_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Map_Popup_Field_Count: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Map_Popup_Field_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Map_Popup_Field_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_MarketActivityTypeName_AD: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_MarketActivityTypeName_FOR_RENT: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_MarketActivityTypeName_OPM_TRANSACTION: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_MarketActivityTypeName_OTHER_TRANSACTION: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/analytics/AnalyzeCommercialTransactionAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Panel_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionPanelContent.tsx",
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTablePanel.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Footer_Result: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_BuiltYear: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_MarketActivityTypeName: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_OwnershipForm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.text.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_TotalPrice: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Header_TransactionType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTable.tsx",
        "v2-console-ui/src/analyze/commercialTransaction/analyze.commercialTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Table_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Type_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/commercialTransaction/AnalyzeCommercialTransactionMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_View_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Commercial_Transaction_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/commercialTransaction/AnalyzeCommercialTransactionPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_Draw_Hint: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/Analyze.tsx"],
    },
  ],
  UI_Analyze_Legacy_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_MapClick_OpenAnalysis: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/AnalyzeDynamic.tsx",
        "v2-console/src/analyze/AnalyzeDynamicItems.tsx",
      ],
    },
  ],
  UI_Analyze_MapClick_ViewInObjectPanel: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/AnalyzeDynamic.tsx",
        "v2-console/src/analyze/AnalyzeDynamicItems.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_Analytics_Header_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolAnalyticsHeader.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_Analytics_Results: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolAnalyticsHeader.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_HideChart: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_HideTable: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_Apartment: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_DetachedHouse: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_Duplex: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_Garage: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_HolidayHome: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_Other: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopupItemHeader.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_SharedHousing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_Studio: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_HousingType_Townhouse: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_MapTool_No_Data_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolFeedbackAlert.tsx",
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_Reset_Button_Tooltip: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_ShowChart: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolAnalyticsHeader.tsx",
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_ShowTable: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_Table_Close: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolTableToolbar.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_Table_Export: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolTableToolbar.tsx",
      ],
    },
  ],
  UI_Analyze_MapTool_TimePeriod_FiveYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/analyze.mapTool.text.ts"],
    },
  ],
  UI_Analyze_MapTool_TimePeriod_FourYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/analyze.mapTool.text.ts"],
    },
  ],
  UI_Analyze_MapTool_TimePeriod_OneYear: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/analyze.mapTool.text.ts"],
    },
  ],
  UI_Analyze_MapTool_TimePeriod_SixMonths: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/analyze.mapTool.text.ts"],
    },
  ],
  UI_Analyze_MapTool_TimePeriod_TenYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/analyze.mapTool.text.ts"],
    },
  ],
  UI_Analyze_MapTool_TimePeriod_ThreeMonths: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/analyze.mapTool.text.ts"],
    },
  ],
  UI_Analyze_MapTool_TimePeriod_ThreeYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/analyze.mapTool.text.ts"],
    },
  ],
  UI_Analyze_MapTool_TimePeriod_TwoYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/analyze.mapTool.text.ts"],
    },
  ],
  UI_Analyze_MapTool_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolFeedbackAlert.tsx",
        "v2-console-ui/src/analyze/mapTool/AnalyzeMapToolPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_BuiltYear_FiftyYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/analyzeMarketActivity.text.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_BuiltYear_FortyYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/analyzeMarketActivity.text.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_BuiltYear_TenYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/analyzeMarketActivity.text.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_BuiltYear_ThirtyYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/analyzeMarketActivity.text.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_BuiltYear_TwentyYears: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/analyzeMarketActivity.text.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Chart_PropertyType_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/analytics/AnalyzeMarketActivityAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Chart_PropertyType_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/chart/AnalyzeMarketActivityPropertyTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Chart_Transaction_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/analytics/AnalyzeMarketActivityAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Chart_Transaction_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/chart/AnalyzeMarketActivityTransactionChart.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Filter_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Filter_BuiltYear: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Filter_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Filter_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Filter_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Filter_TurnoverType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Map_Layer_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/mapLayer/properties/AnalyzeMarketActivityMapLayerProperties.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Map_Layer_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/mapLayer/AnalyzeMarketActivityMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Map_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/map/AnalyzeMarketActivityMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Map_Popup_Field_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/map/AnalyzeMarketActivityMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Map_Popup_Field_Count: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/map/AnalyzeMarketActivityMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Map_Popup_Field_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/map/AnalyzeMarketActivityMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Map_Popup_Field_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/map/AnalyzeMarketActivityMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Map_Popup_Field_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/map/AnalyzeMarketActivityMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/analytics/AnalyzeMarketActivityAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Panel_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityPanelContent.tsx",
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Market_Activity_Table_Footer_Result: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/analyze.marketActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
        "v2-console-ui/src/analyze/marketActivity/analyze.marketActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
        "v2-console-ui/src/analyze/marketActivity/analyze.marketActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
        "v2-console-ui/src/analyze/marketActivity/analyze.marketActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
        "v2-console-ui/src/analyze/marketActivity/analyze.marketActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
        "v2-console-ui/src/analyze/marketActivity/analyze.marketActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header_PropertyType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
        "v2-console-ui/src/analyze/marketActivity/analyze.marketActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Header_TurnoverType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/marketActivity/AnalyzeMarketActivityTable.tsx",
        "v2-console-ui/src/analyze/marketActivity/analyze.marketActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Table_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_TurnoverType_Advertisements: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_TurnoverType_ForSale: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_TurnoverType_LandRecordsCleaned: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_TurnoverType_LandRecordsOther: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_View_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Market_Activity_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/marketActivity/AnalyzeMarketActivityPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_Menu_Hint: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/Analyze.tsx"],
    },
  ],
  UI_Analyze_NearestActivity_Navigate: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/nearestActivity/AnalyzeNearestActivity.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_AdStatus_ForSale: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectSaleStatusBadge.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_AdStatus_NotForSale: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectSaleStatusBadge.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_AdStatus_SoldOut: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectSaleStatusBadge.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_BuildingStatus_ConstructionStart: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_BuildingStatus_Handover: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_BuildingStatus_Planning: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_BuildingStatus_SalesStart: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Chart_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/analytics/AnalyzeNewBuildProjectAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Count: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_AdStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_BRA: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_BuildingStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_NumberOfUnits: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_OwnershipForm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_PricePerMeterSquare: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Filter_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_OwnershipForm_Freehold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_OwnershipForm_Housing_Cooperative: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Panel_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectPanelContent.tsx",
        "v2-console/src/analyze/newBuildProject/mapLayer/AnalyzeNewBuildProjectMapLayer.tsx",
        "v2-console/src/analyze/newBuildProject/table/AnalyzeNewBuildProjectTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Popup_Field_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Popup_Field_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Popup_Field_PricePerMeterSquare: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Popup_Field_Sold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Popup_Text_Sold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/mapLayer/AnalyzeNewBuildProjectMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Projects_Table_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/table/AnalyzeNewBuildProjectTablePanel.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_PropertyType_Chart_Bar_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/chart/AnalyzeNewBuildProjectPropertyTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_PropertyType_Chart_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/analytics/AnalyzeNewBuildProjectAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_PropertyType_Chart_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/chart/analyze.newBuildProject.chart.text.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_NewBuildProject_Status_Activated: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/analyze.newBuildProject.text.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Status_Inactive: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/analyze.newBuildProject.text.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Status_Sold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/analyze.newBuildProject.text.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Action_Export: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/analyze.newBuildProject.text.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_AdStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Balcony: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Broker: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Developer: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Floor: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Listing_Action: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/table/AnalyzeNewBuildProjectTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/projects/analyze.newBuildProject.projects.utils.ts",
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_ProjectDetails: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_ProjectDetails_Action: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/table/AnalyzeNewBuildProjectTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Room: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Column_Type: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Table_Footer_TotalResults: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/projects/AnalyzeNewBuildProjectsTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsTable.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Transaction_Chart_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/analytics/AnalyzeNewBuildProjectAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Transaction_Chart_Legend: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/chart/AnalyzeNewBuildProjectTransactionChart.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Transaction_Chart_Line_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/chart/AnalyzeNewBuildProjectTransactionChart.tsx",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Units_Table_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/table/AnalyzeNewBuildProjectTablePanel.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
  ],
  UI_Analyze_NewBuildProject_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_AdStatus_Annet: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnitsStatus.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_AdStatus_IkkeTilSalgs: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_AdStatus_Solgt: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_AdStatus_TilSalgs: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Chart_Area_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Chart_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Chart_Price_Per_SQM_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Chart_Tooltip_Label_Units_Count: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/histogramChart/AnalyzeNewBuildProjectDetailsHistogramChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Chart_Total_Price_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Chart_Label_Average_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsPriceCompareChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Chart_Label_Average_PricePerSqm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsPricePerSqmCompareChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Chart_Label_Sold_Units: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Chart_Label_Unsold_Units: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Chart_PricePerSqm_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Chart_PricePerSqm_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsPricePerSqmCompareChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Chart_Price_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Chart_Price_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsPriceCompareChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Label_Sold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Label_Unsold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Columns_Footer_Total: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Columns_Header_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Columns_Header_Floor: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Columns_Header_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Columns_Header_PriceChange:
    [
      {
        label: "Analyze",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsSummaryTable.tsx",
        ],
      },
    ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Columns_Header_PricePerSQM:
    [
      {
        label: "Analyze",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsSummaryTable.tsx",
        ],
      },
    ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Columns_Header_Quantity: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Sold_Units_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Sold_Units_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloors.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Unsold_Units_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Floors_Table_Unsold_Units_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloors.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_HousingType_Annet: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnitsHousingType.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_HousingType_Enebolig: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_HousingType_Fritidsbolig: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_HousingType_Leilighet: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_HousingType_Rekkehus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_HousingType_Tomannsbolig: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Info_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsInfo.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Info_Proximity_GroceryStore: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsInfo.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Info_Proximity_Kindergarten: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsInfo.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Info_Proximity_PublicTransport: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsInfo.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Info_Sold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsInfo.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Chart_Label_Room_Size: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Chart_Sold_Units_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Chart_Sold_Units_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsChart.tsx",
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSoldUnitsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Chart_Tooltip_Label_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomChartTooltip.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Chart_Tooltip_Label_Rooms: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomChartTooltip.tsx",
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTableTypeColumn.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Chart_Tooltip_Label_Size: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTableTypeColumn.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Chart_Unsold_Units_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Chart_Unsold_Units_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsChart.tsx",
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsUnsoldUnitsChart.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Columns_Footer_Total: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTable.tsx",
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTableTypeColumn.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Columns_Header_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Columns_Header_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Columns_Header_PriceChange: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Columns_Header_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Columns_Header_Quantity: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Columns_Header_Type: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRoomsSummaryTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Header_Type: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Sold_Units_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Sold_Units_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRooms.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Unsold_Units_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Rooms_Table_Unsold_Units_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/rooms/AnalyzeNewBuildProjectDetailsRooms.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Sold_Placeholder_Of: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsSoldInfo.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Tab_Floors: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsTabs.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Tab_Rooms: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsTabs.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Tab_Units: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsTabs.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Thumbnail_Alt_Text: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsThumbnail.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnitsTable.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/details/AnalyzeNewBuildProjectDetailsContent.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/analyzeNewBuildProjectDetails.text.ts",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_AdStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Balcony: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Bedroom: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Floor: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/floors/AnalyzeNewBuildProjectDetailsFloorsChart.tsx",
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Room: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Header_Type: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Value_Balcony_No: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_New_Build_Project_Details_Units_Table_Value_Balcony_Yes: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/details/units/AnalyzeNewBuildProjectDetailsUnits.tsx",
      ],
    },
  ],
  UI_Analyze_Option_BraBuildings: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraBuildings_Column_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraBuildings_Column_BraPercent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraBuildings_Display2: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraBuildings_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraBuildings_Stat_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraBuildings_Stat_Percent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Column_BraSize: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Column_BuildingCount: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Column_CadastreNumber: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Column_Percent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Column_PercentOfResults: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Column_PlotSize: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Display3: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Sort_BraSize: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Sort_Percent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Sort_PercentOfResults: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Sort_PlotSize: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Stat_BraSize: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Stat_Percent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Stat_PercentOfResults: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_BraCadastres_Stat_PlotSize: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Column_Available: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Column_AvailablePercent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Column_CadastreNumber: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Column_Total: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Column_Used: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Column_UsedPercent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Display3: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Sort_Available: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Sort_Total: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Sort_Used: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Stat_Available: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Stat_AvailablePercent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Stat_Total: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Stat_Used: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_ByaCadastres_Stat_UsedPercent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_DemographicsArea: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_FloorsBuildings: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_FloorsBuildings_Column_Floors: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_FloorsBuildings_Column_FloorsPercent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_FloorsBuildings_Display2: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_FloorsBuildings_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_FloorsBuildings_Stat_Count: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_FloorsBuildings_Stat_Count_Unit: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_Option_FloorsBuildings_Stat_Percent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/analyze.constants.ts"],
    },
  ],
  UI_Analyze_PanelLoading_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanel.tsx"],
    },
  ],
  UI_Analyze_PanelTitle_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanel.tsx"],
    },
  ],
  UI_Analyze_Placeholder_ChooseAnalysis: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePlaceholder.tsx"],
    },
  ],
  UI_Analyze_Placeholder_DrawArea: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePlaceholder.tsx"],
    },
  ],
  UI_Analyze_Placeholder_DrawAreaAndChooseAnalysis: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePlaceholder.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_AdStatus_Activated: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx",
        "v2-console-ui/src/analyze/plotAds/analytics/AnalyzePlotAdsPlotTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_AdStatus_Inactive: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx",
        "v2-console-ui/src/analyze/plotAds/analytics/AnalyzePlotAdsPlotTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_AdStatus_Other: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx",
        "v2-console-ui/src/analyze/plotAds/analytics/AnalyzePlotAdsPlotTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_AdStatus_Sold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx",
        "v2-console-ui/src/analyze/plotAds/analytics/AnalyzePlotAdsPlotTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_AdType_Commercial: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_AdType_Residential: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Analytics_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/analytics/AnalyzePlotAdsAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Analytics_PlotType_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/analytics/AnalyzePlotAdsAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Analytics_PlotType_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/analytics/AnalyzePlotAdsPlotTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Analytics_Transaction_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/analytics/AnalyzePlotAdsAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Analytics_Transaction_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/analytics/AnalyzePlotAdsAnalyticsPriceChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Filter_AdStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Filter_AdType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Filter_PlotSize: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Filter_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Filter_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Filter_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsFilter.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Map_Layer_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/mapLayer/details/AnalyzePlotAdsMapLayerDetails.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Map_Layer_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotAds/AnalyzePlotAdsTablePanel.tsx",
        "v2-console/src/analyze/plotAds/mapLayer/AnalyzePlotAdsMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Panel_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsPanelContent.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Panel_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Popup_Field_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Popup_Field_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Popup_Field_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Popup_Field_PricePerSqm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Popup_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsMapLayerPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Header_AdStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsTable.tsx",
        "v2-console-ui/src/analyze/plotAds/analyze.plotAds.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Header_AdType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsTable.tsx",
        "v2-console-ui/src/analyze/plotAds/analyze.plotAds.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Header_CadastreNumber: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsTable.tsx",
        "v2-console-ui/src/analyze/plotAds/analyze.plotAds.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Header_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsTable.tsx",
        "v2-console-ui/src/analyze/plotAds/analyze.plotAds.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsTable.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Header_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsTable.tsx",
        "v2-console-ui/src/analyze/plotAds/analyze.plotAds.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Header_PricePerSQM: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsTable.tsx",
        "v2-console-ui/src/analyze/plotAds/analyze.plotAds.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Header_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/plotAds/analyze.plotAds.utils.ts"],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsTablePanel.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Table_Rows: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/analyze/plotAds/AnalyzePlotAdsTable.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_View_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsTablePanel.tsx"],
    },
  ],
  UI_Analyze_Plot_Ads_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/plotAds/AnalyzePlotAdsPanelContent.tsx"],
    },
  ],
  UI_Analyze_Plot_Transaction_Analytics_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transaction_Analytics_PlotType_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transaction_Analytics_PlotType_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionPlotTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transaction_Analytics_Price_Per_Meter_Square_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transaction_Analytics_Transaction_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transaction_Analytics_Transaction_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionPriceChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_ActivityCount: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/details/AnalyzePlotTransactionDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionFilter.tsx",
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
        "v2-console-ui/src/analyze/plotTransaction/details/AnalyzePlotTransactionDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_BuildingStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionFilter.tsx",
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Commissioning_Permit: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionFilter.tsx",
        "v2-console-ui/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionPlotTypeChart.tsx",
        "v2-console-ui/src/analyze/plotTransaction/details/AnalyzePlotTransactionStatusBadge.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
        "v2-console-ui/src/analyze/plotTransaction/details/AnalyzePlotTransactionDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Frame_Permit: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionFilter.tsx",
        "v2-console-ui/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionPlotTypeChart.tsx",
        "v2-console-ui/src/analyze/plotTransaction/details/AnalyzePlotTransactionStatusBadge.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Map_Layer_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/mapLayer/details/AnalyzePlotTransactionMapLayerDetails.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/details/AnalyzePlotTransactionDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_No_Building_Permit: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionFilter.tsx",
        "v2-console-ui/src/analyze/plotTransaction/analytics/AnalyzePlotTransactionPlotTypeChart.tsx",
        "v2-console-ui/src/analyze/plotTransaction/details/AnalyzePlotTransactionStatusBadge.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_PricePerSqm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
        "v2-console-ui/src/analyze/plotTransaction/details/AnalyzePlotTransactionDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Footer_Result: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/analyze.plotTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/analyze.plotTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header_CadastreNumber: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
        "v2-console-ui/src/analyze/plotTransaction/analyze.plotTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header_CpiPrice: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
        "v2-console-ui/src/analyze/plotTransaction/analyze.plotTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/analyze.plotTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header_KrogsveenIndexPrice: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
        "v2-console-ui/src/analyze/plotTransaction/analyze.plotTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/AnalyzePlotTransactionTable.tsx",
        "v2-console-ui/src/analyze/plotTransaction/analyze.plotTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Header_PricePerSqm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotTransaction/analyze.plotTransaction.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Table_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionPanelContent.tsx",
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionTablePanel.tsx",
        "v2-console/src/analyze/plotTransaction/mapLayer/AnalyzePlotTransactionMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_View_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Transactions_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotTransaction/AnalyzePlotTransactionPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_ActivityCount: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/details/AnalyzePlotValuationDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Analytics_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/analytics/AnalyzePlotValuationAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Analytics_PlotType_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/analytics/AnalyzePlotValuationAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Analytics_PlotType_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/analytics/AnalyzePlotValuationTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Analytics_Price_Per_Meter_Square_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/analytics/analyze.plotValuation.analytics.text.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Analytics_Transaction_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/analytics/AnalyzePlotValuationAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Analytics_Transaction_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/analytics/AnalyzePlotValuationTransactionChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationFilter.tsx",
        "v2-console-ui/src/analyze/plotValuation/details/AnalyzePlotValuationDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/details/AnalyzePlotValuationDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Export: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/details/AnalyzePlotValuationDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Map_Layer_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/mapLayer/details/AnalyzePlotValuationMapLayerDetails.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/details/AnalyzePlotValuationDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_OwnerType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationFilter.tsx",
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_OwnerType_Leasehold: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationFilter.tsx",
        "v2-console-ui/src/analyze/plotValuation/analytics/AnalyzePlotValuationTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_OwnerType_Owner: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationFilter.tsx",
        "v2-console-ui/src/analyze/plotValuation/analytics/AnalyzePlotValuationTypeChart.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_PricePerSqm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationFilter.tsx",
        "v2-console-ui/src/analyze/plotValuation/details/AnalyzePlotValuationDetailsPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Footer_Result: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_Broker: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_CadastreNumber: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_CpiPrice: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_KrogsveenIndexPrice: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Header_PricePerSqm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/plotValuation/AnalyzePlotValuationTable.tsx",
        "v2-console-ui/src/analyze/plotValuation/analyze.plotValuation.utils.ts",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Table_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationPanelContent.tsx",
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationTablePanel.tsx",
        "v2-console/src/analyze/plotValuation/mapLayer/AnalyzePlotValuationMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_View_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Plot_Valuation_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/plotValuation/AnalyzePlotValuationPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Analytics_HousingType_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/analytics/AnalyzeRentalActivityAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Analytics_HousingType_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/analytics/AnalyzeRentalActivityHousingTypeChart.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Analytics_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/analytics/AnalyzeRentalActivityAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Analytics_Transaction_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/analytics/AnalyzeRentalActivityAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Analytics_Transaction_Tooltip_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/analytics/AnalyzeRentalActivityAnalyticsTransactionChart.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Filter_Bedrooms: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Filter_Bedrooms_All: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Filter_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Filter_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Filter_MarketStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Filter_MonthlyRent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Filter_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Map_Layer_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/mapLayer/AnalyzeRentalActivityPopupWrapper.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Map_Layer_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityTablePanel.tsx",
        "v2-console/src/analyze/rentalActivity/mapLayer/AnalyzeRentalActivityMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_MarketStatus_OnTheMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_MarketStatus_PreviouslyOnTheMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Panel_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityPanelContent.tsx",
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Panel_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Popup_Field_Area: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Popup_Field_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Popup_Field_MonthlyRent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Popup_Field_RentPerSqm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Popup_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Rooms_Label: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopup.tsx",
        "v2-console-ui/src/analyze/rentalActivity/popup/AnalyzeRentalActivityPopupItem.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_BRA: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_MarketStatus: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_MonthlyRent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_RentPerSqm: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_Rooms: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Header_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/analyze.rentalActivity.utils.ts",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Table_Rows: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/rentalActivity/AnalyzeRentalActivityTable.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_View_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Rental_Activity_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityPanelContent.tsx",
      ],
    },
  ],
  UI_Analyze_Results_AreaTooLarge: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzeResults.tsx"],
    },
  ],
  UI_Analyze_Results_ExportFileName: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzeResultsPanel.tsx"],
    },
  ],
  UI_Analyze_Results_SortLabel: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzeDynamic.tsx"],
    },
  ],
  UI_Analyze_Results_SortSelect_Placeholder: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzeDynamic.tsx"],
    },
  ],
  UI_Analyze_Results_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/AnalyzeDynamic.tsx",
        "v2-console/src/analyze/AnalyzeResultsPanel.tsx",
        "v2-console/src/analyze/custom/AnalyzeCustomRiskSubjects.tsx",
      ],
    },
  ],
  UI_Analyze_Results_ViewTableButton: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzeDynamic.tsx"],
    },
  ],
  UI_Analyze_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_Analyze_Stats_AttributeSelect_Placeholder: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Stats_Average: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Stats_Count: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Stats_Highest: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Stats_Lowest: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Stats_Median: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Stats_Sum: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Stats_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Stats_UniqueCount: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/stats/AnalyzeStatsNumbers.tsx"],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_AverageListingTime_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketAnalytics.tsx",
        "v2-console/src/analyze/timeOnMarket/analytics/listingTime/AnalyzeTimeOnMarketListingTimes.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_Category_Max: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketListingTimesChart.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_Category_Mean: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketListingTimesChart.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_Category_Medium: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketListingTimesChart.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_Category_Min: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketListingTimesChart.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_Days: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketListingTimesChart.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_Legend_Based_on_map: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketListingTimesChart.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketPropertyByYearChart.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketYearlyDistributionChart.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_Legend_National_average: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketListingTimesChart.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketPropertyByYearChart.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketYearlyDistributionChart.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_Months: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketListingTimesChart.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketAnalytics.tsx",
        "v2-console/src/analyze/timeOnMarket/analytics/listingTime/AnalyzeTimeOnMarketListingTimes.tsx",
        "v2-console/src/analyze/timeOnMarket/analytics/propertyType/AnalyzeTimeOnMarketPropertyByYear.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_PropertyType_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_SelectYear: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Analytics_YearlyDistribution_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/analytics/AnalyzeTimeOnMarketAnalytics.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Days: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/mapLayer/AnalyzeTimeOnMarketMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_Commercial: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_CommercialRental: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_DevelopmentSingleProperty: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_HolidaySale: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_LandGeneral: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_Plot: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_ProjectGeneral: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_ProjectHoliday: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_ProjectHolidayGeneral: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_ProjectUnit: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_Rental: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_Residential: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_AdTypes_SinglePropertyGeneral: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_DaysOnMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_HousingType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_PropertyType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_PropertyType_Commercial: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_PropertyType_HolidayHome: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_PropertyType_Plot: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_PropertyType_Residential: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_Rent: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_SalesType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_SalesType_NewBuildSale: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_SalesType_PlotSale: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_SalesType_Rental: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_SalesType_Sale: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Filter_TimePeriod: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketFilter.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Map_Layer_Listing_Details_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/mapLayer/details/AnalyzeTimeOnMarketMapLayerDetails.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Map_Layer_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/mapLayer/AnalyzeTimeOnMarketMapLayer.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Map_NoData: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Map_Popup_Field_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Map_Popup_Field_Count: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Map_Popup_Field_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Map_Popup_Field_OnTheMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Map_Popup_Field_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopup.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_No_Data: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.text.ts",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Panel_Title: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketPanelContent.tsx",
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_AdType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_Bedrooms: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_Broker: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_BuiltYear: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_EnergyRating: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_LastEditedDate: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_ListingCode: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_OnTheMarket: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_OwnerShip: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_Published: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_Rooms: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Popup_SaleDate: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/analyze/AnalyzePanelSidebarItem.tsx"],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTablePanel.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.utils.ts",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header_Address: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.utils.ts",
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header_Bra: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.utils.ts",
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header_Date: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.utils.ts",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header_DaysPassed: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.utils.ts",
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header_Price: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.utils.ts",
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header_PropertyType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.utils.ts",
        "v2-console-ui/src/analyze/timeOnMarket/popup/AnalyzeTimeOnMarketMapPopupContent.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Header_SalesType: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
        "v2-console-ui/src/analyze/timeOnMarket/analyze.timeOnMarket.utils.ts",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Table_Rows_Result: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTable.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_View_Listing: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketTablePanel.tsx",
      ],
    },
  ],
  UI_Analyze_Time_On_Market_Zoom_Level_Feedback_Message: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/timeOnMarket/AnalyzeTimeOnMarketPanelContent.tsx",
      ],
    },
  ],
  UI_ApolloErrorBanner_ItemsFailed_Root: [
    {
      label: "Apollo",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/apollo/ApolloErrorBanner.tsx"],
    },
  ],
  UI_ApolloErrorBanner_NetworkError_Root: [
    {
      label: "Apollo",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/apollo/ApolloErrorBanner.tsx"],
    },
  ],
  UI_ApolloErrorBanner_Title_Root: [
    {
      label: "Apollo",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/apollo/ApolloErrorBanner.tsx"],
    },
  ],
  UI_AppContext_ErrorNotification_ContinueLimited: [
    {
      label: "App",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/app/context/AppContextErrorNotification.tsx"],
    },
  ],
  UI_AppContext_ErrorNotification_ReLogin: [
    {
      label: "App",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/app/context/AppContextErrorNotification.tsx"],
    },
  ],
  UI_AppStore_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebar.tsx"],
    },
  ],
  UI_AppVersion_Banner_Message: [
    {
      label: "App Version",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/appVersion/AppVersionBanner.tsx"],
    },
  ],
  UI_AppVersion_Banner_RemindLater: [
    {
      label: "App Version",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/appVersion/AppVersionBanner.tsx"],
    },
  ],
  UI_AppVersion_Banner_UpdateNow: [
    {
      label: "App Version",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/appVersion/AppVersionBanner.tsx"],
    },
  ],
  UI_Auth_ActivateGate_AccountLine: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_CancelBody: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_CancelTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_CheckFailed: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_Checking: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_Consumed: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_ConsumedAction: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_Expired: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_Gate: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_Intro: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_IntroNewApp: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_IntroNoTenant: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_IntroNoTenantNewApp: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_InvalidTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_NotFound: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_Retry: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_Submit: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_SuccessAction: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_SuccessBody: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_SuccessTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_TenantGone: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_Title: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_TitleNewApp: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_ActivateGate_UserGone: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthActivatePage.tsx"],
    },
  ],
  UI_Auth_Code: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Code_Resend: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Code_Submit: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Common_BackToSignIn: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthLoginForm.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
        "v2-console/src/auth/AuthSignupForm.tsx",
      ],
    },
  ],
  UI_Auth_Common_Cancel: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
        "v2-console/src/auth/AuthSignupForm.tsx",
      ],
    },
  ],
  UI_Auth_Common_ConfirmPassword: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthNewPasswordFields.tsx"],
    },
  ],
  UI_Auth_Common_Email: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthEmailVerification.tsx",
        "v2-console/src/auth/AuthLoginForm.tsx",
        "v2-console/src/auth/AuthSignupForm.tsx",
      ],
    },
  ],
  UI_Auth_Common_EmailPlaceholder: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthEmailVerification.tsx",
        "v2-console/src/auth/AuthLoginForm.tsx",
      ],
    },
  ],
  UI_Auth_Common_FirstName: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Common_GenericFailure: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthLoginForm.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_Common_HidePassword: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthLoginForm.tsx",
        "v2-console/src/auth/AuthNewPasswordFields.tsx",
      ],
    },
  ],
  UI_Auth_Common_LastName: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Common_LockedByInvite: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Common_NewPassword: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_Common_No: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
        "v2-console/src/auth/AuthSignupForm.tsx",
      ],
    },
  ],
  UI_Auth_Common_Password: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthLoginForm.tsx",
        "v2-console/src/auth/AuthSignupForm.tsx",
      ],
    },
  ],
  UI_Auth_Common_ShowPassword: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthLoginForm.tsx",
        "v2-console/src/auth/AuthNewPasswordFields.tsx",
      ],
    },
  ],
  UI_Auth_Common_StartOver: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Common_SupportPrompt: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthLoginForm.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_Common_VerificationCode: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthEmailVerification.tsx",
        "v2-console/src/auth/AuthLoginForm.tsx",
      ],
    },
  ],
  UI_Auth_Common_Yes: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
        "v2-console/src/auth/AuthSignupForm.tsx",
      ],
    },
  ],
  UI_Auth_EmailVerification_BadFormat: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_ChangeAddress: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_CodeExpired: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_CodeRuleText: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthEmailVerification.tsx",
        "v2-console/src/auth/AuthLoginForm.tsx",
      ],
    },
  ],
  UI_Auth_EmailVerification_CodeSent: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_Label: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_NoRetry: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_Resend: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_Send: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_SendFailure: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_SendFailureFixed: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_Sending: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_SentTo: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_Throttled: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_Unsent: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_Verified: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_Verify: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_VerifyFailure: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_EmailVerification_WrongCode: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthEmailVerification.tsx"],
    },
  ],
  UI_Auth_Error_Action_Cancel: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Action_ContactSupport: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Action_GoToMarketing: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Action_LoginAgain: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Action_Retry: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Action_Takeover: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_ClientCanceled: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Diagnostics_Code: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Diagnostics_CopyLabel: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthError.tsx"],
    },
  ],
  UI_Auth_Error_Diagnostics_CopyTooltip: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthError.tsx"],
    },
  ],
  UI_Auth_Error_Diagnostics_Detail: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthError.tsx"],
    },
  ],
  UI_Auth_Error_Diagnostics_Hide: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthError.tsx"],
    },
  ],
  UI_Auth_Error_Diagnostics_RequestId: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Diagnostics_SessionId: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Diagnostics_Show: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthError.tsx"],
    },
  ],
  UI_Auth_Error_Diagnostics_Status: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Diagnostics_Timestamp: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Footnote_LicensesLink: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Footnote_LicensesText: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_Generic: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_InvalidCode: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Error_InvitationRequired: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_LoginConflict: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_LoginConflict_DetailIp: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_LoginConflict_DetailLastActive: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_LoginConflict_FromPlace: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_LoginConflict_Lead: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_LoginConflict_OtherDevice: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_LoginConflict_Trailer: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_NetworkError: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_NoActiveTenant: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_PasswordResetRequired: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Error_Server: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/auth.error.utils.ts",
        "v2-console/src/auth/auth.instance.ts",
      ],
    },
  ],
  UI_Auth_Error_SessionExpired: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_SignedOutElsewhere: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_SignedOutElsewhere_DetailSignedIn: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_SignedOutElsewhere_Fallback: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_SignedOutElsewhere_Lead: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_SignedOutElsewhere_Trailer: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_TakeoverFailed: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthError.tsx"],
    },
  ],
  UI_Auth_Error_TryAgain: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Error_UserAlreadyExists: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Error_UserBlocked: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_UserDeleted: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Error_UserNotFound: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Error_WeakPassword: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Error_WrongCredentials: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_ForgotPassword_BackendFailure: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ForgotPassword_CodeExpired: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ForgotPassword_ErrNoUser: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ForgotPassword_Gate: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ForgotPassword_Intro: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ForgotPassword_Locked: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ForgotPassword_LockedTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ForgotPassword_NoRetry: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ForgotPassword_NoRetryTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ForgotPassword_Submit: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ForgotPassword_Throttled: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.auth.ts"],
    },
  ],
  UI_Auth_ForgotPassword_Title: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ForgotPassword_VerifiedNext: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_InviteGate_CheckFailed: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_Checking: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_Consumed: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_ConsumedAction: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_Expired: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_InvalidTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_JoiningTenant: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_NotFound: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_Retry: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_InviteGate_TenantGone: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthRedeemInvitationPage.tsx"],
    },
  ],
  UI_Auth_Loading_Base: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoader.tsx"],
    },
  ],
  UI_Auth_Loading_Token: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthGuard.tsx"],
    },
  ],
  UI_Auth_Login: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthLoginButton.tsx",
        "v2-console/src/auth/AuthLoginPage.tsx",
      ],
    },
  ],
  UI_Auth_Login_Button: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthLoginButton.tsx",
        "v2-console/src/auth/AuthLoginForm.tsx",
      ],
    },
  ],
  UI_Auth_Login_ContactLink: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginPage.tsx"],
    },
  ],
  UI_Auth_Login_ContactSuffix: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginPage.tsx"],
    },
  ],
  UI_Auth_Login_Email: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Login_ForgotPassword: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Login_LanguageSelector: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLanguageSelector.tsx"],
    },
  ],
  UI_Auth_Login_NoAccount: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginPage.tsx"],
    },
  ],
  UI_Auth_Login_Password: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_MfaCode_CodeExpired: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_MfaCode_ErrBadFormat: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_MfaCode_ErrCodeMissing: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_MfaCode_Intro: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_MfaCode_Resend: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_MfaCode_Throttled: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_MfaCode_Title: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_MfaCode_Verify: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_MfaCode_WrongCode: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_PasswordRules_AllMet: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthPasswordChecklist.tsx"],
    },
  ],
  UI_Auth_PasswordRules_DisallowedCharacter: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthNewPasswordFields.tsx",
        "v2-console/src/auth/AuthPasswordChecklist.tsx",
      ],
    },
  ],
  UI_Auth_PasswordRules_HeaderAll: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthPasswordChecklist.tsx"],
    },
  ],
  UI_Auth_PasswordRules_HeaderSome: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthPasswordChecklist.tsx"],
    },
  ],
  UI_Auth_PasswordRules_LengthRange: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthPasswordChecklist.tsx"],
    },
  ],
  UI_Auth_PasswordRules_Lowercase: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.passwordRules.ts"],
    },
  ],
  UI_Auth_PasswordRules_Number: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.passwordRules.ts"],
    },
  ],
  UI_Auth_PasswordRules_RejectedBanned: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthNewPasswordFields.tsx"],
    },
  ],
  UI_Auth_PasswordRules_RejectedPattern: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthNewPasswordFields.tsx"],
    },
  ],
  UI_Auth_PasswordRules_RejectedRecentlyUsed: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthNewPasswordFields.tsx"],
    },
  ],
  UI_Auth_PasswordRules_RejectedRefused: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthNewPasswordFields.tsx"],
    },
  ],
  UI_Auth_PasswordRules_Symbol: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.passwordRules.ts"],
    },
  ],
  UI_Auth_PasswordRules_Uppercase: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.passwordRules.ts"],
    },
  ],
  UI_Auth_PasswordRules_Whitespace: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthPasswordChecklist.tsx"],
    },
  ],
  UI_Auth_Reset: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_ResetPassword_Blocked: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
        "v2-console/src/auth/auth.native.classify.ts",
      ],
    },
  ],
  UI_Auth_ResetPassword_ErrMismatch: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ResetPassword_ErrNoUser: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ResetPassword_ErrRequiredField: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ResetPassword_FlowRestarted: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ResetPassword_Intro: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_ResetPassword_Submit: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ResetPassword_SuccessBody: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ResetPassword_SuccessTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_ResetPassword_Title: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthActivatePage.tsx",
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
      ],
    },
  ],
  UI_Auth_Reset_Confirm: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthResetPasswordPage.tsx"],
    },
  ],
  UI_Auth_Reset_NewPassword: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Reset_Submit: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Signin_Disabled: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_DisabledTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_ErrEmailMalformed: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_ErrEmailMissing: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_ErrNoAccount: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_ErrNoAccountHelp: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_ErrPasswordMissing: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_ErrWrongCredentials: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_ErrWrongPassword: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_ForgotPassword: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_Identifier: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_Intro: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_Locked: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_LockedTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_MigratedHint: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_PasswordExpired: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_PasswordExpiredAction: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_PasswordExpiredHelp: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_Submit: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_Throttled: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_UnknownError: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_WorkAccount: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signin_WorkAccountDivider: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthLoginForm.tsx"],
    },
  ],
  UI_Auth_Signup: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Signup_BackendFailure: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_CancelBody: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
        "v2-console/src/auth/AuthSignupForm.tsx",
      ],
    },
  ],
  UI_Auth_Signup_CancelTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/auth/AuthResetPasswordPage.tsx",
        "v2-console/src/auth/AuthSignupForm.tsx",
      ],
    },
  ],
  UI_Auth_Signup_CancelledBody: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_CancelledTitle: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_ErrAlreadyExists: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_ErrAlreadyExistsAction: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_ErrMismatch: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_ErrMissingElement: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_ErrRequiredField: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_ErrValidation: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_GivenName: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Signup_HaveAccount: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_Intro: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_InvalidLink: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Signup_InvitePrefillNote: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_Password: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Signup_SignInLink: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_Submit: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_Surname: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/text/offline/catalog.ts"],
    },
  ],
  UI_Auth_Signup_Throttled: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_Title: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Signup_VerifyIntro: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/AuthSignupForm.tsx"],
    },
  ],
  UI_Auth_Support_MailContext: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Support_MailDiagnosticsLabel: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Support_MailGreeting: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_Auth_Support_MailSubject: [
    {
      label: "Login",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/auth/auth.error.utils.ts"],
    },
  ],
  UI_BasemapSelector_Copyright: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/basemap/MapWidgetBasemapMenuItem.tsx"],
    },
  ],
  UI_BasemapSelector_CopyrightMissingDescription: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/basemap/MapWidgetBasemapMenuItem.tsx"],
    },
  ],
  UI_BasemapSelector_CopyrightMissingName: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/basemap/MapWidgetBasemapMenuItem.tsx"],
    },
  ],
  UI_BasemapSelector_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/basemap/map.widget.basemap.text.ts"],
    },
  ],
  UI_BasemapSelector_HighQuality: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/basemap/MapWidgetBasemapQualitySwitch.tsx",
      ],
    },
  ],
  UI_BasemapSelector_LandUseToggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/basemap/MapWidgetBasemapLandUseSwitch.tsx",
      ],
    },
  ],
  UI_BasemapSelector_NavLayerToggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/basemap/MapWidgetBasemapNavLayerSwitch.tsx",
      ],
    },
  ],
  UI_BasemapSelector_Quality: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/basemap/MapWidgetBasemapMenuItemQuality.tsx",
      ],
    },
  ],
  UI_BasemapSelector_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemBackgroundSettings.tsx",
        "v2-console/src/map/toolbar/MapToolbarItemBasemap.tsx",
      ],
    },
  ],
  UI_BasemapSelector_Sticky: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/basemap/MapWidgetBasemapStickySwitch.tsx",
      ],
    },
  ],
  UI_BasemapSelector_ToolbarTrigger: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemBackgroundSettings.tsx",
      ],
    },
  ],
  UI_BasemapSelector_Type: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/basemap/MapWidgetBasemapMenuItem.tsx"],
    },
  ],
  UI_BetaWidgets_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetBetaGroupButton.tsx",
        "v2-console/src/map/widget/MapWidgetToolbarRight.tsx",
      ],
    },
  ],
  UI_Bookmark_AnimationDisabled: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_CreateBookmark: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/MapWidgetBookmarkFolder.tsx"],
    },
  ],
  UI_Bookmark_CreateFolder: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_DefaultName: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/bookmark/map.widget.bookmark.state.ts",
      ],
    },
  ],
  UI_Bookmark_Delete: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/bookmark/MapWidgetBookmarkFolder.tsx",
        "v2-console/src/map/widget/bookmark/MapWidgetBookmarkListItem.tsx",
      ],
    },
  ],
  UI_Bookmark_Edit: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/bookmark/MapWidgetBookmarkFolder.tsx",
        "v2-console/src/map/widget/bookmark/MapWidgetBookmarkListItem.tsx",
      ],
    },
  ],
  UI_Bookmark_EmptyFolder: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_EmptyRootFolder: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/MapWidgetBookmark.tsx"],
    },
  ],
  UI_Bookmark_EnterAnimation: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_ErrorCreateFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/bookmark.api.ts"],
    },
  ],
  UI_Bookmark_ErrorFolderCreateFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/bookmark.api.ts"],
    },
  ],
  UI_Bookmark_ErrorFolderRemoveFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/bookmark.api.ts"],
    },
  ],
  UI_Bookmark_ErrorFolderUpdateFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/bookmark.api.ts"],
    },
  ],
  UI_Bookmark_ErrorMoveFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/bookmark.api.ts"],
    },
  ],
  UI_Bookmark_ErrorRemoveFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/bookmark.api.ts"],
    },
  ],
  UI_Bookmark_ErrorReorderFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_ErrorUpdateFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/bookmark.api.ts"],
    },
  ],
  UI_Bookmark_ErrorUploadThumbnailFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/bookmark.api.ts"],
    },
  ],
  UI_Bookmark_ExitAnimation: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemBookmark.tsx",
        "v2-console/src/map/widget/bookmark/MapWidgetBookmark.tsx",
      ],
    },
  ],
  UI_Bookmark_New: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/MapWidgetBookmark.tsx"],
    },
  ],
  UI_Bookmark_NewFolder: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/MapWidgetBookmark.tsx"],
    },
  ],
  UI_Bookmark_Pause: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_Play: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_Reset: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemBookmark.tsx",
        "v2-console/src/map/widget/MapWidgetBookmarkPopoverButton.tsx",
      ],
    },
  ],
  UI_Bookmark_RootFolder: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_StartLoop: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_Bookmark_StopLoop: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/bookmark/map.widget.bookmark.text.ts"],
    },
  ],
  UI_BuildingRight_Header: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/buildingRight/panel/BuildingRightPanel.tsx"],
    },
  ],
  UI_BuildingRight_TabDescription: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightDescriptionModule.tsx",
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
        "v2-console/src/buildingRight/panel/buildingRight.panel.config.tsx",
      ],
    },
  ],
  UI_BuildingRight_TabDocuments: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightDocumentsModule.tsx",
        "v2-console/src/buildingRight/panel/buildingRight.panel.config.tsx",
      ],
    },
  ],
  UI_BuildingRight_TabLinkedProfiles: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightLinkedProfilesModule.tsx",
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
        "v2-console/src/buildingRight/panel/buildingRight.panel.config.tsx",
      ],
    },
  ],
  UI_BuildingRight_TabOverview: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
        "v2-console/src/buildingRight/panel/buildingRight.panel.config.tsx",
      ],
    },
  ],
  UI_BuildingRight_TypeBuildingRight: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
      ],
    },
  ],
  UI_BuildingRight_ZoomTo: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/buildingRight/panel/BuildingRightPanel.tsx"],
    },
  ],
  UI_BuildingStyle_ApplyError: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/map.layer.building.style.utils.ts",
      ],
    },
  ],
  UI_BuildingStyle_BuildingColor: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomAdd: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/MapLayerBuildingStyleList.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomCancel: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
        "v2-console/src/map/layer/buildingStyle/custom/delete/MapLayerBuildingStyleCustomDeleteButton.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomCreateError: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/create/MapLayerBuildingStyleCustomCreate.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomDefaultName: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomDeleteButton: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/delete/MapLayerBuildingStyleCustomDeleteButton.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomDeleteDialogDescription: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/delete/MapLayerBuildingStyleCustomDeleteButton.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomDeleteDialogHeader: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/delete/MapLayerBuildingStyleCustomDeleteButton.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomDeleteDialogSubmit: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/delete/MapLayerBuildingStyleCustomDeleteButton.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomDeleteError: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/delete/MapLayerBuildingStyleCustomDeleteButton.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomDeleteSuccess: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/delete/MapLayerBuildingStyleCustomDeleteButton.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomEdit: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/MapLayerBuildingStyleList.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomGridEmpty: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/map.layer.buildingStyle.text.ts",
      ],
    },
  ],
  UI_BuildingStyle_CustomGridHeader: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/map.layer.buildingStyle.text.ts",
      ],
    },
  ],
  UI_BuildingStyle_CustomSave: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
      ],
    },
  ],
  UI_BuildingStyle_CustomUpdateError: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/update/MapLayerBuildingStyleCustomUpdate.tsx",
      ],
    },
  ],
  UI_BuildingStyle_EdgeColor: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
      ],
    },
  ],
  UI_BuildingStyle_EdgeDeviation: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
      ],
    },
  ],
  UI_BuildingStyle_EdgeThickness: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
      ],
    },
  ],
  UI_BuildingStyle_EdgeType: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
      ],
    },
  ],
  UI_BuildingStyle_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/map.layer.buildingStyle.text.ts",
      ],
    },
  ],
  UI_BuildingStyle_ListHeader: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/MapLayerBuildingStyleList.tsx",
      ],
    },
  ],
  UI_BuildingStyle_ListItem_TypeCustom: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/MapLayerBuildingStyleList.tsx",
      ],
    },
  ],
  UI_BuildingStyle_ListItem_TypeLabel: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/MapLayerBuildingStyleList.tsx",
      ],
    },
  ],
  UI_BuildingStyle_ListItem_TypePreset: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/MapLayerBuildingStyleList.tsx",
      ],
    },
  ],
  UI_BuildingStyle_Name: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/custom/MapLayerBuildingStyleCustom.tsx",
      ],
    },
  ],
  UI_BuildingStyle_PresetGridEmpty: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/map.layer.buildingStyle.text.ts",
      ],
    },
  ],
  UI_BuildingStyle_PresetGridHeader: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/buildingStyle/map.layer.buildingStyle.text.ts",
      ],
    },
  ],
  UI_BuildingStyle_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Building_Floors_AreaNotRegistered: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/floors/BuildingFloorsStackingPlanBar.tsx",
      ],
    },
  ],
  UI_Building_Floors_AreaType_AlternativeArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Floors_AreaType_AlternativeArea2: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Floors_AreaType_GrossArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Floors_AreaType_UtilityFloorSpace: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Floors_Breakdown_AreaType: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Floors_Breakdown_Units: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Floors_Breakdown_UseType: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Floors_Commercial: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/floors/BuildingFloorsContent.tsx",
        "v2-console/src/building/floors/building.floors.constants.ts",
      ],
    },
  ],
  UI_Building_Floors_EstimatedArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/floors/BuildingFloorsStackingPlanBar.tsx",
      ],
    },
  ],
  UI_Building_Floors_FloorCount: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsContent.tsx"],
    },
  ],
  UI_Building_Floors_GrossAreaOutsideBra: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsStackingPlan.tsx"],
    },
  ],
  UI_Building_Floors_KeyFigures: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsContent.tsx"],
    },
  ],
  UI_Building_Floors_NotInUnit: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsStackingPlan.tsx"],
    },
  ],
  UI_Building_Floors_Residential: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/floors/BuildingFloorsContent.tsx",
        "v2-console/src/building/floors/building.floors.constants.ts",
      ],
    },
  ],
  UI_Building_Floors_ShareOfFloor: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/floors/BuildingFloorsStackingPlanBar.tsx",
      ],
    },
  ],
  UI_Building_Floors_StackingPlan: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsContent.tsx"],
    },
  ],
  UI_Building_Floors_Summary_Area: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsSummaryTable.tsx"],
    },
  ],
  UI_Building_Floors_Summary_Share: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsSummaryTable.tsx"],
    },
  ],
  UI_Building_Floors_Summary_Total: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsSummaryTable.tsx"],
    },
  ],
  UI_Building_Floors_Summary_UnitType: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Floors_TotalArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsContent.tsx"],
    },
  ],
  UI_Building_Floors_TotalGrossArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsContent.tsx"],
    },
  ],
  UI_Building_Floors_UnitCount: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/BuildingFloorsStackingPlan.tsx"],
    },
  ],
  UI_Building_Floors_Unknown: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/floors/building.floors.constants.ts"],
    },
  ],
  UI_Building_Header: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/building.text.ts"],
    },
  ],
  UI_Building_Overview_Esg_Empty: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/insight/BuildingOverviewInsight.tsx",
      ],
    },
  ],
  UI_Building_Overview_Esg_EnergyLabel: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/building.text.ts"],
    },
  ],
  UI_Building_Overview_Insight_Header: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/insight/BuildingOverviewInsight.tsx",
      ],
    },
  ],
  UI_Building_Overview_Property_BuiltArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/property/BuildingOverviewProperty.tsx",
      ],
    },
  ],
  UI_Building_Overview_Property_Empty: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/property/BuildingOverviewProperty.tsx",
      ],
    },
  ],
  UI_Building_Overview_Property_GrossArea: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/property/BuildingOverviewProperty.tsx",
      ],
    },
  ],
  UI_Building_Overview_Property_HousingUnits: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/building.text.ts"],
    },
  ],
  UI_Building_Overview_Property_MixedTypes: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/property/BuildingOverviewProperty.tsx",
      ],
    },
  ],
  UI_Building_Overview_Property_NoHousingUnits: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/property/BuildingOverviewProperty.tsx",
      ],
    },
  ],
  UI_Building_Overview_Property_Sections: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/building.text.ts"],
    },
  ],
  UI_Building_Overview_Property_Unknown: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/property/BuildingOverviewProperty.tsx",
      ],
    },
  ],
  UI_Building_Overview_Property_UtilityFloorSpace: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/property/BuildingOverviewProperty.tsx",
      ],
    },
  ],
  UI_Building_Overview_ToTabLink: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/overview/BuildingOverviewToTabLink.tsx"],
    },
  ],
  UI_Building_PanelMany_NotImplemented: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/panel/BuildingPanelMany.tsx"],
    },
  ],
  UI_Building_Statuses_Date: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/statuses/building.statuses.utils.ts"],
    },
  ],
  UI_Building_Statuses_Empty: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/statuses/BuildingStatusAccordionItem.tsx",
        "v2-console/src/building/statuses/BuildingStatusesContent.tsx",
      ],
    },
  ],
  UI_Building_Statuses_MainBuilding: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/statuses/BuildingStatusAccordionItem.tsx",
      ],
    },
  ],
  UI_Building_Statuses_RegisteredDate: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/statuses/building.statuses.utils.ts"],
    },
  ],
  UI_Building_Statuses_UnknownStatus: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/statuses/building.statuses.utils.ts"],
    },
  ],
  UI_Building_TabESG: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/building.overview.constants.ts",
        "v2-console/src/building/panel/building.panel.config.ts",
      ],
    },
  ],
  UI_Building_TabFloors: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/panel/building.panel.config.ts"],
    },
  ],
  UI_Building_TabOverview: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/panel/building.panel.config.ts"],
    },
  ],
  UI_Building_TabProperty: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/overview/building.overview.constants.ts",
        "v2-console/src/building/panel/building.panel.config.ts",
      ],
    },
  ],
  UI_Building_TabStatuses: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/building/panel/building.panel.config.ts"],
    },
  ],
  UI_Building_ZoomTo: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/building/panel/BuildingPanel.tsx",
        "v2-console/src/building/panel/BuildingPanelActions.tsx",
      ],
    },
  ],
  UI_CadastreDocuments_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/documents/CadastreDocumentsContent.tsx",
      ],
    },
  ],
  UI_CadastreDocuments_ErrorDownload: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/documents/CadastreDocumentsLinkBlob.tsx",
      ],
    },
  ],
  UI_CadastreDocuments_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/documents/CadastreDocuments.tsx"],
    },
  ],
  UI_CadastreDocuments_LandRegistry: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/documents/CadastreDocumentsContent.tsx",
      ],
    },
  ],
  UI_CadastreDocuments_MarketReport: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/documents/CadastreDocumentsContent.tsx",
      ],
    },
  ],
  UI_CadastreDocuments_RegulationPlans: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/documents/CadastreDocumentsContent.tsx",
      ],
    },
  ],
  UI_CadastreDocuments_RiskReport: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/documents/CadastreDocumentsContent.tsx",
      ],
    },
  ],
  UI_CadastreDocuments_UnconfirmedHistoricalLandRegistry: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/documents/CadastreDocumentsContent.tsx",
      ],
    },
  ],
  UI_CadastreDocuments_ViewReport: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/documents/cadastreDocuments.text.ts"],
    },
  ],
  UI_CadastreListingDetails_Description: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/CadastreListingDetailsDescription.tsx",
      ],
    },
  ],
  UI_CadastreListingDetails_Facilities: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/CadastreListingDetails.tsx",
      ],
    },
  ],
  UI_CadastreListingDetails_FinnSelectPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/CadastreListingDetailsFinnSelect.tsx",
      ],
    },
  ],
  UI_CadastreListingDetails_KeyInfo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/CadastreListingDetails.tsx",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/CadastreListingDetailsPriceInfo.tsx",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_AppraisedValue: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_AskingPrice: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_CommonDebt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_Costs: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_Deposit: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_Includes: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_LoanValue: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_MonthlyRent: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_MortgageValue: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_MunicipalFees: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_PriceWithSharedDebt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_PropertyTax: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_RentPerSquareMeterMonth: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_RentPerSquareMeterYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_RentalIncome: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_SharedCostsAfterGrace: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_SharedCostsMonthly: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_SharedDebt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_SharedWealth: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_SoldPrice: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_TaxValue: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_TaxableValue: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_TotalPrice: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_PriceInfo_TransactionCosts: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/cadastreListingDetails.text.ts",
      ],
    },
  ],
  UI_CadastreListingDetails_Sold: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/CadastreListingDetails.tsx",
      ],
    },
  ],
  UI_CadastreListingDetails_Source: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/listingDetails/CadastreModuleListingDetailsSheetContent.tsx",
      ],
    },
  ],
  UI_CadastreListingDetails_SourceLinkLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingDetails/CadastreListingDetailsHeader.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Details: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/listingImage/CadastreModuleListingImage.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingImage/CadastreListingImageContent.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingImage/CadastreListingImage.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Open_Gallery: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingImage/CadastreListingImageTabContent.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Open_Listing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/listingImage/CadastreModuleListingImage.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Show_All: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingImage/sheet/CadastreListingImageSheet.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Sold: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingImage/CadastreListingImageTabContent.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Tab_Rental: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingImage/sheet/CadastreListingImageSheetContent.tsx",
      ],
    },
  ],
  UI_CadastreListingImage_Tab_Sales: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingImage/sheet/CadastreListingImageSheetContent.tsx",
      ],
    },
  ],
  UI_CadastreListing_CardFieldTitle_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listing/CadastreListingTabContentItem.tsx",
      ],
    },
  ],
  UI_CadastreListing_CardFieldTitle_ListingDate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listing/CadastreListingTabContentItem.tsx",
      ],
    },
  ],
  UI_CadastreListing_CardFieldTitle_ListingDetails: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listing/CadastreListingTabContentItem.tsx",
      ],
    },
  ],
  UI_CadastreListing_CardFieldTitle_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listing/CadastreListingTabContentItem.tsx",
      ],
    },
  ],
  UI_CadastreListing_CardFieldTitle_Prom: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listing/CadastreListingTabContentItem.tsx",
      ],
    },
  ],
  UI_CadastreListing_CardFieldTitle_PropertyType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listing/CadastreListingTabContentItem.tsx",
      ],
    },
  ],
  UI_CadastreListing_Details: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/listing/CadastreModuleListing.tsx",
      ],
    },
  ],
  UI_CadastreListing_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listing/CadastreListingTabContent.tsx",
        "v2-console-ui/src/cadastre/listing/CadastreListingTabs.tsx",
      ],
    },
  ],
  UI_CadastreListing_Empty_Image: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/listing/cadastreListing.text.ts"],
    },
  ],
  UI_CadastreListing_Filter_InputPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/listing/CadastreListingFilter.tsx"],
    },
  ],
  UI_CadastreListing_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/listing/CadastreListing.tsx"],
    },
  ],
  UI_CadastreListing_SeeLess: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/listing/cadastreListing.text.ts"],
    },
  ],
  UI_CadastreListing_Select_Type: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/listingTabs/CadastreModuleListingTabs.tsx",
      ],
    },
  ],
  UI_CadastreListing_Sold: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/cadastre/listing/cadastreListing.text.ts"],
    },
  ],
  UI_CadastreListing_Tab_Rental: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingTabs/CadastreListingTab.context.tsx",
      ],
    },
  ],
  UI_CadastreListing_Tab_Sales: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/listingTabs/CadastreListingTab.context.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_Action: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_Action_Active: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_Count: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/marketActivity/CadastrePlotValuationLandTransactionMarketActivityPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/marketActivity/CadastrePlotValuationNewBuildsMarketActivityPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/marketActivity/CadastrePlotValuationPlotAdsMarketActivityPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/marketActivity/CadastrePlotValuationPlotsMarketActivityPopupContent.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/marketActivity/CadasterRentalValuationComparableMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_ItemExist: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityActionButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_LandTransaction_Action: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_LandTransaction_Action_Active: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_NewBuilds_Action: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_NewBuilds_Action_Active: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/marketActivity/CadastrePlotValuationLandTransactionMarketActivityPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/marketActivity/CadastrePlotValuationPlotAdsMarketActivityPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/marketActivity/CadastrePlotValuationPlotsMarketActivityPopupContent.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/marketActivity/CadasterRentalValuationComparableMarketActivityPopupContent.tsx",
        "v2-console-ui/src/cadastre/valuation/comparableSales/marketActivity/CadasterValuationComparableSalesMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_PlotAds_Action: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_PlotAds_Action_Active: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_Plots_Action: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_Plots_Action_Active: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_RentalComparables_Action: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreMapMarketActivity_RentalComparables_Action_Active: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/map/marketActivity/CadastreMapMarketActivityTooltipButton.tsx",
      ],
    },
  ],
  UI_CadastreOwners_Tree_HousingCooperativeShare: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/owners/tree/cadastre.owners.tree.useData.ts",
      ],
    },
  ],
  UI_CadastreOwners_Tree_ShareFraction: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/owners/tree/CadastreOwnersTreeRow.tsx"],
    },
  ],
  UI_CadastrePlotValuation_Estimator_Input_Error: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/plotValuation/CadastreModulePlotValuation.tsx",
      ],
    },
  ],
  UI_CadastrePlotValuation_Estimator_Input_Success: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/plotValuation/CadastreModulePlotValuation.tsx",
      ],
    },
  ],
  UI_CadastreRentalValuation_Estimated: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/CadastreModuleRentalValuationEstimation.tsx",
      ],
    },
  ],
  UI_CadastreRentalValuation_Estimation_Accuracy: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/priceRange/CadastreModuleRentalValuationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreRentalValuation_Estimation_Max: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/priceRange/CadastreModuleRentalValuationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreRentalValuation_Estimation_Min: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/priceRange/CadastreModuleRentalValuationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreRentalValuation_Estimation_Price_Range: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/priceRange/CadastreModuleRentalValuationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreRentalValuation_Monthly_Rental_Estimate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/priceRange/CadastreModuleRentalValuationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Action_Filter: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.text.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Action_Filter_Apply: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.text.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Action_Filter_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.text.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Action_Filter_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.text.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Action_Filter_Transaction: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.text.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Buyer: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Details: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/transactionTimeline/CadastreModuleTransactionTimelineDetails.tsx",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/CadastreTransactionTimeline.tsx",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Joint_Debt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Listing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/CadastreTransactionTimelineListItem.tsx",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_No_Events: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/CadastreTransactionTimeline.tsx",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Price_Quote: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Seller: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Tag_Market: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/CadastreTransactionTimelineListItem.tsx",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Tag_Sold: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/CadastreTransactionTimelineListItem.tsx",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Forced_Sale: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Type: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Type_Estate_Settlement: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Type_Expropriation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Type_Forced_Sale: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Type_Free_Sale: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Type_Gift: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Type_Other: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Transaction_Type_Undivided_Estate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreTransactionTimeline_Value_Changes: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/cadastre.transactionTimeline.utils.ts",
      ],
    },
  ],
  UI_CadastreValuationComparableSales_Details_Empty_Image: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_CadastreValuationComparableSales_Details_PriceInfo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/CadastreValuationComparableSalesDetails.tsx",
      ],
    },
  ],
  UI_CadastreValuationComparableSales_Details_PriceInfo_Sold: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/CadastreValuationComparableSalesDetails.tsx",
      ],
    },
  ],
  UI_CadastreValuationProperty_Bathrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Bedrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Bta: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_BuildingTypeNameAggregated: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_BuildingTypeNameAggregated_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_BuiltYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_EnergyLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_EnergyLabel_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_FloorNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Floors: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Form_Error: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/property/CadastreModuleValuationProperty.tsx",
      ],
    },
  ],
  UI_CadastreValuationProperty_Form_Error_Bathrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Form_Error_Bedrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Form_Error_BuiltYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/cadastre/valuation/cadastre.valuation.property.constant.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Form_Error_FloorNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Form_Success: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/property/CadastreModuleValuationProperty.tsx",
      ],
    },
  ],
  UI_CadastreValuationProperty_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/CadastreValuationPropertyCardTitle.tsx",
      ],
    },
  ],
  UI_CadastreValuationProperty_History_SubTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_LandArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Prom: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_PropertyType_Duplex: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_PropertyType_Flat: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_PropertyType_HolidayHome: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_PropertyType_House: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_PropertyType_Townhouse: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuationProperty_Rooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/property/cadastreValuationProperty.text.ts",
      ],
    },
  ],
  UI_CadastreValuation_AreaScoreMap_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/CadastreModuleValuationMapToolsAreaScoreMap.tsx",
      ],
    },
  ],
  UI_CadastreValuation_AreaScoreMap_Legend_AreaScore_Title: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/CadastreModuleValuationMapToolsAreaScoreMap.tsx",
      ],
    },
  ],
  UI_CadastreValuation_AreaScoreMap_Legend_Default_Label: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/cadastre.module.valuation.mapTools.areaScoreMap.utils.ts",
      ],
    },
  ],
  UI_CadastreValuation_AreaScoreMap_Legend_MunicipalityScore_Title: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/CadastreModuleValuationMapToolsAreaScoreMap.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Comparable_Sales_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/summary/CadastreValuationSummary.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Estimated: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/estimation/CadastreModuleValuationEstimation.tsx",
        "v2-console-ui/src/cadastre/valuation/summary/CadastreValuationSummary.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Estimation_Accuracy: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/estimation/priceRange/CadastreModuleValuationEstimationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Estimation_Max: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/estimation/priceRange/CadastreModuleValuationEstimationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Estimation_Min: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/estimation/priceRange/CadastreModuleValuationEstimationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Estimation_Price_Range: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/estimation/priceRange/CadastreModuleValuationEstimationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Estimation_Sales_Chart_Avg_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/index/graph/cadastre.valuation.index.graph.utils.ts",
      ],
    },
  ],
  UI_CadastreValuation_Estimation_Selling: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/estimation/priceRange/CadastreModuleValuationEstimationPriceRange.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Index_Graph_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/index/graph/CadastreValuationIndexGraph.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Index_Graph_Last_Trade_Marker: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/index/graph/CadastreValuationIndexGraph.tsx",
        "v2-console-ui/src/cadastre/valuation/index/graph/cadastre.valuation.index.graph.utils.ts",
      ],
    },
  ],
  UI_CadastreValuation_Index_Graph_No_Data: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/index/graph/CadastreValuationIndexGraph.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Index_Graph_Tooltip_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/index/graph/CadastreValuationIndexGraph.tsx",
        "v2-console-ui/src/cadastre/valuation/index/graph/cadastre.valuation.index.graph.utils.ts",
      ],
    },
  ],
  UI_CadastreValuation_Index_Valuation_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/index/CadastreModuleValuationIndex.tsx",
        "v2-console-ui/src/cadastre/valuation/summary/CadastreValuationSummary.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Score_Area_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/CadastreValuationComparableSalesDetailsScore.tsx",
        "v2-console-ui/src/cadastre/valuation/score/CadastreValuationScoreArea.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Score_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/score/CadastreModuleValuationScore.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Score_High: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/progressScore/ProgressScore.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Score_Low: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/progressScore/ProgressScore.tsx",
      ],
    },
  ],
  UI_CadastreValuation_Score_Municipality_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/CadastreValuationComparableSalesDetailsScore.tsx",
        "v2-console-ui/src/cadastre/valuation/score/CadastreValuationScoreMunicipality.tsx",
      ],
    },
  ],
  UI_Cadastre_AddressCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/panel/CadastrePanelHeaderDisplay.tsx"],
    },
  ],
  UI_Cadastre_AddressEmpty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/address/CadastreAddresses.tsx"],
    },
  ],
  UI_Cadastre_AddressSearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/address/CadastreAddresses.tsx"],
    },
  ],
  UI_Cadastre_AddressZoomTo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/address/CadastreAddresses.tsx"],
    },
  ],
  UI_Cadastre_Building_Column_BuildingType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_BuildingTypePrimary: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_BuildingTypeSub: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_BuiltArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_EnergySource: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_ExtensionType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_GrossArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_GrossAreaHousing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_GrossAreaOther: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_HasLift: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_Heating: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_HousingUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_IndustryGroup: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_IsAreaIncomplete: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_IsCulturalHeritage: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_IsSEFRAK: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_IsWithoutBuiltUpArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_Number: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_Origin: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_Sewer: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_Status: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_UtilityFloorSpace: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_UtilityFloorSpaceHousing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_UtilityFloorSpaceOther: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Building_Column_WaterSupply: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_ExpandDescription: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_Filter_BuildingNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_Filter_BuildingNumber_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_Filter_BuildingType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_Filter_BuildingType_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_Filter_GrossArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_Filter_HousingUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_SearchPlaceholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_Title: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Buildings_Unknown: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Comparables_Quality_High: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/CadastreModuleValuationMapToolsAreaScoreMap.tsx",
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/cadastre.module.valuation.mapTools.areaScoreMap.utils.ts",
        "v2-console-ui/src/cadastre/comparables/CadastreComparablesTableToolbar.tsx",
      ],
    },
  ],
  UI_Cadastre_Comparables_Quality_Low: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/CadastreModuleValuationMapToolsAreaScoreMap.tsx",
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/cadastre.module.valuation.mapTools.areaScoreMap.utils.ts",
        "v2-console-ui/src/cadastre/comparables/CadastreComparablesTableToolbar.tsx",
      ],
    },
  ],
  UI_Cadastre_Comparables_Quality_Medium: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/CadastreModuleValuationMapToolsAreaScoreMap.tsx",
        "v2-console/src/cadastre/module/valuation/mapTools/areaScoreMap/cadastre.module.valuation.mapTools.areaScoreMap.utils.ts",
        "v2-console-ui/src/cadastre/comparables/CadastreComparablesTableToolbar.tsx",
      ],
    },
  ],
  UI_Cadastre_Comparables_ShowInMap: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/comparables/CadastreComparablesTableToolbar.tsx",
      ],
    },
  ],
  UI_Cadastre_Filter_Max: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Filter_Min: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Building_Type_all: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Building_Type_enebolig: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Building_Type_fritidsbolig: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Building_Type_leilighet: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Building_Type_rekkehus: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Building_Type_tomannsbolig: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Category_other: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Category_price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Category_price_per_sqm: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Category_rental_estimate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Category_rental_estimate_per_sqm: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Category_value_estimate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Category_value_estimate_per_sqm: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Other_byggealder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Other_etasjer: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Filter_Other_meter_over_havet: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_Hex_Map_Legend_Title: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/module/hexMap/CadastreModuleHexMap.tsx"],
    },
  ],
  UI_Cadastre_HousingCooperativeBadge: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/panel/CadastrePanelHeaderDisplay.tsx"],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_HousingUnitSelector_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/housingUnitSelector/CadastreHousingUnitSelector.tsx",
      ],
    },
  ],
  UI_Cadastre_HousingUnitSelector_NoUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/housingUnitSelector/CadastreHousingUnitSelector.tsx",
      ],
    },
  ],
  UI_Cadastre_HousingUnitSelector_RentalValuation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/housingUnitSelector/CadastreHousingUnitSelectorItem.tsx",
      ],
    },
  ],
  UI_Cadastre_HousingUnitSelector_UnitType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/housingUnitSelector/CadastreHousingUnitSelectorItem.tsx",
      ],
    },
  ],
  UI_Cadastre_HousingUnitSelector_Valuation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/housingUnitSelector/CadastreHousingUnitSelectorItem.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_DialogTitleSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDialog.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_ErrorToastTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportActions.tsx",
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportPdfButton.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_ExportMore: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportActions.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_ExportPdf: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportPdfButton.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_ExportPrint: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportActions.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_ExportText: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportActions.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_FileNameBase: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportActions.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_FileNameHistoricalSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportActions.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_MenuCurrent: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDropdown.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_MenuHistorical: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDropdown.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_MenuLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDropdown.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_MenuLegalDocs: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDropdown.tsx",
        "v2-console/src/cadastre/landregister/cadastre.landregister.tracking.ts",
      ],
    },
  ],
  UI_Cadastre_Landregister_MenuOld: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDropdown.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_PrintWindowTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterExportActions.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_TitleCurrent: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDialog.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_TitleHistorical: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDialog.tsx",
      ],
    },
  ],
  UI_Cadastre_Landregister_Trigger: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/landregister/CadastreLandregisterDropdown.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Action: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/map/tableDataView/CadastreModuleMapTableDataViewAction.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/map/CadastrePlotValuationPlotsMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Area: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/map/CadastrePlotValuationLandTransactionsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/map/CadastrePlotValuationPlotAdsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/map/CadastrePlotValuationPlotsMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/map/CadastrePlotValuationLandTransactionsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/map/CadastreRentalValuationComparablesMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/valuation/comparableSales/map/CadastreValuationComparableSalesMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Date: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/map/CadastrePlotValuationLandTransactionsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/map/CadastrePlotValuationNewBuildsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/map/CadastrePlotValuationPlotAdsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/map/CadastrePlotValuationPlotsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/map/CadastreRentalValuationComparablesMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Invalid_Data: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/map/CadastrePlotValuationLandTransactionsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/map/CadastrePlotValuationNewBuildsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/map/CadastrePlotValuationPlotAdsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/map/CadastrePlotValuationPlotsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/map/CadastreRentalValuationComparablesMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Listed: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/map/CadastreValuationComparableSalesMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Market: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/map/CadastreValuationComparableSalesMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_No_Data: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/map/CadastrePlotValuationLandTransactionsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/map/CadastrePlotValuationNewBuildsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/map/CadastrePlotValuationPlotAdsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/map/CadastreRentalValuationComparablesMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/valuation/comparableSales/map/CadastreValuationComparableSalesMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/map/CadastrePlotValuationLandTransactionsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/map/CadastrePlotValuationNewBuildsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/map/CadastrePlotValuationPlotAdsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/map/CadastrePlotValuationPlotsMapPopupContent.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/map/CadastreRentalValuationComparablesMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Map_Table_Data_View_Room: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/map/CadastreRentalValuationComparablesMapPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_ModuleDevelopments: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/developments/CadastreDevelopmentsModule.tsx",
        "v2-console/src/cadastre/overview/insight/CadastreOverviewInsight.tsx",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_ObjectFeatureValue_History_EditedBy: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/objectFeatureValue/CadastreObjectFeatureValueHistoryDropdownContent.tsx",
      ],
    },
  ],
  UI_Cadastre_ObjectFeatureValue_History_OriginalValue: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/objectFeatureValue/CadastreObjectFeatureValueHistoryDropdownContent.tsx",
      ],
    },
  ],
  UI_Cadastre_ObjectFeatureValue_History_SubTitle: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/objectFeatureValue/cadastreObjectFeatureValue.text.ts",
      ],
    },
  ],
  UI_Cadastre_ObjectFeatureValue_History_Title: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/objectFeatureValue/CadastreObjectFeatureValueHistoryDropdownContent.tsx",
      ],
    },
  ],
  UI_Cadastre_OpenIn1881: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/cadastre.tracking.ts",
        "v2-console/src/cadastre/panel/CadastrePanelActions.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_ContextBanner_PartOf: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/contextBanner/CadastreOverviewContextBanner.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_ContextBanner_SectionsSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/contextBanner/CadastreOverviewContextBanner.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Esg_Certifications: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Overview_Esg_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/insight/CadastreOverviewInsight.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Esg_EnergyLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Overview_GovernmentCases_CasesSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/insight/CadastreOverviewInsight.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_GovernmentCases_DocumentsSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/insight/CadastreOverviewInsight.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_GovernmentCases_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/insight/CadastreOverviewInsight.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_GovernmentCases_FilesSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/insight/CadastreOverviewInsight.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_HousingCooperative: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/owners/CadastreOverviewOwners.tsx",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_Overview_HousingCooperative_LinkedShareCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/owners/CadastreOverviewOwners.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_HousingCooperative_ShareCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/owners/CadastreOverviewOwners.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Insight: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/insight/CadastreOverviewInsight.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Owners_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/owners/CadastreOverviewOwners.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_AreaUtilization: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_BRA: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_BYA: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_BuildingCount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_HousingUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_MixedUse: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_NoBuildings: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_OfPlotSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_PlotArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_Sections: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Property_Unknown: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/property/CadastreOverviewProperty.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Tenants_AvgTenancy: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/tenants/CadastreOverviewTenants.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Tenants_Current: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/tenants/CadastreOverviewTenants.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Tenants_EmployeesSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/tenants/CadastreOverviewTenants.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Tenants_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/tenants/CadastreOverviewTenants.tsx",
      ],
    },
  ],
  UI_Cadastre_Overview_Tenants_Historic: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Overview_Tenants_TenantsSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Overview_Tenants_YearsSuffix: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Overview_Transactions_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Overview_Transactions_LastTransaction: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Overview_Transactions_Total: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Overview_Transactions_TotalAmount: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_PanelMany_NotImplemented: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/panel/CadastrePanelMany.tsx"],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Status_Default: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/marketActivity/CadastrePlotValuationLandTransactionMarketActivityStatusBadge.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Status_IG: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Status_Igangsettelse: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/marketActivity/CadastrePlotValuationLandTransactionMarketActivityStatusBadge.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Status_RA: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Status_Rammetillatelse: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/marketActivity/CadastrePlotValuationLandTransactionMarketActivityStatusBadge.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_Area: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/marketActivity/CadastrePlotValuationLandTransactionMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_CadastreNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_Date: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/marketActivity/CadastrePlotValuationLandTransactionMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_MeterSquarePrice: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/marketActivity/CadastrePlotValuationLandTransactionMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_PriceByArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_Status: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_Table_Header_Type: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactions/CadastrePlotValuationLandTransactions.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_BRA_Value_Estimate:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_BRA_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_BRA_Input_BRA:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_BRA_Input_BraMeterSqPrice:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_Bra_Input_BraMeterSqPrice_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_Bra_Input_Bra_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_Land_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_Land_Input_MeterSqPrice:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_Land_Input_MeterSqPrice_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_Land_Input_PlotArea:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Card_Land_Input_PlotArea_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/cadastrePlotValuationLandTransactionsValueEstimator.text.ts",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_Land_Value_Estimate:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/CadastrePlotValuationLandTransactionValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_LandTransactions_ValueEstimator_SubHeader: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/landTransactionsValueEstimator/cadastrePlotValuationLandTransactionsValueEstimator.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Balcony_No: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Balcony_Yes: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Button_Source: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/plotValuation/newBuilds/CadastreModulePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_HousingType_enebolig: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_HousingType_fritidsbolig: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_HousingType_leilighet: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_HousingType_rekkehus: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_HousingType_tomannsbolig: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_MarketActivity_Sold: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/plotValuation/newBuilds/marketActivity/CadastreModulePlotValuationNewBuildsMarketActivitySoldLabel.tsx",
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/marketActivity/CadastrePlotValuationNewBuildsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_MarketActivity_Type: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/marketActivity/CadastrePlotValuationNewBuildsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_MarketActivity_Units: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/marketActivity/CadastrePlotValuationNewBuildsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_NoHousingType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/marketActivity/CadastrePlotValuationNewBuildsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Status_ForSale: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProjectPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Status_Inaktiv: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Status_SoldOut: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProjectPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Status_Solgt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Status_activated: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Status_sold_unknown: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/cadastrePlotValuationNewBuilds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Address: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Area: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/marketActivity/CadastrePlotValuationNewBuildsMarketActivityPopupItem.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Balcony: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Date: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/marketActivity/CadastrePlotValuationNewBuildsMarketActivityPopupItem.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Distance: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_MeterSquarePrice: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/marketActivity/CadastrePlotValuationNewBuildsMarketActivityPopupItem.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Source: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Status: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_Table_Header_Type: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuilds/CadastrePlotValuationNewBuilds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ConstructionCost_Header:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  "UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ConstructionCost_Input_BTA/BRA":
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/cadastrePlotValuationNewBuildsValueEstimator.text.ts",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ConstructionCost_Input_ConstructionCostPerBTA:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ConstructionCost_Input_ConstructionCostPerBTA_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ConstructionCost_Input_EstBTA:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ConstructionCost_Value_Estimate:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ResidualValue_Header:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ResidualValue_Input_DiscountRate:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ResidualValue_Input_DiscountRate_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ResidualValue_Input_ResidualValue:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_ResidualValue_Value_Estimate:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_RetailPrice_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_RetailPrice_Input_BRA:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_RetailPrice_Input_BRA_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_RetailPrice_Input_MeterSqPrice:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_RetailPrice_Input_MeterSqPrice_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Card_RetailPrice_Value_Estimate:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_NewBuilds_ValueEstimator_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/newBuildsValueEstimator/CadastrePlotValuationNewBuildsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_AppraisalLogo_Alt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Button_Source: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/plotValuation/plotAds/CadastreModulePlotValuationPlotAds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Table_Header_AdType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Table_Header_Address: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Table_Header_AppraisalLogo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Table_Header_Area: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/marketActivity/CadastrePlotValuationPlotAdsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Table_Header_Date: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/marketActivity/CadastrePlotValuationPlotAdsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Table_Header_ListingSource: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Table_Header_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/marketActivity/CadastrePlotValuationPlotAdsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Table_Header_PricePerSQM: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/CadastrePlotValuationPlotAds.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plotAds/marketActivity/CadastrePlotValuationPlotAdsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Type_Næringstomt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/cadastrePlotValuationPlotAds.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Type_Tomt: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAds/marketActivity/CadastrePlotValuationPlotAdsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Value_Estimator_Card_Info_Body: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAdsValueEstimator/CadastrePlotValuationPlotAdsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Value_Estimator_Card_Info_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAdsValueEstimator/CadastrePlotValuationPlotAdsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Value_Estimator_Card_Land_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAdsValueEstimator/CadastrePlotValuationPlotAdsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Value_Estimator_Card_Land_Input_MeterSqPrice:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/plotAdsValueEstimator/CadastrePlotValuationPlotAdsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_PlotAds_Value_Estimator_Card_Land_Input_MeterSqPrice_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/plotAdsValueEstimator/CadastrePlotValuationPlotAdsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_PlotAds_Value_Estimator_Card_Land_Input_PlotArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAdsValueEstimator/CadastrePlotValuationPlotAdsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Value_Estimator_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAdsValueEstimator/CadastrePlotValuationPlotAdsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_PlotAds_Value_Estimator_Land_Value_Estimate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotAdsValueEstimator/CadastrePlotValuationPlotAdsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Table_Header_AppraisalLogo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Table_Header_Area: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/marketActivity/CadastrePlotValuationPlotsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Table_Header_CadastreNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Table_Header_Date: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/marketActivity/CadastrePlotValuationPlotsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Table_Header_DownloadLink: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Table_Header_Price: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/marketActivity/CadastrePlotValuationPlotsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Table_Header_PricePerSQM: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
        "v2-console-ui/src/cadastre/plotValuation/plots/marketActivity/CadastrePlotValuationPlotsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Table_Header_Type: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/CadastrePlotValuationPlots.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Type_Eiet: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/cadastrePlotValuationPlots.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Type_Feste: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/cadastrePlotValuationPlots.text.ts",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_Valuation_Report: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plots/marketActivity/CadastrePlotValuationPlotsMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_ValueEstimator_Card_Info_Body: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotsValueEstimator/CadastrePlotValuationPlotsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_ValueEstimator_Card_Info_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotsValueEstimator/CadastrePlotValuationPlotsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_ValueEstimator_Card_Land_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotsValueEstimator/CadastrePlotValuationPlotsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_ValueEstimator_Card_Land_Input_MeterSqPrice:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-shared/src/cadastre/plotValuation/cadastre.plotValuation.constant.ts",
          "v2-console-ui/src/cadastre/plotValuation/plotsValueEstimator/CadastrePlotValuationPlotsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_Plots_ValueEstimator_Card_Land_Input_MeterSqPrice_Lock_Info:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/plotValuation/plotsValueEstimator/CadastrePlotValuationPlotsValueEstimator.tsx",
        ],
      },
    ],
  UI_Cadastre_Plot_Valuation_Plots_ValueEstimator_Card_Land_Input_PlotArea: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotsValueEstimator/CadastrePlotValuationPlotsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_ValueEstimator_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotsValueEstimator/CadastrePlotValuationPlotsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Plots_ValueEstimator_Land_Value_Estimate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/plotsValueEstimator/CadastrePlotValuationPlotsValueEstimator.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Summary_LandTransactions_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/summary/CadastrePlotValuationSummary.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Summary_NewBuild_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/summary/CadastrePlotValuationSummary.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Summary_PlotAds_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/summary/CadastrePlotValuationSummary.tsx",
      ],
    },
  ],
  UI_Cadastre_Plot_Valuation_Summary_Plots_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/plotValuation/summary/CadastrePlotValuationSummary.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Button_Details: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/cadastreRentalValuationComparables.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Details_Button: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/comparables/CadastreModuleRentalValuationComparables.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_Address: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/marketActivity/CadasterRentalValuationComparableMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_Date: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/marketActivity/CadasterRentalValuationComparableMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_Details: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_Distance: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_MonthlyRent: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/marketActivity/CadasterRentalValuationComparableMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_PropertyType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_RentPerSquareMeter: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/marketActivity/CadasterRentalValuationComparableMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationComparables_Table_Header_Rooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/comparables/CadastreRentalValuationComparables.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/comparables/marketActivity/CadasterRentalValuationComparableMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_Bedrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/cadastre/rentalValuation/cadastre.rentalValuation.model.constant.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/cadastre/rentalValuation/cadastre.rentalValuation.model.constant.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_Bta: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/cadastre/rentalValuation/cadastre.rentalValuation.model.constant.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_BuildingTypeNameAggregated: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/cadastre/rentalValuation/cadastre.rentalValuation.model.constant.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_BuildingTypeNameAggregated_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_EnergyLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/cadastre/rentalValuation/cadastre.rentalValuation.model.constant.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_EnergyLabel_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_Form_Error: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/model/CadastreModuleRentalValuationModel.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_Form_Success: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/model/CadastreModuleRentalValuationModel.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/CadastreRentalValuationModelCardTitle.tsx",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_IsAnimalsAllowed: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/cadastre/rentalValuation/cadastre.rentalValuation.model.constant.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_IsAnimalsAllowed_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_Duplex: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_Flat: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_GarageOrParking: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_House: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_Other: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_Placeholder: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_RoomInSharedHousing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_Studio: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_RentalValuationModel_PropertyType_Townhouse: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/model/cadastreRentalValuationModel.text.ts",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/mapTools/CadastreModuleRentalValuationMapTools.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Hex_Map_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/mapTools/hexMap/CadastreModuleRentalValuationMapToolsHexMap.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Rental_Activity_Count: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/mapTools/rentalActivity/CadastreRentalValuationMapToolsRentalActivityPopup.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Rental_Activity_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/rentalValuation/mapTools/rentalActivity/CadastreModuleRentalValuationRentalActivityLayer.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/mapTools/rentalActivity/CadastreRentalValuationMapToolsRentalActivity.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Rental_Activity_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/mapTools/rentalActivity/CadastreRentalValuationMapToolsRentalActivityPopup.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Rental_Activity_Popup_Field_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/mapTools/rentalActivity/cadastreRentalValuationMapToolsRentalActivity.text.ts",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Rental_Activity_Popup_Field_Date: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/mapTools/rentalActivity/cadastreRentalValuationMapToolsRentalActivity.text.ts",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Rental_Activity_Popup_Field_MonthlyRent:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/rentalValuation/mapTools/rentalActivity/cadastreRentalValuationMapToolsRentalActivity.text.ts",
        ],
      },
    ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Rental_Activity_Popup_Field_RentPerSqm:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/rentalValuation/mapTools/rentalActivity/cadastreRentalValuationMapToolsRentalActivity.text.ts",
        ],
      },
    ],
  UI_Cadastre_Rental_Valuation_Map_Tools_Rental_Activity_Popup_Field_Rooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/mapTools/rentalActivity/CadastreRentalValuationMapToolsRentalActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Summary_ComparableRentalProperties_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/summary/CadastreRentalValuationSummary.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Summary_RentalEstimate_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/summary/CadastreRentalValuationSummary.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Summary_YieldBasedRentalEstimate_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/summary/CadastreRentalValuationSummary.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Summary_YieldBasedRentalEstimate_Tooltip_Annual:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/rentalValuation/summary/CadastreRentalValuationYieldTooltip.tsx",
        ],
      },
    ],
  UI_Cadastre_Rental_Valuation_Summary_YieldBasedRentalEstimate_Tooltip_Monthly:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/rentalValuation/summary/CadastreRentalValuationYieldTooltip.tsx",
        ],
      },
    ],
  UI_Cadastre_Rental_Valuation_Summary_YieldBasedRentalEstimate_Tooltip_Title: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/summary/CadastreRentalValuationYieldTooltip.tsx",
      ],
    },
  ],
  UI_Cadastre_Rental_Valuation_Summary_YieldBasedRentalEstimate_Tooltip_Valuation:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/rentalValuation/summary/CadastreRentalValuationYieldTooltip.tsx",
        ],
      },
    ],
  UI_Cadastre_Rental_Valuation_Summary_YieldBasedRentalEstimate_Tooltip_Yield: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/rentalValuation/summary/CadastreRentalValuationYieldTooltip.tsx",
      ],
    },
  ],
  UI_Cadastre_SectionPanelHeader: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_TabBuildings: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_TabESG: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/cadastre.overview.constants.ts",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
  ],
  UI_Cadastre_TabGeneral: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_TabGovernmentCases: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/cadastre.overview.constants.ts",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
  ],
  UI_Cadastre_TabHousingUnits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_TabListing: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_TabOverview: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
  ],
  UI_Cadastre_TabOwners: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/cadastre.overview.constants.ts",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
  ],
  UI_Cadastre_TabPlotValuation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_TabProperty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/cadastre.overview.constants.ts",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
  ],
  UI_Cadastre_TabPublicJournals: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_TabRentalValuation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_TabReportsAndDocuments: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_TabRisks: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/feature/BetaListGlobalDialog.tsx",
        "v2-console/src/feature/featureGates.registry.ts",
      ],
    },
  ],
  UI_Cadastre_TabTenants: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/cadastre.overview.constants.ts",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
  ],
  UI_Cadastre_TabTransactions: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/cadastre.overview.constants.ts",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
        "v2-console/src/cadastre/transactions/cadastre.transactions.tabTexts.ts",
      ],
    },
  ],
  UI_Cadastre_TabTransactions_Market: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_TabValuation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Cadastre_TabZoning: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/cadastre.overview.constants.ts",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
  ],
  UI_Cadastre_TabZoning2: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/cadastre.overview.constants.ts",
        "v2-console/src/cadastre/panel/main/cadastre.panel.main.config.ts",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Feature Flag",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/featureFlag/featureFlag.registry.ts"],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Details_Button: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Header_Market: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/CadastreValuationComparableSalesDetailsHeader.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_Bedrooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_BraE: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_BraI: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_BrokerLogo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_BuildingTypeNameAggregated: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_BuiltYear: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_Distance: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_FloorNumber: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_Floors: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Info_Rooms: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_PriceInfo_ComparablePricePerSqm: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_PriceInfo_IndexValuation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_PriceInfo_TransactionDate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_PriceInfo_TransactionPrice: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_PriceInfo_TransactionTypeCodeName:
    [
      {
        label: "Cadastre panel",
        url: "https://app.placepoint.no/map",
        files: [
          "v2-console-ui/src/cadastre/valuation/comparableSales/details/cadastreValuationComparableSalesDetails.text.ts",
        ],
      },
    ],
  UI_Cadastre_ValuationComparableSalesDetails_Section_Header_Area_Score: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/CadastreValuationComparableSalesDetails.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Section_Header_Facilities: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/CadastreValuationComparableSalesDetails.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSalesDetails_Section_Header_KeyInfo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/details/CadastreValuationComparableSalesDetails.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Button_Details: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/comparableSales/details/CadastreModuleValuationComparableSalesDetails.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_Address: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_Bra: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
        "v2-console-ui/src/cadastre/valuation/comparableSales/marketActivity/CadasterValuationComparableSalesMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_BrokerLogo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_BuildingType: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_Details: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_Distance: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_IndexValuation: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_PricePerSqm: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
        "v2-console-ui/src/cadastre/valuation/comparableSales/marketActivity/CadasterValuationComparableSalesMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_TransactionDate: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
        "v2-console-ui/src/cadastre/valuation/comparableSales/marketActivity/CadasterValuationComparableSalesMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_ValuationComparableSales_Table_Header_TransactionPrice: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/comparableSales/CadastreValuationComparableSales.tsx",
        "v2-console-ui/src/cadastre/valuation/comparableSales/marketActivity/CadasterValuationComparableSalesMarketActivityPopupContent.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_Map_Tools_Card_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/CadastreModuleValuationMapTools.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_Map_Tools_Hex_Map_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/hexMap/CadastreModuleValuationMapToolsHexMap.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_Map_Tools_Market_Activity_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/marketActivity/CadastreValuationMapToolsMarketActivity.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_NewBuildProject_Count: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProjectPopup.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_NewBuildProject_Header: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/newBuildProject/CadastreModuleValuationNewBuildProjectLayer.tsx",
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProject.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_NewBuildProject_NoData: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProjectPopup.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_NewBuildProject_Popup_Field_Address: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProjectPopup.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_NewBuildProject_Popup_Field_Date: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProjectPopup.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_NewBuildProject_Popup_Field_PricePerMeterSquare: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProjectPopup.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_NewBuildProject_Popup_Field_Sold: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/valuation/mapTools/newBuildProject/CadastreValuationMapToolsNewBuildProjectPopup.tsx",
      ],
    },
  ],
  UI_Cadastre_Valuation_NewBuildProject_Popup_Text_Sold: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/module/valuation/mapTools/newBuildProject/CadastreModuleValuationNewBuildProjectLayer.tsx",
      ],
    },
  ],
  UI_Cadastre_Zoning_AreaPurpose: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Zoning_EnableLayer: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Zoning_MunicipalPlan: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Zoning_MunicipalPlanLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Zoning_Purpose: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Zoning_RegulationPlan: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Zoning_RegulationPlanLabel: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_Zoning_RegulationsHits: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/cadastre.text.ts"],
    },
  ],
  UI_Cadastre_ZoomTo: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/panel/CadastrePanelActions.tsx",
        "v2-console/src/cadastre/panel/main/CadastrePanelMain.tsx",
        "v2-console/src/cadastre/panel/section/CadastrePanelSection.tsx",
      ],
    },
  ],
  UI_Canvas_Align_Center: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Align_Label: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Align_Left: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Align_Right: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_ColorTrigger_MixedColor: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_ColorTrigger_MixedFill: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_ColorTrigger_MixedOutline: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Crop_Apply: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx"],
    },
  ],
  UI_Canvas_Crop_ApplyAction: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx"],
    },
  ],
  UI_Canvas_Crop_CancelAction: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx"],
    },
  ],
  UI_Canvas_Draw_Finish: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx"],
    },
  ],
  UI_Canvas_History_Redo: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_History_Undo: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Stacking_BringForward: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Stacking_BringToFront: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Stacking_Order: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Stacking_SendBackward: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Stacking_SendToBack: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_StrokeWidth_Hairline: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_StrokeWidth_Heavy: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_StrokeWidth_Label: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx",
        "v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx",
      ],
    },
  ],
  UI_Canvas_StrokeWidth_Medium: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_StrokeWidth_SemiThick: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_StrokeWidth_Thick: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_StrokeWidth_Thin: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_TextSize_CustomLabel: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasTextSizeSelect.tsx"],
    },
  ],
  UI_Canvas_TextSize_ExtraLarge: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasTextSizeSelect.tsx"],
    },
  ],
  UI_Canvas_TextSize_Huge: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasTextSizeSelect.tsx"],
    },
  ],
  UI_Canvas_TextSize_Label: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-canvas-ui/src/fullEditor/CanvasTextSizeSelect.tsx",
        "v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx",
      ],
    },
  ],
  UI_Canvas_TextSize_Large: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasTextSizeSelect.tsx"],
    },
  ],
  UI_Canvas_TextSize_Medium: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasTextSizeSelect.tsx"],
    },
  ],
  UI_Canvas_TextSize_Mixed: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasTextSizeSelect.tsx"],
    },
  ],
  UI_Canvas_TextSize_Small: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasTextSizeSelect.tsx"],
    },
  ],
  UI_Canvas_Tool_AddImage: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Arrow: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Crop: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Ellipse: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Focus: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Line: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Move: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Pen: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Rectangle: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Select: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Sticker: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Tool_Text: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Toolbar_Bold: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Toolbar_Color: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx",
        "v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx",
      ],
    },
  ],
  UI_Canvas_Toolbar_Delete: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Toolbar_Duplicate: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Toolbar_Fill: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Toolbar_Italic: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Toolbar_MoreActions: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasToolbarBar.tsx"],
    },
  ],
  UI_Canvas_Toolbar_Outline: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Toolbar_Strikethrough: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/canvas.fullEditor.actions.tsx"],
    },
  ],
  UI_Canvas_Zoom_Fit: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx"],
    },
  ],
  UI_Canvas_Zoom_In: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx"],
    },
  ],
  UI_Canvas_Zoom_Out: [
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx"],
    },
  ],
  UI_ComingSoon_Root: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/nav/ModelNavPanelContent.tsx"],
    },
    {
      label: "Monitoring",
      url: "https://app.placepoint.no/map/monitor",
      files: ["v2-console/src/monitor/MonitorPanelContent.tsx"],
    },
  ],
  UI_Common_2D_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/toolbar/MapToolbarItemMode.tsx"],
    },
  ],
  UI_Common_3D_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/toolbar/MapToolbarItemMode.tsx"],
    },
  ],
  UI_Common_ActorOwnerTypeCommercial_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorOwnerTypeMunicipality_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorOwnerTypePrivate_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorOwnerTypePublic_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleApplicant_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleArchitecture_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleCityPlanning_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleConstruction_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleConsultant_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleContractor_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleController_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleDeveloper_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleExpert_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleInvestor_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleKeyLandowners_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleMotherCompany_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleOther_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleOwner_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRolePlanningConsultant_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleProjectOwner_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleProposer_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ActorRoleVisualization_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_AddTag_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_All_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableContent.tsx",
        "v2-console/src/cadastre/property/buildings/CadastrePropertyBuildingsFilterBody.tsx",
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/marketTransactions/CompanyMarketTransactionsTableContent.tsx",
        "v2-console/src/company/offices/table/CompanyOfficesTableFilterBody.tsx",
        "v2-console/src/company/properties/table/CompanyPropertiesTableFilterBody.tsx",
        "v2-console/src/company/transactions/CompanyTransactionsTable.tsx",
      ],
    },
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/EsgCertificationsFilterFields.tsx",
        "v2-console/src/esg/energyLabel/EsgEnergyLabelFilterFields.tsx",
        "v2-console/src/esg/tek/EsgTekFilterFields.tsx",
      ],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/transactions/PersonTransactionsTable.tsx"],
    },
  ],
  UI_Common_AndMore_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/CombifyProfileList.tsx"],
    },
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchResultListItemMore.tsx"],
    },
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
    {
      label: "Stacked Summary",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/stackedSummary/StackedSummaryLegend.tsx"],
    },
  ],
  UI_Common_AverageShort_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.useStackedSummaryData.ts",
      ],
    },
  ],
  UI_Common_BornYearPrefix_Root: [
    {
      label: "Formatters",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/formatters/formatters.objectIdentity.test.ts",
        "v2-console-shared/src/formatters/formatters.objectIdentity.ts",
      ],
    },
  ],
  UI_Common_BtaM2_Root: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightDescriptionModule.tsx",
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
      ],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitDescriptionModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
      ],
    },
  ],
  UI_Common_BuildingNumberPrefix_Root: [
    {
      label: "Formatters",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/formatters/formatters.objectIdentity.test.ts",
        "v2-console-shared/src/formatters/formatters.objectIdentity.ts",
        "v2-console-shared/src/formatters/formatters.ts",
      ],
    },
  ],
  UI_Common_BuiltUnits_Root: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanOverview.tsx"],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderOverviewModule.tsx"],
    },
  ],
  UI_Common_Cancel_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionRemove.tsx",
        "v2-console/src/dataset/settings/DatasetSettingsDangerZone.tsx",
        "v2-console/src/dataset/sketcher/DatasetSketcherAddNotice.tsx",
        "v2-console/src/dataset/sketcher/DatasetSketcherUpdateNotice.tsx",
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRemove.tsx",
      ],
    },
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
    {
      label: "Full Editor",
      url: "https://app.placepoint.no/map",
      files: ["v2-canvas-ui/src/fullEditor/CanvasFullEditor.tsx"],
    },
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/chat/ChatMessage.tsx",
        "v2-layout-ui/src/chat/SessionActionsMenu.tsx",
        "v2-layout-ui/src/chat/SessionList.tsx",
      ],
    },
  ],
  UI_Common_Checkbox_SelectAll_Root: [
    {
      label: "Form Checkbox Group",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/formCheckboxGroup/FormCheckboxGroup.tsx"],
    },
  ],
  UI_Common_ContactPerson_Root: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanActorsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderActorsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Common_DevelopmentStateCancelled_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_DevelopmentStateDelayed_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_DevelopmentStateDescriptionLabel_Root: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/hoverCard/infrastructure/InfrastructureHoverCardLazy.tsx",
      ],
    },
  ],
  UI_Common_DevelopmentStateEarlyStage_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_DevelopmentStateLabel_Root: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/hoverCard/infrastructure/InfrastructureHoverCardLazy.tsx",
      ],
    },
  ],
  UI_Common_DevelopmentStateOnHold_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_DevelopmentStateOngoing_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_DevelopmentStateUnderConstruction_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_Documents_Root: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightDocumentsModule.tsx",
      ],
    },
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanDocumentsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
      ],
    },
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureDocumentsModule.tsx",
      ],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitDocumentsModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderDocumentsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Common_Email_Root: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanContactsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
      ],
    },
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureContactsModule.tsx",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderContactsModule.tsx"],
    },
  ],
  UI_Common_ErrorState_Root: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelContent.tsx"],
    },
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorGeneric.tsx"],
    },
    {
      label: "Loadable",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/loadable/LoadableRenderer.tsx"],
    },
    {
      label: "State",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/state/error/StateError.tsx"],
    },
  ],
  UI_Common_GoBack_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/state/DatasetStyleFieldSelectorEmptyState.tsx",
        "v2-console/src/dataset/style/fieldSelector/state/DatasetStyleFieldSelectorErrorState.tsx",
      ],
    },
  ],
  UI_Common_GoTo_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/cadastre/overview/CadastreOverviewToTabLink.tsx"],
    },
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/combify/CombifyProfileList.tsx",
        "v2-console/src/combify/CombifyPropertyDesignationLink.tsx",
        "v2-console/src/combify/CombifyToTabLink.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/overview/CompanyOverviewToTabLink.tsx"],
    },
  ],
  UI_Common_Input_Name_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_InvalidNumber_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_LandUseBuildingActivities_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingCarServiceFuel_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingCommunityFunction_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingComplementBuilding_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingCulturalValues_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingEducational_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingFence_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingGarageParking_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingGeneralPurpose_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingHealthcare_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingIndustrial_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingInfrastructureTechnical_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingOffice_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingOther_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingOutdoorActivitiesCamping_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingProtection_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingPumpStation_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingRecycling_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingReligious_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingResidential_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingRetail_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingShed_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingSolarCellPlant_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingSportsRecreation_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingStorageWarehouse_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingTemporaryStay_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingTransportation_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseBuildingVisitorFacilitiesHospitality_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectCommercial_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectCultural_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectEducational_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectHealthcare_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectHospitality_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectIndustrial_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectLandscape_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectPublic_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectReligious_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectResidential_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectSports_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUseProjectTransportationInfrastructure_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_LandUse_Root: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightDescriptionModule.tsx",
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
      ],
    },
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanOverviewModule.tsx"],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitDescriptionModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderOverviewModule.tsx"],
    },
  ],
  UI_Common_Links_Root: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightDocumentsModule.tsx",
      ],
    },
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanDocumentsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
      ],
    },
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureDocumentsModule.tsx",
      ],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitDocumentsModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderDocumentsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Common_Loading_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
        "v2-console/src/dataset/style/library/DatasetStyleLibrarySelector.tsx",
      ],
    },
    {
      label: "Regulation",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/regulation/RegulationPlanListSkeleton.tsx",
        "v2-console/src/regulation/RegulationSummaryCardSkeleton.tsx",
      ],
    },
  ],
  UI_Common_NoData_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/tenants/cadastre.tenants.history.useData.ts",
        "v2-console/src/cadastre/tenants/cadastre.tenants.map.ts",
        "v2-console/src/cadastre/tenants/cadastre.tenants.useData.ts",
      ],
    },
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/CombifyFactList.tsx"],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/properties/tenants/company.properties.tenants.useData.ts",
      ],
    },
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/interaction/StatisticsGridPopup.tsx",
        "v2-console/src/statistics/grid/interaction/StatisticsGridSelectedPopup.tsx",
      ],
    },
    {
      label: "State",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/state/empty/StateEmpty.tsx"],
    },
  ],
  UI_Common_NoResults_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelRowSelector.tsx",
        "v2-console/src/dataset/selection/contextMenu/hits/dataset/ContextMenuHitsDatasetDetails.tsx",
      ],
    },
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/selector/DataTableFilterSelectorColumn.tsx",
        "v2-layout-ui/src/dataTable/filter/selector/DataTableFilterSelectorType.tsx",
      ],
    },
    {
      label: "Graphic",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/graphic/displayer/MapGraphicDisplayerItems.tsx"],
    },
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/layer/displayer/MapLayerDisplayerItems.tsx"],
    },
  ],
  UI_Common_No_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/model/CadastreRentalValuationModelForm.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/filter.selectOptions.ts"],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTableExpand.tsx"],
    },
    {
      label: "Formatters",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/formatters/formatters.test.ts",
        "v2-console-shared/src/formatters/formatters.ts",
      ],
    },
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsBalconyBadge.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx"],
    },
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/cells/DataTableBooleanCell.tsx"],
    },
  ],
  UI_Common_ObjectTypeBuildingRightPlural_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypeBuildingRight_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypeDetailPlanPlural_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypeDetailPlan_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypeInfrastructurePlural_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypeInfrastructure_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypePermitPlural_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypePermit_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypePropertyPlural_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypeProperty_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypeTenderPlural_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_ObjectTypeTender_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_OnlyIn3DBadge_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemPrint.tsx",
        "v2-console/src/map/widget/MapWidgetDaylightButton.tsx",
        "v2-console/src/map/widget/MapWidgetLineOfSightButton.tsx",
        "v2-console/src/map/widget/MapWidgetShadowCastButton.tsx",
        "v2-console/src/map/widget/MapWidgetViewpointButton.tsx",
      ],
    },
  ],
  UI_Common_OpenInfrastructureProject_Root: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/hoverCard/infrastructure/InfrastructureHoverCardLazy.tsx",
      ],
    },
  ],
  UI_Common_OrgNumber_Root: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanActorsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
      ],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitActorsModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderActorsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Common_Other_Root: [
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/analyze/newBuildProject/AnalyzeNewBuildProjectFilter.tsx",
        "v2-console/src/analyze/rentalActivity/AnalyzeRentalActivityFilter.tsx",
        "v2-console-ui/src/analyze/AnalyzeHousingTypes.tsx",
        "v2-console-ui/src/analyze/newBuildProject/AnalyzeNewBuildProjectSaleStatusBadge.tsx",
        "v2-console-ui/src/analyze/newBuildProject/chart/AnalyzeNewBuildProjectPropertyTypeChart.tsx",
      ],
    },
  ],
  UI_Common_PermitTypeAdvanceNotice_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PermitTypeBuildingPermit_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PermitTypeDemolitionPermit_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PermitTypeGroundPermit_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PermitType_Root: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
      ],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/panel/PermitOverviewModule.tsx"],
    },
  ],
  UI_Common_PhaseDateNotSpecified_Root: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanTimelineModule.tsx"],
    },
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureTimelineModule.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderTimelineModule.tsx"],
    },
  ],
  UI_Common_PhaseDateToBeDecided_Root: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanTimelineModule.tsx"],
    },
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureTimelineModule.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderTimelineModule.tsx"],
    },
  ],
  UI_Common_Phone_Root: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanActorsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanContactsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
      ],
    },
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureContactsModule.tsx",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderActorsModule.tsx",
        "v2-console/src/tender/panel/TenderContactsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Common_PlanPhaseAntagande_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PlanPhaseGranskning_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PlanPhaseLagaKraft_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PlanPhasePlanbesked_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PlanPhasePlanuppdrag_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PlanPhaseSamrad_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_PlanPhaseUnknown_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_ProcedureBid_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_ProcedureCompetition_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_ProcedureDirect_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_ProcedureModification_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_ProcedureNewBuilding_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_Procedure_Root: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
      ],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/panel/PermitOverviewModule.tsx"],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderOverviewModule.tsx"],
    },
  ],
  UI_Common_PropertyDesignation_Root: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/buildingRight/panel/BuildingRightOverviewModule.tsx",
      ],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/panel/PermitOverviewModule.tsx"],
    },
  ],
  UI_Common_Range_From_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cases/CadastreGovernmentCasesTableContent.tsx",
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCaseDocumentsTableContent.tsx",
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
      ],
    },
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/energyLabel/EsgEnergyLabelFilterFields.tsx"],
    },
  ],
  UI_Common_Range_To_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/governmentCases/cases/CadastreGovernmentCasesTableContent.tsx",
        "v2-console/src/cadastre/governmentCases/documents/CadastreGovernmentCaseDocumentsTableContent.tsx",
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
      ],
    },
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/esg/energyLabel/EsgEnergyLabelFilterFields.tsx"],
    },
  ],
  UI_Common_RelationAddress_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationArea_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationBoa_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationBta_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationBuildingStatus_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationCaseNumber_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationCategory_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationDecisionDate_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationDocuments_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationLoa_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationOwners_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationPhaseDate_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationProcedure_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_RelationType_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.typeLabels.ts"],
    },
  ],
  UI_Common_Remove_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDangerZone.tsx"],
    },
  ],
  UI_Common_Required_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_ResetAll_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_Reset_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelFooter.tsx",
        "v2-console/src/dataset/style/DatasetStyleLabelByField.tsx",
        "v2-console/src/dataset/style/panel/DatasetStylePanelContent.tsx",
      ],
    },
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
    {
      label: "Filter New",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/filterNew/FilterItemInput.tsx",
        "v2-layout-ui/src/filterNew/FilterItemNumberRange.tsx",
      ],
    },
    {
      label: "Filterable With Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterableWithTabs/FilterButton.tsx"],
    },
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_Common_Save_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_Search_Root: [
    {
      label: "App store",
      url: "https://app.placepoint.no/map/app-store",
      files: ["v2-console/src/appStore/AppStoreSearchbar.tsx"],
    },
    {
      label: "Command Simple",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/commandSimple/CommandSimple.tsx"],
    },
  ],
  UI_Common_ShowLess_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/combify/CombifyExpandableText.tsx",
        "v2-console/src/combify/CombifyProfileList.tsx",
      ],
    },
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputReadOnly.tsx"],
    },
    {
      label: "Stacked Summary",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/stackedSummary/StackedSummaryLegend.tsx"],
    },
  ],
  UI_Common_ShowMore_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/CombifyExpandableText.tsx"],
    },
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputReadOnly.tsx"],
    },
  ],
  UI_Common_Slider_Max_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableContent.tsx",
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
      ],
    },
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/EsgCertificationsFilterFields.tsx",
      ],
    },
    {
      label: "Form Slider With Inputs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/formSliderWithInputs/FormSliderWithInputs.tsx"],
    },
  ],
  UI_Common_Slider_Min_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/marketTransactions/CadastreMarketTransactionsTableContent.tsx",
        "v2-console/src/cadastre/tenants/CadastreTenantsFilterBody.tsx",
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
      ],
    },
    {
      label: "ESG",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/esg/certifications/EsgCertificationsFilterFields.tsx",
      ],
    },
    {
      label: "Form Slider With Inputs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/formSliderWithInputs/FormSliderWithInputs.tsx"],
    },
  ],
  UI_Common_Source_Root: [
    {
      label: "Building Right",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/buildingRight/panel/BuildingRightPanel.tsx"],
    },
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanPanel.tsx"],
    },
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/infrastructure/panel/InfrastructurePanel.tsx"],
    },
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/panel/PermitPanel.tsx"],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderPanel.tsx"],
    },
  ],
  UI_Common_TenderPhaseAnnounced_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_TenderPhaseClosed_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_TenderPhaseDecided_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_TenderPhaseOpen_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_TenderPhasePlanned_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.enumLabels.ts"],
    },
  ],
  UI_Common_TryAgain_Root: [
    {
      label: "App",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/app/context/AppContextErrorNotification.tsx"],
    },
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateSection.tsx",
      ],
    },
  ],
  UI_Common_Type_Name_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_Unknown_Root: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveScaleWarning.tsx"],
    },
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx"],
    },
  ],
  UI_Common_Upload_Root: [
    {
      label: "Upload",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/upload/UploaderSubmit.tsx"],
    },
  ],
  UI_Common_UsageApartmentPlural_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_UsageApartment_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_UsageOfficePlural_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_UsageOffice_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_UsagePreschoolPlural_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_UsagePreschool_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_UsageRetailPlural_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_UsageRetail_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_UsageTotal_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.tokenLabels.ts"],
    },
  ],
  UI_Common_UsageUnspecified_Root: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/combify.tokenLabels.ts"],
    },
  ],
  UI_Common_WhatWillBeBuilt_Root: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanOverview.tsx"],
    },
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderOverviewModule.tsx"],
    },
  ],
  UI_Common_YearsAgo_Root: [
    {
      label: "Common",
      url: "https://app.placepoint.no/map",
      files: ["v2-text/src/common/catalog.ts"],
    },
  ],
  UI_Common_Years_Root: [
    {
      label: "Formatters",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/formatters/formatters.test.ts",
        "v2-console-shared/src/formatters/formatters.ts",
      ],
    },
  ],
  UI_Common_Yes_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTable.tsx",
        "v2-console-ui/src/cadastre/rentalValuation/model/CadastreRentalValuationModelForm.tsx",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/roles/CompanyRolesTableExpand.tsx"],
    },
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/filter.selectOptions.ts"],
    },
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTableExpand.tsx"],
    },
    {
      label: "Formatters",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-shared/src/formatters/formatters.test.ts",
        "v2-console-shared/src/formatters/formatters.ts",
      ],
    },
    {
      label: "Analyze",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/analyze/newBuildProject/table/units/AnalyzeNewBuildProjectUnitsBalconyBadge.tsx",
        "v2-console-ui/src/analyze/newBuildProject/table/units/analyze.newBuildProject.units.utils.ts",
      ],
    },
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx"],
    },
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/cells/DataTableBooleanCell.tsx"],
    },
  ],
  UI_Common_ZoomTo_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsRowHover.tsx",
        "v2-console/src/dataset/table/actions/DatasetTableActionsSelect.tsx",
      ],
    },
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchZoomAction.tsx"],
    },
  ],
  UI_Company_AccountingYear: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoBusinessSection.tsx"],
    },
  ],
  UI_Company_Address: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoAddressSection.tsx"],
    },
  ],
  UI_Company_AddressLine1: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_AddressLine2: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_AddressLine3: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_ArticlesApprovedAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoFoundingSection.tsx"],
    },
  ],
  UI_Company_BankruptAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoStatusSection.tsx"],
    },
  ],
  UI_Company_Business: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoBusinessSection.tsx"],
    },
  ],
  UI_Company_BusinessActivity: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoBusinessSection.tsx",
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_CEO_PersonName: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoOrganizationalSection.tsx",
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_City: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_CompulsoryLiquidationAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoStatusSection.tsx"],
    },
  ],
  UI_Company_Contact: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoContactSection.tsx",
        "v2-console/src/company/overview/contact/CompanyOverviewContact.tsx",
      ],
    },
  ],
  UI_Company_CountryCode: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_CreditScore: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/panel/CompanyPanelActions.tsx"],
    },
  ],
  UI_Company_DissolutionAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoStatusSection.tsx"],
    },
  ],
  UI_Company_Email: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoContactSection.tsx",
        "v2-console/src/company/overview/contact/CompanyOverviewContact.tsx",
      ],
    },
  ],
  UI_Company_FoundedAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoFoundingSection.tsx",
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_Founding: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoFoundingSection.tsx"],
    },
  ],
  UI_Company_Header: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_HeadquartersAddress: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoAddressSection.tsx",
        "v2-console/src/company/overview/contact/CompanyOverviewContact.tsx",
      ],
    },
  ],
  UI_Company_IndustrialClassification1: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoTypeSectorSection.tsx"],
    },
  ],
  UI_Company_IndustrialClassification2: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoTypeSectorSection.tsx"],
    },
  ],
  UI_Company_IndustrialClassification3: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoTypeSectorSection.tsx"],
    },
  ],
  UI_Company_IndustrialSector: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoTypeSectorSection.tsx"],
    },
  ],
  UI_Company_IsActive: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoStatusSection.tsx"],
    },
  ],
  UI_Company_IsPbox: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoAddressSection.tsx"],
    },
  ],
  UI_Company_LEI: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoOrganizationalSection.tsx",
      ],
    },
  ],
  UI_Company_LegalEntityType: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoTypeSectorSection.tsx",
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_LiquidationAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoStatusSection.tsx"],
    },
  ],
  UI_Company_MailingAddress: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoAddressSection.tsx",
        "v2-console/src/company/overview/contact/CompanyOverviewContact.tsx",
      ],
    },
  ],
  UI_Company_MarketName: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoOrganizationalSection.tsx",
      ],
    },
  ],
  UI_Company_Mobile: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoContactSection.tsx"],
    },
  ],
  UI_Company_MoveHistory_MovedAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_Name: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoOrganizationalSection.tsx",
      ],
    },
  ],
  UI_Company_NumberOfEmployees: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoBusinessSection.tsx",
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_NumberOfEmployeesDate: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoBusinessSection.tsx"],
    },
  ],
  UI_Company_OpenInAllabolag: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/CompanyLinkToProff.tsx"],
    },
  ],
  UI_Company_OpenInProff: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/CompanyLinkToProff.tsx"],
    },
  ],
  UI_Company_OrganizationNumber: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoOrganizationalSection.tsx",
      ],
    },
  ],
  UI_Company_Organizational: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoOrganizationalSection.tsx",
      ],
    },
  ],
  UI_Company_Overview_Contact_Error: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/contact/CompanyOverviewContact.tsx",
      ],
    },
  ],
  UI_Company_Overview_GeoDistribution: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_Identity: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_Overview_Identity_Error: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Financials_Empty: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Owners: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Owners_Empty: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Owners_Error: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Owners_Suffix: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Roles_BoardRolePlural: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Roles_BoardRoleSingular: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Roles_Empty: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Roles_Error: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Insight_Roles_GeneralManager: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_PartOf: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_Count: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_Empty: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_Error: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_Municipalities: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_MunicipalitySuffixPlural: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_MunicipalitySuffixSingular: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_Other: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_SeriesName: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_SuffixPlural: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_SuffixSingular: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_Properties_Unspecified: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/properties/CompanyOverviewProperties.tsx",
      ],
    },
  ],
  UI_Company_Overview_PurposeEmpty: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_Cities: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_CitySuffixPlural: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_CitySuffixSingular: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_Count: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_Empty: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_Error: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_SeriesName: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_SuffixPlural: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_RentedSites_SuffixSingular: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/rentedSites/CompanyOverviewRentedSites.tsx",
      ],
    },
  ],
  UI_Company_Overview_Result: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_Overview_Revenue: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
        "v2-console/src/company/overview/insight/CompanyOverviewInsight.tsx",
      ],
    },
  ],
  UI_Company_PanelMany_NotImplemented: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/panel/CompanyPanelMany.tsx"],
    },
  ],
  UI_Company_ParentOrganizationNumber: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoOrganizationalSection.tsx",
      ],
    },
  ],
  UI_Company_Phone: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoContactSection.tsx",
        "v2-console/src/company/overview/contact/CompanyOverviewContact.tsx",
      ],
    },
  ],
  UI_Company_PostalCode: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_RegisteredAt: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoFoundingSection.tsx"],
    },
  ],
  UI_Company_RegisteredPurpose: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoBusinessSection.tsx",
        "v2-console/src/company/overview/identity/CompanyOverviewIdentity.tsx",
      ],
    },
  ],
  UI_Company_Status: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoStatusSection.tsx"],
    },
  ],
  UI_Company_TabDocuments: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/panel/company.panel.config.tsx"],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Company_TabFinancials: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/company.overview.constants.ts",
        "v2-console/src/company/panel/company.panel.config.tsx",
      ],
    },
  ],
  UI_Company_TabInfo: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/panel/company.panel.config.tsx"],
    },
  ],
  UI_Company_TabOffices: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/company.overview.constants.ts",
        "v2-console/src/company/panel/company.panel.config.tsx",
      ],
    },
  ],
  UI_Company_TabOverview: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/panel/company.panel.config.tsx"],
    },
  ],
  UI_Company_TabOwnership: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/company.overview.constants.ts",
        "v2-console/src/company/panel/company.panel.config.tsx",
      ],
    },
  ],
  UI_Company_TabProperties: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/company.overview.constants.ts",
        "v2-console/src/company/panel/company.panel.config.tsx",
      ],
    },
  ],
  UI_Company_TabRoles: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/overview/company.overview.constants.ts",
        "v2-console/src/company/panel/company.panel.config.tsx",
      ],
    },
  ],
  UI_Company_TabTenants: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/company.text.ts"],
    },
  ],
  UI_Company_TabTransactions: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/cadastre.transactions.tabTexts.ts",
      ],
    },
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/panel/company.panel.config.tsx"],
    },
  ],
  UI_Company_TabTransactions_Market: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/transactions/CompanyTransactionsTable.tsx",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
  ],
  UI_Company_TypeSector: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/company/info/CompanyInfoTypeSectorSection.tsx"],
    },
  ],
  UI_Company_Website: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/info/CompanyInfoContactSection.tsx",
        "v2-console/src/company/overview/contact/CompanyOverviewContact.tsx",
      ],
    },
  ],
  UI_Company_ZoomTo: [
    {
      label: "Company panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/company/panel/CompanyPanel.tsx",
        "v2-console/src/company/panel/CompanyPanelActions.tsx",
      ],
    },
  ],
  UI_Compass_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/toolbar/MapToolbarItemCompass.tsx"],
    },
  ],
  UI_CountrySelector_Header: [
    {
      label: "Country Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/countrySelector/CountrySelector.tsx"],
    },
  ],
  UI_CountrySelector_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_CountrySelector_SearchEmpty: [
    {
      label: "Country Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/countrySelector/CountrySelector.tsx"],
    },
  ],
  UI_CountrySelector_SearchPlaceholder: [
    {
      label: "Country Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/countrySelector/CountrySelector.tsx"],
    },
  ],
  UI_CurrentLocation: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetCurrentLocationButton.tsx",
        "v2-console/src/map/widget/currentLocation/map.widget.currentLocation.constants.ts",
      ],
    },
  ],
  UI_CurrentLocation_Error_Denied: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/map.widget.currentLocation.text.ts",
      ],
    },
  ],
  UI_CurrentLocation_Error_Insecure: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/map.widget.currentLocation.text.ts",
      ],
    },
  ],
  UI_CurrentLocation_Error_NoSupport: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/map.widget.currentLocation.text.ts",
      ],
    },
  ],
  UI_CurrentLocation_Error_Timeout: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/map.widget.currentLocation.text.ts",
      ],
    },
  ],
  UI_CurrentLocation_Error_Unavailable: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/map.widget.currentLocation.text.ts",
      ],
    },
  ],
  UI_CurrentLocation_Error_Unknown: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/map.widget.currentLocation.text.ts",
      ],
    },
  ],
  UI_CurrentLocation_Permission_Dismiss: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/MapWidgetCurrentLocationPermissionAlert.tsx",
      ],
    },
  ],
  UI_CurrentLocation_Permission_Intro: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/MapWidgetCurrentLocationPermissionAlert.tsx",
      ],
    },
  ],
  UI_CurrentLocation_Permission_Retry: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/MapWidgetCurrentLocationPermissionAlert.tsx",
      ],
    },
  ],
  UI_CurrentLocation_Permission_Step_Browser: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/MapWidgetCurrentLocationPermissionAlert.tsx",
      ],
    },
  ],
  UI_CurrentLocation_Permission_Step_Device: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/MapWidgetCurrentLocationPermissionAlert.tsx",
      ],
    },
  ],
  UI_CurrentLocation_Permission_Title: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/currentLocation/MapWidgetCurrentLocationPermissionAlert.tsx",
      ],
    },
  ],
  UI_CurrentUserAvatar_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_CurrentUser_AccountSettings: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/menu/CurrentUserAccountMenuContent.tsx",
      ],
    },
  ],
  UI_CurrentUser_BetaMode: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/menu/CurrentUserAccountMenuBetaItem.tsx",
      ],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarBrandingBeta.tsx"],
    },
  ],
  UI_CurrentUser_BetaMode_List: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/menu/CurrentUserAccountMenuBetaItem.tsx",
      ],
    },
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/BetaListGlobalDialog.tsx"],
    },
  ],
  UI_CurrentUser_BetaMode_ListDev: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/BetaListGlobalDialog.tsx"],
    },
  ],
  UI_CurrentUser_BetaMode_ListEmpty: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/BetaListGlobalDialog.tsx"],
    },
  ],
  UI_CurrentUser_BetaMode_ListFlag: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/BetaListGlobalDialog.tsx"],
    },
  ],
  UI_CurrentUser_BetaMode_ListStaff: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/BetaListGlobalDialog.tsx"],
    },
  ],
  UI_CurrentUser_Header: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/CurrentUserSidebarItem.tsx"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarUserMenu.tsx"],
    },
  ],
  UI_CurrentUser_Logout: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/menu/CurrentUserAccountMenuContent.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileEmail: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileEmailEmptyError: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileEmailInvalidError: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileEmailPlaceholder: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileEmailTooLongError: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileFirstName: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileFirstNameEmptyError: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileFirstNamePlaceholder: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileFirstNameTooLongError: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileFormCancel: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileFormHeader: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_CurrentUser_ProfileFormOnError: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileFormOnSuccess: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileFormSubmit: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileFormUnsavedChanges: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileLastName: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileLastNameEmptyError: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_ProfileLastNamePlaceholder: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/profile/CurrentUserProfileForm.tsx"],
    },
  ],
  UI_CurrentUser_ProfileLastNameTooLongError: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/profile/currentUser.profile.utils.tsx",
      ],
    },
  ],
  UI_CurrentUser_QuickAction_InviteColleague: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarInviteItem.tsx"],
    },
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/selfService/SelfServiceInviteDialog.tsx"],
    },
  ],
  UI_CurrentUser_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_CurrentUser_TenantChange_ErrorFallbackMessage: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/tenant/currentUser.tenant.utils.tsx"],
    },
  ],
  UI_CurrentUser_TenantChange_ErrorReceivedMessage: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/tenant/currentUser.tenant.utils.tsx"],
    },
  ],
  UI_CurrentUser_TenantChange_ErrorTitle: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/tenant/currentUser.tenant.utils.tsx"],
    },
  ],
  UI_CurrentUser_TenantPicker: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/currentUser.text.ts"],
    },
  ],
  UI_CurrentUser_TenantPickerItem: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/currentUser.text.ts"],
    },
  ],
  UI_DatasetNav_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_Dataset_AutocompleteActionCreate_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/inputs/autocomplete/AutocompleteActionCreate.tsx",
      ],
    },
  ],
  UI_Dataset_BackButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelBackButton.tsx",
        "v2-console/src/dataset/table/panel/DatasetTablePanelHeader.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_Category_Address: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_Category_Cadaster: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_City: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_Entrance: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_LeaseNumber: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_Matrikkelnummer: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_MunicipalityCode: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_None: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_Number: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_PostalCode: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_RegistrationNumber: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_StoryNumber: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_Street: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_ColumnSemantic_SubregistrationNumber: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/columnSemantic/DatasetMatchingColumnSemanticSelect.tsx",
      ],
    },
  ],
  UI_Dataset_CreateErrorToast: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/create/dataset.create.utils.ts"],
    },
  ],
  UI_Dataset_DetailsActionIntersects_Error_Convert: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersects.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_Error_FetchResults: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersectsContent.tsx",
        "v2-console/src/dataset/selection/contextMenu/action/ContextMenuActionIntersectPolygon.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_Error_InvalidPolygon: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersects.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_Error_LoadLayers: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersectsContent.tsx",
        "v2-console/src/dataset/selection/contextMenu/action/ContextMenuActionIntersectPolygon.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_Error_LoadPolygons: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersects.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_Error_NoGeometry: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersects.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_Error_SelectFeatures: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersectsContent.tsx",
        "v2-console/src/dataset/selection/contextMenu/action/ContextMenuActionIntersectPolygon.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_HitsCount: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersectsContent.tsx",
        "v2-console/src/dataset/selection/contextMenu/action/ContextMenuActionIntersectPolygon.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_NoGeometry: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersectsContent.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_NoResults: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersectsContent.tsx",
        "v2-console/src/dataset/selection/contextMenu/action/ContextMenuActionIntersectPolygon.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_OverLimit: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersectsContent.tsx",
        "v2-console/src/dataset/selection/contextMenu/action/ContextMenuActionIntersectPolygon.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_SelectFrom: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersectsContent.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionIntersects_Trigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionIntersects.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionMove_Feature: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionMove.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionMove_Line: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionMove.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionMove_Point: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionMove.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionMove_Polygon: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionMove.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionRemove_ConfirmAction: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionRemove.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionRemove_ConfirmDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionRemove.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionRemove_ConfirmTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionRemove.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionRemove_Trigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionRemove.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionTable_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionTable.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsActionZoomTo_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/action/DatasetDetailsActionZoomTo.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsApi_ChangesErrorToast_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/details/dataset.details.api.tsx"],
    },
  ],
  UI_Dataset_DetailsApi_ChangesSuccessToast_Description: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/details/dataset.details.api.tsx"],
    },
  ],
  UI_Dataset_DetailsApi_ChangesSuccessToast_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/details/dataset.details.api.tsx"],
    },
  ],
  UI_Dataset_DetailsApi_ChangesToast_Row: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/details/dataset.details.api.tsx"],
    },
  ],
  UI_Dataset_DetailsPanelFooter_FieldsChanged: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelFooter.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelFooter_Submit: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelFooter.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelManyItem_RowCount: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelManyItem.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelMany_Description: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelMany.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelMany_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelMany.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelMany_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelMany.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelMixedWarning_Message: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelMixedWarning.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelRowSelector_AdjustSelection: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelRowSelector.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelRowSelector_DeselectAll: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelRowSelector.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelRowSelector_OpenSelected: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelRowSelector.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelRowSelector_SearchPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelRowSelector.tsx",
      ],
    },
  ],
  UI_Dataset_DetailsPanelRowSelector_ToggleAll: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/panel/DatasetDetailsPanelRowSelector.tsx",
      ],
    },
  ],
  UI_Dataset_Errors_Dismiss: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/errors/DatasetErrorBanner.tsx"],
    },
  ],
  UI_Dataset_Errors_DismissAll: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/errors/DatasetErrorBanner.tsx"],
    },
  ],
  UI_Dataset_Errors_QueuedFailures: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/errors/DatasetErrorBanner.tsx"],
    },
  ],
  UI_Dataset_Errors_Retry: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/errors/DatasetErrorBanner.tsx",
        "v2-console/src/dataset/matching/DatasetMatchingReport.tsx",
      ],
    },
  ],
  UI_Dataset_Errors_Toast_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/errors/DatasetErrorBanner.tsx",
        "v2-console/src/dataset/upload/dataset.upload.sheetItems.hook.tsx",
      ],
    },
  ],
  UI_Dataset_ExportButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/DatasetExportButton.tsx"],
    },
  ],
  UI_Dataset_ExportButtonCancel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/DatasetExportButton.tsx"],
    },
  ],
  UI_Dataset_ExportButtonOptionWithFilteres: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/DatasetExportButton.tsx"],
    },
  ],
  UI_Dataset_ExportButtonOptionWithOutFilteres: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/DatasetExportButton.tsx"],
    },
  ],
  UI_Dataset_ExportButtonOptions: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/DatasetExportButton.tsx"],
    },
  ],
  UI_Dataset_ExportButtonSelected: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/DatasetExportButtonSelected.tsx"],
    },
  ],
  UI_Dataset_ExportButtonSubmit: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/DatasetExportButton.tsx"],
    },
  ],
  UI_Dataset_ExportErrorToast: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/dataset.export.utils.ts"],
    },
  ],
  UI_Dataset_ExportSuccessToast: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/export/dataset.export.utils.ts"],
    },
  ],
  UI_Dataset_FilterButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/filter/DatasetFilter.tsx",
        "v2-console/src/dataset/filter/global/DatasetFilterGlobal.tsx",
      ],
    },
  ],
  UI_Dataset_FilterGlobalContent_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/filter/global/DatasetFilterGlobalContent.tsx",
      ],
    },
  ],
  UI_Dataset_FilterGlobal_Description: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/filter/global/DatasetFilterGlobal.tsx"],
    },
  ],
  UI_Dataset_FilterGlobal_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/filter/global/DatasetFilterGlobal.tsx"],
    },
  ],
  UI_Dataset_GeometryAdd_ErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/geometry/dataset.geometry.add.utils.ts"],
    },
  ],
  UI_Dataset_GeometryAdd_NoGeometriesDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/geometry/dataset.geometry.add.utils.ts"],
    },
  ],
  UI_Dataset_GeometryAdd_SuccessDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/geometry/dataset.geometry.add.utils.ts"],
    },
  ],
  UI_Dataset_GeometryAdd_SuccessTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/geometry/dataset.geometry.add.utils.ts"],
    },
  ],
  UI_Dataset_GeometryAdd_TryAgainDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/geometry/dataset.geometry.add.utils.ts"],
    },
  ],
  UI_Dataset_GeometryUpdate_ConstructErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/geometry/dataset.geometry.update.utils.ts",
      ],
    },
  ],
  UI_Dataset_GeometryUpdate_ErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/geometry/dataset.geometry.update.utils.ts",
      ],
    },
  ],
  UI_Dataset_GeometryUpdate_NoGeometriesDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/geometry/dataset.geometry.update.utils.ts",
      ],
    },
  ],
  UI_Dataset_GeometryUpdate_SuccessDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/geometry/dataset.geometry.update.utils.ts",
      ],
    },
  ],
  UI_Dataset_GeometryUpdate_SuccessTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/geometry/dataset.geometry.update.utils.ts",
      ],
    },
  ],
  UI_Dataset_GeometryUpdate_TryAgainDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/geometry/dataset.geometry.update.utils.ts",
      ],
    },
  ],
  UI_Dataset_InputFacet_CreateNew: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputDynamicFacet.tsx"],
    },
  ],
  UI_Dataset_InputFacet_Empty: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputDynamicFacet.tsx"],
    },
  ],
  UI_Dataset_InputFacet_SearchPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputDynamicFacet.tsx"],
    },
  ],
  UI_Dataset_InputMixed_Empty: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputMixed.tsx"],
    },
  ],
  UI_Dataset_InputReadOnlyMixedHover_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/inputs/DatasetInputReadOnlyMixedHover.tsx",
      ],
    },
  ],
  UI_Dataset_InputReadOnlyMixedHover_ShowMore: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/inputs/DatasetInputReadOnlyMixedHover.tsx",
      ],
    },
  ],
  UI_Dataset_InputStaticFacet_AdditionalValuesHeading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputStaticFacet.tsx"],
    },
  ],
  UI_Dataset_InputStaticFacet_EmptyValue: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputStaticFacet.tsx"],
    },
  ],
  UI_Dataset_InputStaticFacet_NoValues: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputStaticFacet.tsx"],
    },
  ],
  UI_Dataset_InputStaticFacet_SearchPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputStaticFacet.tsx"],
    },
  ],
  UI_Dataset_InputStaticFacet_SelectedValuesHeading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/inputs/DatasetInputStaticFacet.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Badge_Completed: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Badge_RowsMatched: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Details_Empty: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Details_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Details_Loading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Details_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Dialog_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/matching/DatasetMatchingReportDialog.tsx",
      ],
    },
  ],
  UI_Dataset_MatchingReport_EmDash: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_MissingDatasetError: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Overview: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Progress_Complete: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_MatchingReport_Progress_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_MatchingReport_Progress_Running: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_MatchingReport_Progress_Starting: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_MatchingReport_RunsCard: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Runs_Empty: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Runs_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Runs_Loading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Runtime_Helper: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Table_Count: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Table_Precision: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Table_RowsFromDataset: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Table_RunDate: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Table_Runtime: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_MatchingReport_Table_Type: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/matching/DatasetMatchingReport.tsx"],
    },
  ],
  UI_Dataset_NavHeader: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelContent.tsx"],
    },
  ],
  UI_Dataset_NavPanelContent_ErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelContent.tsx"],
    },
  ],
  UI_Dataset_NavPanelListItem_AddGeometry: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelListItem.tsx"],
    },
  ],
  UI_Dataset_NavPanelListItem_LoadFailedLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelListItem.tsx"],
    },
  ],
  UI_Dataset_NavPanelListItem_Settings: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelListItem.tsx"],
    },
  ],
  UI_Dataset_NavPanelListItem_Style: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelListItem.tsx"],
    },
  ],
  UI_Dataset_NavPanelListItem_Table: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelListItem.tsx"],
    },
  ],
  UI_Dataset_NavPanelListItem_UpdateDataset: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelListItem.tsx"],
    },
  ],
  UI_Dataset_NavPanelList_EmptyDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelList.tsx"],
    },
  ],
  UI_Dataset_NavPanelList_EmptyTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/nav/DatasetNavPanelList.tsx"],
    },
  ],
  UI_Dataset_OrderButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/table/order/DatasetTableOrder.tsx"],
    },
  ],
  UI_Dataset_PopoverPager_Count: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/popup/DatasetPanelPopupPagerFooter.tsx",
      ],
    },
  ],
  UI_Dataset_PopoverPager_Next: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/popup/DatasetPanelPopupPagerFooter.tsx",
      ],
    },
  ],
  UI_Dataset_PopoverPager_Prev: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/details/popup/DatasetPanelPopupPagerFooter.tsx",
      ],
    },
  ],
  UI_Dataset_RemoveRows_ErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/remove/dataset.removeRows.utils.ts"],
    },
  ],
  UI_Dataset_RemoveRows_SuccessTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/remove/dataset.removeRows.utils.ts"],
    },
  ],
  UI_Dataset_RowsRemove_ConfirmAction: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsSelect.tsx",
      ],
    },
  ],
  UI_Dataset_RowsRemove_ConfirmDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsSelect.tsx",
      ],
    },
  ],
  UI_Dataset_RowsRemove_ConfirmTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsSelect.tsx",
      ],
    },
  ],
  UI_Dataset_RowsRemove_Trigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsSelect.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionContextMenuDetails_BackButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_SelectionContextMenuDetails_CloseButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_SelectionContextMenuHitsDetails_ErrorLoading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/hits/dataset/ContextMenuHitsDatasetDetails.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionContextMenuHitsDetails_MaxExceeded: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/hits/dataset/ContextMenuHitsDatasetDetails.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionContextMenuHitsDetails_SearchPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/hits/dataset/ContextMenuHitsDatasetDetails.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionContextMenuHitsDetails_SelectAll: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/hits/dataset/ContextMenuHitsDatasetDetails.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionContextMenuIntersect_Loading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/action/ContextMenuActionIntersectPolygon.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionContextMenuIntersect_SelectFrom: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/action/ContextMenuActionIntersectPolygon.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionContextMenuSubItemDetails_MoreFields: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/hits/dataset/ContextMenuHitsDatasetSubItemDetails.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionContextMenu_CloseButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_SelectionContextMenu_NoActions: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_SelectionContextMenu_SearchPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_SelectionPopupOverLimit_CloseButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_SelectionPopupOverLimit_MaxIs: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/popup/DatasetSelectionPopupOverLimit.tsx",
        "v2-console/src/dataset/selection/popup/DatasetSelectionPopupOverLimitSketch.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionPopupOverLimit_SelectedOfMax: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/popup/DatasetSelectionPopupOverLimit.tsx",
        "v2-console/src/dataset/selection/popup/DatasetSelectionPopupOverLimitSketch.tsx",
      ],
    },
  ],
  UI_Dataset_SelectionPopupOverLimit_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/popup/DatasetSelectionPopupOverLimit.tsx",
        "v2-console/src/dataset/selection/popup/DatasetSelectionPopupOverLimitSketch.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsDetails_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDetails.tsx"],
    },
  ],
  UI_Dataset_SettingsDialogContent_Description: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_SettingsDialogContent_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsDisplay_Display1: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDisplay.tsx"],
    },
  ],
  UI_Dataset_SettingsDisplay_Display2: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDisplay.tsx"],
    },
  ],
  UI_Dataset_SettingsDisplay_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDisplay.tsx"],
    },
  ],
  UI_Dataset_SettingsGeneralFooter_DeleteTrigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDangerZone.tsx"],
    },
  ],
  UI_Dataset_SettingsGeneralFooter_RemoveConfirmDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDangerZone.tsx"],
    },
  ],
  UI_Dataset_SettingsGeneralFooter_RemoveConfirmTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDangerZone.tsx"],
    },
  ],
  UI_Dataset_SettingsGeneral_Reset: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsGeneralFooter.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsGeneral_Save: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsGeneralFooter.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_Behavior_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_Fields_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_Fields_ShowHide: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_Hover: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_Hover_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_PopoverDockPosition: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_PopoverDocked: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_ReadOnly: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_Reset: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_Save: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_SelectMode: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_SettingsInteraction_ShowActions: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsInteractionTab.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_DangerZone_Delete: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDangerZone.tsx"],
    },
  ],
  UI_Dataset_Settings_DangerZone_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDangerZone.tsx"],
    },
  ],
  UI_Dataset_Settings_EnableLinking_Back: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_EnableLinking_Continue: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_EnableLinking_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_EnableLinking_Immutable_Confirm: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_EnableLinking_Immutable_Confirm_Action: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_EnableLinking_Immutable_Confirm_Cancel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_EnableLinking_Intro: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_EnableLinking_ObjectType_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_EnableLinking_Submit: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_LeaveTab_Confirm: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_LeaveTab_Confirm_Action: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_LeaveTab_Confirm_Cancel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Linking_Disable_Confirm: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_Disable_Confirm_Action: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_Disable_Confirm_Cancel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_ObjectTypeLabel_Address: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_ObjectTypeLabel_Cadaster: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_ObjectTypeLabel_Companies: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_ObjectType_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Linking_Toggle_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsLinking.tsx"],
    },
  ],
  UI_Dataset_Settings_Rerun_All_Confirm: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_All_Confirm_Action: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_All_Confirm_Cancel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_All_Option: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_Button: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_LastRun_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_Unmatched_Option: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Rerun_ViewReport_Link: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsRerunMatching.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_SemanticMapping_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsSemanticColumnMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_SemanticMapping_Heading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
        "v2-console/src/dataset/settings/DatasetSettingsSemanticColumnMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Tab_ConnectData: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Tab_General: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_Tab_Interaction: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_Settings_UnsavedChanges_Confirm: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDialog.tsx"],
    },
  ],
  UI_Dataset_Settings_UnsavedChanges_Confirm_Action: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDialog.tsx"],
    },
  ],
  UI_Dataset_Settings_UnsavedChanges_Confirm_Cancel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/settings/DatasetSettingsDialog.tsx"],
    },
  ],
  UI_Dataset_SketcherAddNotice_Complete: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/sketcher/DatasetSketcherAddNotice.tsx"],
    },
  ],
  UI_Dataset_SketcherUpdateNotice_Complete: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/DatasetSketcherUpdateNotice.tsx",
      ],
    },
  ],
  UI_Dataset_Sketcher_Add_Point: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/dataset.sketcher.messages.utils.ts",
      ],
    },
  ],
  UI_Dataset_Sketcher_Add_Polygon: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/dataset.sketcher.messages.utils.ts",
      ],
    },
  ],
  UI_Dataset_Sketcher_Add_Polyline: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/dataset.sketcher.messages.utils.ts",
      ],
    },
  ],
  UI_Dataset_Sketcher_Edit_Point: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/dataset.sketcher.messages.utils.ts",
      ],
    },
  ],
  UI_Dataset_Sketcher_Edit_Polygon: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/dataset.sketcher.messages.utils.ts",
      ],
    },
  ],
  UI_Dataset_Sketcher_Edit_Polyline: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/dataset.sketcher.messages.utils.ts",
      ],
    },
  ],
  UI_Dataset_Sketcher_NoGeometryType: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/dataset.sketcher.messages.utils.ts",
      ],
    },
  ],
  UI_Dataset_Sketcher_UnsupportedGeometryType: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/sketcher/dataset.sketcher.messages.utils.ts",
      ],
    },
  ],
  UI_Dataset_SortButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/table/sort/DatasetTableSort.tsx"],
    },
  ],
  UI_Dataset_StyleCategoricalByField_FieldPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/DatasetStyleCategoricalByField.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategoricalByField_NotSuitable: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/DatasetStyleCategoricalByField.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategoricalItem_ItemCount: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalItem.tsx",
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalOther.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategoricalItem_MissingValue: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalItem.tsx",
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalOther.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategoricalOther_Collapse: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalOther.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategoricalOther_EmptyOthers: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalOther.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategoricalOther_Expand: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalOther.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategoricalOther_MoveToTop: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalOther.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategoricalOther_OthersLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalOther.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategorical_CommonStylesTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategorical.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategorical_FieldStylesTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategorical.tsx",
      ],
    },
  ],
  UI_Dataset_StyleCategorical_MoveToOthers: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategorical.tsx",
      ],
    },
  ],
  UI_Dataset_StyleClusteringMaxScaleSlider_Description: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/DatasetStyleClusteringMaxScaleSlider.tsx",
      ],
    },
  ],
  UI_Dataset_StyleClusteringMaxScaleSlider_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/DatasetStyleClusteringMaxScaleSlider.tsx",
      ],
    },
  ],
  UI_Dataset_StyleClustering_EnableToggle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleClustering.tsx"],
    },
  ],
  UI_Dataset_StyleClustering_MaximumLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleClustering.tsx"],
    },
  ],
  UI_Dataset_StyleClustering_MinimumLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleClustering.tsx"],
    },
  ],
  UI_Dataset_StyleClustering_PointCountLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleClustering.tsx"],
    },
  ],
  UI_Dataset_StyleClustering_ShowCountLabelToggle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleClustering.tsx"],
    },
  ],
  UI_Dataset_StyleClustering_SizeMappingTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleClustering.tsx"],
    },
  ],
  UI_Dataset_StyleClustering_SizePxLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleClustering.tsx"],
    },
  ],
  UI_Dataset_StyleColorMapByField_FieldPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleColorMapByField.tsx"],
    },
  ],
  UI_Dataset_StyleColorMapByField_NotSuitable: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleColorMapByField.tsx"],
    },
  ],
  UI_Dataset_StyleColorMapPreview_LoadingHistogram: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/colormap/DatasetStyleColorMapPreview.tsx",
      ],
    },
  ],
  UI_Dataset_StyleColorMapPreview_NoValidValues: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/colormap/DatasetStyleColorMapPreview.tsx",
      ],
    },
  ],
  UI_Dataset_StyleColormap_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/categorical/DatasetStyleCategoricalCommon.tsx",
        "v2-console/src/dataset/style/colormap/DatasetStyleColorMap.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelectorEmptyState_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/state/DatasetStyleFieldSelectorEmptyState.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelectorErrorState_Message: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/state/DatasetStyleFieldSelectorErrorState.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelectorHistogram_BinTooltip: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/DatasetStyleFieldSelectorHistogram.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelectorMetadata_ValueCount: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/DatasetStyleFieldSelectorMetadata.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelector_Loading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/DatasetStyleFieldSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelector_NoFieldsFound: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/DatasetStyleFieldSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelector_Placeholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/DatasetStyleFieldSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelector_SearchPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/DatasetStyleFieldSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelector_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/DatasetStyleFieldSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleFieldSelector_UnavailableHeading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/fieldSelector/DatasetStyleFieldSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleHeatmap_3DNotice: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleHeatmap.tsx"],
    },
  ],
  UI_Dataset_StyleHeatmap_RadiusLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleHeatmap.tsx"],
    },
  ],
  UI_Dataset_StyleHeatmap_RampLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleHeatmap.tsx"],
    },
  ],
  UI_Dataset_StyleItem_ActiveBadge: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_CategoricalSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_CategoricalTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_ClusteringSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_ClusteringTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_ColormapSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_ColormapTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_GlobalColorSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_GlobalColorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_HeatmapSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_HeatmapTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_LabelSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_LabelTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_SelectSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_SelectTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_SizeGlobalSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_SizeGlobalTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_SizeScaleSubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_SizeScaleTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_VisibilitySubtitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleItem_VisibilityTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleItem.tsx"],
    },
  ],
  UI_Dataset_StyleLabelByField_FieldPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleLabelByField.tsx"],
    },
  ],
  UI_Dataset_StyleLabelFontWeight_Bold: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLabelFontWeight_Bolder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLabelFontWeight_Lighter: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLabelFontWeight_Normal: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AboveAfter: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AboveAlong: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AboveBefore: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AboveCenter: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AboveEnd: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AboveLeft: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AboveRight: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AboveStart: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_AlwaysHorizontal: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_BelowAfter: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_BelowAlong: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_BelowBefore: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_BelowCenter: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_BelowEnd: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_BelowLeft: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_BelowRight: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_BelowStart: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_Center: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_CenterAfter: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_CenterAlong: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_CenterBefore: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_CenterEnd: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_CenterLeft: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_CenterRight: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_CenterStart: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelPlacement_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelPlacement.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelScaleSlider_Description: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelScaleSlider.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabelScaleSlider_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/label/DatasetStyleLabelScaleSlider.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLabel_FontSize: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLabel_FontWeight: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLabel_HaloColor: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLabel_HaloSize: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLabel_TextColor: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/label/DatasetStyleLabel.tsx"],
    },
  ],
  UI_Dataset_StyleLibraryRemove_ConfirmButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRemove.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRemove_ConfirmMessage: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRemove.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRemove_Removing: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRemove.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRemove_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRemove.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRemove_Trigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRemove.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRename_ConfirmButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRename.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRename_ExtensionLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRename.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRename_FileNameLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRename.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRename_FileNamePlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRename.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRename_PromptMessage: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRename.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRename_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRename.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibraryRename_Trigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibraryRename.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibrarySelector_ChoosePlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibrarySelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibrarySelector_GroupDefault: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibrarySelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibrarySelector_GroupUploaded: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibrarySelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibrarySelector_NoIconsFound: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibrarySelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibrarySelector_SearchPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleLibrarySelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_RemoveErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_RemoveSuccessDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_RemoveSuccessTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_UnknownError: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_UpdateErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_UpdateSuccessDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_UpdateSuccessTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_UploadErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_UploadSuccessDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_UploadSuccessTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/dataset.style.library.api.ts",
      ],
    },
  ],
  UI_Dataset_StyleLibrary_UploadTrigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/library/DatasetStyleLibrary.tsx"],
    },
  ],
  UI_Dataset_StyleNav_Clustering: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyle.tsx"],
    },
  ],
  UI_Dataset_StyleNav_HeatmapOverridesHint: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyle.tsx"],
    },
  ],
  UI_Dataset_StyleNav_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyle.tsx"],
    },
  ],
  UI_Dataset_StyleNav_Size: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyle.tsx"],
    },
  ],
  UI_Dataset_StyleNav_Styling: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyle.tsx"],
    },
  ],
  UI_Dataset_StyleNav_Visibility: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyle.tsx"],
    },
  ],
  UI_Dataset_StylePanelBackButton_LeaveButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelBackButton_SaveAndLeaveButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelBackButton_UnsavedTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelContent_Description: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelContent.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelContent_NoPendingChanges: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelContent.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelContent_PendingChanges: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelContent.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelContent_SaveAndExitButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelContent.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelContent_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/DatasetStylePanelContent.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelErrorState_CloseButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/state/DatasetStylePanelErrorState.tsx",
      ],
    },
  ],
  UI_Dataset_StylePanelErrorState_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/panel/state/DatasetStylePanelErrorState.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSave_ErrorToast: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/dataset.style.api.ts"],
    },
  ],
  UI_Dataset_StyleScale_Building: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Buildings: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Cities: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_City: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Continent: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Counties: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_CountriesBig: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_CountriesSmall: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_County: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_MetropolitanArea: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Neighborhood: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Rooms: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_SmallBuilding: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_StateProvince: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_StatesProvinces: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Street: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Streets: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_Town: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleScale_World: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleScaleSlider.tsx"],
    },
  ],
  UI_Dataset_StyleSizeRangeByField_FieldPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleSizeRangeByField.tsx"],
    },
  ],
  UI_Dataset_StyleSizeRangeByField_NotSuitable: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleSizeRangeByField.tsx"],
    },
  ],
  UI_Dataset_StyleSizeRange_DisabledAlert: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/sizeRange/DatasetStyleSizeRangeAlert.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSizeRange_MaximumLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/sizeRange/DatasetStyleSizeRange.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSizeRange_MinimumLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/sizeRange/DatasetStyleSizeRange.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSizeRange_SelectTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/sizeRange/DatasetStyleSizeRange.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFillStyleSelector_CustomIcon: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFillStyleSelector_Placeholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_BackwardDiagonal: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_Circle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_Cross: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_DiagonalCross: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_Diamond: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_ForwardDiagonal: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_Horizontal: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_Solid: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_Square: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_Triangle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_Vertical: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolFill_X: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFillStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolMixed_ReplaceHint: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolMixed.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutlineStyleSelector_Placeholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutlineStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutline_Dash: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutlineStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutline_DashDot: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutlineStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutline_Dot: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutlineStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutline_DotDash: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutlineStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutline_LongDash: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutlineStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutline_ShortDash: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutlineStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutline_Solid: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutlineStyleSelector.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolOutline_WidthPlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutline.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbolSize_DisabledSuffix: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/symbol/DatasetStyleSymbolSize.tsx"],
    },
  ],
  UI_Dataset_StyleSymbol_FillLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/colormap/DatasetStyleColorMap.tsx",
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolFill.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbol_OutlineLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/symbol/DatasetStyleSymbolOutline.tsx",
      ],
    },
  ],
  UI_Dataset_StyleSymbol_SizeLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/symbol/DatasetStyleSymbolSize.tsx"],
    },
  ],
  UI_Dataset_StyleUploadDialog_BackButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_ErrorDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_ErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_FileTooLargeMessage: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_FileTooLargeTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_NameLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_NamePlaceholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_NameTooltip: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_SelectFileHint: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_SubmitButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_TitleNotAllowed: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_TitleRename: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleUploadDialog_TitleSelect: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/style/library/DatasetStyleUploadDialogContent.tsx",
      ],
    },
  ],
  UI_Dataset_StyleVisibility_AlwaysVisibleToggle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleVisibility.tsx"],
    },
  ],
  UI_Dataset_StyleVisibility_RangeDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleVisibility.tsx"],
    },
  ],
  UI_Dataset_StyleVisibility_RangeLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyleVisibility.tsx"],
    },
  ],
  UI_Dataset_Style_BackToOptions: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/style/DatasetStyle.tsx"],
    },
  ],
  UI_Dataset_TableActionLinkOr: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/state/DatasetTableFilterEmpty.tsx",
        "v2-console/src/dataset/table/state/DatasetTableSelectionOnlyEmpty.tsx",
      ],
    },
  ],
  UI_Dataset_TableActionsRowHover_DeleteConfirmAction: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsRowHover.tsx",
      ],
    },
  ],
  UI_Dataset_TableActionsRowHover_DeleteConfirmDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsRowHover.tsx",
      ],
    },
  ],
  UI_Dataset_TableActionsRowHover_DeleteConfirmTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsRowHover.tsx",
      ],
    },
  ],
  UI_Dataset_TableActionsRowHover_DeleteTrigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsRowHover.tsx",
      ],
    },
  ],
  UI_Dataset_TableActionsRowHover_ZoomTo: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsRowHover.tsx",
      ],
    },
  ],
  UI_Dataset_TableActionsSelectSelectedCount: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsSelect.tsx",
      ],
    },
  ],
  UI_Dataset_TableActionsSelect_ZoomTo: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/DatasetTableActionsSelect.tsx",
      ],
    },
  ],
  UI_Dataset_TableActionsZoom_ErrorDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/dataset.table.actions.utils.ts",
      ],
    },
  ],
  UI_Dataset_TableActionsZoom_ErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/actions/dataset.table.actions.utils.ts",
      ],
    },
  ],
  UI_Dataset_TableEmptyHintPrefix: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/state/DatasetTableFilterEmpty.tsx",
        "v2-console/src/dataset/table/state/DatasetTableSelectionOnlyEmpty.tsx",
      ],
    },
  ],
  UI_Dataset_TableFilterEmptyTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/table/state/DatasetTableFilterEmpty.tsx"],
    },
  ],
  UI_Dataset_TableFooterFilteredCount: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/table/DatasetTableFooter.tsx"],
    },
  ],
  UI_Dataset_TableFooterTotalCount: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/table/DatasetTableFooter.tsx"],
    },
  ],
  UI_Dataset_TableNoRowsSelectedHintPrefix: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/state/DatasetTableSelectionOnlyEmpty.tsx",
      ],
    },
  ],
  UI_Dataset_TableNoRowsSelectedTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/state/DatasetTableSelectionOnlyEmpty.tsx",
      ],
    },
  ],
  UI_Dataset_TableNumberOfShownRowsPostfix: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_TablePanelBackButtonConfirmDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/panel/DatasetTablePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_TablePanelBackButtonConfirmNote: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/panel/DatasetTablePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_TablePanelBackButtonConfirmTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/panel/DatasetTablePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_TablePanelBackButtonLeaveWithoutSaving: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/panel/DatasetTablePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_TablePanelBackButtonSaveAndLeave: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/panel/DatasetTablePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_TablePanelBackButtonSaveErrorMessage: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/panel/DatasetTablePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_TablePanelBackButtonSaveErrorTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/panel/DatasetTablePanelBackButton.tsx",
      ],
    },
  ],
  UI_Dataset_TableResetFiltersLink: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/state/DatasetTableFilterEmpty.tsx",
        "v2-console/src/dataset/table/state/DatasetTableSelectionOnlyEmpty.tsx",
      ],
    },
  ],
  UI_Dataset_TableSelectedOnlyToggleLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/DatasetTableSelectedOnlyToggle.tsx",
      ],
    },
  ],
  UI_Dataset_TableSelectionOnlyEmptyTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/state/DatasetTableSelectionOnlyEmpty.tsx",
      ],
    },
  ],
  UI_Dataset_TableTurnOffSelectionLink: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/table/state/DatasetTableSelectionOnlyEmpty.tsx",
      ],
    },
  ],
  UI_Dataset_UploadFile_ErrorTag: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DatasetUploadFile.tsx"],
    },
  ],
  UI_Dataset_Upload_Code_cache_no_data: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_cache_no_geometry: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_cache_no_source_state: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_dataset_match_failed: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_dataset_metadata_not_found: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_dataset_name_missing: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_dataset_not_found: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_dataset_pending_update_failed: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_geometry_not_supplied: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_invalid_range: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_member_not_found: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_no_member_selected: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_tabular_header_ambiguous: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_too_many_records: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_candidate_required: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_dataset_id_invalid: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_dataset_required: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_datatype_unsupported_format: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_file_corrupt: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_file_empty: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_file_not_found: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_file_read_error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_file_required: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_file_too_large: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_file_unsupported: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_geometry_format_unknown: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_geometry_lat_lon_same_field: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_geometry_resolve_failed: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_input_type_invalid: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_invalid_response: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/dataset.upload.utils.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_job_required: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_no_dataset_id: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_no_usable_members: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_object_type_action_required: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_object_type_company_not_supported: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_object_type_invalid: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_processing_failed: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/dataset.upload.utils.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_selected_member_missing: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_semantic_invalid: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_type_input_missing: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_type_no_applicable_fields: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_unauthorized: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_Code_upload_value_lookup_invalid_field: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ColumnMapping: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardObjectTypeColumnMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ColumnMapping_LoadingSheet: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardObjectTypeColumnMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ColumnMapping_Mutation_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardObjectTypeColumnMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_DragDrop_ChooseExcel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DragAndDropArea.tsx"],
    },
  ],
  UI_Dataset_Upload_DragDrop_DragDropOr: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DragAndDropArea.tsx"],
    },
  ],
  UI_Dataset_Upload_DragDrop_DropFile: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DragAndDropArea.tsx"],
    },
  ],
  UI_Dataset_Upload_DragDrop_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DragAndDropArea.tsx"],
    },
  ],
  UI_Dataset_Upload_DragDrop_MaxSize: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DragAndDropArea.tsx"],
    },
  ],
  UI_Dataset_Upload_DragDrop_NoFileSelected: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DragAndDropArea.tsx"],
    },
  ],
  UI_Dataset_Upload_DragDrop_TryAgain: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DragAndDropArea.tsx"],
    },
  ],
  UI_Dataset_Upload_Error_Unknown: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/dataset.upload.utils.ts"],
    },
  ],
  UI_Dataset_Upload_FileDetails_CompletionBlocked: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_FileDetails_CreateDataset: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_FileDetails_Description: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_FileDetails_Description_Placeholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_FileDetails_Name: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_FileDetails_Name_Placeholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_FileDetails_SectionHeading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_FileDetails_Spinner_Default: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_FileDetails_Spinner_Matching: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_File_IssuesDetected: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DatasetUploadFile.tsx"],
    },
  ],
  UI_Dataset_Upload_File_UploadAnotherFile: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DatasetUploadFile.tsx"],
    },
  ],
  UI_Dataset_Upload_Geometry_Display_LatLon: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Display_Single: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_FocusColumnButton: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Label_GeoJSON: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Label_Latitude: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Label_Longitude: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Label_UnnamedColumn: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Label_Wkt: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_NoGeometry: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_PreviewHeading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_SectionHeading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Select_Helper: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Select_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_Select_Placeholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Geometry_StaleSelection: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Heartbeat_AssistanceDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWSHeartbeatOverlays.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Heartbeat_AssistanceDismiss: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWSHeartbeatOverlays.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Heartbeat_AssistanceTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWSHeartbeatOverlays.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Heartbeat_SessionEndedDescription: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWSHeartbeatOverlays.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Heartbeat_SessionEndedDismiss: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWSHeartbeatOverlays.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Heartbeat_SessionEndedTitle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWSHeartbeatOverlays.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_IntroHeading: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_MatchPlacepoint: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_Mutation_Error: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_ObjectType_Addresses: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_ObjectType_Cadastre: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_ObjectType_Companies: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_ObjectType_Companies_Badge: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/settings/DatasetSettingsEnableLinking.tsx",
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_OwnGeometry: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_OwnGeometry_Helper: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_OwnGeometry_NoGeometry: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Mapping_RadioGroup_Label: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_MatchingLinkingChoice_BeOverride_Notice: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_MatchingSummary_Finish: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/update/DatasetUploadUpdateWizard.tsx",
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizard.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_data_entry_duplicate_primary_keys_CellRow: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_data_entry_duplicate_primary_keys_CellTrigger:
    [
      {
        label: "Datasets",
        url: "https://app.placepoint.no/map/datasets",
        files: ["v2-console/src/dataset/dataset.text.ts"],
      },
    ],
  UI_Dataset_Upload_ProcessingEvent_data_required_field_missing_ColumnRow: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_data_required_field_missing_ColumnTrigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_data_required_field_missing_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_data_type_mismatch_CellRow: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_data_type_mismatch_CellTrigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_field_duplicate_names_ColumnOnIndex: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_field_duplicate_names_ColumnTrigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_field_extra_ColumnOnIndex: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_field_extra_ColumnTrigger: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_geometry_not_supplied_Summary: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_geometry_not_supplied_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_no_data_Summary: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_no_data_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_tabular_header_ambiguous_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_too_many_records_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvent_upload_datatype_unsupported_format_Summary:
    [
      {
        label: "Datasets",
        url: "https://app.placepoint.no/map/datasets",
        files: ["v2-console/src/dataset/dataset.text.ts"],
      },
    ],
  UI_Dataset_Upload_ProcessingEvent_upload_datatype_unsupported_format_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_CapReached_Banner: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/processingEvents/DatasetUploadProcessingEvents.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_Generic_RowText: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_Generic_Summary: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/dataset.text.ts"],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_Generic_Title: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/processingEvents/DatasetUploadProcessingEventsCard.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_List_EmptySheet: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/processingEvents/DatasetUploadProcessingEventsList.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_List_ErrorsSummary: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/processingEvents/DatasetUploadProcessingEventsList.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_List_LoadingMore: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/processingEvents/DatasetUploadProcessingEventsList.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_List_MoreAvailable: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/processingEvents/DatasetUploadProcessingEventsList.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_NextIssue: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/processingEvents/DatasetUploadProcessingEventsCard.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_ProcessingEvents_PreviousIssue: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/processingEvents/DatasetUploadProcessingEventsCard.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_SheetSelection: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardSheetSelection.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_SheetSelection_ExcelSheetLabel: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardSheetSelection.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_SheetSelection_Placeholder: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/update/DatasetUploadUpdatePreview.tsx",
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardSheetSelection.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Table_LoadingRows: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/table/DatasetUploadTable.tsx"],
    },
  ],
  UI_Dataset_Upload_Table_LoadingRowsRange: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/table/DatasetUploadTable.tsx"],
    },
  ],
  UI_Dataset_Upload_Table_NoRows: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/table/DatasetUploadTable.tsx"],
    },
  ],
  UI_Dataset_Upload_Table_TotalRows: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/table/DatasetUploadTable.tsx"],
    },
  ],
  UI_Dataset_Upload_Table_TotalRowsZero: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/table/DatasetUploadTable.tsx"],
    },
  ],
  UI_Dataset_Upload_Trigger_UploadDataset: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/wizard/DatasetUploadWizard.tsx"],
    },
  ],
  UI_Dataset_Upload_Types_Input_Date: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardTypes.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Types_Input_DateTime: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardTypes.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Types_Input_Number: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardTypes.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Types_Input_Text: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardTypes.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Types_Input_TextArea: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardTypes.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Types_Input_Time: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardTypes.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Types_Input_Toggle: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardTypes.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_UpdatePreview_CompleteUpdate: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/update/DatasetUploadUpdatePreview.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_UpdatePreview_SelectSheet: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/update/DatasetUploadUpdatePreview.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_UpdatePreview_TableTop: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/update/DatasetUploadUpdatePreview.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Wizard_Back: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/wizard/Wizard.tsx"],
    },
  ],
  UI_Dataset_Upload_Wizard_Next: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/wizard/Wizard.tsx"],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Create_DataTypeMapping: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardTypes.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Create_FileDetails: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardFileDetails.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Create_FileUpload: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DatasetUploadFile.tsx"],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Create_GeometryTypeMapping: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardGeometry.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Create_MappingType: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Create_MatchingSummary: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/wizard/DatasetUploadWizard.tsx"],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Create_ObjectTypeMapping: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardObjectTypeColumnMapping.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Create_SheetSelection: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/wizard/DatasetUploadWizardSheetSelection.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Update_FileUpload: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/upload/DatasetUploadFile.tsx"],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Update_MatchingSummary: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/update/DatasetUploadUpdateWizard.tsx",
      ],
    },
  ],
  UI_Dataset_Upload_Wizard_StepTitle_Update_Preview: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/upload/update/DatasetUploadUpdatePreview.tsx",
      ],
    },
  ],
  UI_Daylight_Date: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_PlayDay: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_PlayYear: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_Reset: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetDaylightButton.tsx",
        "v2-console/src/map/widget/daylight/MapWidgetDaylightSuspender.tsx",
      ],
    },
  ],
  UI_Daylight_Season: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_SeasonFall: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_SeasonSpring: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_SeasonSummer: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_SeasonWinter: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_Shadows: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_SunLighting: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_Daylight_TimeOfDay: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/daylight/MapWidgetDaylight.tsx"],
    },
  ],
  UI_DemoCustom_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_DetailPlan_Header: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanPanel.tsx"],
    },
  ],
  UI_DetailPlan_LabelLandArea: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanOverviewModule.tsx"],
    },
  ],
  UI_DetailPlan_TabActors: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanActorsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
        "v2-console/src/detailPlan/panel/detailPlan.panel.config.tsx",
      ],
    },
  ],
  UI_DetailPlan_TabContacts: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanContactsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
        "v2-console/src/detailPlan/panel/detailPlan.panel.config.tsx",
      ],
    },
  ],
  UI_DetailPlan_TabDescription: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanDescriptionModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
        "v2-console/src/detailPlan/panel/detailPlan.panel.config.tsx",
      ],
    },
  ],
  UI_DetailPlan_TabDocuments: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanDocumentsModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
        "v2-console/src/detailPlan/panel/detailPlan.panel.config.tsx",
      ],
    },
  ],
  UI_DetailPlan_TabLinkedProfiles: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanLinkedProfilesModule.tsx",
        "v2-console/src/detailPlan/panel/DetailPlanOverview.tsx",
        "v2-console/src/detailPlan/panel/detailPlan.panel.config.tsx",
      ],
    },
  ],
  UI_DetailPlan_TabOverview: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/detailPlan/panel/DetailPlanOverviewModule.tsx",
        "v2-console/src/detailPlan/panel/detailPlan.panel.config.tsx",
      ],
    },
  ],
  UI_DetailPlan_Timeline: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanTimelineModule.tsx"],
    },
  ],
  UI_DetailPlan_TimelineAppealed: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanTimelineModule.tsx"],
    },
  ],
  UI_DetailPlan_TimelineCancelled: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanTimelineModule.tsx"],
    },
  ],
  UI_DetailPlan_TimelineDelayed: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanTimelineModule.tsx"],
    },
  ],
  UI_DetailPlan_TimelinePaused: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanTimelineModule.tsx"],
    },
  ],
  UI_DetailPlan_ZoomTo: [
    {
      label: "Detail Plan",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/detailPlan/panel/DetailPlanPanel.tsx"],
    },
  ],
  UI_ElevationProfile_BuildingsSeries: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
        "v2-console/src/map/widget/elevationProfile/map.widget.elevationProfile.restore.ts",
      ],
    },
  ],
  UI_ElevationProfile_ClosePanel: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileBottomPanel.tsx",
      ],
    },
  ],
  UI_ElevationProfile_Computing: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_DefaultLabel: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfile.tsx",
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileCreate.tsx",
      ],
    },
  ],
  UI_ElevationProfile_DrawingHint: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileCreate.tsx",
      ],
    },
  ],
  UI_ElevationProfile_Empty: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileList.tsx",
      ],
    },
  ],
  UI_ElevationProfile_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfile.tsx",
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_ListHeader: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileList.tsx",
      ],
    },
  ],
  UI_ElevationProfile_NewProfile: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfile.tsx",
      ],
    },
  ],
  UI_ElevationProfile_NoBuildingsIn2D: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfile.tsx",
      ],
    },
  ],
  UI_ElevationProfile_NoData: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_Remove: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileListItem.tsx",
      ],
    },
  ],
  UI_ElevationProfile_RemoveAll: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileList.tsx",
      ],
    },
  ],
  UI_ElevationProfile_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetElevationProfileButton.tsx",
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileSuspender.tsx",
      ],
    },
  ],
  UI_ElevationProfile_SelectHint: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileBottomPanel.tsx",
      ],
    },
  ],
  UI_ElevationProfile_StatsAvg: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_StatsAvgSlope: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_StatsGain: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_StatsLength: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_StatsLoss: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_StatsMax: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_StatsMaxSlope: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_StatsMin: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
      ],
    },
  ],
  UI_ElevationProfile_SwitchTo3D: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfile.tsx",
      ],
    },
  ],
  UI_ElevationProfile_TerrainSeries: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileChart.tsx",
        "v2-console/src/map/widget/elevationProfile/map.widget.elevationProfile.restore.ts",
      ],
    },
  ],
  UI_ElevationProfile_Toggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileListItem.tsx",
      ],
    },
  ],
  UI_ElevationProfile_ZoomTo: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileListItem.tsx",
      ],
    },
  ],
  UI_EnergyLabel_Buffbar_CertificationsAria: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/buffbar/CertificationsBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_Buffbar_CertificationsHoverDescription: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/energyLabel.text.ts"],
    },
  ],
  UI_EnergyLabel_Buffbar_EnergyAria: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/buffbar/EnergyLabelBuffbar.tsx"],
    },
  ],
  UI_EnergyLabel_Buffbar_EnergyHoverDescription: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/buffbar/EnergyLabelBuffbar.tsx"],
    },
  ],
  UI_EnergyLabel_Buffbar_EnergyHoverDescriptionOverall: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/buffbar/EnergyLabelBuffbar.tsx"],
    },
  ],
  UI_EnergyLabel_Category: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx"],
    },
  ],
  UI_EnergyLabel_Certification_NotRegistered: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/buffbar/CertificationsBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_Certification_Registered: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/buffbar/CertificationsBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_Certifications_Header: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/buffbar/CertificationsBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_Efficiency: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelChartGrid.tsx"],
    },
  ],
  UI_EnergyLabel_ElVsFossil: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelChartGrid.tsx"],
    },
  ],
  UI_EnergyLabel_Empty: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/EnergyLabelChart.tsx",
        "v2-console-ui/src/energyLabel/buffbar/EnergyLabelBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_Header: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/buffbar/EnergyLabelBuffbar.tsx"],
    },
  ],
  UI_EnergyLabel_High: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelChartGrid.tsx"],
    },
  ],
  UI_EnergyLabel_HighShare: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelChartGrid.tsx"],
    },
  ],
  UI_EnergyLabel_Issued: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx"],
    },
  ],
  UI_EnergyLabel_LabelCountTooltip: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelChartGrid.tsx"],
    },
  ],
  UI_EnergyLabel_Low: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelChartGrid.tsx"],
    },
  ],
  UI_EnergyLabel_LowShare: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelChartGrid.tsx"],
    },
  ],
  UI_EnergyLabel_Material: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx"],
    },
  ],
  UI_EnergyLabel_Outdated: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx",
        "v2-console-ui/src/energyLabel/buffbar/EnergyLabelBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_OutdatedCountTooltip: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelChartGrid.tsx"],
    },
  ],
  UI_EnergyLabel_OutdatedDescription: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx",
        "v2-console-ui/src/energyLabel/buffbar/EnergyLabelBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_Rated: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx"],
    },
  ],
  UI_EnergyLabel_Tek_MoreRatings: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/buffbar/CertificationsBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_Tek_RatingBuildingCount: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/energyLabel/buffbar/CertificationsBuffbar.tsx",
      ],
    },
  ],
  UI_EnergyLabel_YearOfConstruction: [
    {
      label: "Energy Label",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/energyLabel/EnergyLabelDetails.tsx"],
    },
  ],
  UI_Error_Generic_Description: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorGeneric.tsx"],
    },
  ],
  UI_Error_Generic_DetailsButton: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorGeneric.tsx"],
    },
  ],
  UI_Error_Generic_DialogTitle: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorGeneric.tsx"],
    },
  ],
  UI_Error_Generic_ImgAlt: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorGeneric.tsx"],
    },
  ],
  UI_Error_Generic_RestartButton: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorGeneric.tsx"],
    },
  ],
  UI_Error_Generic_Thanks: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorGeneric.tsx"],
    },
  ],
  UI_Error_Outdated: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorOutdated.tsx"],
    },
  ],
  UI_Error_Outdated_ImgAlt: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorOutdated.tsx"],
    },
  ],
  UI_Error_Outdated_UpdateButton: [
    {
      label: "Error",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/error/ErrorOutdated.tsx"],
    },
  ],
  UI_FilterAdmin_AddCategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCanvas.tsx",
        "v2-console/src/filter/admin/FilterRigGroupDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_AddField: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_AddSubcategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCanvas.tsx",
        "v2-console/src/filter/admin/FilterRigGroupDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_AddVariant: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantDialog.tsx"],
    },
  ],
  UI_FilterAdmin_AddVariantGroup: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCanvas.tsx",
        "v2-console/src/filter/admin/FilterRigVariantDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Advanced: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Applied: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Applied_DisplayNames: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Applied_Renames: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Applied_Texts: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Copied: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_CopyError: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_CopyPrompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Includes: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Includes_Codes: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Includes_Filters: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Includes_IndexFields: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Introduced: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Introduced_Filled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Introduced_Missing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Introduced_NoSource: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Issues: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Open: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiToolbar.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_Apply: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_Blocked: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_Current: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_Empty: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_Pasted: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_Placeholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_Step: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_Unchanged: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Paste_WrongShape: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Preview_Texts: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Refused: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_alreadyReferenced: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_entityColumn: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_entityText: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_inCatalog: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_invalidCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_labelWithoutText: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_notLabelCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_notRigOwned: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_unchanged: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_unknownCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Refused_unknownField: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Ai_Section_All: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Task: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Task_Placeholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Ai_TokenEstimate: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigAiDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Autosave_Discard: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Autosave_Found: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Autosave_Note: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Autosave_Restore: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Breadcrumb_Filter: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Cancel: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigAiDialog.tsx",
        "v2-console/src/filter/admin/FilterRigCreateDraftDialog.tsx",
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
        "v2-console/src/filter/admin/FilterRigFieldDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Categories: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_Collapse: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCanvas.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Conflict: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Copy: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCodeEditor.tsx",
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Create: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCreateDraftDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Delete: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
        "v2-console/src/filter/admin/FilterRigResultEditor.tsx",
        "v2-console/src/filter/admin/FilterRigSheetsEditor.tsx",
      ],
    },
  ],
  UI_FilterAdmin_DeleteDraft: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_DeleteDraft_Confirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Details_BaseRig: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Details_Code: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Details_Created: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Details_Description: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Details_Index: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Details_NoDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Changes: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigDiffView.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Draft_Side: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Entity_Toggle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEntityDiffList.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Entity_Unchanged: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEntityDiffList.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Inline: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigDiffView.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Kind_added: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Diff_Kind_changed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Diff_Kind_moved: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Diff_Kind_removed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Diff_Loading: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigDiffView.tsx",
        "v2-console/src/filter/admin/FilterRigEntityDiffList.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Diff_NoChanges: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigDiffView.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Published_Side: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Scope: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigDiffView.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Scope_All: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigDiffView.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_SideBySide: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigDiffView.tsx"],
    },
  ],
  UI_FilterAdmin_Diff_Unchanged: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigDiffView.tsx",
        "v2-console/src/filter/admin/FilterRigEntityDiffList.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Drafts: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVersionControl.tsx"],
    },
  ],
  UI_FilterAdmin_DragHandle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCanvas.tsx",
        "v2-console/src/filter/admin/FilterRigFieldRow.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx",
        "v2-console/src/filter/admin/FilterRigSheetFieldRow.tsx",
        "v2-console/src/filter/admin/FilterRigSheetsEditor.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Duplicate: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCreateDraftDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVersionControl.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Duplicate_NamePrefix: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCreateDraftDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Duplicate_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCreateDraftDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Edit: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVersionControl.tsx"],
    },
  ],
  UI_FilterAdmin_EditCategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCanvas.tsx",
        "v2-console/src/filter/admin/FilterRigGroupDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_EditField: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldRow.tsx"],
    },
  ],
  UI_FilterAdmin_EditSubcategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCanvas.tsx",
        "v2-console/src/filter/admin/FilterRigGroupDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_EditVariantGroup: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigVariantDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVariantGroupBlock.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Editor_Json: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Editor_Name: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Editor_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Error: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigHistoryDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVersionControl.tsx",
      ],
    },
  ],
  UI_FilterAdmin_FieldCount: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantGroupBlock.tsx"],
    },
  ],
  UI_FilterAdmin_Field_Apply: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
        "v2-console/src/filter/admin/FilterRigFieldDialog.tsx",
        "v2-console/src/filter/admin/FilterRigGroupDialog.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterChipDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Field_Category: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFieldDialog.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Field_Config: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_ConfigOtherKeys: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_DisplayName: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_FacetPath: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_FeatureCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_HelpText: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_HelpText_None: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_IsEnabled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_IsInverted: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_Json: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_None: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_Placement: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_Subcategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFieldDialog.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Field_Tags: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_Title_Edit: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_Title_New: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_Type: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_TypeTable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_Variant: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Field_VariantGroup: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Fold: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCodeEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Fold_Level: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCodeEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Fold_OpenAll: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCodeEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Format: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCodeEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Group_FeatureCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigGroupDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVariantDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_History: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigHistoryDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVersionControl.tsx",
      ],
    },
  ],
  UI_FilterAdmin_History_Created: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Current: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Draft_Description: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Empty: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Fork: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_ForkName: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Loading: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_NoContentChanges: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_OnlyOne: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Published_Description: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Restore: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_SelectHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Selected_Side: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_History_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigHistoryDialog.tsx"],
    },
  ],
  UI_FilterAdmin_InvalidJson: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigAiDialog.tsx",
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigFieldDialog.tsx",
        "v2-console/src/filter/admin/FilterRigJsonEditor.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Inverted: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldRow.tsx"],
    },
  ],
  UI_FilterAdmin_Issue_catalogUnavailable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_descriptionMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_duplicateFacetPath: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_featureTextMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_fieldNamePathNotSearchable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_fieldNotFacetable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_fieldNotFilterable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_fieldNotInIndex: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_fieldNotSearchable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_fieldTypeMismatch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_incompatibleType: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_missingFacetPath: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_missingType: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfChipNoRules: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfDuplicateKey: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfPlacementMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfRowEmpty: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfRowMissingChip: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfRuleOpIncompatible: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfRuleTargetDisabled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfRuleTargetMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfValueLabelShaped: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_qfValueNotAnOption: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_resultAddressPartOutside: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_resultGeometryMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_resultIdMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_resultIdentityPathsMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_resultOpenByUnknown: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_resultOpenPartial: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_resultPathNotInIndex: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_scaleIgnored: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetAggregateUnknown: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetDuplicateFieldPath: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetDuplicateKey: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetFieldNoHeader: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetMissingFeatureCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetMultipleIdentity: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetOpenByUnknown: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetOpenPathMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_sheetScaleInvalid: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_unitMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_variantGroupMixedLevels: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issue_variantGroupSingleVariant: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_catalog: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_chip: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_field: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_result: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_rig: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_row: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_sheet: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_sheetField: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Anchor_text: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Issues_Blocking_Many: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_Blocking_One: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_Catalog_FeatureCodes: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_Catalog_IndexFields: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_Catalog_TypeTables: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_Errors: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigIssuesTab.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_GoTo: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigIssuesTab.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_None: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigIssuesTab.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_OpenTab: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Issues_Warnings: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigIssuesTab.tsx"],
    },
  ],
  UI_FilterAdmin_LoadingDrafts: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVersionControl.tsx",
      ],
    },
  ],
  UI_FilterAdmin_NewDraft: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCreateDraftDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVersionControl.tsx",
      ],
    },
  ],
  UI_FilterAdmin_NewDraft_Name: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCreateDraftDialog.tsx"],
    },
  ],
  UI_FilterAdmin_NewDraft_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCreateDraftDialog.tsx"],
    },
  ],
  UI_FilterAdmin_NoCategories: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_NoDrafts: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVersionControl.tsx"],
    },
  ],
  UI_FilterAdmin_NoFields: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_Open: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVersionControl.tsx"],
    },
  ],
  UI_FilterAdmin_Overwrite: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Picker_Bound: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCombobox.tsx"],
    },
  ],
  UI_FilterAdmin_Picker_Catalog_Unavailable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodePicker.tsx",
        "v2-console/src/filter/admin/FilterRigIndexFieldPicker.tsx",
        "v2-console/src/filter/admin/FilterRigResultEditor.tsx",
        "v2-console/src/filter/admin/FilterRigSheetColumnPicker.tsx",
        "v2-console/src/filter/admin/FilterRigTypeTablePicker.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Picker_Clear: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCombobox.tsx"],
    },
  ],
  UI_FilterAdmin_Picker_CreateNew: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCombobox.tsx",
        "v2-console/src/filter/admin/FilterRigFeatureCodePicker.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Picker_Legend_Bound: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigIndexFieldPicker.tsx"],
    },
  ],
  UI_FilterAdmin_Picker_Legend_NotFilterable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigIndexFieldPicker.tsx"],
    },
  ],
  UI_FilterAdmin_Picker_NoMatch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCombobox.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterChipPicker.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Picker_NotFilterable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigIndexFieldPicker.tsx"],
    },
  ],
  UI_FilterAdmin_Picker_Search: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCombobox.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterChipPicker.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Picker_ShowAll: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFeatureCodePicker.tsx"],
    },
  ],
  UI_FilterAdmin_Picker_TypeTable_Kind_administrativeArea: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Picker_TypeTable_Kind_countries: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Picker_TypeTable_Kind_dedicated: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Picker_TypeTable_Kind_generic: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Picker_TypeTable_Kind_planClassification: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Picker_UseText: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCombobox.tsx"],
    },
  ],
  UI_FilterAdmin_Preview: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Published: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigHistoryDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVersionControl.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters_AddChip: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_AddRow: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_AddRule: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_ChipCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Chip_Json: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters_Chip_Title_Edit: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Chip_Title_New: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_CodeTaken: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters_Duplicate: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_EditChip: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters_EditRow: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_InRow: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipPicker.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Library: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Library_NoChips: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Library_SelectHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Library_UnusedOnly: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_NewChip: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipPicker.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_NoRows: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Orphans: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_PickChip: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipPicker.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Placement: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Placement_Category: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Placement_Panel: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Placement_Panel_Short: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Placement_Subcategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_RawJson: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters_RemoveChip: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_RemoveChip_Confirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_RemoveChip_Rows: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_RemoveRow: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_RemoveRow_Confirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_RemoveRule: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Revert: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_RowCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Row_Title_Edit: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Row_Title_New: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterRowDialog.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Amount: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Field: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_From: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Months: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_NoOps: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Op: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_OpIncompatible: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Op_Help: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Required: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_TargetDisabled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_TargetMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_To: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value_Help_between: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value_Help_eq: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value_Help_gt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value_Help_gte: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value_Help_in: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value_Help_lt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value_Help_not_empty: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Value_Help_within_last: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Values: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rule_Years: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Rules: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Tab_Editor: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters_Unplace: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx"],
    },
  ],
  UI_FilterAdmin_QuickFilters_Unused: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_QuickFilters_UnusedTag: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigQuickFilterChipPicker.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters_UsedIn: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigQuickFilterChipPicker.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
      ],
    },
  ],
  UI_FilterAdmin_QuickFilters_VisibleIn: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx"],
    },
  ],
  UI_FilterAdmin_Reload: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_RemoveCategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_RemoveField: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFieldRow.tsx"],
    },
  ],
  UI_FilterAdmin_RemoveSubcategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_RemoveVariant: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantDialog.tsx"],
    },
  ],
  UI_FilterAdmin_RemoveVariantGroup: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantGroupBlock.tsx"],
    },
  ],
  UI_FilterAdmin_RemoveVariantGroup_Confirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantGroupBlock.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Add: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Address: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Address_Parts: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Address_Path: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Address_Preview: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Geometry: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Geometry_Crs: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Geometry_Path: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Id: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Id_KeyHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Id_Path: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_IdentityPaths: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_IdentityPaths_Suggest: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Legacy: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Map: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Map_Display1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Result_Map_Display2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Result_Map_Display3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Result_Map_Select: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Map_Select_Suggest: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Open: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Open_By: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Open_LegacyHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Open_NavLayerHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Open_None: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Open_Opens: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Open_Path: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Optional: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Pick: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_PickMany: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_RawJson: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Remove: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Remove_Confirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Result_Tab_Editor: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigResultEditor.tsx"],
    },
  ],
  UI_FilterAdmin_RigDraftBadge: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigDraftBadge.tsx"],
    },
  ],
  UI_FilterAdmin_RigKey_Description: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_RigKey_Empty: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigResultEditor.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Save: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_SelectCategoryHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_SelectVariant: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantGroupBlock.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_AddColumn: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigSheetColumnPicker.tsx",
        "v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx",
        "v2-console/src/filter/admin/FilterRigSheetsEditor.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Sheets_AddSheet: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Dialog_Create: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Dialog_Edit: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_EditColumn: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldRow.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_EditSheet: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_FeatureCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Aggregate: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Aggregate_None: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Dialog: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_DisplayName: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Enabled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_FeatureCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Identity: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Json: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_ObjectRef: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Open: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_OpenBy: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_OpenPath: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_OpenPath_Self: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Path: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_RenderType: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_RenderType_Derived: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Scale: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Field_Unit: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Identity: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldRow.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_List: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_NoColumns: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_NoHeader: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldRow.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_NoSheets: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Opens: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldRow.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Path: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_RawJson: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_RemoveColumn: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetFieldRow.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_RemoveSheet: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_RemoveSheet_Confirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Root: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_SelectHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Shown: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Source_Self: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Sheets_Tab_Editor: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSheetsEditor.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Added: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Categories: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Changed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Chips: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigChangeSummary.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterBlock.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Summary_Columns: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Disabled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Enabled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Loading: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigChangeSummary.tsx",
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Summary_NoChanges: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_QuickFilters: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Removed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Reordered: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_RigKeys: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Rows: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Sheets: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_Unavailable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigChangeSummary.tsx",
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Summary_VariantGroupsAdded: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Summary_VariantGroupsRemoved: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigChangeSummary.tsx"],
    },
  ],
  UI_FilterAdmin_Tab_BaseFilters: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Tab_Canvas: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Tab_Details: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Tab_Diff: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Tab_ExportSheets: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigSheetDialog.tsx",
        "v2-console/src/filter/admin/FilterRigSheetsEditor.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Tab_Filter_Json: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Tab_Form: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFieldDialog.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterChipForm.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
        "v2-console/src/filter/admin/FilterRigSheetFieldDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Tab_Issues: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Tab_Json: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Tab_QuickFilters: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigQuickFilterLibrary.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Tab_Result: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigEditorDialog.tsx",
        "v2-console/src/filter/admin/FilterRigResultEditor.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Tab_Texts: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Tag_Level: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTagControls.tsx"],
    },
  ],
  UI_FilterAdmin_Tag_Level_Locked: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTagControls.tsx"],
    },
  ],
  UI_FilterAdmin_Tag_Level_None: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigTagControls.tsx",
        "v2-console/src/filter/admin/FilterRigVariantDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Tag_Other: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTagControls.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_CatalogNotLoaded: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTab.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Code: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
        "v2-console/src/filter/admin/FilterRigTextsTable.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Code_Derived: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Code_Prefix: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
        "v2-console/src/filter/admin/FilterRigTextsTable.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Code_Reset: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Column_code: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Column_description: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Column_findings: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Column_name: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Column_slot: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Create_AlreadyPending: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Create_InCatalog: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
        "v2-console/src/filter/admin/FilterRigTextsTable.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Create_InvalidCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
        "v2-console/src/filter/admin/FilterRigTextsTable.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Create_Submit: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Create_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Description: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFeatureTextFields.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_EditPending: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFeatureCodePicker.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Edit_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFeatureCodeCreateDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Family_none: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Filled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Finding_none: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Finding_notStandard: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Finding_otherRig: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Finding_slotFamilyMismatch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Finding_textMissing: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Finding_usedInSeveralSlots: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_GroupBy: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_GroupBy_family: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_GroupBy_finding: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_GroupBy_none: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_GroupBy_ownership: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_GroupBy_slot: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_GroupBy_state: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Intro: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTab.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Json_Invalid: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTab.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Name: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFeatureTextFields.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_NoMatch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_None: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigTextsTab.tsx",
        "v2-console/src/filter/admin/FilterRigTextsTable.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Texts_Ownership_entity: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Ownership_otherRig: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Ownership_rigOwned: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Pending: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigFeatureCodePicker.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_ReadOnly: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Rename: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Rename_AlreadyReferenced: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Rename_NotRigOwned: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Rename_Unchanged: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_RenamedFrom: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Renames_Json: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTab.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Search: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Show: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Show_all: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Show_findings: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Show_pending: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_category: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_column: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_displayName: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_featureCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_placeholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_quickFilterChip: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_quickFilterRow: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_sheet: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_subcategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_variant: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_Slot_variantGroup: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_State_catalog: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_State_pending: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_UndoRename: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_Unfilled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTable.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_UsedIn: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/filterAdmin.text.ts"],
    },
  ],
  UI_FilterAdmin_Texts_View_Editor: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTab.tsx"],
    },
  ],
  UI_FilterAdmin_Texts_View_Json: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigTextsTab.tsx"],
    },
  ],
  UI_FilterAdmin_ToggleEnabled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFieldRow.tsx",
        "v2-console/src/filter/admin/FilterRigSheetFieldRow.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Ungrouped: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigCanvas.tsx",
        "v2-console/src/filter/admin/FilterRigFieldDialog.tsx",
      ],
    },
  ],
  UI_FilterAdmin_Updated: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigEditorDialog.tsx"],
    },
  ],
  UI_FilterAdmin_VariantGroup: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigCanvas.tsx"],
    },
  ],
  UI_FilterAdmin_VariantGroup_DuplicateVariant: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantDialog.tsx"],
    },
  ],
  UI_FilterAdmin_VariantGroup_EmptyHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantDialog.tsx"],
    },
  ],
  UI_FilterAdmin_VariantGroup_FeatureCode: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantDialog.tsx"],
    },
  ],
  UI_FilterAdmin_VariantGroup_Fields: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantDialog.tsx"],
    },
  ],
  UI_FilterAdmin_VariantGroup_Level: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigVariantDialog.tsx",
        "v2-console/src/filter/admin/FilterRigVariantGroupBlock.tsx",
      ],
    },
  ],
  UI_FilterAdmin_VariantGroup_NoVariants: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/admin/FilterRigFieldDialog.tsx",
        "v2-console/src/filter/admin/FilterRigSubcategoryItems.tsx",
      ],
    },
  ],
  UI_FilterAdmin_VariantGroup_ToggleEnabled: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantGroupBlock.tsx"],
    },
  ],
  UI_FilterAdmin_VariantGroup_Variants: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVariantDialog.tsx"],
    },
  ],
  UI_FilterAdmin_Variant_NoFields: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigSubcategoryItems.tsx"],
    },
  ],
  UI_FilterAdmin_VersionMenu: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/admin/FilterRigVersionControl.tsx"],
    },
  ],
  UI_Filter_AiOpener_Card: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterAiOpener.tsx"],
    },
  ],
  UI_Filter_Back: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterPanelHeader.tsx",
        "v2-console/src/filter/FilterPanelNavList.tsx",
      ],
    },
  ],
  UI_Filter_BooleanField_All: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterBooleanControl.tsx"],
    },
  ],
  UI_Filter_BooleanField_No: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterBooleanControl.tsx"],
    },
  ],
  UI_Filter_BooleanField_Yes: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterBooleanControl.tsx"],
    },
  ],
  UI_Filter_ByCategory: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFields.tsx"],
    },
  ],
  UI_Filter_Chat_AlreadyInForm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_AlreadySet: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ApplyAgain: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ApplyFailed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ApplyPatch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_AreaLevel_BSU: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_AreaLevel_CNTY: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_AreaLevel_MUNIC: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_AreaLevel_POST: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_AreaLevel_SAREA: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_ChangeAdded: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ChangeRemoved: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ChangeReplaced: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ChangedSince: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_Current: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_CurrentValue: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatExplainCard.tsx"],
    },
  ],
  UI_Filter_Chat_DeleteDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatSidecar.tsx"],
    },
  ],
  UI_Filter_Chat_DeleteTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatSidecar.tsx"],
    },
  ],
  UI_Filter_Chat_EmptyDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_EmptyTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChat.tsx"],
    },
  ],
  UI_Filter_Chat_ExplainHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_ExplainTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatExplainCard.tsx"],
    },
  ],
  UI_Filter_Chat_GoToField: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/chat/FilterChatActionCard.tsx",
        "v2-console/src/filter/chat/FilterChatExplainCard.tsx",
      ],
    },
  ],
  UI_Filter_Chat_Level_Ekspert: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Loading: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChat.tsx"],
    },
  ],
  UI_Filter_Chat_New: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatSidecar.tsx"],
    },
  ],
  UI_Filter_Chat_OpenField: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/chat/FilterChatActionCard.tsx",
        "v2-console/src/filter/chat/FilterChatExplainCard.tsx",
      ],
    },
  ],
  UI_Filter_Chat_Placeholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChat.tsx"],
    },
  ],
  UI_Filter_Chat_ProposalCountLabel: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ProposalCounting: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ProposalTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_ResetDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatSidecar.tsx"],
    },
  ],
  UI_Filter_Chat_Retry: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChat.tsx"],
    },
  ],
  UI_Filter_Chat_Suggestion: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChat.tsx"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCadastres_1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCadastres_1_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCadastres_2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCadastres_2_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCadastres_3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCadastres_3_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCompanies_1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCompanies_1_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCompanies_2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCompanies_2_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCompanies_3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_NOCompanies_3_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEBuildingRights_1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEBuildingRights_1_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEBuildingRights_2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEBuildingRights_2_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEBuildingRights_3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEBuildingRights_3_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEDetailPlans_1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEDetailPlans_1_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEDetailPlans_2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEDetailPlans_2_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEDetailPlans_3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEDetailPlans_3_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEInfrastructure_1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEInfrastructure_1_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEInfrastructure_2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEInfrastructure_2_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEInfrastructure_3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEInfrastructure_3_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEPermits_1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEPermits_1_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEPermits_2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEPermits_2_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEPermits_3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEPermits_3_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEProperties_1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEProperties_1_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEProperties_2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEProperties_2_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEProperties_3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SEProperties_3_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SETenders_1: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SETenders_1_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SETenders_2: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SETenders_2_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SETenders_3: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/filter.chat.constants.ts"],
    },
  ],
  UI_Filter_Chat_Suggestion_SETenders_3_Prompt: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_SuggestionsTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_Thinking: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChat.tsx"],
    },
  ],
  UI_Filter_Chat_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatSidecar.tsx"],
    },
  ],
  UI_Filter_Chat_Toggle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Chat_UndoFailed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_Chat_UndoPatch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/chat/FilterChatActionCard.tsx"],
    },
  ],
  UI_Filter_ChooseFilters: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterSelectorDialog.tsx",
        "v2-console/src/filter/FilterSelectorHover.tsx",
      ],
    },
  ],
  UI_Filter_ChooseFilters_Expand: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSelectorHover.tsx"],
    },
  ],
  UI_Filter_ChooseFilters_ShowLess: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSelectorDialog.tsx"],
    },
  ],
  UI_Filter_ChooseFilters_ShowMore: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSelectorDialog.tsx"],
    },
  ],
  UI_Filter_Close: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterPanelHeader.tsx",
        "v2-console/src/filter/FilterPanelNav.tsx",
      ],
    },
  ],
  UI_Filter_ColAddress: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_ColCadastreNumber: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_ColMunicipality: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_CompanyGroupChildrenError: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCompanyGroupControl.tsx"],
    },
  ],
  UI_Filter_CompanyGroupNotIndexed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCompanyGroupControl.tsx"],
    },
  ],
  UI_Filter_CompanyGroupPick: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCompanyGroupControl.tsx"],
    },
  ],
  UI_Filter_CompanyGroupSearchPlaceholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCompanyGroupControl.tsx"],
    },
  ],
  UI_Filter_CompanyNamePatternPick: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCompanyNameControl.tsx"],
    },
  ],
  UI_Filter_CompanyNameSearchPlaceholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCompanyNameControl.tsx"],
    },
  ],
  UI_Filter_CompanyRefPatternPick: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCompanyRefControl.tsx"],
    },
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerCompanyRef.tsx"],
    },
  ],
  UI_Filter_CompanyRefSearchPlaceholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCompanyRefControl.tsx"],
    },
  ],
  UI_Filter_DateFrom: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterDateRangeControl.tsx"],
    },
  ],
  UI_Filter_DateTo: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterDateRangeControl.tsx"],
    },
  ],
  UI_Filter_DeleteSavedSearch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_DeselectAll: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterSelectorDialog.tsx",
        "v2-console/src/filter/FilterSelectorHover.tsx",
        "v2-console/src/filter/FilterSelectorHoverSectionRow.tsx",
      ],
    },
  ],
  UI_Filter_DetailClose: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterSidecar.tsx",
        "v2-console/src/filter/FilterSidecarDetail.tsx",
      ],
    },
  ],
  UI_Filter_Detail_BackToChat: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSidecarDetail.tsx"],
    },
  ],
  UI_Filter_DialogCancel: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSelectorDialog.tsx"],
    },
  ],
  UI_Filter_DialogDone: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSelectorDialog.tsx"],
    },
  ],
  UI_Filter_DialogReset: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSelectorDialog.tsx"],
    },
  ],
  UI_Filter_ExcludeHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterField.tsx",
        "v2-console/src/filter/section/FilterVariantBlockView.tsx",
      ],
    },
  ],
  UI_Filter_Export: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterResultsExportButton.tsx",
        "v2-console/src/filter/FilterResultsExportDialog.tsx",
        "v2-console/src/filter/filter.tracking.ts",
      ],
    },
  ],
  UI_Filter_ExportCancel: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportConfirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportDialogTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportEmpty: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportButton.tsx"],
    },
  ],
  UI_Filter_ExportFailed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportFilename: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportLargeHint: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterResultsExportDialog.tsx",
        "v2-console/src/filter/filter.tracking.ts",
      ],
    },
  ],
  UI_Filter_ExportRelatedTable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportRelatedTables: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportScope: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportScopeAll: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportScopeAllLead: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportScopeResult: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_ExportTooLarge: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportButton.tsx"],
    },
  ],
  UI_Filter_Exporting: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsExportDialog.tsx"],
    },
  ],
  UI_Filter_FacetsError: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_FilterBy: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_FilterManually: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFields.tsx"],
    },
  ],
  UI_Filter_FilterReset: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterField.tsx",
        "v2-console/src/filter/FilterHasContentPill.tsx",
      ],
    },
  ],
  UI_Filter_FilterUnavailable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterDisabledControl.tsx"],
    },
  ],
  UI_Filter_FollowExtent: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterExtentToggle.tsx",
        "v2-console/src/filter/filter.tracking.ts",
      ],
    },
  ],
  UI_Filter_FooterReset: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_FooterResetToSaved: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_From: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterRangeInputControl.tsx"],
    },
  ],
  UI_Filter_GoBack: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelNavList.tsx"],
    },
  ],
  UI_Filter_Header: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterPanelHeader.tsx",
        "v2-console/src/filter/FilterPanelNav.tsx",
        "v2-console/src/filter/legend/FilterMapLegend.tsx",
      ],
    },
  ],
  UI_Filter_HideResults: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_Legend_Cluster: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/legend/FilterMapLegend.tsx"],
    },
  ],
  UI_Filter_Legend_Extent: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/legend/FilterMapLegend.tsx"],
    },
  ],
  UI_Filter_Legend_Header: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/legend/FilterMapLegend.tsx"],
    },
  ],
  UI_Filter_Legend_Single: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/legend/FilterMapLegend.tsx"],
    },
  ],
  UI_Filter_Loading: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterPanelFooter.tsx",
        "v2-console/src/filter/FilterSidecar.tsx",
      ],
    },
  ],
  UI_Filter_MoreSaveOptions: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_Nav_StartNew: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelNav.tsx"],
    },
  ],
  UI_Filter_NoFilters: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFields.tsx"],
    },
  ],
  UI_Filter_NoFiltersMatch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_NoResults: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_NoSavedSearches: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_OrderButton: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterResultsTableOrder.tsx"],
    },
  ],
  UI_Filter_OrgNumberSearchPlaceholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterOrgNumberControl.tsx"],
    },
  ],
  UI_Filter_QuickFilterMore: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/quickFilter/FilterQuickFilterRow.tsx"],
    },
  ],
  UI_Filter_ResultNoun_Companies: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/filter.utils.spec.ts",
        "v2-console/src/filter/filter.utils.ts",
      ],
    },
  ],
  UI_Filter_ResultNoun_Company: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.utils.ts"],
    },
  ],
  UI_Filter_ResultNoun_Properties: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/filter.utils.spec.ts",
        "v2-console/src/filter/filter.utils.ts",
      ],
    },
  ],
  UI_Filter_ResultNoun_Property: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/filter.utils.spec.ts",
        "v2-console/src/filter/filter.utils.ts",
      ],
    },
  ],
  UI_Filter_ResultNoun_Result: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/filter.utils.spec.ts",
        "v2-console/src/filter/filter.utils.ts",
      ],
    },
  ],
  UI_Filter_Results: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/filter.utils.spec.ts",
        "v2-console/src/filter/filter.utils.ts",
      ],
    },
  ],
  UI_Filter_ResultsClose: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSidecar.tsx"],
    },
  ],
  UI_Filter_ResultsExpand: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSidecar.tsx"],
    },
  ],
  UI_Filter_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterPrefetch.tsx",
        "v2-console/src/filter/FilterSidebarItem.tsx",
        "v2-console/src/filter/FilterSidecar.tsx",
      ],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_Filter_Save: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_SaveAs: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_SaveAsNew: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_SaveSearchCancel: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSaveSearchDialog.tsx"],
    },
  ],
  UI_Filter_SaveSearchConfirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSaveSearchDialog.tsx"],
    },
  ],
  UI_Filter_SaveSearchDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSaveSearchDialog.tsx"],
    },
  ],
  UI_Filter_SaveSearchDuplicate: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSaveSearchDialog.tsx"],
    },
  ],
  UI_Filter_SaveSearchName: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSaveSearchDialog.tsx"],
    },
  ],
  UI_Filter_SaveSearchTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSaveSearchDialog.tsx"],
    },
  ],
  UI_Filter_SavedSearches: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_Saved_Cancel: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Confirm: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_CopySuffix: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Delete: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/saved/FilterSavedFilterRow.tsx",
        "v2-console/src/filter/saved/FilterSavedGroupHeader.tsx",
      ],
    },
  ],
  UI_Filter_Saved_DeleteDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_DeleteGroupDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_DeleteGroupTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_DeleteTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Draft: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterDraftBadge.tsx",
        "v2-console/src/filter/filter.tracking.ts",
      ],
    },
  ],
  UI_Filter_Saved_Duplicate: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFilterRow.tsx"],
    },
  ],
  UI_Filter_Saved_EmptyDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersEmpty.tsx"],
    },
  ],
  UI_Filter_Saved_EmptyTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersEmpty.tsx"],
    },
  ],
  UI_Filter_Saved_More: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/saved/FilterSavedFilterRow.tsx",
        "v2-console/src/filter/saved/FilterSavedFiltersSection.tsx",
        "v2-console/src/filter/saved/FilterSavedGroupHeader.tsx",
      ],
    },
  ],
  UI_Filter_Saved_NewGroup: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/filter.tracking.ts",
        "v2-console/src/filter/saved/FilterSavedFiltersSection.tsx",
      ],
    },
  ],
  UI_Filter_Saved_NewGroupDefaultName: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_NoMatches: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersEmpty.tsx"],
    },
  ],
  UI_Filter_Saved_RemoveAll: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/filter.tracking.ts",
        "v2-console/src/filter/saved/FilterSavedFiltersSection.tsx",
      ],
    },
  ],
  UI_Filter_Saved_RemoveAllDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_RemoveAllTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Rename: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/saved/FilterSavedFilterRow.tsx",
        "v2-console/src/filter/saved/FilterSavedGroupHeader.tsx",
      ],
    },
  ],
  UI_Filter_Saved_Search: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_TimeFilter: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Title_One: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Updated_any: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Updated_last30Days: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Updated_last7Days: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Updated_lastHour: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_Saved_Updated_today: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/saved/FilterSavedFiltersSection.tsx"],
    },
  ],
  UI_Filter_SearchError: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterPanelFooter.tsx",
        "v2-console/src/filter/FilterSidecar.tsx",
      ],
    },
  ],
  UI_Filter_SearchFailed: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_SearchFilters: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterSearch.tsx",
        "v2-console/src/filter/FilterSelectorDialog.tsx",
        "v2-console/src/filter/FilterSelectorHoverSectionRow.tsx",
        "v2-console/src/filter/FilterSidecarSearch.tsx",
      ],
    },
  ],
  UI_Filter_SearchRetry: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_Search_Close: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSidecarSearch.tsx"],
    },
  ],
  UI_Filter_Search_EmptyDescription: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSidecarSearch.tsx"],
    },
  ],
  UI_Filter_Search_EmptyTitle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSidecarSearch.tsx"],
    },
  ],
  UI_Filter_Search_Title: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSidecarSearch.tsx"],
    },
  ],
  UI_Filter_Search_Toggle: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterSearchToggle.tsx"],
    },
  ],
  UI_Filter_Searching: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_SectionActiveCount: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterPanelFields.tsx",
        "v2-console/src/filter/FilterSidecarDetail.tsx",
        "v2-console/src/filter/section/FilterSectionBody.tsx",
        "v2-console/src/filter/section/FilterVariantBlockView.tsx",
      ],
    },
  ],
  UI_Filter_SectionOpenDetail: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFields.tsx"],
    },
  ],
  UI_Filter_SelectAll: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterSelectorDialog.tsx",
        "v2-console/src/filter/FilterSelectorHover.tsx",
        "v2-console/src/filter/FilterSelectorHoverSectionRow.tsx",
      ],
    },
  ],
  UI_Filter_SelfSuggestError: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterSelfSuggestControl.tsx"],
    },
  ],
  UI_Filter_SelfSuggestInResults: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterSelfSuggestControl.tsx"],
    },
  ],
  UI_Filter_SelfSuggestOutsideResults: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterSelfSuggestControl.tsx"],
    },
  ],
  UI_Filter_SelfSuggestPick: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/filter.text.ts"],
    },
  ],
  UI_Filter_SelfSuggestSearchPlaceholder: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterSelfSuggestControl.tsx"],
    },
  ],
  UI_Filter_SelfSuggestTypeToSearch: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterSelfSuggestControl.tsx"],
    },
  ],
  UI_Filter_ServiceUnavailable: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelNavList.tsx"],
    },
  ],
  UI_Filter_ShowAdvanced: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/section/FilterAdvancedFoldout.tsx",
        "v2-console/src/filter/section/FilterSectionBody.tsx",
      ],
    },
  ],
  UI_Filter_ShowLess: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/controls/FilterCheckboxGroupControl.tsx",
        "v2-console/src/filter/section/FilterSectionBody.tsx",
      ],
    },
  ],
  UI_Filter_ShowMore: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterCheckboxGroupControl.tsx"],
    },
  ],
  UI_Filter_ShowResults: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterPanelFooter.tsx"],
    },
  ],
  UI_Filter_TagEmpty: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/tag/FilterResultsTagButton.tsx"],
    },
  ],
  UI_Filter_TagResults: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/tag/FilterResultsTagButton.tsx"],
    },
  ],
  UI_Filter_TagResultsAll: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/tag/FilterResultsTagButton.tsx"],
    },
  ],
  UI_Filter_TagResultsSelected: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/tag/FilterResultsTagButton.tsx"],
    },
  ],
  UI_Filter_TagTooLarge: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/tag/FilterResultsTagButton.tsx"],
    },
  ],
  UI_Filter_To: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/controls/FilterRangeInputControl.tsx"],
    },
  ],
  UI_Filter_Unknown: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterMapLayer.tsx",
        "v2-console/src/filter/FilterResultsSheetTable.tsx",
      ],
    },
  ],
  UI_Filter_VariantHiddenActive: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/section/FilterVariantBlockView.tsx"],
    },
  ],
  UI_Filter_ZoomTo: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/filter/FilterResultsSheetTable.tsx",
        "v2-console/src/filter/filter.tracking.ts",
      ],
    },
  ],
  UI_Filter_ZoomToResults: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterZoomToResultsButton.tsx"],
    },
  ],
  UI_Filter_ZoomToResultsFollowExtent: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/filter/FilterZoomToResultsButton.tsx"],
    },
  ],
  UI_FinancialChart_AmountsInThousands: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/components/financialChart/FinancialChart.tsx"],
    },
  ],
  UI_FinancialChart_SelectValues: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/components/financialChart/FinancialChart.tsx"],
    },
  ],
  UI_FinancialChart_Series_EBIT: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/components/financialChart/financialChart.constants.ts",
        "v2-console/src/components/financialChart/financialChart.types.ts",
      ],
    },
  ],
  UI_FinancialChart_Series_EBITDA: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/components/financialChart/financialChart.constants.ts",
        "v2-console/src/components/financialChart/financialChart.types.ts",
      ],
    },
  ],
  UI_FinancialChart_Series_EBT: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/components/financialChart/financialChart.constants.ts",
        "v2-console/src/components/financialChart/financialChart.types.ts",
      ],
    },
  ],
  UI_FinancialChart_Series_Equity: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/components/financialChart/financialChart.constants.ts",
        "v2-console/src/components/financialChart/financialChart.types.ts",
      ],
    },
  ],
  UI_FinancialChart_Series_Liabilities: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/components/financialChart/financialChart.constants.ts",
        "v2-console/src/components/financialChart/financialChart.types.ts",
      ],
    },
  ],
  UI_FinancialChart_Series_NetIncome: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/components/financialChart/financialChart.constants.ts",
        "v2-console/src/components/financialChart/financialChart.types.ts",
      ],
    },
  ],
  UI_FinancialChart_Series_Revenue: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/components/financialChart/financialChart.constants.ts",
        "v2-console/src/components/financialChart/financialChart.types.ts",
      ],
    },
  ],
  UI_FinancialChart_Series_TotalAssets: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/components/financialChart/financialChart.constants.ts",
        "v2-console/src/components/financialChart/financialChart.types.ts",
      ],
    },
  ],
  UI_FinancialChart_ShapeBar: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/components/financialChart/FinancialChart.tsx"],
    },
  ],
  UI_FinancialChart_ShapeLine: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/components/financialChart/FinancialChart.tsx"],
    },
  ],
  UI_FinancialChart_ShowInChart: [
    {
      label: "Components",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/components/financialChart/FinancialChart.tsx"],
    },
  ],
  UI_FocusMode_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Fullscreen_Enable_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/toolbar/MapToolbarItemFullscreen.tsx"],
    },
  ],
  UI_GlobalSearch_Empty: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchDropdownBody.tsx"],
    },
  ],
  UI_GlobalSearch_Error: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/globalSearch/GlobalSearchDropdownBody.tsx",
        "v2-console/src/globalSearch/log/GlobalSearchLog.tsx",
      ],
    },
  ],
  UI_GlobalSearch_GroupAddresses_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/globalSearch.utils.ts"],
    },
  ],
  UI_GlobalSearch_GroupAll_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/globalSearch/GlobalSearchGroupFilter.tsx",
        "v2-console/src/globalSearch/globalSearch.scope.constants.ts",
      ],
    },
  ],
  UI_GlobalSearch_GroupBuildings_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/globalSearch/globalSearch.scope.constants.ts",
        "v2-console/src/globalSearch/globalSearch.utils.ts",
      ],
    },
  ],
  UI_GlobalSearch_GroupCompanies_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/globalSearch/globalSearch.scope.constants.ts",
        "v2-console/src/globalSearch/globalSearch.utils.ts",
      ],
    },
  ],
  UI_GlobalSearch_GroupGoogle_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/globalSearch/GlobalSearchGroupFilter.tsx",
        "v2-console/src/globalSearch/globalSearch.utils.ts",
      ],
    },
  ],
  UI_GlobalSearch_GroupHeader: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchGroupFilter.tsx"],
    },
  ],
  UI_GlobalSearch_GroupPlaces_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/globalSearch/globalSearch.scope.constants.ts",
        "v2-console/src/globalSearch/globalSearch.utils.ts",
      ],
    },
  ],
  UI_GlobalSearch_GroupProperties_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/globalSearch/globalSearch.scope.constants.ts",
        "v2-console/src/globalSearch/globalSearch.utils.ts",
      ],
    },
  ],
  UI_GlobalSearch_GroupRecent_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/globalSearch.utils.ts"],
    },
  ],
  UI_GlobalSearch_HotkeyClose: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchHotKeys.tsx"],
    },
  ],
  UI_GlobalSearch_HotkeyKeyNavigateTypes: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchHotKeys.tsx"],
    },
  ],
  UI_GlobalSearch_HotkeyKeySelect: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchHotKeys.tsx"],
    },
  ],
  UI_GlobalSearch_HotkeyKeyToggle: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchHotKeys.tsx"],
    },
  ],
  UI_GlobalSearch_HotkeyNavigateItems: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchHotKeys.tsx"],
    },
  ],
  UI_GlobalSearch_HotkeyNavigateTypes: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchHotKeys.tsx"],
    },
  ],
  UI_GlobalSearch_HotkeySelect: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchHotKeys.tsx"],
    },
  ],
  UI_GlobalSearch_HotkeyToogle: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchHotKeys.tsx"],
    },
  ],
  UI_GlobalSearch_PlaceholderBuildings_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/globalSearch.scope.constants.ts"],
    },
  ],
  UI_GlobalSearch_PlaceholderCompanies_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/globalSearch.scope.constants.ts"],
    },
  ],
  UI_GlobalSearch_PlaceholderPlaces_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/globalSearch.scope.constants.ts"],
    },
  ],
  UI_GlobalSearch_PlaceholderProperties_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/globalSearch.scope.constants.ts"],
    },
  ],
  UI_GlobalSearch_Placeholder_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/globalSearch.scope.constants.ts"],
    },
  ],
  UI_GlobalSearch_RemoveAllSearchLogs: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/log/GlobalSearchLog.tsx"],
    },
  ],
  UI_GlobalSearch_RemoveSearchLog: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchResultListItem.tsx"],
    },
  ],
  UI_GlobalSearch_ScopeMenuLabel_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchScopeToggle.tsx"],
    },
  ],
  UI_GlobalSearch_ScopeToggle_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchScopeToggle.tsx"],
    },
  ],
  UI_GlobalSearch_SearchLogsEmpty: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/log/GlobalSearchLog.tsx"],
    },
  ],
  UI_GlobalSearch_SearchLogsHeader: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/log/globalSearch.log.utils.ts"],
    },
  ],
  UI_GlobalSearch_ZoomToAllSearchLogs: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/log/GlobalSearchLog.tsx"],
    },
  ],
  UI_GlobalSearch_ZoomToGroup: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchResultList.tsx"],
    },
  ],
  UI_GlobalSearch_ZoomTo_Root: [
    {
      label: "Search",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/globalSearch/GlobalSearchBar.tsx"],
    },
  ],
  UI_Help_Root: [
    {
      label: "Help",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/help/help.utils.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sidebar/MapSidebar.tsx",
        "v2-console/src/map/sidebar/MapSidebarHelpMenu.tsx",
      ],
    },
  ],
  UI_Home_AllProjects_Root: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/project/menu/ProjectMenuControls.tsx",
        "v2-console/src/project/menu/ProjectMenuGrid.tsx",
      ],
    },
  ],
  UI_Home_ExternalProjects_Root: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/project/menu/ProjectMenuControls.tsx",
        "v2-console/src/project/menu/ProjectMenuGrid.tsx",
      ],
    },
  ],
  UI_Home_PrivateProjectsSidebar_Root: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Home_PrivateProjects_Root: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/project/menu/ProjectMenuControls.tsx",
        "v2-console/src/project/menu/ProjectMenuGrid.tsx",
      ],
    },
  ],
  UI_Home_Recent_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Home_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Home_TenantProjectsSidebar_Root: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Home_Tenant_Admin_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Home_Tenant_Deleted_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Home_Tenant_Projects_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Home_Tenant_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Home_Toolbar_Description: [
    {
      label: "Home",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/home/HomeToolbar.tsx"],
    },
  ],
  UI_Home_Toolbar_PremiumBadge_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Home_Toolbar_Title: [
    {
      label: "Home",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/home/HomeToolbar.tsx"],
    },
  ],
  UI_Home_UserProjects_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_HousingCooperativeShareLabel_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/transactions/CadastreTransactionsTableExpand.tsx",
      ],
    },
  ],
  UI_HousingUnit_Estimation_High_Range: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/priceRange/CadastrePriceRange.utils.ts",
      ],
    },
  ],
  UI_HousingUnit_Estimation_Low_Range: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/priceRange/CadastrePriceRange.utils.ts",
      ],
    },
  ],
  UI_HousingUnit_Estimation_Medium_Range: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/priceRange/CadastrePriceRange.utils.ts",
      ],
    },
  ],
  UI_HousingUnit_Header: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/housingUnit/housingUnit.text.ts"],
    },
  ],
  UI_HousingUnit_HousingCooperativeBadge: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/HousingUnitPanelHeader.tsx"],
    },
  ],
  UI_HousingUnit_Overview_Esg_Empty: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/overview/esg/HousingUnitOverviewEsg.tsx",
      ],
    },
  ],
  UI_HousingUnit_Overview_Esg_EnergyLabel: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/overview/esg/HousingUnitOverviewEsg.tsx",
      ],
    },
  ],
  UI_HousingUnit_Overview_ToTabLink: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/overview/HousingUnitOverviewToTabLink.tsx",
      ],
    },
  ],
  UI_HousingUnit_PanelActions_Grunnbok: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/housingUnit/housingUnit.text.ts"],
    },
  ],
  UI_HousingUnit_PanelActions_Reports: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/housingUnit/housingUnit.text.ts"],
    },
  ],
  UI_HousingUnit_PanelMany_NotImplemented: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/HousingUnitPanelMany.tsx"],
    },
  ],
  UI_HousingUnit_TabBuildings: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/housingUnit.panel.config.ts"],
    },
  ],
  UI_HousingUnit_TabESG: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/overview/housingUnit.overview.constants.ts",
        "v2-console/src/housingUnit/panel/housingUnit.panel.config.ts",
      ],
    },
  ],
  UI_HousingUnit_TabGeneral: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/housingUnit.panel.config.ts"],
    },
  ],
  UI_HousingUnit_TabListings: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/housingUnit.panel.config.ts"],
    },
  ],
  UI_HousingUnit_TabOverview: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/housingUnit.panel.config.ts"],
    },
  ],
  UI_HousingUnit_TabOwners: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/housingUnit.panel.config.ts"],
    },
  ],
  UI_HousingUnit_TabRentalValuation: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/housingUnit.panel.config.ts"],
    },
  ],
  UI_HousingUnit_TabValuation: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/housingUnit/panel/housingUnit.panel.config.ts"],
    },
  ],
  UI_HousingUnit_ZoomTo: [
    {
      label: "Housing unit panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/housingUnit/panel/HousingUnitPanel.tsx",
        "v2-console/src/housingUnit/panel/HousingUnitPanelActions.tsx",
      ],
    },
  ],
  UI_ImageGallery_No_Images_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_ImageGallery_No_ThumbnailList_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Infrastructure_CategoryRailwayProject: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
  ],
  UI_Infrastructure_Header: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/infrastructure/panel/InfrastructurePanel.tsx"],
    },
  ],
  UI_Infrastructure_LabelCategory: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
  ],
  UI_Infrastructure_PhaseApproval: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/infrastructure.phases.ts",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
  ],
  UI_Infrastructure_PhaseCompleted: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/infrastructure.phases.ts",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
  ],
  UI_Infrastructure_PhaseConstruction: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/infrastructure.phases.ts",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
  ],
  UI_Infrastructure_PhasePlanning: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/infrastructure.phases.ts",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
  ],
  UI_Infrastructure_PhaseProcurement: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/infrastructure.phases.ts",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
      ],
    },
  ],
  UI_Infrastructure_TabContacts: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureContactsModule.tsx",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
        "v2-console/src/infrastructure/panel/infrastructure.panel.config.tsx",
      ],
    },
  ],
  UI_Infrastructure_TabDescription: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureDescriptionModule.tsx",
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
        "v2-console/src/infrastructure/panel/infrastructure.panel.config.tsx",
      ],
    },
  ],
  UI_Infrastructure_TabDocuments: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureDocumentsModule.tsx",
        "v2-console/src/infrastructure/panel/infrastructure.panel.config.tsx",
      ],
    },
  ],
  UI_Infrastructure_TabLinkedProfiles: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureLinkedProfilesModule.tsx",
        "v2-console/src/infrastructure/panel/infrastructure.panel.config.tsx",
      ],
    },
  ],
  UI_Infrastructure_TabOverview: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureOverviewModule.tsx",
        "v2-console/src/infrastructure/panel/infrastructure.panel.config.tsx",
      ],
    },
  ],
  UI_Infrastructure_Timeline: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/infrastructure/panel/InfrastructureTimelineModule.tsx",
        "v2-console/src/infrastructure/panel/infrastructure.panel.config.tsx",
      ],
    },
  ],
  UI_Infrastructure_ZoomTo: [
    {
      label: "Infrastructure",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/infrastructure/panel/InfrastructurePanel.tsx"],
    },
  ],
  UI_LandUse_Bog: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_CultivatedLand: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_Developed: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_Forest: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_Freshwater: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_InfieldPasture: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_Mixed: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/NavLayerLandUsePopup.tsx",
      ],
    },
  ],
  UI_LandUse_NotMapped: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_OpenLand: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_Sea: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_SnowIce: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_SurfaceCultivated: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_Transport: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/map.layer.navLayer.landUse.ts",
      ],
    },
  ],
  UI_LandUse_Unknown: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/property/plots/CadastrePropertyPlotsLandUse.tsx",
      ],
    },
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/landUse/NavLayerLandUsePopup.tsx",
      ],
    },
  ],
  UI_LanguageSelector_Header: [
    {
      label: "Language Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/languageSelector/LanguageSelector.tsx"],
    },
  ],
  UI_LanguageSelector_Root: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/language/CurrentUserLanguagePicker.tsx",
      ],
    },
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsGeneralSection.tsx"],
    },
  ],
  UI_LanguageSelector_SearchEmpty: [
    {
      label: "Language Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/languageSelector/LanguageSelector.tsx"],
    },
  ],
  UI_LanguageSelector_SearchPlaceholder: [
    {
      label: "Language Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/languageSelector/LanguageSelector.tsx"],
    },
  ],
  UI_LastVisited_ClearHistory: [
    {
      label: "Last Visited",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/lastVisited/LastVisitedDropdown.tsx"],
    },
  ],
  UI_LastVisited_EmptyHint: [
    {
      label: "Last Visited",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/lastVisited/LastVisitedDropdown.tsx"],
    },
  ],
  UI_LastVisited_EmptyTitle: [
    {
      label: "Last Visited",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/lastVisited/LastVisitedDropdown.tsx"],
    },
  ],
  UI_LastVisited_Header: [
    {
      label: "Last Visited",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/lastVisited/LastVisitedDropdown.tsx"],
    },
  ],
  UI_LastVisited_Remove: [
    {
      label: "Last Visited",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/lastVisited/LastVisitedDropdownItem.tsx"],
    },
  ],
  UI_Layers_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sidebar/MapSidebarItem.tsx",
        "v2-console/src/map/sidebar/map.sidebar.registry.tsx",
        "v2-console/src/map/toolbar/MapToolbarItemLayerMenu.tsx",
      ],
    },
  ],
  UI_Layout_AccessGuard_DevOnly: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardDevMarkers.tsx"],
    },
  ],
  UI_Layout_AccessGuard_DevOnly_HoverBody: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardDevMarkers.tsx"],
    },
  ],
  UI_Layout_AccessGuard_FeatureFlag: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardDevMarkers.tsx"],
    },
  ],
  UI_Layout_AccessGuard_FeatureFlag_HoverBody: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardDevMarkers.tsx"],
    },
  ],
  UI_Layout_AccessGuard_LockedAlert_DescriptionAfter: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardLockedAlert.tsx"],
    },
  ],
  UI_Layout_AccessGuard_LockedAlert_DescriptionBefore: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardLockedAlert.tsx"],
    },
  ],
  UI_Layout_AccessGuard_LockedAlert_FeatureNoun: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardLockedAlert.tsx"],
    },
  ],
  UI_Layout_AccessGuard_LockedAlert_Title: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardLockedAlert.tsx"],
    },
  ],
  UI_Layout_AccessGuard_PillUpgrade: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardLockBadge.tsx"],
    },
  ],
  UI_Layout_AccessGuard_StaffOnly: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardDevMarkers.tsx"],
    },
  ],
  UI_Layout_AccessGuard_StaffOnly_HoverBody: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardDevMarkers.tsx"],
    },
  ],
  UI_Layout_AccessGuard_UpgradeNeeded: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardOverlays.tsx"],
    },
  ],
  UI_Layout_AccessGuard_UpgradeToUnlock: [
    {
      label: "Access Guard",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/accessGuard/AccessGuardSmall.tsx"],
    },
  ],
  UI_Layout_ArtifactCard_Preview: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/artifact/ArtifactCard.tsx"],
    },
  ],
  UI_Layout_AttachmentChip_Remove: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/AttachmentChip.tsx"],
    },
  ],
  UI_Layout_BarSummaryGrouped_BreakdownLabel: [
    {
      label: "Bar Summary Grouped",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/barSummaryGrouped/BarSummaryGrouped.tsx"],
    },
  ],
  UI_Layout_BarSummaryStacked_RowCompositionLabel: [
    {
      label: "Bar Summary",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/barSummary/BarSummaryStacked.tsx"],
    },
  ],
  UI_Layout_BarSummaryStacked_SegmentLegend: [
    {
      label: "Bar Summary",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/barSummary/BarSummaryStacked.tsx"],
    },
  ],
  UI_Layout_BarSummary_CompositionTotal: [
    {
      label: "Bar Summary",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/barSummary/BarSummaryStacked.tsx"],
    },
  ],
  UI_Layout_CardGallery_ScrollLeft: [
    {
      label: "Card Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/cardGallery/CardGallery.tsx"],
    },
  ],
  UI_Layout_CardGallery_ScrollRight: [
    {
      label: "Card Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/cardGallery/CardGallery.tsx"],
    },
  ],
  UI_Layout_Chat_AddAttachment: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatComposer.tsx"],
    },
  ],
  UI_Layout_Chat_Close: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_Collapse: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_Confirm: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionActionsMenu.tsx"],
    },
  ],
  UI_Layout_Chat_Delete: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionActionsMenu.tsx"],
    },
  ],
  UI_Layout_Chat_DeleteConfirmDescription: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionActionsMenu.tsx"],
    },
  ],
  UI_Layout_Chat_DeleteConfirmTitle: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionActionsMenu.tsx"],
    },
  ],
  UI_Layout_Chat_DeleteSession: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionList.tsx"],
    },
  ],
  UI_Layout_Chat_Dismiss: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/chat/ChatAlert.tsx",
        "v2-layout-ui/src/chat/Suggestions.tsx",
      ],
    },
  ],
  UI_Layout_Chat_Drawer_Close: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionDrawer.tsx"],
    },
  ],
  UI_Layout_Chat_EditPrompt: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatMessage.tsx"],
    },
  ],
  UI_Layout_Chat_Expand: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_ExpandExit: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_Group_Earlier: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionList.tsx"],
    },
  ],
  UI_Layout_Chat_Group_LastWeek: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionList.tsx"],
    },
  ],
  UI_Layout_Chat_Group_Today: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/chat/ChatDayMarker.tsx",
        "v2-layout-ui/src/chat/SessionList.tsx",
      ],
    },
  ],
  UI_Layout_Chat_Group_Yesterday: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/chat/ChatDayMarker.tsx",
        "v2-layout-ui/src/chat/SessionList.tsx",
      ],
    },
  ],
  UI_Layout_Chat_LearnMore: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatNotice.tsx"],
    },
  ],
  UI_Layout_Chat_Menu_Actions: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_Menu_Fallback: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_NewChat: [
    {
      label: "Agent",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/agent/agent.sessions.utils.ts"],
    },
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.utils.ts"],
    },
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/chat/ChatHeader.tsx",
        "v2-layout-ui/src/chat/SessionDropdown.tsx",
        "v2-layout-ui/src/chat/SessionList.tsx",
      ],
    },
  ],
  UI_Layout_Chat_Notice: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatNotice.tsx"],
    },
  ],
  UI_Layout_Chat_Recents: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SuggestionPills.tsx"],
    },
  ],
  UI_Layout_Chat_Rename: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionActionsMenu.tsx"],
    },
  ],
  UI_Layout_Chat_RenameConversation: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_RenameSession: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionList.tsx"],
    },
  ],
  UI_Layout_Chat_Reset: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_ResetConfirmTitle: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatHeader.tsx"],
    },
  ],
  UI_Layout_Chat_RevertTo: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatMessage.tsx"],
    },
  ],
  UI_Layout_Chat_Root: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatPopover.tsx"],
    },
  ],
  UI_Layout_Chat_Send: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/chat/ChatComposer.tsx",
        "v2-layout-ui/src/chat/ChatMessage.tsx",
      ],
    },
  ],
  UI_Layout_Chat_SessionActions: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SessionList.tsx"],
    },
  ],
  UI_Layout_Chat_Sessions: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/chat/SessionDrawer.tsx",
        "v2-layout-ui/src/chat/SessionDropdown.tsx",
      ],
    },
  ],
  UI_Layout_Chat_ShowMore: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SuggestionsClamp.tsx"],
    },
  ],
  UI_Layout_Chat_Stop: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatComposer.tsx"],
    },
  ],
  UI_Layout_Chat_Suggestions: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/SuggestionPills.tsx"],
    },
  ],
  UI_Layout_Chat_UploadImage: [
    {
      label: "Chat",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/chat/ChatComposer.tsx"],
    },
  ],
  UI_Layout_CloseButton_Label: [
    {
      label: "Buttons",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/buttons/CloseButton.tsx"],
    },
  ],
  UI_Layout_CompositionSummary_BarAria: [
    {
      label: "Composition Summary",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/compositionSummary/CompositionSummary.tsx"],
    },
  ],
  UI_Layout_DataTable_AvailableColumns: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/order/DataTableOrderAndVisibilitySelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_DeselectAllRows: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/actions/DataTableActionsSelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterColumnChoose: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/selector/DataTableFilterSelectorColumn.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterColumnSearchPlaceholder: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/selector/DataTableFilterSelectorColumn.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterEmpty: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/filter/DataTableFilterItems.tsx"],
    },
  ],
  UI_Layout_DataTable_FilterFromDate: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/input/DataTableFilterInputDateRange.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterGroupCommon: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/selector/DataTableFilterSelectorColumn.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterGroupOther: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/selector/DataTableFilterSelectorColumn.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterMax: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/input/DataTableFilterInputMinMax.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterMin: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/input/DataTableFilterInputMinMax.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterRemoveTooltip: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/filter/DataTableFilterItem.tsx"],
    },
  ],
  UI_Layout_DataTable_FilterToDate: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/input/DataTableFilterInputDateRange.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterTypeChoose: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/selector/DataTableFilterSelectorType.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterTypeSearchPlaceholder: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/filter/selector/DataTableFilterSelectorType.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_FilterWhere: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/filter/DataTableFilterItem.tsx"],
    },
  ],
  UI_Layout_DataTable_HideColumn: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/cells/DataTableHeaderCell.tsx"],
    },
  ],
  UI_Layout_DataTable_LinksMoreCount: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/cells/DataTableExpandableLinksCell.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_OrderButton: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/order/DataTableOrder.tsx"],
    },
  ],
  UI_Layout_DataTable_OrderResetTooltip: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/order/DataTableOrderAndVisibility.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_Pin: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/order/DataTableOrderAndVisibilitySelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_PinnedSection: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/order/DataTableOrderAndVisibilitySelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_ResetSorting: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/cells/DataTableHeaderCell.tsx"],
    },
  ],
  UI_Layout_DataTable_RowActions: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/actions/DataTableRowActionsMenu.tsx"],
    },
  ],
  UI_Layout_DataTable_RowCount: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/DataTableToolbar.tsx"],
    },
  ],
  UI_Layout_DataTable_RowsSelected: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/actions/DataTableActionsSelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_ScrollToTop: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/DataTableInfiniteScroller.tsx"],
    },
  ],
  UI_Layout_DataTable_SelectAllRows: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/dataTable.selectColumn.tsx"],
    },
  ],
  UI_Layout_DataTable_SelectRow: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/dataTable.selectColumn.tsx"],
    },
  ],
  UI_Layout_DataTable_SortAsc: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/cells/DataTableHeaderCell.tsx"],
    },
  ],
  UI_Layout_DataTable_SortAscending: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/sort/DataTableSortTypeSelector.tsx"],
    },
  ],
  UI_Layout_DataTable_SortButton: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/sort/DataTableSort.tsx"],
    },
  ],
  UI_Layout_DataTable_SortColumnEmpty: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/sort/DataTableSortColumnSelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_SortColumnLabel: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/sort/DataTableSortContent.tsx"],
    },
  ],
  UI_Layout_DataTable_SortColumnSearchPlaceholder: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/sort/DataTableSortColumnSelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_SortColumnSelectPlaceholder: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/sort/DataTableSortColumnSelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_SortDesc: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/cells/DataTableHeaderCell.tsx"],
    },
  ],
  UI_Layout_DataTable_SortDescending: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/sort/DataTableSortTypeSelector.tsx"],
    },
  ],
  UI_Layout_DataTable_SortDirectionLabel: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/sort/DataTableSortContent.tsx"],
    },
  ],
  UI_Layout_DataTable_SortResetTooltip: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/dataTable/sort/DataTableSortContent.tsx"],
    },
  ],
  UI_Layout_DataTable_ToggleAllVisibility: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/order/DataTableOrderAndVisibility.tsx",
        "v2-layout-ui/src/dataTable/order/DataTableOrderAndVisibilitySelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_Unpin: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/order/DataTableOrderAndVisibilitySelector.tsx",
      ],
    },
  ],
  UI_Layout_DataTable_UnpinnedSection: [
    {
      label: "Data Table",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/dataTable/order/DataTableOrderAndVisibilitySelector.tsx",
      ],
    },
  ],
  UI_Layout_ExpandPanelFilterableWithViewModes_OrderColumn: [
    {
      label: "Expand Panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/expandPanel/filterableWithViewModes/ExpandPanelFilterableWithViewModesActions.tsx",
      ],
    },
  ],
  UI_Layout_ExpandPanel_BreadcrumbBack: [
    {
      label: "Expand Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/expandPanel/ExpandPanelBreadcrumb.tsx"],
    },
  ],
  UI_Layout_ExpandPanel_ClosePanel: [
    {
      label: "Expand Panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/expandPanel/state/ExpandPanelErrorState.tsx",
        "v2-layout-ui/src/expandPanel/state/ExpandPanelNotFoundState.tsx",
      ],
    },
  ],
  UI_Layout_ExpandPanel_ComingSoonTabState: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ExpandPanel_EmptyTabState: [
    {
      label: "Expand Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/expandPanel/state/ExpandPanelEmptyState.tsx"],
    },
  ],
  UI_Layout_ExpandPanel_ErrorState: [
    {
      label: "Expand Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/expandPanel/state/ExpandPanelErrorState.tsx"],
    },
  ],
  UI_Layout_ExpandPanel_NotFoundState: [
    {
      label: "Expand Panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/expandPanel/state/ExpandPanelNotFoundState.tsx",
      ],
    },
  ],
  UI_Layout_FeatureDetail_2dOnly: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FeatureDetail_About_Title: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FeatureDetail_Categories_Title: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FeatureDetail_Close: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FeatureDetail_CreatedAt_Title: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FeatureDetail_Filters_Title: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FeatureDetail_Links_Title: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FeatureDetail_Sources_Title: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FeatureDetail_SubLayers_Title: [
    {
      label: "Feature Detail",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/featureDetail/FeatureDetailPage.tsx"],
    },
  ],
  UI_Layout_FilterButton_Reset: [
    {
      label: "Filterable With Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterableWithTabs/FilterButton.tsx"],
    },
  ],
  UI_Layout_FilterButton_Title: [
    {
      label: "Filterable With Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterableWithTabs/FilterButton.tsx"],
    },
  ],
  UI_Layout_FilterButton_Tooltip: [
    {
      label: "Filterable With Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterableWithTabs/FilterButton.tsx"],
    },
  ],
  UI_Layout_FilterFooter_AddFilter: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filter/FilterFooter.tsx"],
    },
  ],
  UI_Layout_FilterFooter_Apply: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filter/FilterFooter.tsx"],
    },
  ],
  UI_Layout_FilterFooter_ClearAll: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filter/FilterFooter.tsx"],
    },
  ],
  UI_Layout_FilterPills_Label: [
    {
      label: "Filterable With Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterableWithTabs/FilterPills.tsx"],
    },
  ],
  UI_Layout_FilterableWithTabsContent_PartialError: [
    {
      label: "Filterable With Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterableWithTabs/Content.tsx"],
    },
  ],
  UI_Layout_FilterableWithTabs_ClearSearch: [
    {
      label: "Filterable With Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterableWithTabs/Search.tsx"],
    },
  ],
  UI_Layout_FilterableWithTabs_ViewSettings: [
    {
      label: "Filterable With Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterableWithTabs/ViewSettingsButton.tsx"],
    },
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_Layout_FilterableWithViewModesContent_EmptyState: [
    {
      label: "Filterable With View Modes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/filterableWithViewModes/FilterableWithViewModesContent.tsx",
      ],
    },
  ],
  UI_Layout_FilterableWithViewModesToggle_ShowAsDiagram: [
    {
      label: "Filterable With View Modes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/filterableWithViewModes/FilterableWithViewModesToggle.tsx",
      ],
    },
  ],
  UI_Layout_FilterableWithViewModesToggle_ShowAsGrid: [
    {
      label: "Filterable With View Modes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/filterableWithViewModes/FilterableWithViewModesToggle.tsx",
      ],
    },
  ],
  UI_Layout_FilterableWithViewModesToggle_ShowAsList: [
    {
      label: "Filterable With View Modes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/filterableWithViewModes/FilterableWithViewModesToggle.tsx",
      ],
    },
  ],
  UI_Layout_FilterableWithViewModesToggle_ShowAsTable: [
    {
      label: "Filterable With View Modes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/filterableWithViewModes/FilterableWithViewModesToggle.tsx",
      ],
    },
  ],
  UI_Layout_FilterableWithViewModesToggle_ShowAsTreeView: [
    {
      label: "Filterable With View Modes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/filterableWithViewModes/FilterableWithViewModesToggle.tsx",
      ],
    },
  ],
  UI_Layout_Filterable_Filters: [
    {
      label: "Filterable",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterable/FilterableActionRow.tsx"],
    },
  ],
  UI_Layout_Filterable_Search: [
    {
      label: "Filterable",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterable/FilterableActionRow.tsx"],
    },
  ],
  UI_Layout_Filterable_Sort: [
    {
      label: "Filterable",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filterable/FilterableActionRow.tsx"],
    },
  ],
  UI_Layout_Filters_Clear: [
    {
      label: "Filter",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/filter/Filters.tsx"],
    },
  ],
  UI_Layout_FloatingTabs_MoreCount: [
    {
      label: "Floating Tabs",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/floatingTabs/FloatingTabsMore.tsx"],
    },
  ],
  UI_Layout_GroupedDndList_EmptyGroup: [
    {
      label: "Grouped Dnd List",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/groupedDndList/DefaultEmptyGroupPlaceholder.tsx",
      ],
    },
  ],
  UI_Layout_GroupedTable_Empty: [
    {
      label: "Grouped Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/groupedTable/GroupedTable.tsx"],
    },
  ],
  UI_Layout_GroupedTable_SortAscendingActive: [
    {
      label: "Grouped Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/groupedTable/GroupedTable.tsx"],
    },
  ],
  UI_Layout_GroupedTable_SortBy: [
    {
      label: "Grouped Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/groupedTable/GroupedTable.tsx"],
    },
  ],
  UI_Layout_GroupedTable_SortDescendingActive: [
    {
      label: "Grouped Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/groupedTable/GroupedTable.tsx"],
    },
  ],
  UI_Layout_ImageGallery_Dialog_Close: [
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imageGallery/ImageGalleryDialog.tsx"],
    },
  ],
  UI_Layout_ImageGallery_Dialog_Description: [
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/imageGallery/ImageGalleryDialog.tsx",
        "v2-layout-ui/src/imageGallery/ImageGalleryThumbnailList.tsx",
      ],
    },
  ],
  UI_Layout_ImageGallery_Dialog_Title: [
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imageGallery/ImageGalleryDialog.tsx"],
    },
  ],
  UI_Layout_ImageGallery_LoadError: [
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imageGallery/ImageGalleryFrame.tsx"],
    },
  ],
  UI_Layout_ImageGallery_MobileDialog_Title: [
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imageGallery/ImageGalleryThumbnailList.tsx"],
    },
  ],
  UI_Layout_ImageGallery_No_Images: [
    {
      label: "Combify",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/combify/CombifyHero.tsx"],
    },
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/imageGallery/ImageGalleryDialog.tsx",
        "v2-layout-ui/src/imageGallery/ImageGalleryFrame.tsx",
      ],
    },
  ],
  UI_Layout_ImageGallery_No_ThumbnailList: [
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imageGallery/ImageGalleryThumbnailList.tsx"],
    },
  ],
  UI_Layout_ImageGallery_SeeAll: [
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imageGallery/ImageGalleryMosaic.tsx"],
    },
  ],
  UI_Layout_ImageGallery_SeeMore: [
    {
      label: "Image Gallery",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imageGallery/ImageGalleryFullGrid.tsx"],
    },
  ],
  UI_Layout_ImagePreview_Dialog_Close: [
    {
      label: "Image Preview",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imagePreview/ImagePreviewDialog.tsx"],
    },
  ],
  UI_Layout_ImagePreview_Dialog_Description: [
    {
      label: "Image Preview",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imagePreview/ImagePreviewDialog.tsx"],
    },
  ],
  UI_Layout_ImagePreview_Dialog_Title: [
    {
      label: "Image Preview",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/imagePreview/ImagePreviewDialog.tsx"],
    },
  ],
  UI_Layout_InfoTooltip_IconLabel: [
    {
      label: "Tooltips",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/tooltips/infoTooltip/InfoTooltip.tsx"],
    },
  ],
  UI_Layout_InputItemLabel_RequiredMarker: [
    {
      label: "Input Item",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/inputItem/InputItemLabel.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_Address: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_AverageFloor: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_BathroomCount: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/HousingUnitObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_BuildingEstablished: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_BuildingType: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/BuildingObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_BuiltUpAreaBya: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/BuildingObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_BuiltUpAreaRatio: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/BuildingObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_CadastreNumber: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/HousingUnitObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_Ceo: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_Close: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/ObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_Company_OrgNrPrefix: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_CreditRating: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_EmployeeCount: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_EnergyLabel_RowLabel: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/ObjectHoverCardEnergyLabelRow.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_FloorPlanMain: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_Floors: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/HousingUnitObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_FoundedYear: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_HousingUnitType: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/HousingUnitObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_IndustrySector: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_LatestTransaction: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_Links: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_Loading: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/ObjectHoverCardSkeleton.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_OpenBuilding: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/BuildingObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_OpenCompany: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_OpenPanel: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/HousingUnitObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_OpenPerson: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/PersonObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_OpenProperty: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_PersonAffiliated: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_PersonHeaderTooltip: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_PersonOwns: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_PersonStatusTooltip: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_Person_StatusLabel: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_Phone: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_PlotArea: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_PropertyType: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_PublicPlotValue: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_PublicPropertyValue: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_RegisteredAt: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/CompanyObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_Result: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_Revenue2024: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_ObjectHoverCard_RoomCount: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/HousingUnitObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_ScrollDown: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/ObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_Sections: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_TenantCount: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_TenantEmployeeCount: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_Units: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/BuildingObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_UsableAreaBra: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/HousingUnitObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_UsableAreaBraTotal: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectHoverCard2/BuildingObjectHoverCard.tsx"],
    },
  ],
  UI_Layout_ObjectHoverCard_UsageUnits: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/CadastreObjectHoverCard.tsx",
        "v2-layout-ui/src/objectHoverCard2/SectionObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectHoverCard_WcCount: [
    {
      label: "Object Hover Card2",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectHoverCard2/HousingUnitObjectHoverCard.tsx",
      ],
    },
  ],
  UI_Layout_ObjectModuleCarousel_Next: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/module/carousel/ObjectModuleCarousel.tsx",
      ],
    },
  ],
  UI_Layout_ObjectModuleCarousel_Previous: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/module/carousel/ObjectModuleCarousel.tsx",
      ],
    },
  ],
  UI_Layout_ObjectModuleFilterableWithViewModes_OrderColumn: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/module/filterableWithViewModes/base/ObjectModuleFilterableWithViewModesBaseActions.tsx",
      ],
    },
  ],
  UI_Layout_ObjectModuleOverview_CustomizeSections: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/module/overview/ObjectModuleOverviewSections.tsx",
      ],
    },
  ],
  UI_Layout_ObjectModuleOverview_CustomizeValues: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/module/overview/ObjectModuleOverviewKeyValues.tsx",
      ],
    },
  ],
  UI_Layout_ObjectModuleTabs_Toggle: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/module/tabs/ObjectModuleTabsToggleGroup.tsx",
      ],
    },
  ],
  UI_Layout_ObjectModule_ExpandButton: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/module/base/header/ObjectModuleHeaderExpandButton.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPanel_BreadcrumbBack: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/panel/ObjectPanelBackButton.tsx",
        "v2-console/src/object/panel/ObjectPanelBreadcrumb.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPanel_Breadcrumb_CurrentlyViewing: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/object/breadcrumb/ObjectHierarchyBreadcrumb.tsx"],
    },
  ],
  UI_Layout_ObjectPanel_Breadcrumb_ParentChainHeader: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/object/breadcrumb/ObjectHierarchyBreadcrumb.tsx"],
    },
  ],
  UI_Layout_ObjectPanel_Breadcrumb_YouAreHere: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/object/breadcrumb/ObjectHierarchyBreadcrumb.tsx"],
    },
  ],
  UI_Layout_ObjectPanel_ClosePanel: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/panel/state/ObjectPanelErrorState.tsx",
        "v2-layout-ui/src/object/panel/state/ObjectPanelNotAvailableState.tsx",
        "v2-layout-ui/src/object/panel/state/ObjectPanelNotFoundState.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPanel_ComingSoonTabState: [
    {
      label: "State",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/state/comingSoon/StateComingSoon.tsx"],
    },
  ],
  UI_Layout_ObjectPanel_EmptyTabState: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/panel/state/ObjectPanelEmptyTabState.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPanel_ErrorState: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/object/panel/state/ObjectPanelErrorState.tsx"],
    },
  ],
  UI_Layout_ObjectPanel_HeaderDropdownMoreActions: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/panel/header/ObjectPanelHeaderActionDropdown.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPanel_ModuleOverview_CustomizeButton: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/module/overview/ObjectModuleOverviewSelector.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPanel_NotAvailableState: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/panel/state/ObjectPanelNotAvailableState.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPanel_NotFoundState: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/panel/state/ObjectPanelNotFoundState.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPanel_Tabs_More: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/object/panel/content/ObjectPanelContentTabs.tsx",
      ],
    },
  ],
  UI_Layout_ObjectPopup_Close: [
    {
      label: "Object Popup",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectPopup/ObjectPopup.tsx"],
    },
  ],
  UI_Layout_ObjectPopup_Loading: [
    {
      label: "Object Popup",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/objectPopup/ObjectPopupSkeleton.tsx"],
    },
  ],
  UI_Layout_ObjectPopup_Open: [
    {
      label: "Object Popup",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/objectPopup/BuildingObjectPopup.tsx",
        "v2-layout-ui/src/objectPopup/CadastreObjectPopup.tsx",
        "v2-layout-ui/src/objectPopup/HousingUnitObjectPopup.tsx",
        "v2-layout-ui/src/objectPopup/SectionObjectPopup.tsx",
      ],
    },
  ],
  UI_Layout_OrderAndVisibility_Reset: [
    {
      label: "Order And Visibility",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/orderAndVisibility/OrderAndVisibility.tsx"],
    },
  ],
  UI_Layout_OrderAndVisibility_ToggleAll: [
    {
      label: "Order And Visibility",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/orderAndVisibility/OrderAndVisibility.tsx"],
    },
  ],
  UI_Layout_Panel_Direction_Bottom: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
  ],
  UI_Layout_Panel_Direction_Left: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
  ],
  UI_Layout_Panel_Direction_Right: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
  ],
  UI_Layout_Panel_Direction_Top: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
  ],
  UI_Layout_Panel_Floating_Toggle_Button_Floating: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
  ],
  UI_Layout_Panel_Floating_Toggle_Button_Overlay: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
  ],
  UI_Layout_Panel_Position_Bottom: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_Panel_Position_Left: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_Panel_Position_Menu: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
  ],
  UI_Layout_Panel_Position_Right: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_Panel_Position_Top: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_Panel_Settings_Menu: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsButton.tsx"],
    },
  ],
  UI_Layout_ScrollIndicator_ScrollDown: [
    {
      label: "Scroll Indicator",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/scrollIndicator/ScrollDownIndicator.tsx"],
    },
  ],
  UI_Layout_Sidebar_BrandingVersion: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/text/catalog.ts"],
    },
  ],
  UI_Layout_Sidebar_Overflow_More: [
    {
      label: "Sidebar2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sidebar2/SidebarOverflowList.tsx"],
    },
  ],
  UI_Layout_SortColumnSelector_Empty: [
    {
      label: "Sort New",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sortNew/SortColumnSelector.tsx"],
    },
  ],
  UI_Layout_SortColumnSelector_SearchPlaceholder: [
    {
      label: "Sort New",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sortNew/SortColumnSelector.tsx"],
    },
  ],
  UI_Layout_SortColumnSelector_SelectPlaceholder: [
    {
      label: "Sort New",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sortNew/SortColumnSelector.tsx"],
    },
  ],
  UI_Layout_SortContent_ColumnLabel: [
    {
      label: "Sort New",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sortNew/SortContent.tsx"],
    },
  ],
  UI_Layout_SortContent_DirectionLabel: [
    {
      label: "Sort New",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sortNew/SortContent.tsx"],
    },
  ],
  UI_Layout_SortContent_ResetTooltip: [
    {
      label: "Sort New",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sortNew/SortContent.tsx"],
    },
  ],
  UI_Layout_SortDirectionSelector_Ascending: [
    {
      label: "Sort New",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sortNew/SortDirectionSelector.tsx"],
    },
  ],
  UI_Layout_SortDirectionSelector_Descending: [
    {
      label: "Sort New",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/sortNew/SortDirectionSelector.tsx"],
    },
  ],
  UI_Layout_StackedSummary_BreakdownPlaceholder: [
    {
      label: "Bar Summary Grouped",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/barSummaryGrouped/BarSummaryGrouped.tsx"],
    },
    {
      label: "Stacked Summary2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/stackedSummary2/StackedSummary2.tsx"],
    },
  ],
  UI_Layout_StateEmptyFilter_Message: [
    {
      label: "State",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/state/empty/StateEmptyFilter.tsx"],
    },
  ],
  UI_Layout_StateEmptySearchFull_Description: [
    {
      label: "State",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/state/empty/StateEmptySearchFull.tsx"],
    },
  ],
  UI_Layout_StateEmptySearch_Message: [
    {
      label: "State",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/state/empty/StateEmptySearch.tsx",
        "v2-layout-ui/src/state/empty/StateEmptySearchFull.tsx",
      ],
    },
  ],
  UI_Layout_StateError_ReportedNotice: [
    {
      label: "State",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/state/error/StateError.tsx"],
    },
  ],
  UI_Layout_StateError_Unknown: [
    {
      label: "State",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/state/error/StateError.tsx"],
    },
  ],
  UI_Layout_StoreDetail_2dOnly: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_StoreDetail_About_Title: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_StoreDetail_Categories_Title: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_StoreDetail_Close: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_StoreDetail_CreatedAt_Title: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_StoreDetail_Filters_Title: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_StoreDetail_Links_Title: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_StoreDetail_Sources_Title: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_StoreDetail_SubLayers_Title: [
    {
      label: "Store",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/store/detail/StoreDetailPage.tsx"],
    },
  ],
  UI_Layout_Summary_BreakdownByPrefix: [
    {
      label: "Stacked Summary2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/stackedSummary2/StackedSummary2.tsx"],
    },
  ],
  UI_Layout_Summary_ShowLess: [
    {
      label: "Bar Summary",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/barSummary/BarSummary.tsx",
        "v2-layout-ui/src/barSummary/BarSummaryStacked.tsx",
      ],
    },
    {
      label: "Stacked Summary2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/stackedSummary2/StackedSummaryLegend.tsx"],
    },
  ],
  UI_Layout_Summary_ShowMoreCount: [
    {
      label: "Bar Summary",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-layout-ui/src/barSummary/BarSummary.tsx",
        "v2-layout-ui/src/barSummary/BarSummaryStacked.tsx",
      ],
    },
    {
      label: "Stacked Summary2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/stackedSummary2/StackedSummaryLegend.tsx"],
    },
  ],
  UI_Layout_Summary_TooltipShareOfOverall: [
    {
      label: "Bar Summary",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/barSummary/BarSummaryStacked.tsx"],
    },
    {
      label: "Stacked Summary2",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/stackedSummary2/StackedSummary2.tsx"],
    },
  ],
  UI_Layout_TimelineSimple_Title: [
    {
      label: "Timeline Simple",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/timelineSimple/TimelineSimple.tsx"],
    },
  ],
  UI_Layout_TreeView_OwnershipBadge_MaxWidthGuide: [
    {
      label: "Tree View",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/treeView/TreeViewOwnershipBadge.tsx"],
    },
  ],
  UI_Layout_TreeView_OwnershipBadge_Ownership: [
    {
      label: "Tree View",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/treeView/TreeViewOwnershipBadge.tsx"],
    },
  ],
  UI_Layout_ViewSettings_GroupByLabel: [
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_Layout_ViewSettings_NoGroupingOption: [
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_Layout_ViewSettings_ResetLabel: [
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_Layout_ViewSettings_SortByLabel: [
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_Layout_ViewSettings_SortColumnPlaceholder: [
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_Layout_ViewSettings_SortDirectionAscending: [
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_Layout_ViewSettings_SortDirectionDescending: [
    {
      label: "View Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/viewSettings/ViewSettings.tsx"],
    },
  ],
  UI_LegalDocuments_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.constants.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_LegalPlatform_CadastreList_Clear: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_DocumentCount: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_EmptyFree: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalDocumentsPanel.tsx"],
    },
  ],
  UI_LegalPlatform_CadastreList_EmptyFreeReports: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalReportsPanel.tsx"],
    },
  ],
  UI_LegalPlatform_CadastreList_EmptyPaste: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_EmptyPasteExample: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_EmptySearch: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_EmptyTags: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_EmptyTitle: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_EmptyTitleSearch: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_Error_Add: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.cadastreClickHandler.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_Max: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_NoAddress: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreListItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_Remove: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreListItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_SelectedCount: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsInline.tsx",
      ],
    },
  ],
  UI_LegalPlatform_CadastreList_ZoomTo: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreListItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Back: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_BeforeTitle: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Before_FailedNotBilled: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Before_NoChargeYet: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Before_PantebokDelay: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Before_StaysInLibrary: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Confirm: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_NothingOrderable: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_PartlyUnavailable: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Placing: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Remove: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Subtitle: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Success: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Summary: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_TagHint: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_TagLabel: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_TagPlaceholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_TagRequired: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_TagRequiredMarker: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Checkout_Title: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Badge_Available: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocumentItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Badge_Failed: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocumentItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Badge_Owned: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocumentItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Badge_Pending: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocumentItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Cadastre_NotFound: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Cadastre_TemporarilyUnavailable: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_CannotOrder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Cause_AlreadyOrdered: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Cause_Before1951: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Cause_NotFound: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Cause_Unknown: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_CheckoutHint: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsInline.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_ClearSelection: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsInline.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Description: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalDocumentsPanel.tsx"],
    },
  ],
  UI_LegalPlatform_Documents_DirectEntry_Add: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformDirectEntry.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_DirectEntry_AlreadyAdded: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDirectEntry.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_DirectEntry_InvalidFormat: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDirectEntry.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_DirectEntry_Label: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalDocumentsPanel.tsx"],
    },
  ],
  UI_LegalPlatform_Documents_DirectEntry_NotFound: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDirectEntry.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_DirectEntry_Placeholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDirectEntry.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_DirectEntry_Pre1951: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDirectEntry.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_DirectEntry_Unavailable: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDirectEntry.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocuments.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Group_Available: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Group_NotLoaded: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Group_Selected: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_GrunnbokExtract: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentReference.utils.ts",
      ],
    },
  ],
  UI_LegalPlatform_Documents_InputDocs_Count: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocuments.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_InputDocs_Remove: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocuments.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_InputDocs_Title: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocuments.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Loading: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocuments.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_None: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocuments.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Owned_Download: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocumentItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_PantebokReference: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentReference.utils.ts",
      ],
    },
  ],
  UI_LegalPlatform_Documents_PendingElsewhere: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocumentItem.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Pre1951: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableDocumentItem.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Prefill_Added: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentsPrefill.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Prefill_Full: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentsPrefill.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Prefill_ReplaceSelection: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentsPrefill.hook.ts",
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
      ],
    },
  ],
  UI_LegalPlatform_Documents_PriceUnavailable: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformCheckout.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_RemoveCadastre: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderableList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_ReviewOrder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsInline.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_SelectionSummary: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformDocumentsInline.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Documents_Title: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalDocumentsPanel.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformPageHeader.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Failure_EnqueueFailed: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.utils.ts"],
    },
  ],
  UI_LegalPlatform_Failure_Internal: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.utils.ts"],
    },
  ],
  UI_LegalPlatform_Failure_NoData: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.utils.ts"],
    },
  ],
  UI_LegalPlatform_Failure_NotPickedUp: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.utils.ts"],
    },
  ],
  UI_LegalPlatform_Failure_Timeout: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.utils.ts"],
    },
  ],
  UI_LegalPlatform_Failure_Unknown: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.utils.ts"],
    },
  ],
  UI_LegalPlatform_FirstRun_Dismiss: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGuidance.tsx",
      ],
    },
  ],
  UI_LegalPlatform_FirstRun_Documents: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGuidance.tsx",
      ],
    },
  ],
  UI_LegalPlatform_FirstRun_Generate: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGuidance.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_BackgroundHint: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateProgress.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_Cancel: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_Close: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_DialogFooterHint: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_DialogSubtitle: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_DownloadZip: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_Error_NoCadastres: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.analysisJob.hook.ts"],
    },
  ],
  UI_LegalPlatform_Generate_Error_NoReportOption: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.analysisJob.hook.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_Error_Start: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.analysisJob.hook.ts"],
    },
  ],
  UI_LegalPlatform_Generate_Failed: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_GenerateAgain: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_GenerateReport: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_OpenOptions: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_OptionsHint: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_OrderDocuments: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_ReadySubtitle: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_ReportNameLabel: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_ReportNameOptional: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_ReportNamePlaceholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_ReportReady: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_RunInBackground: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateProgress.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_RunningTitle: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateDialog.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateProgress.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_RunningView: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateSection.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_StageCounter: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateProgress.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_Stage_Documents: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateProgress.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_Stage_Packaging: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateProgress.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_Stage_Queued: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateProgress.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Generate_Stage_Register: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateProgress.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Header_History: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalReportsPanel.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformPageHeader.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Header_Orders: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalDocumentsPanel.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformPageHeader.tsx",
      ],
    },
  ],
  UI_LegalPlatform_History_Age_Days: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Age_Rerun: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Age_Today: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Column_AnalysisName: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Column_CadastreKeys: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Column_DataAsOf: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_DefaultFileName: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Download: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx",
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
      ],
    },
  ],
  UI_LegalPlatform_History_Download_NotReady: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Empty: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Error_Download: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.analysesHistory.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_History_Error_Load: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Error_Refresh: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.analysesHistory.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_History_Loading: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Refresh: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Rerun: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_RerunTooltip: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_ResultCount: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Retry: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_SearchPlaceholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Stale: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Subtitle: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_History_Title: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformHistoryPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_CopyDocumentId_Copied: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_CopyDocumentId_Tooltip: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Creator: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Download: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Download_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentDownload.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Orders_EditTag: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Empty: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_EmptyPeriod: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_EmptySearch: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_Error_Load: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_Error_Retry: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_GroupTotal: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderGroup.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Loading: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_PendingEta: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_PendingOrderedOn: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Reorder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_ReorderCharge: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Reorder_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentOrders.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Retry: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_RetryCharge: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_RetryUnavailable: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Retry_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentOrders.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Search_Placeholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_ShowMore: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalPlatformOrdersPage.tsx"],
    },
  ],
  UI_LegalPlatform_Orders_Status_FailedNotBilled: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Status_Processing: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Status_Settled: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Subtitle: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_Superseded: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_TagRename_Cancel: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_TagRename_Done: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentOrders.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Orders_TagRename_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentOrders.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Orders_TagRename_Placeholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_TagRename_Save: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/LegalPlatformOrderBatch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Orders_TagRename_Undo: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.documentOrders.hook.ts",
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
      ],
    },
  ],
  UI_LegalPlatform_ReportOptions_AssessmentReport: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformReportOptions.tsx",
      ],
    },
  ],
  UI_LegalPlatform_ReportOptions_AssessmentReport_Detail: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformReportOptions.tsx",
      ],
    },
  ],
  UI_LegalPlatform_ReportOptions_ExcelFile: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformReportOptions.tsx",
      ],
    },
  ],
  UI_LegalPlatform_ReportOptions_ExcelFile_Detail: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformReportOptions.tsx",
      ],
    },
  ],
  UI_LegalPlatform_ReportOptions_PropertyReport: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformReportOptions.tsx",
      ],
    },
  ],
  UI_LegalPlatform_ReportOptions_PropertyReport_Detail: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformReportOptions.tsx",
      ],
    },
  ],
  UI_LegalPlatform_ReportOptions_Title: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformReportOptions.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Reports_Description: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalReportsPanel.tsx"],
    },
  ],
  UI_LegalPlatform_Reports_LockedHint: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/LegalReportsPanel.tsx"],
    },
  ],
  UI_LegalPlatform_Reports_Title: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalReportsPanel.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformPageHeader.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_LegalPlatform_Search_Added: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabSearch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Search_Empty: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabSearch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Search_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.searchCadastres.utils.ts",
      ],
    },
  ],
  UI_LegalPlatform_Search_Group_AddAll: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabSearch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Search_Group_Hide: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabSearch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Search_Group_Sections: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabSearch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Search_Group_Show: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabSearch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Search_Placeholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabSearch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Search_Searching: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabSearch.tsx",
      ],
    },
  ],
  UI_LegalPlatform_StepCounter: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/sections/LegalPlatformDialog.tsx"],
    },
  ],
  UI_LegalPlatform_Step_AddProperties: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.steps.constants.ts"],
    },
  ],
  UI_LegalPlatform_Step_AddToOrder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.steps.constants.ts"],
    },
  ],
  UI_LegalPlatform_Step_ChooseContents: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.steps.constants.ts"],
    },
  ],
  UI_LegalPlatform_Step_ConfirmOrder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.steps.constants.ts"],
    },
  ],
  UI_LegalPlatform_Step_GetZip: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.steps.constants.ts"],
    },
  ],
  UI_LegalPlatform_Step_PickDocuments: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/legalPlatform/legalPlatform.steps.constants.ts"],
    },
  ],
  UI_LegalPlatform_Summary_BillableCount: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_Copy: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_Copy_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.purchaseSummary.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Summary_DocumentCount: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_Empty: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_ExportCsv: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_ExportFileName: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.purchaseSummary.hook.ts",
      ],
    },
  ],
  UI_LegalPlatform_Summary_FailedExcluded: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_From: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_InvalidRange: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_Overline: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_Provisional: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_To: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Summary_Unsettled: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformSpendSummary.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_AddCadastres: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_AddCadastresCount: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_AlreadyListed: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_Duplicate: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_LookingUp: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_NotFound: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_OverLimit: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_Placeholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_Ready: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabPaste_Unrecognized: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabPaste.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabTags_AlreadyAddedSuffix: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabTags.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabTags_CadastreCount: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabTags.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabTags_Error: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabTags.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabTags_Import: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.tracking.ts",
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabTags.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabTags_LookingUp: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabTags.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabTags_NoResults: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabTags.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabTags_Placeholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabTags.tsx",
      ],
    },
  ],
  UI_LegalPlatform_TabTags_SearchPlaceholder: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/tabs/LegalPlatformTabTags.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Tab_Paste: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalReportsPanel.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Tab_Search: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalReportsPanel.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Tab_Tags: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/LegalReportsPanel.tsx",
        "v2-console/src/legalPlatform/sections/LegalPlatformCadastreList.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Warning_AmbitaUnavailable: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Warning_BuildIssues: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Warning_PdfsPartial: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Warning_PdfsUnreachable: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Warning_RightsCountsScoped: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Warning_RightsPartial: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LegalPlatform_Warning_Unknown: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/sections/LegalPlatformGenerateOutcome.tsx",
      ],
    },
  ],
  UI_LineOfSight_AddTargets: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSight.tsx",
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Create: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSight.tsx"],
    },
  ],
  UI_LineOfSight_Empty: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Finish: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSight.tsx"],
    },
  ],
  UI_LineOfSight_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSight.tsx"],
    },
  ],
  UI_LineOfSight_ListHeader: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_ListItem: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_ListItem_Targets: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_MoveTarget: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSight.tsx"],
    },
  ],
  UI_LineOfSight_MoveTarget_Cancel: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSight.tsx"],
    },
  ],
  UI_LineOfSight_Remove: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_RemoveAll: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Rename: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetLineOfSightButton.tsx",
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightSuspender.tsx",
      ],
    },
  ],
  UI_LineOfSight_Target: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Target_Occluded: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Target_Remove: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Target_Unknown: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Target_Visible: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_Toggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_LineOfSight_ZoomTo: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightList.tsx",
      ],
    },
  ],
  UI_MapContextMenu_Action_AddToLegalList_Root: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.cadastreClickHandler.hook.ts",
      ],
    },
  ],
  UI_MapContextMenu_Action_GoToLocation_Root: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/layer/TagAggregatedLayerBindings.tsx",
      ],
    },
  ],
  UI_MapContextMenu_Action_OpenBuilding_Root: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/map.layer.navLayer.clickHandlers.ts",
      ],
    },
  ],
  UI_MapContextMenu_Action_OpenCadastre_Root: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/navLayer/map.layer.navLayer.clickHandlers.ts",
        "v2-console/src/map/layer/navLayer/map.layer.navLayer.external.ts",
      ],
    },
  ],
  UI_MapContextMenu_Action_RemoveFromLegalList_Root: [
    {
      label: "Legal Platform",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/legalPlatform/legalPlatform.cadastreClickHandler.hook.ts",
      ],
    },
  ],
  UI_MapContextMenu_Action_SelectCell_Root: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/interaction/StatisticsGridSelectionHandler.tsx",
      ],
    },
  ],
  UI_MapContextMenu_Action_SelectCluster_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/selection/dataset.selection.tsx"],
    },
  ],
  UI_MapContextMenu_Action_SelectIntersecting_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/action/contextMenu.action.intersectPolygon.tsx",
      ],
    },
  ],
  UI_MapContextMenu_Action_Select_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/selection/dataset.selection.tsx"],
    },
  ],
  UI_MapContextMenu_Action_ShadowCast_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/shadowCast/map.widget.shadowCast.contextMenu.ts",
      ],
    },
  ],
  UI_MapContextMenu_Action_TravelTime_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.contextMenu.ts",
      ],
    },
  ],
  UI_MapContextMenu_Action_ZoomToCluster_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: ["v2-console/src/dataset/selection/dataset.selection.tsx"],
    },
  ],
  UI_MapContextMenu_Back_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/contextMenu/MapContextMenu.tsx"],
    },
  ],
  UI_MapContextMenu_Chooser_Description_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/contextMenu/MapContextMenu.tsx"],
    },
  ],
  UI_MapContextMenu_Chooser_Title_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/contextMenu/MapContextMenu.tsx"],
    },
  ],
  UI_MapContextMenu_Close_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/contextMenu/MapContextMenu.tsx"],
    },
  ],
  UI_MapContextMenu_Group_Actions_Root: [
    {
      label: "Context Menu",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/contextMenu/map.contextMenu.groups.ts"],
    },
  ],
  UI_MapContextMenu_Group_Buildings_Root: [
    {
      label: "Context Menu",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/contextMenu/map.contextMenu.groups.ts"],
    },
  ],
  UI_MapContextMenu_Group_Dataset_Root: [
    {
      label: "Context Menu",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/contextMenu/map.contextMenu.groups.ts"],
    },
  ],
  UI_MapContextMenu_Group_MapHits_Root: [
    {
      label: "Context Menu",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/contextMenu/map.contextMenu.groups.ts"],
    },
  ],
  UI_MapContextMenu_Group_Navigation_Root: [
    {
      label: "Context Menu",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/contextMenu/map.contextMenu.groups.ts"],
    },
  ],
  UI_MapContextMenu_Group_Properties_Root: [
    {
      label: "Context Menu",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/contextMenu/map.contextMenu.groups.ts"],
    },
  ],
  UI_MapContextMenu_Group_Selection_Root: [
    {
      label: "Context Menu",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/contextMenu/map.contextMenu.groups.ts"],
    },
  ],
  UI_MapContextMenu_ItemCount_Root: [
    {
      label: "Datasets",
      url: "https://app.placepoint.no/map/datasets",
      files: [
        "v2-console/src/dataset/selection/contextMenu/hits/dataset/contextMenu.hits.dataset.utils.tsx",
      ],
    },
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/map.layer.menu.popupClickHandler.tsx",
        "v2-console/src/map/layer/menu/map.layer.menu.rasterPopupClickHandler.tsx",
        "v2-console/src/map/layer/menu/map.layer.menu.vectorTilePopupClickHandler.tsx",
      ],
    },
  ],
  UI_MapContextMenu_NoActions_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/contextMenu/MapContextMenu.tsx"],
    },
  ],
  UI_MapContextMenu_SearchPlaceholder_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/contextMenu/MapContextMenu.tsx"],
    },
  ],
  UI_MapLayer_NavLayer_UnsupportedDescription: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/navLayer/map.layer.navLayer.utils.tsx"],
    },
  ],
  UI_MapLayer_NavLayer_UnsupportedTitle: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/navLayer/map.layer.navLayer.utils.tsx"],
    },
  ],
  UI_MapMainLoader_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/MapMainLoader.tsx"],
    },
  ],
  UI_MapSceneViewFOV_Description: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sceneView/fov/MapSceneViewFOVFormItem.tsx"],
    },
  ],
  UI_MapSceneViewFOV_Label: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sceneView/fov/MapSceneViewFOVFormItem.tsx"],
    },
  ],
  UI_MapSceneViewFOV_ResetButton_Description: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sceneView/fov/MapSceneViewFOVFormItem.tsx"],
    },
  ],
  UI_MapSceneViewGarniture_GarnitureSub_BridgesAndDocks: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_GarnitureSub_FencesAndWalls: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_GarnitureSub_Other: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_GarnitureSub_PolesAndMasts: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_GarnitureToggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_BridgeDeck: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_BridgeDetail: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Chimney: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Crossarm: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Dock: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Fence: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_FencePost: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_FlagPole: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Foundation: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_FreestandingWall: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_GatePost: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Hedge: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_LampPost: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Mast: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_PoolEdge: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_PowerLine: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_RetainingWall: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_RoadBarrier: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_RoadRailing: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_StairSteps: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Stairs: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_StoneFence: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_SwimmingPool: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Tank: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_Item_Wall: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_TreesSub_CityTrees: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_TreesSub_Forest: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_TreesSub_Trees: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewGarniture_TreesToggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/garniture/MapSceneViewGarnitureSettings.tsx",
      ],
    },
  ],
  UI_MapSceneViewSettings_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sceneView/settings/map.sceneView.settings.text.ts",
      ],
    },
  ],
  UI_MapWidget_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/daylight/MapWidgetDaylightSuspender.tsx",
        "v2-console/src/map/widget/elevationProfile/MapWidgetElevationProfileSuspender.tsx",
        "v2-console/src/map/widget/lineOfSight/MapWidgetLineOfSightSuspender.tsx",
        "v2-console/src/map/widget/measure/MapWidgetMeasureSuspender.tsx",
        "v2-console/src/map/widget/print/MapWidgetPrintFocusMode.tsx",
      ],
    },
  ],
  UI_MapWidget_Screenshot_Cancel: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/screenshot/MapWidgetScreenshotDialog.tsx",
      ],
    },
  ],
  UI_MapWidget_Screenshot_CopyToClipboard: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/screenshot/MapWidgetScreenshotDialog.tsx",
      ],
    },
  ],
  UI_MapWidget_Screenshot_Dialog: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/screenshot/map.widget.screenshot.text.ts",
      ],
    },
  ],
  UI_MapWidget_Screenshot_Save: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/screenshot/MapWidgetScreenshotDialog.tsx",
      ],
    },
  ],
  UI_MapWidget_Screenshot_SaveAs: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/screenshot/MapWidgetScreenshotDialog.tsx",
      ],
    },
  ],
  UI_Map_3d_Trees: [
    {
      label: "3d",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/3d/map.3d.trees.ts"],
    },
  ],
  UI_Map_Layer_Active_AddLayer: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveList.tsx"],
    },
  ],
  UI_Map_Layer_Active_AriaLabel: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveList.tsx"],
    },
  ],
  UI_Map_Layer_Active_Blend_Button: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveBlendButton.tsx"],
    },
  ],
  UI_Map_Layer_Active_Effect_Button: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveEffectButton.tsx"],
    },
  ],
  UI_Map_Layer_Active_Empty: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveList.tsx"],
    },
  ],
  UI_Map_Layer_Active_Expand_All_Collapse_All: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveExpandAllButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_Expand_All_Expand_All: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveExpandAllButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveList.tsx"],
    },
  ],
  UI_Map_Layer_Active_Label_Toggle_Hide: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveLabelToggleButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_Label_Toggle_Show: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveLabelToggleButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_Legend_Toggle_Hide: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveLegendToggleButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_Legend_Toggle_Show: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveLegendToggleButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_ListItem_AriaLabel: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveListItem.tsx"],
    },
  ],
  UI_Map_Layer_Active_ListItem_Expand_Button_Hide: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveListItemExpandButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_ListItem_Expand_Button_Loading: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveListItemExpandButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_ListItem_Expand_Button_Show: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveListItemExpandButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_ListItem_Expand_Button_Warning: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveListItemExpandButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_ListItem_Expand_Button_Warning_Description: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveListItemExpandButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_ListItem_Sub_AriaLabel: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveListItemSub.tsx"],
    },
  ],
  UI_Map_Layer_Active_ListItem_Title_Count_AriaLabel: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveListItemTitle.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_ListItem_Toggle_Hide: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveExpandButton.tsx"],
    },
  ],
  UI_Map_Layer_Active_ListItem_Toggle_Show: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveExpandButton.tsx"],
    },
  ],
  UI_Map_Layer_Active_Result_Button: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveResultButton.tsx"],
    },
  ],
  UI_Map_Layer_Active_ScaleWarning_Banner: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveScaleWarning.tsx"],
    },
  ],
  UI_Map_Layer_Active_ScaleWarning_ClickToZoom: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveScaleWarning.tsx"],
    },
  ],
  UI_Map_Layer_Active_ScaleWarning_ListIntro: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveScaleWarning.tsx"],
    },
  ],
  UI_Map_Layer_Active_ScaleWarning_SeeDetails: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/active/MapLayerActiveScaleWarning.tsx"],
    },
  ],
  UI_Map_Layer_Active_Scale_TooClose: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveScaleIndicator.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_Scale_TooFar: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveScaleIndicator.tsx",
      ],
    },
  ],
  UI_Map_Layer_Active_Visibility_Button_Label: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/active/MapLayerActiveVisibilityButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Details_Category_Label: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuDetailsDialog.tsx"],
    },
  ],
  UI_Map_Layer_Details_CreatedAt_Label: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuDetailsDialog.tsx"],
    },
  ],
  UI_Map_Layer_Details_Feature_Code_Label: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuDetailsDialog.tsx"],
    },
  ],
  UI_Map_Layer_Details_Type_Label: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuDetailsDialog.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Blend_Close: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/blend/MapLayerBlendManager.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Blend_Default: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/blend/MapLayerBlendModeList.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Blend_Error: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/blend/MapLayerBlendModeList.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Blend_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/blend/MapLayerBlendModeList.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Blend_Reset: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/blend/MapLayerBlendManager.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Blend_Standard: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/blend/MapLayerBlendManager.tsx"],
    },
  ],
  UI_Map_Layer_Edit_CloseConfirm_Description: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFocusMode.tsx"],
    },
  ],
  UI_Map_Layer_Edit_CloseConfirm_Discard: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFocusMode.tsx"],
    },
  ],
  UI_Map_Layer_Edit_CloseConfirm_Keep: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFocusMode.tsx"],
    },
  ],
  UI_Map_Layer_Edit_CloseConfirm_Title: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFocusMode.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Effect_Close: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/effect/MapLayerEffectManager.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Effect_Error: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/effect/MapLayerEffectList.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Effect_Reset: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/effect/MapLayerEffectManager.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Effect_Standard: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/effect/MapLayerEffectManager.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Effect_Widget: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/effect/MapLayerEffectList.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Button: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Count_Error: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFooter.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Count_Features: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/edit/MapLayerEditFooter.tsx",
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsPanel.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Count_Loading: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/edit/MapLayerEditFooter.tsx",
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsPanel.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Count_OfTotal: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFooter.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Count_Retry: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFooter.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Error_Generic: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/fields/map.layer.filter.field.useDateBounds.ts",
        "v2-console/src/map/layer/filter/fields/map.layer.filter.field.useHistogram.ts",
        "v2-console/src/map/layer/filter/fields/map.layer.filter.field.useRangeBounds.ts",
        "v2-console/src/map/layer/filter/fields/map.layer.filter.field.useSelectOptions.ts",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Error_TryAgain: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/fields/MapLayerFilterFieldState.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_FollowExtent: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/MapLayerFilterExtentToggle.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_HideResults: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFooter.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Histogram_NotEnoughData: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/MapLayerFilterHistogram.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_LayerNotVisible: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_MatchCount: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFooter.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_NoFilters: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/edit/MapLayerEditFilterTab.tsx",
        "v2-console/src/map/layer/filter/MapLayerFilters.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_NoFiltersAvailable: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/MapLayerFilterLayerItems.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_NoMatches: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/fields/MapLayerFilterFieldState.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_PackageRequired_Message: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_PackageRequired_Title: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Panel_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFocusMode.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Reset: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/MapLayerFilterLayerItem.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_ResetAll: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/edit/MapLayerEditFocusMode.tsx",
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsPills.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_ResetFilter: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/MapLayerFilterLayerItem.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Results_Close: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsPanel.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Results_Columns: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsTableOrder.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Results_Expand: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsPanel.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Results_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Results_Placement: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsPanel.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Results_ZoomTo: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsZoomButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_FallbackLabel: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/fields/map.layer.filter.field.useSelectOptions.ts",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_HideAll: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_Option_Aria: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_Search_Placeholder: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_ShowAll: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_ShowAllCount: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_ShowAllFromSearch: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_ShowFewer: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_SortSelected: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/map.layer.filter.text.ts"],
    },
  ],
  UI_Map_Layer_Edit_Filter_Select_TooManyValues: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/fields/map.layer.filter.field.useSelectOptions.ts",
      ],
    },
  ],
  UI_Map_Layer_Edit_Filter_ShowResults: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFooter.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_ZoomToResults: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/MapLayerFilterExtentToggle.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Filter_ZoomToResultsFollowExtent: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/filter/MapLayerFilterExtentToggle.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Footer: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFooter.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Footer_Save: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFooter.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_BlendMode: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditStyleTab.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_Changed: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditStyleControl.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_Default: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditStyleTab.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_Effects: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditStyleTab.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_Effects_Open: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditStyleTab.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_Panel_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFocusMode.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_Reset: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditStyleControl.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_ResetAll: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditFocusMode.tsx"],
    },
  ],
  UI_Map_Layer_Edit_Style_ShowLabels: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/edit/MapLayerEditStyleTab.tsx"],
    },
  ],
  UI_Map_Layer_Error_Title: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuErrorIndicators.tsx"],
    },
  ],
  UI_Map_Layer_Favorite_Button_Add: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/favorite/MapLayerFavoriteButton.tsx"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreFavoriteButton.tsx"],
    },
  ],
  UI_Map_Layer_Favorite_Button_Remove: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/favorite/MapLayerFavoriteButton.tsx"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreFavoriteButton.tsx"],
    },
  ],
  UI_Map_Layer_Favorite_Error: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/favorite/MapLayerFavoriteButton.tsx"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreFavoriteButton.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_AddLayer: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuList.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_BrowseLayers: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuList.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Empty: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuList.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_ExpandSublayers: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx",
        "v2-console/src/map/activeLayer/MapActiveLayerMenuSubItem.tsx",
        "v2-console/src/map/activeLayer/MapActiveLayerMenuTagItem.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Active_Filter: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Filtered: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuList.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Info: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerInfoButton.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Info_Docs: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerInfoButton.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Info_Provider: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerInfoButton.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Info_UpdateFrequency: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerInfoButton.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_MoreActions: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Remove: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_ResetFilter: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_ResetFilter_Confirm: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_ResetStyle: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_ResetStyle_Confirm: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Style: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Styled: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_SublayerCount: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerItemCount.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_Sublayer_ToggleVisibility: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/activeLayer/MapActiveLayerMenuSubItem.tsx",
        "v2-console/src/map/activeLayer/MapActiveLayerMenuTagItem.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Active_ToggleVisibility: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_UnsupportedIn3d: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenu.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Active_ViewLegend: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuRow.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Categories: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/category/MapLayerMenuCategory.tsx",
        "v2-console/src/map/layer/menu/category/MapLayerMenuCategoryGridItem.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Categories_Icon: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/category/MapLayerMenuCategoryGridItem.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Favorites: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/favorite/MapLayerMenuFavorites.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_ListItem_LoadError: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuList.tsx"],
    },
  ],
  UI_Map_Layer_Menu_List_Empty: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuList.tsx"],
    },
  ],
  UI_Map_Layer_Menu_More: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/MapLayerMenuListItem.tsx",
        "v2-console/src/map/layer/toggleButton/MapLayerToggleMenuRow.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Panel_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuPanelContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Placeholder_Error: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/category/layer/MapLayerMenuCategoryLayers.tsx",
        "v2-console/src/map/layer/toggleButton/MapLayerToggleButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Search_Placeholder: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/search/MapLayerMenuSearch.tsx"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Search_Placeholder_Error: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/search/MapLayerMenuSearch.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_Add: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreAddButton.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_Added: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreAddButton.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatActions: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChatView.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatBack: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChatView.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatDeleteDescription: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChatView.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatDeleteTitle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChatView.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatEmptyDescription: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChat.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatEmptyTitle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChat.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatLoading: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChat.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatNew: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChatView.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatPlaceholder: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChat.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatRename: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChatView.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatRetry: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChat.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatSuggestionDemographics: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/map.store.chat.constants.ts"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatSuggestionRisk: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/map.store.chat.constants.ts"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatSuggestionZoning: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/map.store.chat.constants.ts"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatSuggestionsTitle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChat.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatThinking: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChat.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatTitle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/chat/MapStoreChatView.tsx",
        "v2-console/src/map/store/chat/map.store.chat.api.ts",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatToday: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/chat/MapStoreChat.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ChatToggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_Close: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreContent.tsx",
        "v2-console/src/map/store/chat/MapStoreChatView.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_CountAcross: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_CountCategories: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_CountLayers: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_DetailDocs: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreLayerDetailDrawer.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_DetailNoDescription: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreLayerDetailDrawer.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_DetailUpdateFrequency: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreLayerDetailDrawer.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_DialogTitle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreContent.tsx",
        "v2-console/src/map/store/MapStoreDialog.tsx",
        "v2-console/src/map/store/chat/MapStoreChatView.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_EmptyNoAddedDescription: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreGrid.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_EmptyNoFavoritesDescription: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreGrid.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_EmptyNoLayersTitle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreGrid.tsx",
        "v2-console/src/map/store/MapStoreSections.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_EmptyNoRecentDescription: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreGrid.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_LayoutHorizontal: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_LayoutSidebar: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_Meta2dOnly: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreCard.tsx",
        "v2-console/src/map/store/MapStoreLayerDetailDrawer.tsx",
        "v2-console/src/map/store/map.store.catalog.ts",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_MetaFilters: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreCard.tsx",
        "v2-console/src/map/store/MapStoreLayerDetailDrawer.tsx",
        "v2-console/src/map/store/map.store.catalog.ts",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_MetaSublayers: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreCard.tsx",
        "v2-console/src/map/store/MapStoreLayerDetailDrawer.tsx",
        "v2-console/src/map/store/map.store.catalog.ts",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_More: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContentHorizontal.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_TabAdded: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreContentHorizontal.tsx",
        "v2-console/src/map/store/MapStoreContentSidebar.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_TabAll: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreContentHorizontal.tsx",
        "v2-console/src/map/store/MapStoreContentSidebar.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_TabFavorite: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreContentHorizontal.tsx",
        "v2-console/src/map/store/MapStoreContentSidebar.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_TabRecent: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/store/MapStoreContentHorizontal.tsx",
        "v2-console/src/map/store/MapStoreContentSidebar.tsx",
      ],
    },
  ],
  UI_Map_Layer_Menu_Store_ViewGrid: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Store_ViewList: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/store/MapStoreContent.tsx"],
    },
  ],
  UI_Map_Layer_Menu_Unsupported: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/MapLayerMenuListItem.tsx",
        "v2-console/src/map/layer/toggleButton/MapLayerToggleButton.tsx",
      ],
    },
  ],
  UI_Map_Layer_Preview_LoadError: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/preview/MapLayerPreviewOpener.tsx"],
    },
  ],
  UI_Map_Layer_Preview_LoadErrorDescription: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/preview/MapLayerPreviewOpener.tsx"],
    },
  ],
  UI_Map_Layer_Preview_Previewing: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/preview/MapLayerPreviewOpener.tsx"],
    },
  ],
  UI_Map_Layer_Preview_Published: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/preview/MapLayerPreviewOpener.tsx"],
    },
  ],
  UI_Map_Layer_Preview_Unpublished: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/preview/MapLayerPreviewOpener.tsx"],
    },
  ],
  UI_Map_Layer_Result_Count_Label: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/result/MapLayerResultPanelContent.tsx"],
    },
  ],
  UI_Map_Layer_Result_Error_TableUnavailable: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/result/MapLayerResultPanelContent.tsx"],
    },
  ],
  UI_Map_Layer_Result_Export_FileName: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/result/MapLayerResultPanelContent.tsx"],
    },
  ],
  UI_Map_Layer_Result_Export_Tooltip: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/filter/results/MapLayerFilterResultsPanel.tsx",
        "v2-console/src/map/layer/result/MapLayerResultExportButton.tsx",
        "v2-console/src/map/layer/result/MapLayerResultPanelContent.tsx",
      ],
    },
  ],
  UI_Map_Layer_Result_Loading: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/result/map.layer.result.text.ts"],
    },
  ],
  UI_Map_Layer_Result_Panel_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/result/MapLayerResultPanelContent.tsx"],
    },
  ],
  UI_Map_Layer_Result_Table_Disabled: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/result/MapLayerResultTable.tsx"],
    },
  ],
  UI_Map_Layer_Result_Table_MissingConfig: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/result/MapLayerResultTable.tsx"],
    },
  ],
  UI_Map_Layer_Result_Table_MissingLayer: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/result/MapLayerResultTable.tsx"],
    },
  ],
  UI_Map_Layer_Warning_Title: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/layer/menu/MapLayerMenuErrorIndicators.tsx"],
    },
  ],
  UI_Map_Legend_Empty_Body: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/legend/MapLegendEmpty.tsx"],
    },
  ],
  UI_Map_Legend_Empty_Title: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/legend/MapLegendEmpty.tsx"],
    },
  ],
  UI_Map_Legend_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/legend/MapLegend.tsx",
        "v2-console/src/map/legend/MapLegendButton.tsx",
      ],
    },
  ],
  UI_Map_MapCoordinatesDisplay_Copy: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/MapCoordinatesDisplay.tsx"],
    },
  ],
  UI_Map_MapCopyright_And: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/MapCopyright.tsx"],
    },
  ],
  UI_Map_MapCopyright_BaseMapLabel: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/MapCopyright.tsx"],
    },
  ],
  UI_Map_MapCopyright_GeodataAs: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/MapCopyright.tsx"],
    },
  ],
  UI_Map_MapCopyright_Geovekst: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/MapCopyright.tsx"],
    },
  ],
  UI_Map_MapCopyright_Kartverket: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/MapCopyright.tsx"],
    },
  ],
  UI_Map_MapCopyright_Kommuner: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/MapCopyright.tsx"],
    },
  ],
  UI_Map_MapExportFeatureLayerButton_Export: [
    {
      label: "Export",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/export/MapExportFeatureLayerButton.tsx"],
    },
  ],
  UI_Map_MapExport_FailureToast: [
    {
      label: "Export",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/export/map.export.utils.ts"],
    },
  ],
  UI_Map_MapExport_NotFoundToast: [
    {
      label: "Export",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/export/map.export.utils.ts"],
    },
  ],
  UI_Map_MapGoToButton_Navigate: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/MapGoToButton.tsx"],
    },
  ],
  UI_Map_MapGraphicDisplayerCenterButton_Center: [
    {
      label: "Graphic",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-map-ui/src/graphic/displayer/MapGraphicDisplayerCenterButton.tsx",
      ],
    },
  ],
  UI_Map_MapGraphicDisplayerItem_Center: [
    {
      label: "Graphic",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/graphic/displayer/MapGraphicDisplayerItem.tsx"],
    },
  ],
  UI_Map_MapGraphicDisplayerItem_Remove: [
    {
      label: "Graphic",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/graphic/displayer/MapGraphicDisplayerItem.tsx"],
    },
  ],
  UI_Map_MapGraphicDisplayerResetButton_Reset: [
    {
      label: "Graphic",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-map-ui/src/graphic/displayer/MapGraphicDisplayerResetButton.tsx",
      ],
    },
  ],
  UI_Map_MapGraphicDisplayerVisibilityButton_Hide: [
    {
      label: "Graphic",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-map-ui/src/graphic/displayer/MapGraphicDisplayerVisibilityButton.tsx",
      ],
    },
  ],
  UI_Map_MapGraphicDisplayerVisibilityButton_Show: [
    {
      label: "Graphic",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-map-ui/src/graphic/displayer/MapGraphicDisplayerVisibilityButton.tsx",
      ],
    },
  ],
  UI_Map_MapHoverPopupHost_MoreCount: [
    {
      label: "Hover",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/hover/MapHoverPopupHost.tsx"],
    },
  ],
  UI_Map_MapLabelAnnotationSettings_Background: [
    {
      label: "Labels",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/labels/annotation/MapLabelAnnotationSettings.tsx"],
    },
  ],
  UI_Map_MapLabelAnnotationSettings_FontSize: [
    {
      label: "Labels",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/labels/annotation/MapLabelAnnotationSettings.tsx"],
    },
  ],
  UI_Map_MapLabelAnnotation_Placeholder: [
    {
      label: "Labels",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/labels/annotation/MapLabelAnnotation.tsx"],
    },
  ],
  UI_Map_MapLayerDisplayerCenterButton_Center: [
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-map-ui/src/layer/displayer/MapLayerDisplayerCenterButton.tsx",
      ],
    },
  ],
  UI_Map_MapLayerDisplayerResetButton_Reset: [
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/layer/displayer/MapLayerDisplayerResetButton.tsx"],
    },
  ],
  UI_Map_MapLayerDisplayerVisibilityButton_Hide: [
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-map-ui/src/layer/displayer/MapLayerDisplayerVisibilityButton.tsx",
      ],
    },
  ],
  UI_Map_MapLayerDisplayerVisibilityButton_Show: [
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-map-ui/src/layer/displayer/MapLayerDisplayerVisibilityButton.tsx",
      ],
    },
  ],
  UI_Map_MapLayerLegendMapImage_LoadFailed: [
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/layer/legend/MapLayerLegendMapImage.tsx"],
    },
  ],
  UI_Map_MapLayerLegendVectorTile_Other: [
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-map-ui/src/layer/legend/map.layer.legend.vectorTile.hooks.ts",
      ],
    },
  ],
  UI_Map_MapLayerLegend_Loading: [
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/layer/legend/MapLayerLegendMapImage.tsx"],
    },
  ],
  UI_Map_MapLayerLegend_Unavailable: [
    {
      label: "Layer",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/layer/legend/MapLayerLegendWMS.tsx"],
    },
  ],
  UI_Map_MapLayerPopup_No: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/map.layer.menu.vectorTilePopupClickHandler.tsx",
      ],
    },
  ],
  UI_Map_MapLayerPopup_Yes: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: [
        "v2-console/src/map/layer/menu/map.layer.menu.vectorTilePopupClickHandler.tsx",
      ],
    },
  ],
  UI_Map_MapPopupFeatureLayer_ShowInPopupCluster: [
    {
      label: "Popup",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/popup/map.popup.featureLayer.utils.ts"],
    },
  ],
  UI_Map_MapPopupFeatureLayer_ShowInPopupSingle: [
    {
      label: "Popup",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/popup/map.popup.featureLayer.utils.ts"],
    },
  ],
  UI_Map_MapPopupFeatureLayer_ZoomToPoint: [
    {
      label: "Popup",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/popup/map.popup.featureLayer.utils.ts"],
    },
  ],
  UI_Map_MapScreenshot_Alt: [
    {
      label: "Screenshot",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/screenshot/MapScreenshot.tsx"],
    },
  ],
  UI_Map_MapSketchDrawAddButton_Complete: [
    {
      label: "Draw",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/draw/MapSketchDrawAddButton.tsx"],
    },
  ],
  UI_Map_MapSketchDrawAddButton_Draw: [
    {
      label: "Draw",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/draw/MapSketchDrawAddButton.tsx"],
    },
  ],
  UI_Map_MapSketchDrawAddButton_Edit: [
    {
      label: "Draw",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/draw/MapSketchDrawAddButton.tsx"],
    },
  ],
  UI_Map_MapSketchDrawResetButton_Reset: [
    {
      label: "Draw",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/draw/MapSketchDrawResetButton.tsx"],
    },
  ],
  UI_Map_MapSketchDrawScreenButton_Draw: [
    {
      label: "Draw",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/draw/MapSketchDrawScreenButton.tsx"],
    },
  ],
  UI_Map_MapSketchDrawVisibilityButton_Hide: [
    {
      label: "Draw",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/draw/MapSketchDrawVisibilityButton.tsx"],
    },
  ],
  UI_Map_MapSketchDrawVisibilityButton_Show: [
    {
      label: "Draw",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/draw/MapSketchDrawVisibilityButton.tsx"],
    },
  ],
  UI_Map_MapSketchScreen_Tooltip: [
    {
      label: "Draw",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/draw/MapSketchDrawScreenButton.tsx"],
    },
  ],
  UI_Map_MapTable_RowCount: [
    {
      label: "Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/table/MapTableFeatureLayer.tsx"],
    },
  ],
  UI_Map_MapViewer2D_WebglError: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-map-ui/src/map.utils.ts"],
    },
  ],
  UI_Map_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sidebar/MapSidebar.tsx",
        "v2-console/src/map/sidebar/map.sidebar.registry.tsx",
      ],
    },
  ],
  UI_Map_Widget_KeepOpen_Toggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/MapWidgetKeepOpenToggle.tsx"],
    },
  ],
  UI_Map_Widget_Toolbar_MoreTools: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/MapWidgetToolbarOverflower.tsx"],
    },
  ],
  UI_MarketData_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
    {
      label: "Market Data",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/marketData/MarketDataFrame.tsx"],
    },
  ],
  UI_Measure_DrawArea: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/MapWidgetMeasureActions.tsx"],
    },
  ],
  UI_Measure_DrawCircle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/map.widget.measure.text.ts"],
    },
  ],
  UI_Measure_DrawLine: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/MapWidgetMeasureActions.tsx"],
    },
  ],
  UI_Measure_Empty: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/MapWidgetMeasureList.tsx"],
    },
  ],
  UI_Measure_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/MapWidgetMeasure.tsx"],
    },
  ],
  UI_Measure_ListHeader: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/MapWidgetMeasureList.tsx"],
    },
  ],
  UI_Measure_Remove: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/MapWidgetMeasureListItem.tsx"],
    },
  ],
  UI_Measure_RemoveAll: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/MapWidgetMeasureList.tsx"],
    },
  ],
  UI_Measure_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetMeasureButton.tsx",
        "v2-console/src/map/widget/measure/MapWidgetMeasureSuspender.tsx",
      ],
    },
  ],
  UI_Measure_ZoomTo: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/measure/MapWidgetMeasureListItem.tsx"],
    },
  ],
  UI_ModelGen_Chat_Back: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_Breadcrumb: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_CardFallbackName: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenResultCard.tsx"],
    },
  ],
  UI_ModelGen_Chat_CardTypeLabel: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenResultCard.tsx"],
    },
  ],
  UI_ModelGen_Chat_ComposerPlaceholder: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenChat.tsx"],
    },
  ],
  UI_ModelGen_Chat_CopyCode: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenChat.tsx"],
    },
  ],
  UI_ModelGen_Chat_CopyPrompt: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenChat.tsx"],
    },
  ],
  UI_ModelGen_Chat_Download: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenResultCard.tsx"],
    },
  ],
  UI_ModelGen_Chat_EmptyThread: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenChat.tsx"],
    },
  ],
  UI_ModelGen_Chat_FallbackNotes: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: [
        "v2-console/src/model/gen/ModelGenChat.tsx",
        "v2-console/src/model/gen/ModelGenResultCard.tsx",
      ],
    },
  ],
  UI_ModelGen_Chat_HeaderDeleteConfirm: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_HeaderMenu: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_HeaderRenameInput: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_HeaderReset: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_HeaderResetConfirm: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_HeaderResetPrompt: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_OpenPreview: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenResultCard.tsx"],
    },
  ],
  UI_ModelGen_Chat_OriginDialog: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_Retry: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenChat.tsx"],
    },
  ],
  UI_ModelGen_Chat_SessionFailed: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSessionDrawer.tsx"],
    },
  ],
  UI_ModelGen_Chat_SessionNew: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSessionDrawer.tsx"],
    },
  ],
  UI_ModelGen_Chat_SessionUnseen: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSessionDrawer.tsx"],
    },
  ],
  UI_ModelGen_Chat_StepGenerating: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.constants.ts"],
    },
  ],
  UI_ModelGen_Chat_StepRepairing: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.constants.ts"],
    },
  ],
  UI_ModelGen_Chat_StepRunning: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.constants.ts"],
    },
  ],
  UI_ModelGen_Chat_SuggestionApartments: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.presets.ts"],
    },
  ],
  UI_ModelGen_Chat_SuggestionHouse: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.presets.ts"],
    },
  ],
  UI_ModelGen_Chat_SuggestionOffice: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.presets.ts"],
    },
  ],
  UI_ModelGen_Chat_Suggestions: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenChat.tsx"],
    },
  ],
  UI_ModelGen_Chat_TitleFallback: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Chat_Today: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenChat.tsx"],
    },
  ],
  UI_ModelGen_Chat_Welcome: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenChat.tsx"],
    },
  ],
  UI_ModelGen_Error_GaveUp: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.runtime.context.tsx"],
    },
  ],
  UI_ModelGen_Error_NoCode: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.runtime.context.tsx"],
    },
  ],
  UI_ModelGen_Error_RenderVersion: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: [
        "v2-console/src/model/gen/ModelGenVersionDialog.tsx",
        "v2-console/src/model/gen/modelGen.runtime.context.tsx",
      ],
    },
  ],
  UI_ModelGen_Executor_WorkerCrashed: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.executor.ts"],
    },
  ],
  UI_ModelGen_Overview_DeleteConfirm: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverviewCard.tsx"],
    },
  ],
  UI_ModelGen_Overview_Menu: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverviewCard.tsx"],
    },
  ],
  UI_ModelGen_Overview_NewCard: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverview.tsx"],
    },
  ],
  UI_ModelGen_Overview_NoResults: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverview.tsx"],
    },
  ],
  UI_ModelGen_Overview_OpenButton: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverviewCard.tsx"],
    },
  ],
  UI_ModelGen_Overview_Search: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverviewSearchbar.tsx"],
    },
  ],
  UI_ModelGen_Overview_StatusError: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverviewCard.tsx"],
    },
  ],
  UI_ModelGen_Overview_StatusGenerating: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverviewCard.tsx"],
    },
  ],
  UI_ModelGen_Overview_StatusUnseen: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverviewCard.tsx"],
    },
  ],
  UI_ModelGen_Overview_Title: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenOverview.tsx"],
    },
  ],
  UI_ModelGen_Preview_2dPolygon: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_2dRaster: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_2dRepresentationLabel: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Download: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Edit: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_FallbackName: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Generating: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Label2d: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Label3d: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Map2D: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Map3D: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_MapSceneError: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_MapShowOrigo: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_MapSplit: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_MapZoomTo: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenMapPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_ModeMap: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_ModeModel: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Thumbnail: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenPreview.tsx"],
    },
  ],
  UI_ModelGen_Preview_Versions: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenPreview.tsx"],
    },
  ],
  UI_ModelGen_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_ModelGen_Sessions_DefaultTitle: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.sessions.context.tsx"],
    },
  ],
  UI_ModelGen_Toast_Failed: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.runtime.context.tsx"],
    },
  ],
  UI_ModelGen_Toast_NewModel: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.runtime.context.tsx"],
    },
  ],
  UI_ModelGen_Toast_SessionFallback: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/modelGen.runtime.context.tsx"],
    },
  ],
  UI_ModelGen_Versions_Dialog: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenVersionDialog.tsx"],
    },
  ],
  UI_ModelGen_Versions_Empty: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenVersionDialog.tsx"],
    },
  ],
  UI_ModelGen_Versions_Label: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenSession.tsx"],
    },
  ],
  UI_ModelGen_Versions_Prompt: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenVersionDialog.tsx"],
    },
  ],
  UI_ModelGen_Versions_Rendering: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenVersionDialog.tsx"],
    },
  ],
  UI_ModelGen_Versions_Revert: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/gen/ModelGenVersionDialog.tsx"],
    },
  ],
  UI_ModelNav_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_Model_NavHeader: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-console/src/model/nav/ModelNavPanelContent.tsx"],
    },
  ],
  UI_MonitorPerf_AutoDownshiftDescription: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/MonitorPerfWatcher.tsx"],
    },
  ],
  UI_MonitorPerf_AutoDownshiftTitle: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/MonitorPerfWatcher.tsx"],
    },
  ],
  UI_MonitorPerf_AutoUpshiftDescription: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/MonitorPerfWatcher.tsx"],
    },
  ],
  UI_MonitorPerf_AutoUpshiftTitle: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/MonitorPerfWatcher.tsx"],
    },
  ],
  UI_MonitorPerf_ConnectionTypeLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_DisplayLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.text.ts"],
    },
  ],
  UI_MonitorPerf_DownlinkLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_DroppedLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.text.ts"],
    },
  ],
  UI_MonitorPerf_DroppedShort: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_FpsAvg: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_FpsLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_FpsMax: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_FpsMin: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_FpsShort: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/monitorPerf/MonitorPerfStatusStrip.tsx",
        "v2-console/src/monitorPerf/monitorPerf.sections.tsx",
      ],
    },
  ],
  UI_MonitorPerf_Health_Fair: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/monitorPerf/MonitorPerfStatusStrip.tsx",
        "v2-console/src/monitorPerf/monitorPerf.sections.tsx",
      ],
    },
  ],
  UI_MonitorPerf_Health_Good: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/monitorPerf/MonitorPerfStatusStrip.tsx",
        "v2-console/src/monitorPerf/monitorPerf.sections.tsx",
      ],
    },
  ],
  UI_MonitorPerf_Health_Poor: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/monitorPerf/MonitorPerfStatusStrip.tsx",
        "v2-console/src/monitorPerf/monitorPerf.sections.tsx",
      ],
    },
  ],
  UI_MonitorPerf_HzAssumed: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_LatencyLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_MemoryHeader: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_MemoryHint: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_MemoryLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_MemoryLimitLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_MemoryShort: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/MonitorPerfStatusStrip.tsx"],
    },
  ],
  UI_MonitorPerf_NetworkHeader: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_NetworkHint: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_NetworkShort: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/MonitorPerfStatusStrip.tsx"],
    },
  ],
  UI_MonitorPerf_Offline: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/monitorPerf/MonitorPerfStatusStrip.tsx",
        "v2-console/src/monitorPerf/monitorPerf.sections.tsx",
      ],
    },
  ],
  UI_MonitorPerf_Online: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/monitorPerf/MonitorPerfStatusStrip.tsx",
        "v2-console/src/monitorPerf/monitorPerf.sections.tsx",
      ],
    },
  ],
  UI_MonitorPerf_OnlineLabel: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_PerformanceHeader: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_PerformanceHint: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_MonitorPerf_Unknown: [
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/monitorPerf.sections.tsx"],
    },
  ],
  UI_Monitor_Header: [
    {
      label: "Monitoring",
      url: "https://app.placepoint.no/map/monitor",
      files: ["v2-console/src/monitor/MonitorPanelContent.tsx"],
    },
  ],
  UI_Monitor_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_Notifications_Action_OpenHistory: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_Action_OpenOrders: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_Empty: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/NotificationPanelContent.tsx"],
    },
  ],
  UI_Notifications_LandRegisterDocumentFailed_Body: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_LandRegisterDocumentFailed_Title: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_LandRegisterDocumentReorderable_Body: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_LandRegisterDocumentReorderable_Title: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_LandRegisterDocumentsAvailable_Body: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_LandRegisterDocumentsAvailable_Title: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_LegalReportFailed_Title: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_LegalReportReady_Title: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_Notifications_Trigger: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarNotifications.tsx"],
    },
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/NotificationPanelContent.tsx"],
    },
  ],
  UI_Notifications_Unknown_Title: [
    {
      label: "Notification",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/notification/notification.registry.ts"],
    },
  ],
  UI_ObjectFeatureValue_LastUpdatedBy: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/objectFeatureValue/CadastreObjectFeatureValueLastUpdateBy.tsx",
      ],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_Loading: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/breadcrumb/ObjectHierarchyBreadcrumbSkeleton.tsx",
      ],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_MiddleEllipsis_Trigger: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/object/breadcrumb/ObjectHierarchyBreadcrumb.tsx"],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_Type_Building: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/breadcrumb/objectHierarchyBreadcrumb.constants.ts",
      ],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_Type_Cadastre: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/breadcrumb/objectHierarchyBreadcrumb.constants.ts",
      ],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_Type_Company: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/breadcrumb/objectHierarchyBreadcrumb.constants.ts",
      ],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_Type_HousingUnit: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/breadcrumb/objectHierarchyBreadcrumb.constants.ts",
      ],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_Type_Person: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/breadcrumb/objectHierarchyBreadcrumb.constants.ts",
      ],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_Type_Section: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/breadcrumb/objectHierarchyBreadcrumb.constants.ts",
      ],
    },
  ],
  UI_ObjectHierarchyBreadcrumb_Type_SubCompany: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/object/breadcrumb/objectHierarchyBreadcrumb.constants.ts",
      ],
    },
  ],
  UI_ObjectPicker_Cancel: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerDialogBody.tsx"],
    },
  ],
  UI_ObjectPicker_MorePills: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerPillList.tsx"],
    },
  ],
  UI_ObjectPicker_Or: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerDialogBody.tsx"],
    },
  ],
  UI_ObjectPicker_Paste: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerPaste.tsx"],
    },
  ],
  UI_ObjectPicker_PasteLane: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerDialogBody.tsx"],
    },
  ],
  UI_ObjectPicker_PasteNoMatch: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerPaste.tsx"],
    },
  ],
  UI_ObjectPicker_PasteTooMany: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerPaste.tsx"],
    },
  ],
  UI_ObjectPicker_PickRemove: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/objectPicker/ObjectPickerDialogBody.tsx",
        "v2-console/src/objectPicker/ObjectPickerPillList.tsx",
        "v2-console/src/objectPicker/ObjectPickerSelect.tsx",
      ],
    },
  ],
  UI_ObjectPicker_PreviewEmpty: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerDialogBody.tsx"],
    },
  ],
  UI_ObjectPicker_RemoveAll: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerPillList.tsx"],
    },
  ],
  UI_ObjectPicker_Reset: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerDialogBody.tsx"],
    },
  ],
  UI_ObjectPicker_RunMatching: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerPaste.tsx"],
    },
  ],
  UI_ObjectPicker_SearchLane: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerDialogBody.tsx"],
    },
  ],
  UI_ObjectPicker_SelectError: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerSelect.tsx"],
    },
  ],
  UI_ObjectPicker_SelectSearchPlaceholder: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerSelect.tsx"],
    },
  ],
  UI_ObjectPicker_SelectTypeToSearch: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerSelect.tsx"],
    },
  ],
  UI_ObjectPicker_Submit: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerDialogBody.tsx"],
    },
  ],
  UI_ObjectPicker_SubmitCount: [
    {
      label: "Object Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/objectPicker/ObjectPickerDialogBody.tsx"],
    },
  ],
  UI_ObjectPopup_Close: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/object/popup/object.popup.constants.ts"],
    },
  ],
  UI_ObjectPopup_Error: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/object/popup/ObjectPopupWrapper.tsx"],
    },
  ],
  UI_ObjectPopup_Open: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/object/popup/object.popup.constants.ts"],
    },
  ],
  UI_Panel_Floating_Toggle_Button_Floating: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Panel_Floating_Toggle_Button_Overlay: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Panel_Position_Bottom_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Panel_Position_Left_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Panel_Position_Menu_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Panel_Position_Right_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Panel_Position_Top_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Permit_Header: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/panel/PermitPanel.tsx"],
    },
  ],
  UI_Permit_LabelCaseId: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/panel/PermitOverviewModule.tsx"],
    },
  ],
  UI_Permit_LabelDecisionDate: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/panel/PermitOverviewModule.tsx"],
    },
  ],
  UI_Permit_TabActors: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitActorsModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
        "v2-console/src/permit/panel/permit.panel.config.tsx",
      ],
    },
  ],
  UI_Permit_TabDescription: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitDescriptionModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
        "v2-console/src/permit/panel/permit.panel.config.tsx",
      ],
    },
  ],
  UI_Permit_TabDocuments: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitDocumentsModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
        "v2-console/src/permit/panel/permit.panel.config.tsx",
      ],
    },
  ],
  UI_Permit_TabKeyFigures: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/permit.text.ts"],
    },
  ],
  UI_Permit_TabLinkedProfiles: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitLinkedProfilesModule.tsx",
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
        "v2-console/src/permit/panel/permit.panel.config.tsx",
      ],
    },
  ],
  UI_Permit_TabOverview: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/permit/panel/PermitOverviewModule.tsx",
        "v2-console/src/permit/panel/permit.panel.config.tsx",
      ],
    },
  ],
  UI_Permit_ZoomTo: [
    {
      label: "Permit",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/permit/panel/PermitPanel.tsx"],
    },
  ],
  UI_Person_Deceased: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/panel/PersonPanelHeader.tsx"],
    },
  ],
  UI_Person_Header: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/person.text.ts"],
    },
  ],
  UI_Person_PanelMany_NotImplemented: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/panel/PersonPanelMany.tsx"],
    },
  ],
  UI_Person_Portfolio_Header: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/portfolio/person.portfolio.text.ts"],
    },
  ],
  UI_Person_Portfolio_TreeTab: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/portfolio/PersonPortfolioTable.tsx"],
    },
  ],
  UI_Person_Portfolio_Tree_CollapseAll: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/portfolio/PersonPortfolioTable.tsx"],
    },
  ],
  UI_Person_Portfolio_Tree_EmptyState: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/portfolio/PersonPortfolioTree.tsx"],
    },
  ],
  UI_Person_Portfolio_Tree_ExpandAll: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/portfolio/PersonPortfolioTable.tsx"],
    },
  ],
  UI_Person_Portfolio_Tree_SearchPlaceholder: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/portfolio/person.portfolio.useFilterableConfig.ts",
      ],
    },
  ],
  UI_Person_Portfolio_Tree_Subsidiaries: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/portfolio/PersonPortfolioTree.tsx"],
    },
  ],
  UI_Person_Portfolio_UnknownOwner: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/portfolio/PersonPortfolioTree.tsx"],
    },
  ],
  UI_Person_Portfolio_YearLabel: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/portfolio/PersonPortfolioYearSelect.tsx"],
    },
  ],
  UI_Person_Roles_ColumnCompany: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/roles/PersonRolesTableExpand.tsx",
        "v2-console/src/person/roles/person.roles.useColumns.tsx",
        "v2-console/src/person/roles/person.roles.useFilterableConfig.ts",
      ],
    },
  ],
  UI_Person_Roles_ColumnDescription: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTableExpand.tsx"],
    },
  ],
  UI_Person_Roles_ColumnEnd: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTableExpand.tsx"],
    },
  ],
  UI_Person_Roles_ColumnPeriod: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/roles/person.roles.useColumns.tsx",
        "v2-console/src/person/roles/person.roles.useFilterableConfig.ts",
      ],
    },
  ],
  UI_Person_Roles_ColumnRoleGroup: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTableExpand.tsx"],
    },
  ],
  UI_Person_Roles_ColumnRoleType: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/roles/PersonRolesTableExpand.tsx",
        "v2-console/src/person/roles/person.roles.useColumns.tsx",
        "v2-console/src/person/roles/person.roles.useFilterableConfig.ts",
      ],
    },
  ],
  UI_Person_Roles_ColumnStart: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTableExpand.tsx"],
    },
  ],
  UI_Person_Roles_ColumnStatus: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/person.roles.text.ts"],
    },
  ],
  UI_Person_Roles_CompanyCount: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_Roles_HasResigned: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTableExpand.tsx"],
    },
  ],
  UI_Person_Roles_Header: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTable.tsx"],
    },
  ],
  UI_Person_Roles_HistoricCount: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_Roles_ModeCurrent: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTable.tsx"],
    },
  ],
  UI_Person_Roles_ModeHistoric: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesTable.tsx"],
    },
  ],
  UI_Person_Roles_Overview: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_Roles_StackedSummaryByIndustry: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_Roles_StackedSummaryByRoleGroup: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_Roles_StackedSummaryByRoleType: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_Roles_StackedSummaryCountLabel: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/roles/person.roles.useStackedSummaryData.ts",
      ],
    },
  ],
  UI_Person_Roles_StackedSummaryOthers: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/roles/person.roles.useStackedSummaryData.ts",
      ],
    },
  ],
  UI_Person_Roles_StackedSummaryShareLabel: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_Roles_StackedSummaryTitle: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_Roles_StackedSummaryUnknown: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/roles/person.roles.useStackedSummaryData.ts",
      ],
    },
  ],
  UI_Person_Roles_StatusActive: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/person.roles.text.ts"],
    },
  ],
  UI_Person_Roles_StatusHistoric: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/person.roles.text.ts"],
    },
  ],
  UI_Person_Roles_TableSearchPlaceholder: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/roles/person.roles.useFilterableConfig.ts",
      ],
    },
  ],
  UI_Person_Roles_Today: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/person/roles/PersonRolesTableExpand.tsx",
        "v2-console/src/person/roles/person.roles.useColumns.tsx",
      ],
    },
  ],
  UI_Person_Roles_TotalRoles: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/roles/PersonRolesInsightCards.tsx"],
    },
  ],
  UI_Person_TabPortfolio: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/panel/person.panel.config.tsx"],
    },
  ],
  UI_Person_TabRoles: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/panel/person.panel.config.tsx"],
    },
  ],
  UI_Person_TabTransactions: [
    {
      label: "Person panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/person/panel/person.panel.config.tsx"],
    },
  ],
  UI_Primitive_Breadcrumb_Label: [
    {
      label: "Breadcrumb",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/breadcrumb/base/BreadcrumbBase.tsx"],
    },
  ],
  UI_Primitive_Breadcrumb_More: [
    {
      label: "Breadcrumb",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/breadcrumb/base/BreadcrumbBase.tsx"],
    },
  ],
  UI_Primitive_Carousel_NextSlide: [
    {
      label: "Carousel",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/carousel/base/CarouselBase.tsx"],
    },
  ],
  UI_Primitive_Carousel_PreviousSlide: [
    {
      label: "Carousel",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/carousel/base/CarouselBase.tsx"],
    },
  ],
  UI_Primitive_Carousel_Roledescription: [
    {
      label: "Carousel",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/carousel/base/CarouselBase.tsx"],
    },
  ],
  UI_Primitive_Carousel_SlideRoledescription: [
    {
      label: "Carousel",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/carousel/base/CarouselBase.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_ColorBlindSafeLabel: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPaletteFilter.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_Empty: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPaletteCommand.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_ReversedLabel: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPaletteFilter.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_SearchPlaceholder: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPaletteCommand.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_SelectPlaceholder: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPalettePicker.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_StepsLabel: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPaletteFilter.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_StepsPlaceholder: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPaletteFilter.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_TypeLabel: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPaletteFilter.tsx"],
    },
  ],
  UI_Primitive_ColorPalette_TypePlaceholder: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/palette/ColorPaletteFilter.tsx"],
    },
  ],
  UI_Primitive_ColorPickerEyedropper_PickColor: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/picker/eyedropper/ColorPickerEyedropper.tsx"],
    },
  ],
  UI_Primitive_ColorPresetPicker_Custom: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/picker/ColorPresetPicker.tsx"],
    },
  ],
  UI_Primitive_ColorPresetPicker_Label: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/picker/ColorPresetPicker.tsx"],
    },
  ],
  UI_Primitive_ColorPresetPicker_None: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/picker/ColorPresetPicker.tsx"],
    },
  ],
  UI_Primitive_ColorSwatchSections_AddCurrentColor: [
    {
      label: "Color",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/color/swatchSection/ColorSwatchSections.tsx"],
    },
  ],
  UI_Primitive_ConfirmButton_Cancel: [
    {
      label: "Button",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/button/ConfirmButton.tsx"],
    },
  ],
  UI_Primitive_ConfirmButton_Confirm: [
    {
      label: "Button",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/button/ConfirmButton.tsx"],
    },
  ],
  UI_Primitive_ConfirmButton_Description: [
    {
      label: "Button",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/button/ConfirmButton.tsx"],
    },
  ],
  UI_Primitive_ConfirmButton_Title: [
    {
      label: "Button",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/button/ConfirmButton.tsx"],
    },
  ],
  UI_Primitive_ConfirmationDialog_Cancel: [
    {
      label: "Confirmation",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/confirmation/ConfirmationDialog.tsx"],
    },
  ],
  UI_Primitive_ConfirmationDialog_Confirm: [
    {
      label: "Confirmation",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/confirmation/ConfirmationDialog.tsx"],
    },
  ],
  UI_Primitive_ConfirmationDialog_Description: [
    {
      label: "Confirmation",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/confirmation/ConfirmationDialog.tsx"],
    },
  ],
  UI_Primitive_ConfirmationDialog_Title: [
    {
      label: "Confirmation",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/confirmation/ConfirmationDialog.tsx"],
    },
  ],
  UI_Primitive_CopyButton_Label: [
    {
      label: "Button",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/button/CopyButton.tsx"],
    },
  ],
  UI_Primitive_CustomBarMarker_Label: [
    {
      label: "Chart",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/chart/CustomBarMarker.tsx"],
    },
  ],
  UI_Primitive_DatePicker_MonthPlaceholder: [
    {
      label: "Date Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/datePicker/DatePicker.tsx"],
    },
  ],
  UI_Primitive_DatePicker_Placeholder: [
    {
      label: "Date Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/datePicker/DatePickerTrigger.tsx"],
    },
  ],
  UI_Primitive_DatePicker_Reset: [
    {
      label: "Date Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/datePicker/DatePicker.tsx"],
    },
  ],
  UI_Primitive_DatePicker_YearPlaceholder: [
    {
      label: "Date Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/datePicker/DatePicker.tsx"],
    },
  ],
  UI_Primitive_DialogAdvanced_Close: [
    {
      label: "Dialog Advanced",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/dialogAdvanced/DialogCloseButton.tsx"],
    },
  ],
  UI_Primitive_Dialog_Close: [
    {
      label: "Dialog",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/dialog/base/DialogBase.tsx"],
    },
  ],
  UI_Primitive_ErrorMessage_Root: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/ErrorMessage.tsx"],
    },
  ],
  UI_Primitive_Frame_Close: [
    {
      label: "Frame",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/frame/FrameCloseButton.tsx"],
    },
  ],
  UI_Primitive_Frame_Expand: [
    {
      label: "Frame",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/frame/FrameMinimizeButton.tsx"],
    },
  ],
  UI_Primitive_Frame_FullscreenEnter: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
    {
      label: "Frame",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/frame/FrameFullscreenButton.tsx"],
    },
  ],
  UI_Primitive_Frame_FullscreenExit: [
    {
      label: "Panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/panel/PanelModeSettingsMenuItems.tsx"],
    },
    {
      label: "Frame",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/frame/FrameFullscreenButton.tsx"],
    },
  ],
  UI_Primitive_Frame_Minimize: [
    {
      label: "Frame",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/frame/FrameMinimizeButton.tsx"],
    },
  ],
  UI_Primitive_InlineEditInput_Confirm: [
    {
      label: "Inline Edit Input",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/inlineEditInput/InlineEditInput.tsx"],
    },
  ],
  UI_Primitive_ListLoader_Root: [
    {
      label: "List Loader",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/listLoader/ListLoader.tsx"],
    },
  ],
  UI_Primitive_MultiSelect_Clear: [
    {
      label: "Multi Select",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-ui/src/multiSelect/MultiSelect.tsx",
        "v2-ui/src/multiSelect/MultiSelectTree.tsx",
      ],
    },
  ],
  UI_Primitive_MultiSelect_NoMatches: [
    {
      label: "Multi Select",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-ui/src/multiSelect/MultiSelect.tsx",
        "v2-ui/src/multiSelect/MultiSelectTree.tsx",
      ],
    },
  ],
  UI_Primitive_MultiSelect_Placeholder: [
    {
      label: "Multi Select",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/multiSelect/MultiSelect.tsx"],
    },
  ],
  UI_Primitive_MultiSelect_SearchPlaceholder: [
    {
      label: "Multi Select",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-ui/src/multiSelect/MultiSelect.tsx",
        "v2-ui/src/multiSelect/MultiSelectTree.tsx",
      ],
    },
  ],
  UI_Primitive_MultiSelect_SelectAll: [
    {
      label: "Multi Select",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-ui/src/multiSelect/MultiSelect.tsx",
        "v2-ui/src/multiSelect/MultiSelectTree.tsx",
      ],
    },
  ],
  UI_Primitive_NivoBarChart_Empty: [
    {
      label: "Nivo Chart",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/nivoChart/NivoBarChart.tsx"],
    },
  ],
  UI_Primitive_NivoBarChart_LoadErrorTitle: [
    {
      label: "Nivo Chart",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/nivoChart/NivoBarChart.tsx"],
    },
  ],
  UI_Primitive_NumberRangeColumnFilter_MaxPlaceholder: [
    {
      label: "Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/table/NumberRangeColumnFilter.tsx"],
    },
  ],
  UI_Primitive_NumberRangeColumnFilter_MinPlaceholder: [
    {
      label: "Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/table/NumberRangeColumnFilter.tsx"],
    },
  ],
  UI_Primitive_NumberRangeColumnFilter_Separator: [
    {
      label: "Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/table/NumberRangeColumnFilter.tsx"],
    },
  ],
  UI_Primitive_NumberRangeInput_From: [
    {
      label: "Input",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-ui/src/input/InputNumberRange.tsx",
        "v2-ui/src/input/InputNumberRangeDebounced.tsx",
      ],
    },
    {
      label: "Number Range Inputs",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/numberRangeInputs/NumberRangeInputs.tsx"],
    },
  ],
  UI_Primitive_NumberRangeInput_To: [
    {
      label: "Input",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-ui/src/input/InputNumberRange.tsx",
        "v2-ui/src/input/InputNumberRangeDebounced.tsx",
      ],
    },
    {
      label: "Number Range Inputs",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/numberRangeInputs/NumberRangeInputs.tsx"],
    },
  ],
  UI_Primitive_Pagination_Label: [
    {
      label: "Pagination",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/pagination/base/PaginationBase.tsx"],
    },
  ],
  UI_Primitive_Pagination_MorePages: [
    {
      label: "Pagination",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/pagination/base/PaginationBase.tsx"],
    },
  ],
  UI_Primitive_Pagination_Next: [
    {
      label: "Pagination",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/pagination/base/PaginationBase.tsx"],
    },
  ],
  UI_Primitive_Pagination_Previous: [
    {
      label: "Pagination",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/pagination/base/PaginationBase.tsx"],
    },
  ],
  UI_Primitive_Placeholder_Root: [
    {
      label: "",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/Placeholder.tsx"],
    },
  ],
  UI_Primitive_SearchBar_ClearSearch: [
    {
      label: "Search Bar",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/searchBar/SearchBar.tsx"],
    },
  ],
  UI_Primitive_SelectColumnFilter_All: [
    {
      label: "Table",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/table/SelectColumnFilter.tsx"],
    },
  ],
  UI_Primitive_Sheet_Close: [
    {
      label: "Sheet",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/sheet/base/SheetBase.tsx"],
    },
  ],
  UI_Primitive_Sidebar_MobileDescription: [
    {
      label: "Sidebar",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/sidebar/base/SidebarBase.tsx"],
    },
  ],
  UI_Primitive_Sidebar_MobileTitle: [
    {
      label: "Sidebar",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/sidebar/base/SidebarBase.tsx"],
    },
  ],
  UI_Primitive_Sidebar_Toggle: [
    {
      label: "Widget",
      url: "https://app.placepoint.no/map",
      files: ["v2-layout-ui/src/widget/WidgetBarToggleExpand.tsx"],
    },
    {
      label: "Sidebar",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/sidebar/base/SidebarBase.tsx"],
    },
  ],
  UI_Primitive_Spinner_Loading: [
    {
      label: "Spinner",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/spinner/Spinner.tsx"],
    },
  ],
  UI_Primitive_TimePicker_ClearTime: [
    {
      label: "Time Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/timePicker/TimePicker.tsx"],
    },
  ],
  UI_Primitive_TimePicker_HoursLabel: [
    {
      label: "Time Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/timePicker/TimePicker.tsx"],
    },
  ],
  UI_Primitive_TimePicker_MinutesLabel: [
    {
      label: "Time Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/timePicker/TimePicker.tsx"],
    },
  ],
  UI_Primitive_TimePicker_SecondsLabel: [
    {
      label: "Time Picker",
      url: "https://app.placepoint.no/map",
      files: ["v2-ui/src/timePicker/TimePicker.tsx"],
    },
  ],
  UI_Print_2DOnlyMessage: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/print/MapWidgetPrintFocusMode.tsx"],
    },
  ],
  UI_Print_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/print/MapWidgetPrint.tsx"],
    },
  ],
  UI_Print_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemPrint.tsx",
        "v2-console/src/map/widget/MapWidgetPrintPopoverButton.tsx",
        "v2-console/src/map/widget/_toolbarBottom/MapWidgetPrintButton.tsx",
        "v2-console/src/map/widget/print/MapWidgetPrintFocusMode.tsx",
      ],
    },
  ],
  UI_Privacy_Person_Root: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/cadastre/transactionTimeline/CadastreTransactionTimelineListItemDetails.tsx",
      ],
    },
  ],
  UI_Project_ActivityByMember: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/activity/ProjectActivityChart.tsx"],
    },
  ],
  UI_Project_ActivityByProject: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/activity/ProjectActivityChart.tsx"],
    },
  ],
  UI_Project_ActivityRangeDay: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/activity/ProjectActivityChart.tsx"],
    },
  ],
  UI_Project_ActivityRangeMonth: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/activity/ProjectActivityChart.tsx"],
    },
  ],
  UI_Project_ActivityRangeWeek: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/activity/ProjectActivityChart.tsx"],
    },
  ],
  UI_Project_ActivityTitle: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/activity/ProjectActivityChart.tsx"],
    },
  ],
  UI_Project_CountryFilter: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_CountryFilterAll: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_CountryFilterReset: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_CreateCancelButton: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/create/ProjectCreate.tsx"],
    },
  ],
  UI_Project_CreateConfirmButton: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/create/ProjectCreate.tsx"],
    },
  ],
  UI_Project_CreateError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/create/ProjectCreate.tsx"],
    },
  ],
  UI_Project_CreateLoading: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/project.text.ts"],
    },
  ],
  UI_Project_CreateShareFailed: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/create/ProjectCreate.tsx"],
    },
  ],
  UI_Project_CreatedByAll: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_CreatedByFilter: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_CreatedByReset: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_CreatedBySharedWithYou: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_CreatedBySpecificUsers: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_CreatedByYou: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_EditCancelButton: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/update/ProjectUpdateDialog.tsx"],
    },
  ],
  UI_Project_EditConfirmButton: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/update/ProjectUpdateDialog.tsx"],
    },
  ],
  UI_Project_EditDescription: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/project.text.ts"],
    },
  ],
  UI_Project_EditOnlyOwnerAlert: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/update/ProjectUpdateDialog.tsx"],
    },
  ],
  UI_Project_EditTitle: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/update/ProjectUpdateDialog.tsx"],
    },
  ],
  UI_Project_EmptyCountryFilter: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGrid.tsx"],
    },
  ],
  UI_Project_EmptyCreatedByFilter: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGrid.tsx"],
    },
  ],
  UI_Project_FavoriteError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectFavoriteButton.tsx"],
    },
  ],
  UI_Project_FavoritesSection: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuFavorites.tsx"],
    },
  ],
  UI_Project_FavoritesShowAll: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuFavorites.tsx"],
    },
  ],
  UI_Project_FavoritesShowLess: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuFavorites.tsx"],
    },
  ],
  UI_Project_GridEmptyDescription: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGrid.tsx"],
    },
  ],
  UI_Project_GridEmptyTitle: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGrid.tsx"],
    },
  ],
  UI_Project_GridEmptyTitlePrivate: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGrid.tsx"],
    },
  ],
  UI_Project_GridEmptyTitleTenant: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGrid.tsx"],
    },
  ],
  UI_Project_GridItemCreated: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGridItem.tsx"],
    },
  ],
  UI_Project_GridItemCreatedBy: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGridItem.tsx"],
    },
  ],
  UI_Project_GridItemEdited: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGridItem.tsx"],
    },
  ],
  UI_Project_GridItemFavoriteButtonContent: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectFavoriteButton.tsx"],
    },
  ],
  UI_Project_GridItemFlagAlt: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGridItemCountry.tsx"],
    },
  ],
  UI_Project_GridItemMoreActionItemEdit: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarProjectMenu.tsx"],
    },
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectActionDropdown.tsx"],
    },
  ],
  UI_Project_GridItemMoreActionItemRemove: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarProjectMenu.tsx"],
    },
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectActionDropdown.tsx"],
    },
  ],
  UI_Project_GridItemMoreActionItemRemoveNotOwner: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectActionDropdown.tsx"],
    },
  ],
  UI_Project_GridItemMoreActionsButtonContent: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectActionDropdown.tsx"],
    },
  ],
  UI_Project_GridItemUnfavoriteButtonContent: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectFavoriteButton.tsx"],
    },
  ],
  UI_Project_GridNewProject: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/create/ProjectCreate.tsx"],
    },
  ],
  UI_Project_GridNewProjectForTenant: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/create/ProjectCreate.tsx"],
    },
  ],
  UI_Project_GridNewProjectForUser: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/create/ProjectCreate.tsx"],
    },
  ],
  UI_Project_GridNoProjects: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/project.text.ts"],
    },
  ],
  UI_Project_ItemExternalProject: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGridItemSharing.tsx"],
    },
  ],
  UI_Project_ItemSharedPrivateProject: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGridItemSharing.tsx"],
    },
  ],
  UI_Project_Loading: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectGuard.tsx"],
    },
  ],
  UI_Project_LoadingText: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/project.text.ts"],
    },
  ],
  UI_Project_RemoveCancelButton: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/remove/ProjectRemoveDialog.tsx"],
    },
  ],
  UI_Project_RemoveConfirmButton: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/remove/ProjectRemoveDialog.tsx"],
    },
  ],
  UI_Project_RemoveDescription: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/remove/ProjectRemoveDialog.tsx"],
    },
  ],
  UI_Project_RemoveError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/remove/ProjectRemoveDialog.tsx"],
    },
  ],
  UI_Project_RemoveTitle: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/remove/ProjectRemoveDialog.tsx"],
    },
  ],
  UI_Project_SearchPlaceholder: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_SelectError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGridItem.tsx"],
    },
  ],
  UI_Project_ShareError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/update/ProjectUpdateDialog.tsx"],
    },
  ],
  UI_Project_SharingAccessVia: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingBlocked: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingBlockedTooltip: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingCreator: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInviteAlready: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInviteBlocked: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInviteButton: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInviteCreateFirst: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInviteError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInviteHeader: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInviteNotFound: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInvitePlaceholder: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingInviteSelf: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingManage: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingManageHeader: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingRemove: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingTypeExternal: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingTypeOrganization: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingTypeUser: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/project.text.ts"],
    },
  ],
  UI_Project_SharingWhoCanSee: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_SharingYou: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/share/ProjectSharingSelect.tsx"],
    },
  ],
  UI_Project_ShowFilter: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_ShowFilterReset: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_SidebarDropdownMenuBackItem: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarProjectMenu.tsx"],
    },
  ],
  UI_Project_SidebarDropdownMenuLabel: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarProjectMenu.tsx"],
    },
  ],
  UI_Project_SidebarMenuTitle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/MapSidebarProjectMenu.tsx"],
    },
  ],
  UI_Project_SortCreated: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_SortFilter: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_SortName: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_SortRecent: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_SortReset: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_SortUpdated: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_TenantSection: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuGrid.tsx"],
    },
  ],
  UI_Project_UnfavoriteError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/project.text.ts"],
    },
  ],
  UI_Project_UnshareError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/update/ProjectUpdateDialog.tsx"],
    },
  ],
  UI_Project_Untitled: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/project/create/ProjectCreate.tsx",
        "v2-console/src/project/menu/ProjectMenuGridItem.tsx",
        "v2-console/src/project/update/ProjectUpdateDialog.tsx",
      ],
    },
  ],
  UI_Project_UpdateError: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/update/ProjectUpdateDialog.tsx"],
    },
  ],
  UI_Project_Upsert_Country: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectFormFields.tsx"],
    },
  ],
  UI_Project_Upsert_CountryLockedTooltip: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectFormFields.tsx"],
    },
  ],
  UI_Project_Upsert_Name: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectFormFields.tsx"],
    },
  ],
  UI_Project_Upsert_NamePlaceholder: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/ProjectFormFields.tsx"],
    },
  ],
  UI_Project_ViewGrid: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_Project_ViewList: [
    {
      label: "Projects",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/project/menu/ProjectMenuControls.tsx"],
    },
  ],
  UI_RegulationWidget_DrawPolygon: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/regulation/MapWidgetRegulation.tsx"],
    },
  ],
  UI_RegulationWidget_EmptyState: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/regulation/MapWidgetRegulation.tsx"],
    },
  ],
  UI_RegulationWidget_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/regulation/map.widget.regulation.text.ts",
      ],
    },
  ],
  UI_RegulationWidget_PlacePoint: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/regulation/MapWidgetRegulation.tsx"],
    },
  ],
  UI_RegulationWidget_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetBetaGroupButton.tsx",
        "v2-console/src/map/widget/MapWidgetRegulationButton.tsx",
        "v2-console/src/map/widget/regulation/MapWidgetRegulationSuspender.tsx",
      ],
    },
  ],
  UI_RiskWidget_DrawPolygon: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/risk/MapWidgetRisk.tsx"],
    },
  ],
  UI_RiskWidget_EmptyState: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/risk/MapWidgetRisk.tsx"],
    },
  ],
  UI_RiskWidget_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/risk/map.widget.risk.text.ts"],
    },
  ],
  UI_RiskWidget_PlacePoint: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/risk/MapWidgetRisk.tsx"],
    },
  ],
  UI_RiskWidget_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetBetaGroupButton.tsx",
        "v2-console/src/map/widget/MapWidgetLookupButton.tsx",
        "v2-console/src/map/widget/MapWidgetRiskButton.tsx",
        "v2-console/src/map/widget/risk/MapWidgetRiskSuspender.tsx",
      ],
    },
  ],
  UI_Router_Loading: [
    {
      label: "App",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/app/standalone/AppStandaloneGate.tsx"],
    },
    {
      label: "Router",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/router/Router.tsx"],
    },
  ],
  UI_Screenshot_FileName_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemScreenshot.tsx",
        "v2-console/src/map/widget/MapWidgetScreenshotButton.tsx",
      ],
    },
  ],
  UI_Screenshot_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/toolbar/MapToolbarItemScreenshot.tsx",
        "v2-console/src/map/widget/MapWidgetScreenshotButton.tsx",
        "v2-console/src/map/widget/screenshot/MapWidgetScreenshotDialog.tsx",
      ],
    },
  ],
  UI_SelfService_Error_Title: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/SelfServiceConfirmDialog.tsx",
        "v2-accounts-ui/src/selfService/invitations/copy/SelfServiceInvitationCopyLinkButton.tsx",
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
        "v2-accounts-ui/src/selfService/invitations/resend/SelfServiceInvitationResendButton.tsx",
        "v2-accounts-ui/src/selfService/invitations/revoke/SelfServiceInvitationRevokeButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_CopiedToast: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/copy/SelfServiceInvitationCopyLinkButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_CopyLinkButton: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/copy/SelfServiceInvitationCopyLinkButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_ResendButton: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/resend/SelfServiceInvitationResendButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_ResentToast: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/resend/SelfServiceInvitationResendButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_RevokeButton: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/revoke/SelfServiceInvitationRevokeButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_RevokeDialogCancel: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/revoke/SelfServiceInvitationRevokeButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_RevokeDialogConfirm: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/revoke/SelfServiceInvitationRevokeButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_RevokeDialogDescription: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/revoke/SelfServiceInvitationRevokeButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_RevokeDialogTitle: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/revoke/SelfServiceInvitationRevokeButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_RevokedToast: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/revoke/SelfServiceInvitationRevokeButton.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_SearchPlaceholder: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_StatusClicked: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.utils.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_StatusDelivered: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.utils.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_StatusExpired: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.utils.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_StatusFailed: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.utils.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_StatusOpened: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.utils.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_StatusPending: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.utils.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_TableHeaderEmail: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useColumns.tsx",
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_TableHeaderExpiresAt: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useColumns.tsx",
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_TableHeaderInvitedBy: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useColumns.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_TableHeaderName: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useColumns.tsx",
      ],
    },
  ],
  UI_SelfService_Invitations_TableHeaderSentAt: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useColumns.tsx",
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Invitations_TableHeaderStatus: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/selfService.invitations.useColumns.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_CancelButton: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_ConfirmButton: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_Description: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteView.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_EmailInvalidError: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_EmailLabel: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_EmailPlaceholder: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_EmailRequiredError: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_FirstNameLabel: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_LastNameLabel: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_LicenseDisclaimerDescription: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/licenseUsage/SelfServiceLicenseDisclaimer.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_LicenseDisclaimerTitle: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/licenseUsage/SelfServiceLicenseDisclaimer.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_SeatCapError: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/selfService.invitations.invite.constants.ts",
      ],
    },
  ],
  UI_SelfService_Invite_SentToast: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteForm.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_Title: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteView.tsx",
      ],
    },
  ],
  UI_SelfService_Invite_TriggerButton: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/invitations/invite/SelfServiceInviteButton.tsx",
      ],
    },
  ],
  UI_SelfService_Members_RemoveButton: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/remove/SelfServiceMemberRemoveButton.tsx",
      ],
    },
  ],
  UI_SelfService_Members_RemoveDialogCancel: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/remove/SelfServiceMemberRemoveButton.tsx",
      ],
    },
  ],
  UI_SelfService_Members_RemoveDialogConfirm: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/remove/SelfServiceMemberRemoveButton.tsx",
      ],
    },
  ],
  UI_SelfService_Members_RemoveDialogDescription: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/remove/SelfServiceMemberRemoveButton.tsx",
      ],
    },
  ],
  UI_SelfService_Members_RemoveDialogTitle: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/remove/SelfServiceMemberRemoveButton.tsx",
      ],
    },
  ],
  UI_SelfService_Members_RemovedToast: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/remove/SelfServiceMemberRemoveButton.tsx",
      ],
    },
  ],
  UI_SelfService_Members_SearchPlaceholder: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/selfService.members.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Members_StatusActive: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/selfService.members.useColumns.tsx",
      ],
    },
  ],
  UI_SelfService_Members_StatusBlocked: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/selfService.members.useColumns.tsx",
      ],
    },
  ],
  UI_SelfService_Members_TableHeaderEmail: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/selfService.members.useColumns.tsx",
        "v2-accounts-ui/src/selfService/members/selfService.members.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Members_TableHeaderMemberSince: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/selfService.members.useColumns.tsx",
        "v2-accounts-ui/src/selfService/members/selfService.members.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Members_TableHeaderName: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/selfService.members.useColumns.tsx",
        "v2-accounts-ui/src/selfService/members/selfService.members.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Members_TableHeaderRole: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/selfService.members.useColumns.tsx",
        "v2-accounts-ui/src/selfService/members/selfService.members.useFilterableConfig.ts",
      ],
    },
  ],
  UI_SelfService_Members_TableHeaderStatus: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/members/selfService.members.useColumns.tsx",
      ],
    },
  ],
  UI_SelfService_Page_Subtitle: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: ["v2-accounts-ui/src/selfService/selfService.text.ts"],
    },
  ],
  UI_SelfService_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/sidebar/MapSidebar.tsx",
        "v2-console/src/map/sidebar/MapSidebarInviteItem.tsx",
      ],
    },
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/selfService/SelfServiceInviteDialog.tsx"],
    },
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_SelfService_Settings_NameLabel: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/settings/SelfServiceSettingsForm.tsx",
      ],
    },
  ],
  UI_SelfService_Settings_NameMaxLengthError: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/settings/SelfServiceSettingsForm.tsx",
      ],
    },
  ],
  UI_SelfService_Settings_NameRequiredError: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/settings/SelfServiceSettingsForm.tsx",
      ],
    },
  ],
  UI_SelfService_Settings_SaveButton: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/settings/SelfServiceSettingsForm.tsx",
      ],
    },
  ],
  UI_SelfService_Settings_SavedToast: [
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/settings/SelfServiceSettingsForm.tsx",
      ],
    },
  ],
  UI_SelfService_Tabs_Invitations: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/dialog/SelfServiceDialogInvitationsSection.tsx",
      ],
    },
  ],
  UI_SelfService_Tabs_Members: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
    {
      label: "Self Service",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-accounts-ui/src/selfService/dialog/SelfServiceDialogMembersSection.tsx",
      ],
    },
  ],
  UI_SelfService_Tabs_Settings: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_Settings3D_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Settings_3d_AtmosphereEnabledDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_AtmosphereEnabledReadMore: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_AtmosphereEnabledTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_CameraTrackingDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_CameraTrackingReadMore: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_CameraTrackingTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_EnvironmentHeader: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/settings.map.text.ts"],
    },
  ],
  UI_Settings_3d_LightHeader: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/settings.map.text.ts"],
    },
  ],
  UI_Settings_3d_QualityProfileDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_QualityProfileReadMore: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_QualityProfileTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_QualityProfile_HighHover: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/3d/settings.map.qualityProfile.constants.ts",
      ],
    },
  ],
  UI_Settings_3d_QualityProfile_HighOption: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/3d/settings.map.qualityProfile.constants.ts",
      ],
    },
  ],
  UI_Settings_3d_QualityProfile_LowHover: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/3d/settings.map.qualityProfile.constants.ts",
      ],
    },
  ],
  UI_Settings_3d_QualityProfile_LowOption: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/3d/settings.map.qualityProfile.constants.ts",
      ],
    },
  ],
  UI_Settings_3d_QualityProfile_MediumHover: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/3d/settings.map.qualityProfile.constants.ts",
      ],
    },
  ],
  UI_Settings_3d_QualityProfile_MediumOption: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/3d/settings.map.qualityProfile.constants.ts",
      ],
    },
  ],
  UI_Settings_3d_ShadowsDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_ShadowsReadMore: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_ShadowsTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_StarsDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_StarsReadMore: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_3d_StarsTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_Basemap_Header: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/basemap/SettingBasemapSection.tsx"],
    },
  ],
  UI_Settings_Basemap_Sticky: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/basemap/SettingBasemapSection.tsx",
        "v2-console/src/settings/map/basemap/SettingBasemapSticky.tsx",
      ],
    },
  ],
  UI_Settings_Help_Chat: [
    {
      label: "Help",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/help/HelpMenuItems.tsx"],
    },
    {
      label: "Hubspot",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/hubspot/hubspot.tracking.ts"],
    },
  ],
  UI_Settings_Help_Contact: [
    {
      label: "Help",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/help/HelpMenuItems.tsx"],
    },
  ],
  UI_Settings_Help_Docs: [
    {
      label: "Help",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/help/HelpMenuItems.tsx"],
    },
  ],
  UI_Settings_NavLayer_CadastreToggle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/basemap/SettingBasemapNavLayerToggle.tsx",
        "v2-console/src/settings/map/navLayer/SettingNavLayerCadastre.tsx",
      ],
    },
  ],
  UI_Settings_NavLayer_HighlightDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/basemap/SettingBasemapSection.tsx"],
    },
  ],
  UI_Settings_NavLayer_HighlightTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/basemap/SettingBasemapSection.tsx"],
    },
  ],
  UI_Settings_NavLayer_NoneOption: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/navLayer/settings.map.navLayerType.utils.ts",
      ],
    },
  ],
  UI_Settings_NavLayer_NoneOptionTooltip: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/navLayer/settings.map.navLayerType.utils.ts",
      ],
    },
  ],
  UI_Settings_NavLayer_TypeDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/basemap/SettingBasemapSection.tsx"],
    },
  ],
  UI_Settings_NavLayer_TypeTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/basemap/SettingBasemapSection.tsx"],
    },
  ],
  UI_Settings_NavLayer_VisibilityRangeDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/basemap/SettingBasemapSection.tsx"],
    },
  ],
  UI_Settings_NavLayer_VisibilityRangeTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/basemap/SettingBasemapSection.tsx"],
    },
  ],
  UI_Settings_Nav_Account: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_Settings_Nav_Agent: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_Settings_Nav_General: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_Settings_Nav_Map: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_Settings_Quality_AdvancedHeader: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/settings.map.text.ts"],
    },
  ],
  UI_Settings_Quality_AutoAdjust: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/settings.map.text.ts"],
    },
  ],
  UI_Settings_Quality_AutoManaged: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/map/settings.map.text.ts"],
    },
  ],
  UI_Settings_Quality_AutoOption: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Monitor Perf",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/monitorPerf/MonitorPerfWatcher.tsx"],
    },
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/SettingsMapSection.tsx",
        "v2-console/src/settings/map/quality/SettingQualityPreset.tsx",
        "v2-console/src/settings/map/quality/settings.map.qualityMode.constants.ts",
      ],
    },
  ],
  UI_Settings_Quality_BasemapQuality: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingCustomQualityRows.tsx",
      ],
    },
  ],
  UI_Settings_Quality_CheckSysReq: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingPerformanceSection.tsx",
      ],
    },
  ],
  UI_Settings_Quality_CustomOption: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/settings.map.qualityMode.constants.ts",
      ],
    },
  ],
  UI_Settings_Quality_HighOption: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/settings.map.qualityMode.constants.ts",
      ],
    },
  ],
  UI_Settings_Quality_ModeDescription: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingPerformanceSection.tsx",
      ],
    },
  ],
  UI_Settings_Quality_ModeTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingPerformanceSection.tsx",
      ],
    },
  ],
  UI_Settings_Quality_PerformanceOption: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/settings.map.qualityMode.constants.ts",
      ],
    },
  ],
  UI_Settings_Quality_PresetTitle: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingPerformanceSection.tsx",
      ],
    },
  ],
  UI_Settings_Quality_Reduced: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/settings/map/quality/SettingPerformanceSection.tsx",
      ],
    },
  ],
  UI_Settings_Title: [
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsDialog.tsx"],
    },
  ],
  UI_ShadowCast_Color: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_ContextColor: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_ContextShadows: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_Date: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_Geometry: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_GeometryClear: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_GeometryPick: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_GeometryPicking: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_GradientContinuous: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_GradientHourly: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_GradientStyle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_HighlightColor: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_Interval: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_MinDurationOf: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_MinDurationShadow: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_MinDurationSun: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_MinDurationTooShort: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_ModeDiscrete: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_ModeMinDuration: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_ModeTotalDuration: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_NoDaylight: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_Reset: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetShadowCastButton.tsx",
        "v2-console/src/map/widget/MapWidgetShadowGroupButton.tsx",
        "v2-console/src/map/widget/shadowCast/MapWidgetShadowCastSuspender.tsx",
      ],
    },
  ],
  UI_ShadowCast_SunHours: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_TimeRange: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShadowCast_TooltipShadow: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/shadowCast/MapWidgetShadowCastTooltip.tsx",
      ],
    },
  ],
  UI_ShadowCast_TooltipSun: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/shadowCast/MapWidgetShadowCastTooltip.tsx",
      ],
    },
  ],
  UI_ShadowCast_UnitHours: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx",
        "v2-console/src/map/widget/shadowCast/MapWidgetShadowCastTooltip.tsx",
      ],
    },
  ],
  UI_ShadowCast_UnitMinutes: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx",
        "v2-console/src/map/widget/shadowCast/MapWidgetShadowCastTooltip.tsx",
      ],
    },
  ],
  UI_ShadowCast_Visualization: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/shadowCast/MapWidgetShadowCast.tsx"],
    },
  ],
  UI_ShareFraction_Root: [
    {
      label: "Object",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/object/share/ObjectSharePercentage.tsx"],
    },
  ],
  UI_SidebarMain_Toggle_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_SidebarWidget_Toggle_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/MapWidgetToolbarRight.tsx"],
    },
  ],
  UI_Sketcher_Action_SnapMax: [
    {
      label: "Descriptor",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/descriptor/sketcher.descriptor.actions.ts"],
    },
  ],
  UI_Sketcher_Action_SnapMin: [
    {
      label: "Descriptor",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/descriptor/sketcher.descriptor.actions.ts"],
    },
  ],
  UI_Sketcher_Action_ZoomTo: [
    {
      label: "Descriptor",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/descriptor/sketcher.descriptor.actions.ts"],
    },
  ],
  UI_Sketcher_Area_DrawScreen: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/areaSelector/AreaModeControls.tsx"],
    },
  ],
  UI_Sketcher_Area_Folder: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/areaSelector/sketcher.areaSelector.ts"],
    },
  ],
  UI_Sketcher_Area_ModeCircle: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/areaSelector/sketcher.areaSelector.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Area_ModeExtent: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/areaSelector/sketcher.areaSelector.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Area_ModeLine: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/areaSelector/sketcher.areaSelector.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Area_ModePoint: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/areaSelector/sketcher.areaSelector.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Area_ModePolygon: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/areaSelector/sketcher.areaSelector.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Area_ModeRectangle: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/areaSelector/sketcher.areaSelector.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Area_PointSummary: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/areaSelector/sketcher.areaSelector.utils.ts"],
    },
  ],
  UI_Sketcher_Area_Tool: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/areaSelector/sketcher.area.attributes.ts",
        "v2-sketcher-ui/src/areaSelector/sketcher.area.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Area_UseCurrentView: [
    {
      label: "Area Selector",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/areaSelector/sketcher.area.descriptor.ts"],
    },
  ],
  UI_Sketcher_Attributes_Color: [
    {
      label: "Attributes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/attributes/sketcher.attributes.baseFields.ts",
      ],
    },
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/floor/SketcherFloorsInput.tsx"],
    },
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.fields.ts",
      ],
    },
    {
      label: "Powerline",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/powerline/sketcher.powerline.fields.ts"],
    },
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.fields.ts"],
    },
  ],
  UI_Sketcher_Attributes_Description: [
    {
      label: "Attributes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/attributes/sketcher.attributes.baseFields.ts",
      ],
    },
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/floor/SketcherFloorsInput.tsx"],
    },
  ],
  UI_Sketcher_Attributes_Geometry: [
    {
      label: "Attributes",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/attributes/SketcherAttributePanel.tsx"],
    },
  ],
  UI_Sketcher_Attributes_Mixed: [
    {
      label: "Attributes",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/attributes/sketcher.attributes.presets.ts"],
    },
  ],
  UI_Sketcher_Attributes_MixedEntities: [
    {
      label: "Attributes",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/attributes/SketcherAttributePanel.tsx"],
    },
  ],
  UI_Sketcher_Attributes_Name: [
    {
      label: "Attributes",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/attributes/sketcher.attributes.baseFields.ts",
      ],
    },
  ],
  UI_Sketcher_Buffer_Both: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Center: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Distance: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Edges: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Inner: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Left: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Mode: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Outer: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Right: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Side: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_Buffer_Solid: [
    {
      label: "Buffer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/buffer/sketcher.buffer.fields.ts"],
    },
  ],
  UI_Sketcher_BuildingLine_DrawBuildingLine: [
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_BuildingLine_NamePrefix: [
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.constants.ts",
      ],
    },
  ],
  UI_Sketcher_BuildingLine_Subtype: [
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.fields.ts",
      ],
    },
  ],
  UI_Sketcher_BuildingLine_SubtypeCustom: [
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.fields.ts",
      ],
    },
  ],
  UI_Sketcher_BuildingLine_Tool: [
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_BuildingLine_ToolFloors: [
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_BuildingLine_Width: [
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_DrawBuilding: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.descriptor.ts"],
    },
  ],
  UI_Sketcher_Building_FloorCount: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/floor/sketcher.building.floor.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_FloorDefaultName: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/floor/SketcherFloorsInput.tsx"],
    },
  ],
  UI_Sketcher_Building_FloorInfoDescription: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/floor/sketcher.building.floor.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Building_FloorList: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/floor/sketcher.building.floor.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_Floors: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/floor/sketcher.building.floor.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_Height: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/floor/SketcherFloorsInput.tsx",
        "v2-sketcher-ui/src/building/sketcher.building.fields.ts",
      ],
    },
    {
      label: "Building Line",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/buildingLine/sketcher.buildingLine.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_NamePrefix: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.constants.ts"],
    },
  ],
  UI_Sketcher_Building_Overhang: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_Ridge: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_RidgeLongSide: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_RidgeShortSide: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_Roof: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_RoofFlat: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/roof/sketcher.building.roof.constants.ts",
        "v2-sketcher-ui/src/building/sketcher.building.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_RoofGable: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/roof/sketcher.building.roof.constants.ts",
        "v2-sketcher-ui/src/building/sketcher.building.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_RoofHeight: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_RoofHip: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/roof/sketcher.building.roof.constants.ts",
        "v2-sketcher-ui/src/building/sketcher.building.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_RoofNeedsClosedPolygon: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_RoofNeedsRectangle: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_RoofParapet: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/roof/sketcher.building.roof.constants.ts",
        "v2-sketcher-ui/src/building/sketcher.building.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_RoofShed: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/building/roof/sketcher.building.roof.constants.ts",
        "v2-sketcher-ui/src/building/sketcher.building.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Building_RoofThickness: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_RoofType: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_SlopeDirection: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_SlopeDirection1: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_SlopeDirection2: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_SlopeDirection3: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_SlopeDirection4: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_Subtype: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_SubtypeApartmentFloor: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.constants.ts"],
    },
  ],
  UI_Sketcher_Building_SubtypeCommercial: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.constants.ts"],
    },
  ],
  UI_Sketcher_Building_SubtypeCustom: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.fields.ts"],
    },
  ],
  UI_Sketcher_Building_SubtypeHousing: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.constants.ts"],
    },
  ],
  UI_Sketcher_Building_SubtypeIndustrial: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.constants.ts"],
    },
  ],
  UI_Sketcher_Building_SubtypeOffice: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.constants.ts"],
    },
  ],
  UI_Sketcher_Building_Tool: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.descriptor.ts"],
    },
  ],
  UI_Sketcher_Building_ToolFloors: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.descriptor.ts"],
    },
  ],
  UI_Sketcher_Building_ToolRoof: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.descriptor.ts"],
    },
  ],
  UI_Sketcher_Building_ToolRoofFloors: [
    {
      label: "Building panel",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/building/sketcher.building.descriptor.ts"],
    },
  ],
  UI_Sketcher_CanvasToolbar_ChangeColor: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_CanvasToolbar_ChangeRadius: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/SketcherRadiusPopover.tsx",
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_CanvasToolbar_Delete: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_CanvasToolbar_Duplicate: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_CanvasToolbar_EditVertices: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_CanvasToolbar_FinishEditing: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_CanvasToolbar_MixedColor: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_CanvasToolbar_MixedRadius: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/SketcherRadiusPopover.tsx",
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_CanvasToolbar_MoveMode: [
    {
      label: "Canvas Toolbar",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/canvasToolbar/sketcher.canvasToolbar.actions.tsx",
      ],
    },
  ],
  UI_Sketcher_Catalog_AddCount: [
    {
      label: "Catalog",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/catalog/sketcher.catalog.constants.ts"],
    },
  ],
  UI_Sketcher_Catalog_Clear: [
    {
      label: "Catalog",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/catalog/sketcher.catalog.constants.ts"],
    },
  ],
  UI_Sketcher_Catalog_Collapse: [
    {
      label: "Catalog",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/catalog/AreaCatalogTree.tsx"],
    },
  ],
  UI_Sketcher_Catalog_Empty: [
    {
      label: "Catalog",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/catalog/sketcher.catalog.constants.ts"],
    },
  ],
  UI_Sketcher_Catalog_Expand: [
    {
      label: "Catalog",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/catalog/AreaCatalogTree.tsx"],
    },
  ],
  UI_Sketcher_Catalog_SearchPlaceholder: [
    {
      label: "Catalog",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/catalog/sketcher.catalog.constants.ts"],
    },
  ],
  UI_Sketcher_Catalog_SelectWholeArea: [
    {
      label: "Catalog",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/catalog/sketcher.catalog.constants.ts"],
    },
  ],
  UI_Sketcher_Catalog_Trigger: [
    {
      label: "Catalog",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/catalog/sketcher.catalog.constants.ts"],
    },
  ],
  UI_Sketcher_Constraint_Across: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_Area: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts",
        "v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts",
      ],
    },
  ],
  UI_Sketcher_Constraint_AreaAlongEdge: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_AreaInside: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts",
        "v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts",
      ],
    },
  ],
  UI_Sketcher_Constraint_Average: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_Both: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_Buildable: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts",
        "v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts",
      ],
    },
  ],
  UI_Sketcher_Constraint_DrawBoundaryLine: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/constraint/sketcher.constraint.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Constraint_DrawZone: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/constraint/sketcher.constraint.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Constraint_Highest: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_Kote: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_Left: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_Lowest: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_MaxHeight: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_MeasuredFrom: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_MinHeight: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_NamePrefix: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.constants.ts"],
    },
  ],
  UI_Sketcher_Constraint_Outside: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_Right: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_SectionDisplay: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts"],
    },
  ],
  UI_Sketcher_Constraint_SectionRules: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts"],
    },
  ],
  UI_Sketcher_Constraint_Setback: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_ShowConstraints: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_Side: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Constraint_SummaryBand: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts"],
    },
  ],
  UI_Sketcher_Constraint_SummaryMax: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts"],
    },
  ],
  UI_Sketcher_Constraint_SummaryMin: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts"],
    },
  ],
  UI_Sketcher_Constraint_SummaryNoBuilding: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts"],
    },
  ],
  UI_Sketcher_Constraint_SummarySetback: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.sections.ts"],
    },
  ],
  UI_Sketcher_Constraint_Tool: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/constraint/sketcher.constraint.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Constraint_Width: [
    {
      label: "Constraint",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/constraint/sketcher.constraint.fields.ts"],
    },
  ],
  UI_Sketcher_Core_Circle: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/text/catalog.ts"],
    },
  ],
  UI_Sketcher_Core_FreehandPolygon: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/text/catalog.ts"],
    },
  ],
  UI_Sketcher_Core_Point: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/text/catalog.ts"],
    },
  ],
  UI_Sketcher_Core_Polygon: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/text/catalog.ts"],
    },
  ],
  UI_Sketcher_Core_Polyline: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/text/catalog.ts"],
    },
  ],
  UI_Sketcher_Core_Rectangle: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/text/catalog.ts"],
    },
  ],
  UI_Sketcher_Core_Sketch: [
    {
      label: "Text",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/text/catalog.ts"],
    },
  ],
  UI_Sketcher_Distribute_Algorithm: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_AlongLine: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts",
        "v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_Bake: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_Content: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/SketcherDistributeContentInput.tsx",
        "v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_FillCircle: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_FillPolygon: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_FillRectangle: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_Grid: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts",
        "v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_GridRotation: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_Jitter: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/SketcherDistributeVariationBody.tsx",
        "v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_Max: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_Min: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_NamePrefix: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.constants.ts"],
    },
  ],
  UI_Sketcher_Distribute_Offset: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_Opacity: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_PickContent: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.constants.ts"],
    },
  ],
  UI_Sketcher_Distribute_PlaceAlongLine: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_Poisson: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_Random: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_Rotation: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/SketcherDistributeVariationBody.tsx",
      ],
    },
  ],
  UI_Sketcher_Distribute_Scale: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/SketcherDistributeVariationBody.tsx",
        "v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_Scatter: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts",
        "v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts",
      ],
    },
  ],
  UI_Sketcher_Distribute_SectionAppearance: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SectionDisplay: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SectionGridDetails: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SectionVariation: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_Seed: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_SheetDescription: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.constants.ts"],
    },
  ],
  UI_Sketcher_Distribute_ShowContent: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_ShowFootprint: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_ShowHelpers: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_Spacing: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_SpacingY: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_Strategy: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.fields.ts"],
    },
  ],
  UI_Sketcher_Distribute_SummaryAppearance: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SummaryContent: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SummaryFootprint: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SummaryHelpers: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SummaryJitter: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SummaryNothing: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_SummarySpacing: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/distribute/sketcher.distribute.sections.ts"],
    },
  ],
  UI_Sketcher_Distribute_Tool: [
    {
      label: "Distribute",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/distribute/sketcher.distribute.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Eraser_NamePrefix: [
    {
      label: "Eraser",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/eraser/sketcher.eraser.constants.ts"],
    },
  ],
  UI_Sketcher_Folder_Collapse: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/item/SketcherItemGroupHeader.tsx"],
    },
  ],
  UI_Sketcher_Folder_Expand: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/item/SketcherItemGroupHeader.tsx"],
    },
  ],
  UI_Sketcher_Folder_Remove: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/item/SketcherItemGroupHeader.tsx"],
    },
  ],
  UI_Sketcher_Folder_Rename: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/item/SketcherItemGroupHeader.tsx"],
    },
  ],
  UI_Sketcher_Ground_DrawGround: [
    {
      label: "Ground",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/ground/sketcher.ground.descriptor.ts"],
    },
  ],
  UI_Sketcher_Ground_NamePrefix: [
    {
      label: "Ground",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/ground/sketcher.ground.constants.ts"],
    },
  ],
  UI_Sketcher_Ground_Subtype: [
    {
      label: "Ground",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/ground/sketcher.ground.fields.ts"],
    },
  ],
  UI_Sketcher_Ground_SubtypeGarden: [
    {
      label: "Ground",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/ground/sketcher.ground.constants.ts"],
    },
  ],
  UI_Sketcher_Ground_SubtypePark: [
    {
      label: "Ground",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/ground/sketcher.ground.constants.ts"],
    },
  ],
  UI_Sketcher_Ground_SubtypeParkingPlace: [
    {
      label: "Ground",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/ground/sketcher.ground.constants.ts"],
    },
  ],
  UI_Sketcher_Ground_SubtypeWater: [
    {
      label: "Ground",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/ground/sketcher.ground.constants.ts"],
    },
  ],
  UI_Sketcher_Ground_Tool: [
    {
      label: "Ground",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/ground/sketcher.ground.descriptor.ts"],
    },
  ],
  UI_Sketcher_Helper_DrawGuideLine: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.descriptor.ts"],
    },
  ],
  UI_Sketcher_Helper_DrawGuidePolygon: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.descriptor.ts"],
    },
  ],
  UI_Sketcher_Helper_FillBackwardDiagonal: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_FillCross: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_FillDiagonalCross: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_FillForwardDiagonal: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_FillHorizontal: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_FillNone: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_FillSolid: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_FillStyle: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_FillVertical: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/helper/sketcher.helper.fields.ts"],
    },
  ],
  UI_Sketcher_Helper_Tool: [
    {
      label: "Helper",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/helper/sketcher.helper.constants.ts",
        "v2-sketcher-ui/src/helper/sketcher.helper.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Item_ChangeColor: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/item/SketcherItemColorTrigger.tsx"],
    },
  ],
  UI_Sketcher_Item_Colors: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/item/SketcherItemColorTrigger.tsx"],
    },
  ],
  UI_Sketcher_Item_Delete: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/kit/item/SketcherItemCard.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemPill.tsx",
      ],
    },
  ],
  UI_Sketcher_Item_Edit: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/kit/item/SketcherItemCard.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemPill.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemRow.tsx",
      ],
    },
  ],
  UI_Sketcher_Item_FinishEditing: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/kit/item/SketcherItemCard.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemPill.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemRow.tsx",
      ],
    },
  ],
  UI_Sketcher_Item_Hide: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/kit/item/SketcherItemCard.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemRow.tsx",
      ],
    },
  ],
  UI_Sketcher_Item_MoreOptions: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/item/SketcherItemRow.tsx"],
    },
  ],
  UI_Sketcher_Item_Rename: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/item/SketcherItemRow.tsx"],
    },
  ],
  UI_Sketcher_Item_Show: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/kit/item/SketcherItemCard.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemRow.tsx",
      ],
    },
  ],
  UI_Sketcher_Item_ZoomTo: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/kit/item/SketcherItemCard.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemPill.tsx",
        "v2-sketcher-ui/src/kit/item/SketcherItemRow.tsx",
      ],
    },
  ],
  UI_Sketcher_Library_Description: [
    {
      label: "Library",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/library/sketcher.library.constants.ts"],
    },
  ],
  UI_Sketcher_Library_Empty: [
    {
      label: "Library",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/library/sketcher.library.constants.ts"],
    },
  ],
  UI_Sketcher_Library_GroupImages: [
    {
      label: "Library",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/library/sketcher.library.constants.ts"],
    },
  ],
  UI_Sketcher_Library_GroupModels: [
    {
      label: "Library",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/library/sketcher.library.constants.ts"],
    },
  ],
  UI_Sketcher_Library_GroupPresets: [
    {
      label: "Library",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/library/sketcher.library.constants.ts"],
    },
  ],
  UI_Sketcher_Library_GroupTrees: [
    {
      label: "Library",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/library/sketcher.library.constants.ts"],
    },
  ],
  UI_Sketcher_Library_PlaceHint: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/SketcherHostNotice.tsx"],
    },
  ],
  UI_Sketcher_Library_Title: [
    {
      label: "Library",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/library/sketcher.library.constants.ts"],
    },
  ],
  UI_Sketcher_Library_Trigger: [
    {
      label: "Library",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/library/sketcher.library.constants.ts"],
    },
  ],
  UI_Sketcher_Media_Georeference: [
    {
      label: "Media",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/media/sketcher.media.descriptor.ts"],
    },
  ],
  UI_Sketcher_Media_Opacity: [
    {
      label: "Media",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/media/sketcher.media.fields.ts"],
    },
  ],
  UI_Sketcher_Media_Tool: [
    {
      label: "Media",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/media/sketcher.media.constants.ts",
        "v2-sketcher-ui/src/media/sketcher.media.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Model_Rotation: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-sketcher-ui/src/model/sketcher.model.fields.ts"],
    },
  ],
  UI_Sketcher_Model_Scale: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: ["v2-sketcher-ui/src/model/sketcher.model.fields.ts"],
    },
  ],
  UI_Sketcher_Model_Tool: [
    {
      label: "Models",
      url: "https://app.placepoint.no/map/models",
      files: [
        "v2-sketcher-ui/src/model/sketcher.model.constants.ts",
        "v2-sketcher-ui/src/model/sketcher.model.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Notice_Cancel: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_ClickToContinue: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_ClickToContinueCircle: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_ClickToContinueCircleDrag: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_ClickToContinueRectangle: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_ClickToStart: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_ClickToStartCircle: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_ClickToStartCircleDrag: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_ClickToStartRectangle: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_Delete: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_EditOnMap: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_EditVertices: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_Esc: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/SketcherNotice.tsx"],
    },
  ],
  UI_Sketcher_Notice_Finish: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_MoreActions: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_Notice_MoveMode: [
    {
      label: "Notice",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/notice/sketcher.notice.labels.ts"],
    },
  ],
  UI_Sketcher_ObjectMeasurement_Area: [
    {
      label: "Object Measurement",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/objectMeasurement/sketcher.objectMeasurement.constants.ts",
      ],
    },
  ],
  UI_Sketcher_ObjectMeasurement_Distance: [
    {
      label: "Object Measurement",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/objectMeasurement/sketcher.objectMeasurement.constants.ts",
      ],
    },
  ],
  UI_Sketcher_ObjectMeasurement_NamePrefix: [
    {
      label: "Object Measurement",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/objectMeasurement/sketcher.objectMeasurement.constants.ts",
      ],
    },
  ],
  UI_Sketcher_ObjectMeasurement_Tool: [
    {
      label: "Object Measurement",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/objectMeasurement/sketcher.objectMeasurement.constants.ts",
      ],
    },
  ],
  UI_Sketcher_ObjectMeasurement_Unavailable: [
    {
      label: "Object Measurement",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/objectMeasurement/sketcher.objectMeasurement.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Powerline_DrawPowerline: [
    {
      label: "Powerline",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/powerline/sketcher.powerline.descriptor.ts"],
    },
  ],
  UI_Sketcher_Powerline_NamePrefix: [
    {
      label: "Powerline",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/powerline/sketcher.powerline.constants.ts"],
    },
  ],
  UI_Sketcher_Powerline_Tool: [
    {
      label: "Powerline",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/powerline/sketcher.powerline.descriptor.ts"],
    },
  ],
  UI_Sketcher_Powerline_TowerHeight: [
    {
      label: "Powerline",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/powerline/sketcher.powerline.fields.ts"],
    },
  ],
  UI_Sketcher_Powerline_TowerThickness: [
    {
      label: "Powerline",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/powerline/sketcher.powerline.fields.ts"],
    },
  ],
  UI_Sketcher_Powerline_WireSagConstant: [
    {
      label: "Powerline",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/powerline/sketcher.powerline.fields.ts"],
    },
  ],
  UI_Sketcher_Powerline_WireThickness: [
    {
      label: "Powerline",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/powerline/sketcher.powerline.fields.ts"],
    },
  ],
  UI_Sketcher_Route_DrawRoute: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.descriptor.ts"],
    },
  ],
  UI_Sketcher_Route_NamePrefix: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.constants.ts"],
    },
  ],
  UI_Sketcher_Route_Subtype: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.fields.ts"],
    },
  ],
  UI_Sketcher_Route_SubtypeBicycleAndPathway: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.constants.ts"],
    },
  ],
  UI_Sketcher_Route_SubtypeBicyclePathwayUrban: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.constants.ts"],
    },
  ],
  UI_Sketcher_Route_SubtypePath: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.constants.ts"],
    },
  ],
  UI_Sketcher_Route_SubtypePedestrianPathwayUrban: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.constants.ts"],
    },
  ],
  UI_Sketcher_Route_Tool: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.descriptor.ts"],
    },
  ],
  UI_Sketcher_Route_Width: [
    {
      label: "Route",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/route/sketcher.route.fields.ts"],
    },
  ],
  UI_Sketcher_Subtype_Mixed: [
    {
      label: "Tools",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/tools/sketcher.tools.constants.ts"],
    },
  ],
  UI_Sketcher_Subtype_Other: [
    {
      label: "Tools",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/tools/sketcher.tools.constants.ts"],
    },
  ],
  UI_Sketcher_Terrace_DeckThickness: [
    {
      label: "Terrace",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terrace/sketcher.terrace.fields.ts"],
    },
  ],
  UI_Sketcher_Terrace_DrawDeck: [
    {
      label: "Terrace",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terrace/sketcher.terrace.descriptor.ts"],
    },
  ],
  UI_Sketcher_Terrace_NamePrefix: [
    {
      label: "Terrace",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terrace/sketcher.terrace.constants.ts"],
    },
  ],
  UI_Sketcher_Terrace_RailingHeight: [
    {
      label: "Terrace",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terrace/sketcher.terrace.fields.ts"],
    },
  ],
  UI_Sketcher_Terrace_RailingWidth: [
    {
      label: "Terrace",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terrace/sketcher.terrace.fields.ts"],
    },
  ],
  UI_Sketcher_Terrace_Tool: [
    {
      label: "Terrace",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terrace/sketcher.terrace.descriptor.ts"],
    },
  ],
  UI_Sketcher_Terraformer_Added: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/SketcherTerraformVolumeInput.tsx",
      ],
    },
  ],
  UI_Sketcher_Terraformer_Buffer: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terraformer/sketcher.terraformer.fields.ts"],
    },
  ],
  UI_Sketcher_Terraformer_DrawArea: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/sketcher.terraformer.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Terraformer_DrawCircle: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/sketcher.terraformer.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Terraformer_DrawLine: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/sketcher.terraformer.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Terraformer_DrawRectangle: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/sketcher.terraformer.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Terraformer_EstimateVolume: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/SketcherTerraformVolumeInput.tsx",
      ],
    },
  ],
  UI_Sketcher_Terraformer_HideVisualisation: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/SketcherTerraformVolumeInput.tsx",
      ],
    },
  ],
  UI_Sketcher_Terraformer_NamePrefix: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/sketcher.terraformer.constants.ts",
      ],
    },
  ],
  UI_Sketcher_Terraformer_Removed: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/SketcherTerraformVolumeInput.tsx",
      ],
    },
  ],
  UI_Sketcher_Terraformer_SlopeAngle: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terraformer/sketcher.terraformer.fields.ts"],
    },
  ],
  UI_Sketcher_Terraformer_Tool: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/sketcher.terraformer.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Terraformer_Total: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/SketcherTerraformVolumeInput.tsx",
      ],
    },
  ],
  UI_Sketcher_Terraformer_VisualiseVolumeChange: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/terraformer/SketcherTerraformVolumeInput.tsx",
      ],
    },
  ],
  UI_Sketcher_Terraformer_Volume: [
    {
      label: "Terraformer",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/terraformer/sketcher.terraformer.fields.ts"],
    },
  ],
  UI_Sketcher_Tree_CanopyHeight: [
    {
      label: "Tree",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/tree/sketcher.tree.fields.ts"],
    },
  ],
  UI_Sketcher_Tree_CanopyRadius: [
    {
      label: "Tree",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/tree/sketcher.tree.fields.ts"],
    },
  ],
  UI_Sketcher_Tree_Tool: [
    {
      label: "Tree",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-sketcher-ui/src/tree/sketcher.tree.constants.ts",
        "v2-sketcher-ui/src/tree/sketcher.tree.descriptor.ts",
      ],
    },
  ],
  UI_Sketcher_Tree_TrunkHeight: [
    {
      label: "Tree",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/tree/sketcher.tree.fields.ts"],
    },
  ],
  UI_Sketcher_Tree_TrunkRadius: [
    {
      label: "Tree",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/tree/sketcher.tree.fields.ts"],
    },
  ],
  UI_Sketcher_Trigger_ChooseTool: [
    {
      label: "Kit",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/kit/trigger/SketcherTriggerGroup.tsx"],
    },
  ],
  UI_Sketcher_Validation_AreaForbidden: [
    {
      label: "Validation",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/validation/sketcher.validation.messages.ts"],
    },
  ],
  UI_Sketcher_Validation_AreaOutOfRange: [
    {
      label: "Validation",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/validation/sketcher.validation.messages.ts"],
    },
  ],
  UI_Sketcher_Validation_BufferViolated: [
    {
      label: "Validation",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/validation/sketcher.validation.messages.ts"],
    },
  ],
  UI_Sketcher_Validation_HeightOutOfRange: [
    {
      label: "Validation",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/validation/sketcher.validation.messages.ts"],
    },
  ],
  UI_Sketcher_Validation_MaxHeightExceeded: [
    {
      label: "Validation",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/validation/sketcher.validation.messages.ts"],
    },
  ],
  UI_Sketcher_Validation_MinHeightBelow: [
    {
      label: "Validation",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/validation/sketcher.validation.messages.ts"],
    },
  ],
  UI_Sketcher_Wall_DrawWall: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.descriptor.ts"],
    },
  ],
  UI_Sketcher_Wall_Height: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.fields.ts"],
    },
  ],
  UI_Sketcher_Wall_NamePrefix: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.constants.ts"],
    },
  ],
  UI_Sketcher_Wall_Subtype: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.fields.ts"],
    },
  ],
  UI_Sketcher_Wall_SubtypeFence: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.constants.ts"],
    },
  ],
  UI_Sketcher_Wall_SubtypeGeneric: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.constants.ts"],
    },
  ],
  UI_Sketcher_Wall_SubtypeRetaining: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.constants.ts"],
    },
  ],
  UI_Sketcher_Wall_Thickness: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.fields.ts"],
    },
  ],
  UI_Sketcher_Wall_Tool: [
    {
      label: "Wall",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/wall/sketcher.wall.descriptor.ts"],
    },
  ],
  UI_Sketcher_Workbench_Close: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/SketcherWorkbench.tsx"],
    },
  ],
  UI_Sketcher_Workbench_DockEmptyDescription: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/layouts/SketcherDockLayout.tsx"],
    },
  ],
  UI_Sketcher_Workbench_EmptyDescription: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/SketcherWorkbench.tsx"],
    },
  ],
  UI_Sketcher_Workbench_EmptyTitle: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/SketcherWorkbench.tsx"],
    },
  ],
  UI_Sketcher_Workbench_ExtentDescription: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/SketcherWorkbench.tsx"],
    },
  ],
  UI_Sketcher_Workbench_ExtentTitle: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/SketcherWorkbench.tsx"],
    },
  ],
  UI_Sketcher_Workbench_Selected: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/SketcherWorkbench.tsx"],
    },
  ],
  UI_Sketcher_Workbench_Title: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/layouts/SketcherSidePanelLayout.tsx"],
    },
  ],
  UI_Sketcher_Workbench_Verify: [
    {
      label: "Host",
      url: "https://app.placepoint.no/map",
      files: ["v2-sketcher-ui/src/host/SketcherWorkbench.tsx"],
    },
  ],
  UI_Statistics_Accuracy: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/StatisticsGrid.tsx",
        "v2-console/src/statistics/grid/StatisticsGridContent.tsx",
      ],
    },
  ],
  UI_Statistics_Age: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Building: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_EducationLevel: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationLevel.tsx",
      ],
    },
  ],
  UI_Statistics_EducationSubject: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Error_Summary: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Family: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_13_15: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_16_18: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_19_23: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_24_34: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_35_44: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_45_54: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_55_64: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_65_74: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_6_12: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_75_84: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_AvgFemale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_AvgMale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_Label: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_Over85: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_TotalFemale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_TotalMale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Age_Under5: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_ApartmentBuilding: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_Apartments: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_Cabin: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_Commercial: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_CommercialArea: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_Detached: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_Households: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_Other: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_ResidentialUnits: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Building_SmallHouse: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphBuilding.tsx"],
    },
  ],
  UI_Statistics_Graph_Education_HigherLong: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationLevel.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Education_HigherShort: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationLevel.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Education_NoEducation: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/statistics.text.ts"],
    },
  ],
  UI_Statistics_Graph_Education_Primary: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationLevel.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Education_Secondary: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationLevel.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Education_Total: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationLevel.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Education_Unknown: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationLevel.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Family_Couple: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Family_CoupleNoChildren: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Family_CoupleWithChildren: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Family_MultiFamily: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Family_Single: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Family_SingleNoChildren: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Family_SingleWithChildren: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Family_Total: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphFamily.tsx"],
    },
  ],
  UI_Statistics_Graph_Gender_Female: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Gender_Male: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphAge.tsx"],
    },
  ],
  UI_Statistics_Graph_Housing_Apartment: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphHousing.tsx"],
    },
  ],
  UI_Statistics_Graph_Housing_Detached: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphHousing.tsx"],
    },
  ],
  UI_Statistics_Graph_Housing_Other: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphHousing.tsx"],
    },
  ],
  UI_Statistics_Graph_Housing_SemiDetached: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphHousing.tsx"],
    },
  ],
  UI_Statistics_Graph_Housing_Total: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphHousing.tsx"],
    },
  ],
  UI_Statistics_Graph_Housing_Townhouse: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphHousing.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_0: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_0_100: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_1000_1200: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_100_200: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_1200_1400: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_1400_1600: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_1600_1800: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_1800_2000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_2000_2500: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_200_300: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_2500_3000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_300_400: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_400_500: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_500_600: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_600_700: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_700_800: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_800_900: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_900_1000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_Avg: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_Over3000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_PersonKroner: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Income_Total: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_Graph_Marital_Divorced: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphMaritalStatus.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Marital_Married: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphMaritalStatus.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Marital_SingleFemale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphMaritalStatus.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Marital_SingleMale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphMaritalStatus.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Marital_Total: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphMaritalStatus.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Marital_Widowed: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphMaritalStatus.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Ownership_Coop: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphOwnership.tsx"],
    },
  ],
  UI_Statistics_Graph_Ownership_Owner: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphOwnership.tsx"],
    },
  ],
  UI_Statistics_Graph_Ownership_Renter: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphOwnership.tsx"],
    },
  ],
  UI_Statistics_Graph_Ownership_Total: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphOwnership.tsx"],
    },
  ],
  UI_Statistics_Graph_Subject_Agriculture: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_Business: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_Education: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_General: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_Health: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_Humanities: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_Science: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_Social: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_Total: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/statistics.text.ts"],
    },
  ],
  UI_Statistics_Graph_Subject_Transport: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphEducationSubject.tsx",
      ],
    },
  ],
  UI_Statistics_Graph_Subject_Unknown: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/statistics.text.ts"],
    },
  ],
  UI_Statistics_Graph_Wealth_0: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_0_200: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_10000_15000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_1000_2000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_15000_20000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_2000_3000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_200_400: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_3000_4000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_4000_6000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_400_700: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_6000_8000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_700_1000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_8000_10000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_Avg: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_Over20000: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_PersonKroner: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Graph_Wealth_Total: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_Statistics_Grid_BasicStatisticalUnit: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/grid/StatisticsGridContent.tsx"],
    },
  ],
  UI_Statistics_Grid_Blend: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/grid/StatisticsGridStylePanel.tsx"],
    },
  ],
  UI_Statistics_Grid_CellDetails: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/interaction/StatisticsGridSelectedPopup.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_ClosePopup: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/interaction/StatisticsGridSelectedPopup.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_ColorScaling: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/scaling/StatisticsGridScalingSelector.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_Effects: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/grid/StatisticsGridStylePanel.tsx"],
    },
  ],
  UI_Statistics_Grid_Error: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/grid/statistics.grid.utils.tsx"],
    },
  ],
  UI_Statistics_Grid_Field_Apartments: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_AvgAgeFemale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_AvgAgeMale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_AvgIncome: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_AvgWealth: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_CommercialArea: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_Employed: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_Employees: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_GrocerySpending: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_Households: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_InCommuters: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_OutCommuters: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_Population: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_PopulationDaytime: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Field_ResidentialUnits: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_HideEmptyCells: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/StatisticsGridDisplayOptions.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_Legend_High: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/grid/StatisticsGridLegend.tsx"],
    },
  ],
  UI_Statistics_Grid_Legend_Low: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/grid/StatisticsGridLegend.tsx"],
    },
  ],
  UI_Statistics_Grid_Loading: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/grid/statistics.grid.utils.tsx"],
    },
  ],
  UI_Statistics_Grid_Placeholder: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/StatisticsGridPrecisionSelector.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_Precision: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/StatisticsGridPrecisionSelector.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_Scaling_Linear: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Scaling_NumClasses: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/scaling/StatisticsGridScalingQuantileOptions.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_Scaling_Percentile: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Scaling_PercentileRange: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/scaling/StatisticsGridScalingPercentileOptions.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_Scaling_Quantile: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Scaling_Sqrt: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_ShowGrid: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/grid/StatisticsGridContent.tsx"],
    },
  ],
  UI_Statistics_Grid_ShowLabels: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/StatisticsGridDisplayOptions.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_Unit_Currency: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Unit_CurrencyPerYear: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Unit_SquareMeters: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_Unit_Years: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/statistics.grid.visualization.ts",
      ],
    },
  ],
  UI_Statistics_Grid_VisualizationSettings: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/scaling/StatisticsGridScalingSelector.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_VisualizeBy: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/StatisticsGridVisualizationSelector.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_VisualizeBy_None: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/StatisticsGridVisualizationSelector.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_VisualizeBy_Placeholder: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/StatisticsGridVisualizationSelector.tsx",
      ],
    },
  ],
  UI_Statistics_Grid_ZoomToCell: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/grid/interaction/StatisticsGridSelectedPopup.tsx",
      ],
    },
  ],
  UI_Statistics_Housing: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphHousing.tsx"],
    },
  ],
  UI_Statistics_Income: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphIncome.tsx"],
    },
  ],
  UI_Statistics_MaritalStatus: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: [
        "v2-console/src/statistics/graph/StatisticsGraphMaritalStatus.tsx",
      ],
    },
  ],
  UI_Statistics_Overview: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Ownership: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphOwnership.tsx"],
    },
  ],
  UI_Statistics_Summary_AgeFemale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_AgeMale: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Apartments: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_CommercialBuilding: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Employed: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Employees: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Grocery: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Households: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_InCommuters: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Income: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_OutCommuters: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Population: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_PopulationDaytime: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_ResidentialUnits: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Wealth: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Summary_Workers: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Unit_Currency: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Unit_CurrencyPerYear: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Unit_SquareMeters: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Unit_Years: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/summary/StatisticsSummary.tsx"],
    },
  ],
  UI_Statistics_Wealth: [
    {
      label: "Statistics",
      url: "https://app.placepoint.no/map/statistics",
      files: ["v2-console/src/statistics/graph/StatisticsGraphWealth.tsx"],
    },
  ],
  UI_StreetView_Overview_Close: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/streetview/OverviewStreetView.tsx",
      ],
    },
  ],
  UI_StreetView_Overview_Empty: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/streetview/OverviewStreetView.tsx",
      ],
    },
  ],
  UI_StreetView_Overview_Expand: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/streetview/OverviewStreetView.tsx",
      ],
    },
  ],
  UI_StreetView_Overview_ZoomIn: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/streetview/OverviewStreetView.tsx",
      ],
    },
  ],
  UI_StreetView_Overview_ZoomOut: [
    {
      label: "Cadastre panel",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/cadastre/overview/streetview/OverviewStreetView.tsx",
      ],
    },
  ],
  UI_SysReq_Back: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.text.ts"],
    },
  ],
  UI_SysReq_Browser: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/sysReq/SysReqChecker.tsx",
        "v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx",
      ],
    },
  ],
  UI_SysReq_BrowserName: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_BrowserStatus: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_BrowserSupported: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_BrowserUnsupported: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_BrowserVersion: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_Compatible: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoStatus.tsx"],
    },
  ],
  UI_SysReq_ContinueAnyway: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_CopyDebugInfo: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoCopyDebug.tsx"],
    },
  ],
  UI_SysReq_CopyDebugInfoCopied: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoCopyDebug.tsx"],
    },
  ],
  UI_SysReq_CriticalIssues: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoIssueList.tsx"],
    },
  ],
  UI_SysReq_CriticalIssuesCount: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_DebugHelp: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoCopyDebug.tsx"],
    },
  ],
  UI_SysReq_ErrorBadge: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoStatus.tsx"],
    },
  ],
  UI_SysReq_ErrorsBadge: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoStatus.tsx"],
    },
  ],
  UI_SysReq_Ext_ColorBufferFloat: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.constants.ts"],
    },
  ],
  UI_SysReq_Ext_ColorBufferHalfFloat: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.constants.ts"],
    },
  ],
  UI_SysReq_Ext_TextureFloatLinear: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.constants.ts"],
    },
  ],
  UI_SysReq_Ext_TextureNorm16: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.constants.ts"],
    },
  ],
  UI_SysReq_HideDetails: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_Issue_BrowserOutdated: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_BrowserOutdated_Recommendation: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_BrowserUnsupported: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_BrowserUnsupported_Recommendation: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_HardwareAcceleration: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_HardwareAcceleration_Recommendation: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_Memory: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_Memory_Recommendation: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_VivaldiGestures: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_VivaldiGestures_Recommendation: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_WebGL2: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_WebGL2_Recommendation: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_WebGLExtensions: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_Issue_WebGLExtensions_Recommendation: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/sysReq.checks.ts"],
    },
  ],
  UI_SysReq_IssuesDetected: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoStatus.tsx"],
    },
  ],
  UI_SysReq_LearnMoreLink: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/sysReq/SysReqChecker.tsx",
        "v2-console/src/sysReq/info/SysReqInfoResources.tsx",
      ],
    },
  ],
  UI_SysReq_LiveMonitor: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfo.tsx"],
    },
  ],
  UI_SysReq_Resources: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoResources.tsx"],
    },
  ],
  UI_SysReq_SystemInfo: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfo.tsx"],
    },
  ],
  UI_SysReq_SystemRequirementsUrl: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/sysReq/SysReqChecker.tsx",
        "v2-console/src/sysReq/info/SysReqInfoResources.tsx",
      ],
    },
  ],
  UI_SysReq_TestSystemLink: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/sysReq/SysReqChecker.tsx",
        "v2-console/src/sysReq/info/SysReqInfoResources.tsx",
      ],
    },
  ],
  UI_SysReq_Title: [
    {
      label: "Help",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/help/HelpMenuItems.tsx"],
    },
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/help/SystemRequirementsDialog.tsx"],
    },
  ],
  UI_SysReq_UserAgentLabel: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_ViewDetails: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_WarningBadge: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoStatus.tsx"],
    },
  ],
  UI_SysReq_WarningHelp: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_WarningSubtitle: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_WarningTitle: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_Warnings: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoIssueList.tsx"],
    },
  ],
  UI_SysReq_WarningsBadge: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoStatus.tsx"],
    },
  ],
  UI_SysReq_WarningsCount: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_WebGL: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_WebGLExtensions: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_WebGLHardwareAccel: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_WebGLHardwareAccelDisabled: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_WebGLHardwareAccelEnabled: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_WebGLInfoLabel: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/SysReqChecker.tsx"],
    },
  ],
  UI_SysReq_WebGLMissing: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_WebGLRenderer: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_WebGLReportUrl: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: [
        "v2-console/src/sysReq/SysReqChecker.tsx",
        "v2-console/src/sysReq/info/SysReqInfoResources.tsx",
      ],
    },
  ],
  UI_SysReq_WebGLVendor: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_SysReq_WebGLVersion: [
    {
      label: "System requirements",
      url: "https://app.placepoint.no/",
      files: ["v2-console/src/sysReq/info/SysReqInfoSystemInfo.tsx"],
    },
  ],
  UI_TagManager_ActionsMenuLabel: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_ActiveTagsAddTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/manager/ObjectTags.tsx"],
    },
  ],
  UI_TagManager_ActiveTagsNoTags: [
    {
      label: "Tag Manager",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/tagManager/tag.manager.text.ts"],
    },
  ],
  UI_TagManager_CreateHint: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_CreatePrefix: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_CreateTagSubmit: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_CreateTagTitle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_DeleteButton: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_FailedToCreateActiveTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/tag.object.api.ts"],
    },
  ],
  UI_TagManager_FailedToCreateTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.api.ts"],
    },
  ],
  UI_TagManager_FailedToDeleteTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.api.ts"],
    },
  ],
  UI_TagManager_FailedToRemoveActiveTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/tag.object.api.ts"],
    },
  ],
  UI_TagManager_FailedToUpdateTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.api.ts"],
    },
  ],
  UI_TagManager_FieldColor: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_FieldColorOption: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_FieldName: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_FieldNamePlaceholder: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_FieldPreview: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_FieldPreviewFallbackName: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_FieldPreviewUpdate: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_RemoveTagLabel: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_Save: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_SectionAssigned: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_SectionAvailable: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_SelectorDescriptionEmptySearchResult: [
    {
      label: "Tag Manager",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/tagManager/tag.manager.text.ts"],
    },
  ],
  UI_TagManager_SelectorDescriptionNoTags: [
    {
      label: "Tag Manager",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/tagManager/tag.manager.text.ts"],
    },
  ],
  UI_TagManager_SelectorSearchPlaceholder: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsChangeColor: [
    {
      label: "Tag Manager",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/tagManager/tag.manager.text.ts"],
    },
  ],
  UI_TagManager_TagActionsDelete: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsDeleteDialogCancel: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsDeleteDialogDescription: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsDeleteDialogImpactObjects: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsDeleteDialogImpactTags: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsDeleteDialogImpactTitle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsDeleteDialogSubmit: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsDeleteDialogTitle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsEdit: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/object/useTagsUiText.ts"],
    },
  ],
  UI_TagManager_TagActionsRename: [
    {
      label: "Tag Manager",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/tagManager/tag.manager.text.ts"],
    },
  ],
  UI_Tags_AddObjects: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/addObjects/AddObjectsToTag.tsx",
        "v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx",
      ],
    },
  ],
  UI_Tags_AddObjects_Error: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/addObjects/AddObjectsToTag.tsx"],
    },
  ],
  UI_Tags_AddObjects_Title: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/addObjects/AddObjectsToTag.tsx"],
    },
  ],
  UI_Tags_AddToAllSkipped: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_AddToAllSuccess: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchAddRowJoiner: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchAddRowPrefix: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchAdded: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchConfirmCancel: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchConfirmReset: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchCreateTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchEffectObjects: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchObjectsAffected: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchPreviewEmpty: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchRemoveRowJoiner: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchRemoveRowPrefix: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchRemoved: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx",
        "v2-console/src/tag/batch/AddRemoveTagsDialog.tsx",
      ],
    },
  ],
  UI_Tags_BatchRowRemove: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchSectionJoiner: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchSelectLabelAdd: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchSelectLabelRemove: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchSelectTagAdd: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchSelectTagRemove: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_BatchUnresolved: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_DatasetAllPostfix: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/export/TagAggregatedExport.tsx"],
    },
  ],
  UI_Tags_DatasetFilterReset: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/export/TagAggregatedExport.tsx"],
    },
  ],
  UI_Tags_DatasetFilteredPostfix: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/export/TagAggregatedExport.tsx"],
    },
  ],
  UI_Tags_DatasetName: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/export/tag.aggregated.export.ts"],
    },
  ],
  UI_Tags_DatasetOpen: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/export/TagAggregatedExport.tsx"],
    },
  ],
  UI_Tags_DatasetTagsText: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/export/TagAggregatedExport.tsx"],
    },
  ],
  UI_Tags_Delete_Error: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.text.ts"],
    },
  ],
  UI_Tags_DetailAdd: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailBack: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/TagAggregatedPanelContent.tsx",
        "v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx",
      ],
    },
  ],
  UI_Tags_DetailListCount: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailMoreActions: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailRemoveAll: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailRemoveAllConfirmDescription: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailRemoveConfirmCancel: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailRemoveConfirmImpact: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailRemoveConfirmSubmit: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailRemoveConfirmTitle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailRemoveFiltered: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_DetailRemoveFilteredConfirmDescription: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx"],
    },
  ],
  UI_Tags_EditAll: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/TagAggregatedAllContent.tsx",
        "v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx",
      ],
    },
  ],
  UI_Tags_EditAllConfirmSubmit: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_EditAllConfirmSubmitMany: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_EditAllConfirmTitle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_EditAllError: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx",
        "v2-console/src/tag/batch/AddRemoveTagsDialog.tsx",
      ],
    },
  ],
  UI_Tags_FilterAllTags: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/TagAggregatedPanelContent.tsx",
        "v2-console/src/tag/aggregated/legend/TagAggregatedLegend.tsx",
        "v2-console/src/tag/nav/TagNav.tsx",
      ],
    },
  ],
  UI_Tags_FilterButton: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAggregatedFilter.tsx"],
    },
  ],
  UI_Tags_FilterCreatedBy: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterCreatedByAnyone: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterCreatedByMe: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterCreatedByNotMe: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterMustIncludeAll: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAggregatedFilter.tsx"],
    },
  ],
  UI_Tags_FilterPlaceholder: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAggregatedFilter.tsx"],
    },
  ],
  UI_Tags_FilterReset: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAggregatedFilter.tsx"],
    },
  ],
  UI_Tags_FilterSearch: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAggregatedFilter.tsx"],
    },
  ],
  UI_Tags_FilterUpdatedWithin: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterUpdatedWithinAny: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterUpdatedWithinLast30Days: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterUpdatedWithinLast7Days: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterUpdatedWithinLastHour: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FilterUpdatedWithinToday: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAuditFilterSelects.tsx"],
    },
  ],
  UI_Tags_FollowExtent: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/TagFollowExtentToggle.tsx"],
    },
  ],
  UI_Tags_Header: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuTagItem.tsx"],
    },
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/TagAggregatedPanelContent.tsx",
        "v2-console/src/tag/aggregated/legend/TagAggregatedLegend.tsx",
      ],
    },
  ],
  UI_Tags_Legend_Extent: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/legend/TagAggregatedLegend.tsx"],
    },
  ],
  UI_Tags_Legend_Overlap: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/legend/TagAggregatedLegend.tsx"],
    },
  ],
  UI_Tags_ListEmpty: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/filter/TagAggregatedFilter.tsx",
        "v2-console/src/tag/aggregated/list/TagAggregatedList.tsx",
      ],
    },
  ],
  UI_Tags_ListItemNoAddress: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/list/TagAggregatedListItem.tsx"],
    },
  ],
  UI_Tags_MenuBorrowedByPanel: [
    {
      label: "Map layers",
      url: "https://app.placepoint.no/map/layers",
      files: ["v2-console/src/map/activeLayer/MapActiveLayerMenuTagItem.tsx"],
    },
  ],
  UI_Tags_NavCreateGroup: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavCreateTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavDeleteAll: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavDeleteAllConfirmCancel: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavDeleteAllConfirmDescription: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavDeleteAllConfirmSubmit: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavDeleteAllConfirmTitle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavFilterButton: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavGroupCreateTag: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNavGroup.tsx"],
    },
  ],
  UI_Tags_NavGroupDelete: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNavGroup.tsx"],
    },
  ],
  UI_Tags_NavGroupDeleteConfirmCancel: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavGroupDeleteConfirmDeleteTags: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavGroupDeleteConfirmDescription: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavGroupDeleteConfirmKeepTags: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavGroupDeleteConfirmSubmit: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavGroupDeleteConfirmTitle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavGroupError: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/group/tag.group.api.ts"],
    },
  ],
  UI_Tags_NavGroupMapToggle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNavGroup.tsx"],
    },
  ],
  UI_Tags_NavGroupName: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavGroupRename: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNavGroup.tsx"],
    },
  ],
  UI_Tags_NavGroupZoomTo: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavItemCount: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavItemMapToggle: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavItemOpen: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavItemZoomTo: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavListCount: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/TagAggregatedAllContent.tsx",
        "v2-console/src/tag/nav/TagNav.tsx",
      ],
    },
  ],
  UI_Tags_NavMoreActions: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavNew: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_NavSearch: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/nav/TagNav.tsx"],
    },
  ],
  UI_Tags_ObjectTypeFilterButton: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAggregatedFilter.tsx"],
    },
  ],
  UI_Tags_ObjectTypeFilterPlaceholder: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/filter/TagAggregatedFilter.tsx"],
    },
  ],
  UI_Tags_ObjectType_Building: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.constants.ts"],
    },
  ],
  UI_Tags_ObjectType_Cadastre: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.constants.ts"],
    },
  ],
  UI_Tags_ObjectType_Company: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.constants.ts"],
    },
  ],
  UI_Tags_ObjectType_HousingUnit: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.constants.ts"],
    },
  ],
  UI_Tags_ObjectType_Person: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/tag.constants.ts"],
    },
  ],
  UI_Tags_RemoveFromAllSkipped: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/batch/AddRemoveTagsDialog.tsx"],
    },
  ],
  UI_Tags_RemoveFromAllSuccess: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx",
        "v2-console/src/tag/batch/AddRemoveTagsDialog.tsx",
      ],
    },
  ],
  UI_Tags_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/sidebar/map.sidebar.registry.tsx"],
    },
  ],
  UI_Tags_Search: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: [
        "v2-console/src/tag/aggregated/TagAggregatedAllContent.tsx",
        "v2-console/src/tag/aggregated/detail/TagAggregatedDetail.tsx",
      ],
    },
  ],
  UI_Tags_ZoomTo: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/list/TagAggregatedListItem.tsx"],
    },
  ],
  UI_Tags_ZoomToAll: [
    {
      label: "Tags",
      url: "https://app.placepoint.no/map/tags",
      files: ["v2-console/src/tag/aggregated/list/TagAggregatedList.tsx"],
    },
  ],
  UI_Takmal_BuiltYear: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Details: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Drawing: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalDrawing.tsx"],
    },
  ],
  UI_Takmal_DrawingNorth: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalDrawing.tsx"],
    },
  ],
  UI_Takmal_DrawingScale: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalDrawing.tsx"],
    },
  ],
  UI_Takmal_EaveHeight: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Edge_Eave: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_Edge_Hip: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_Edge_Ridge: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_Edge_Step: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_Edge_Valley: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_Error: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_FaceUncertain: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_Faces: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Length_Eave: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_Length_Hip: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_Length_Ridge: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_Length_Valley: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/map.widget.takmal.text.ts"],
    },
  ],
  UI_Takmal_No: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_NoData: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_NoProperty: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_PickAnother: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Pitch: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_RidgeHeight: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_RoofArea: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_RoofShape: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetBetaGroupButton.tsx",
        "v2-console/src/map/widget/MapWidgetTakmalButton.tsx",
        "v2-console/src/map/widget/takmal/MapWidgetTakmalSuspender.tsx",
      ],
    },
  ],
  UI_Takmal_Source: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_SourceAccuracy: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Tab3D: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx",
        "v2-console/src/map/widget/takmal/MapWidgetTakmalPreview.tsx",
      ],
    },
  ],
  UI_Takmal_TabDrawing: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Tile: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_TileAge: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_TileAgeFrom: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_TileAgeYears: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_TileAppendix: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_TileArea: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_TileTotal: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Takmal_UnplacedExtension: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmal.tsx"],
    },
  ],
  UI_Takmal_Yes: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/takmal/MapWidgetTakmalTiles.tsx"],
    },
  ],
  UI_Tender_Header: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderPanel.tsx"],
    },
  ],
  UI_Tender_LabelAgreementPeriod: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderOverviewModule.tsx"],
    },
  ],
  UI_Tender_LabelAreas: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderAreasPricesModule.tsx"],
    },
  ],
  UI_Tender_LabelEvaluation: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderDescriptionModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Tender_LabelPriceTotal: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderAreasPricesModule.tsx"],
    },
  ],
  UI_Tender_LabelPrices: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderAreasPricesModule.tsx"],
    },
  ],
  UI_Tender_LabelWinner: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderOverviewModule.tsx"],
    },
  ],
  UI_Tender_ParticipationFinalist: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderActorsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Tender_ParticipationOther: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderActorsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Tender_ParticipationParticipant: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderActorsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Tender_ParticipationWinner: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderActorsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
      ],
    },
  ],
  UI_Tender_PriceUnitPerM2: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderAreasPricesModule.tsx"],
    },
  ],
  UI_Tender_PriceUnitPerM2PerYear: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderAreasPricesModule.tsx"],
    },
  ],
  UI_Tender_PriceUnitPerUnit: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderAreasPricesModule.tsx"],
    },
  ],
  UI_Tender_TabActors: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderActorsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
        "v2-console/src/tender/panel/tender.panel.config.tsx",
      ],
    },
  ],
  UI_Tender_TabContacts: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderContactsModule.tsx",
        "v2-console/src/tender/panel/tender.panel.config.tsx",
      ],
    },
  ],
  UI_Tender_TabDescription: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderDescriptionModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
        "v2-console/src/tender/panel/tender.panel.config.tsx",
      ],
    },
  ],
  UI_Tender_TabDocuments: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderDocumentsModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
        "v2-console/src/tender/panel/tender.panel.config.tsx",
      ],
    },
  ],
  UI_Tender_TabLinkedProfiles: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderLinkedProfilesModule.tsx",
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
        "v2-console/src/tender/panel/tender.panel.config.tsx",
      ],
    },
  ],
  UI_Tender_TabOverview: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/tender/panel/TenderOverviewModule.tsx",
        "v2-console/src/tender/panel/tender.panel.config.tsx",
      ],
    },
  ],
  UI_Tender_Timeline: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderTimelineModule.tsx"],
    },
  ],
  UI_Tender_TimelineCancelled: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderTimelineModule.tsx"],
    },
  ],
  UI_Tender_TimelineDelayed: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderTimelineModule.tsx"],
    },
  ],
  UI_Tender_TimelinePaused: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderTimelineModule.tsx"],
    },
  ],
  UI_Tender_ZoomTo: [
    {
      label: "Tender",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/tender/panel/TenderPanel.tsx"],
    },
  ],
  UI_ThemeSubmenu_DarkHighContrast_Root: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/theme/currentUser.theme.constants.ts",
      ],
    },
  ],
  UI_ThemeSubmenu_Dark_Root: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/theme/currentUser.theme.constants.ts",
      ],
    },
  ],
  UI_ThemeSubmenu_LightHighContrast_Root: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/theme/currentUser.theme.constants.ts",
      ],
    },
  ],
  UI_ThemeSubmenu_Light_Root: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: [
        "v2-console/src/currentUser/theme/currentUser.theme.constants.ts",
      ],
    },
  ],
  UI_Theme_Dark_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Theme_FontSizeApply: [
    {
      label: "Theme Customizer",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/themeCustomizer/themeCustomizer.text.ts"],
    },
  ],
  UI_Theme_FontSizePreviewTextLarge: [
    {
      label: "Theme Customizer",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/themeCustomizer/themeCustomizer.text.ts"],
    },
  ],
  UI_Theme_FontSizePreviewTextSmall: [
    {
      label: "Theme Customizer",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/themeCustomizer/themeCustomizer.text.ts"],
    },
  ],
  UI_Theme_FontSizeSelector: [
    {
      label: "Theme Customizer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/themeCustomizer/ThemeCustomizer.tsx",
        "v2-console-ui/src/themeCustomizer/ThemeCustomizerFontSizePicker.tsx",
      ],
    },
  ],
  UI_Theme_Header: [
    {
      label: "Theme Customizer",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/themeCustomizer/themeCustomizer.text.ts"],
    },
  ],
  UI_Theme_Light_Root: [
    {
      label: "Texts",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-shared/src/texts/texts.root.text.ts"],
    },
  ],
  UI_Theme_ModeSelector: [
    {
      label: "Theme Customizer",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/themeCustomizer/themeCustomizer.text.ts"],
    },
  ],
  UI_Theme_Root: [
    {
      label: "User settings",
      url: "https://app.placepoint.no/map/user/settings",
      files: ["v2-console/src/currentUser/theme/CurrentUserThemePicker.tsx"],
    },
    {
      label: "Settings",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/settings/SettingsGeneralSection.tsx"],
    },
  ],
  UI_Theme_ThemeSelector: [
    {
      label: "Theme Customizer",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console-ui/src/themeCustomizer/ThemeCustomizerThemePicker.tsx",
      ],
    },
  ],
  UI_TravelTime_Add: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeLocation.tsx",
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRouteLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Color: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeLocation.tsx",
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRouteLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Demographics: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Demographics_Disabled: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Direction: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeSettings.tsx",
      ],
    },
  ],
  UI_TravelTime_Direction_Arrival: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Direction_Departure: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Distance: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeSettings.tsx",
      ],
    },
  ],
  UI_TravelTime_DistanceUnit: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeDistanceInput.tsx",
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeSettings.tsx",
      ],
    },
  ],
  UI_TravelTime_Duration: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeSettings.tsx",
      ],
    },
  ],
  UI_TravelTime_Error: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Error_Rejected: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Export: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_ExportFailed: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.export.ts",
      ],
    },
  ],
  UI_TravelTime_ExportFailed_NoRig: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.export.ts",
      ],
    },
  ],
  UI_TravelTime_ExportTruncated: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.export.ts",
      ],
    },
  ],
  UI_TravelTime_Export_Disabled: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Hint: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/travelTime/MapWidgetTravelTime.tsx"],
    },
  ],
  UI_TravelTime_Hint_Inactive: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/travelTime/MapWidgetTravelTime.tsx"],
    },
  ],
  UI_TravelTime_Mode: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeLocation.tsx",
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRouteLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Mode_Bus: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Mode_Coach: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Mode_Cycling: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Mode_CyclingFerry: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Mode_Driving: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Mode_DrivingFerry: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Mode_PublicTransport: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Mode_Train: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Mode_Walking: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.constants.ts",
      ],
    },
  ],
  UI_TravelTime_Remove: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeLocation.tsx",
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRouteLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Reset: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/travelTime/MapWidgetTravelTime.tsx"],
    },
  ],
  UI_TravelTime_Root: [
    {
      label: "Feature",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/feature/featureGates.registry.ts"],
    },
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetButton.tsx",
        "v2-console/src/map/widget/MapWidgetToolbarRight.tsx",
        "v2-console/src/map/widget/MapWidgetTravelTimeButton.tsx",
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeSuspender.tsx",
        "v2-console/src/map/widget/travelTime/map.widget.travelTime.contextMenu.ts",
      ],
    },
  ],
  UI_TravelTime_Route_Hint_Adjust: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRoute.tsx",
      ],
    },
  ],
  UI_TravelTime_Route_Hint_Destination: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRoute.tsx",
      ],
    },
  ],
  UI_TravelTime_Route_Hint_Inactive: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRoute.tsx",
      ],
    },
  ],
  UI_TravelTime_Route_Hint_Origin: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRoute.tsx",
      ],
    },
  ],
  UI_TravelTime_Route_Reset: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRoute.tsx",
      ],
    },
  ],
  UI_TravelTime_Route_Result: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRouteLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Route_Select: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRoute.tsx",
      ],
    },
  ],
  UI_TravelTime_Route_Unreachable: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRouteLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Route_Update: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRoute.tsx",
      ],
    },
  ],
  UI_TravelTime_Select: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/travelTime/MapWidgetTravelTime.tsx"],
    },
  ],
  UI_TravelTime_Tab_Area: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeTabs.tsx",
      ],
    },
  ],
  UI_TravelTime_Tab_Distance: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeTabs.tsx",
      ],
    },
  ],
  UI_TravelTime_Tab_Route: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeTabs.tsx",
      ],
    },
  ],
  UI_TravelTime_TravelAt: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/MapWidgetTravelTimeSettings.tsx",
      ],
    },
  ],
  UI_TravelTime_Unit_Hours: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRouteLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Unit_Minutes: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/travelTime/route/MapWidgetTravelTimeRouteLocation.tsx",
      ],
    },
  ],
  UI_TravelTime_Update: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/travelTime/MapWidgetTravelTime.tsx"],
    },
  ],
  UI_Viewpoint_Create: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Create_Cancel: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Create_Current: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Create_Finish: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Edit: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/viewpoint/map.widget.viewpoint.text.ts",
      ],
    },
  ],
  UI_Viewpoint_Empty: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpointList.tsx"],
    },
  ],
  UI_Viewpoint_FollowPointer: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Hint_Editing: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Hint_Idle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Hint_Looking: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_Hint_Placing: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpoint.tsx"],
    },
  ],
  UI_Viewpoint_ListHeader: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpointList.tsx"],
    },
  ],
  UI_Viewpoint_ListItem: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpointList.tsx"],
    },
  ],
  UI_Viewpoint_Remove: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpointList.tsx"],
    },
  ],
  UI_Viewpoint_RemoveAll: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpointList.tsx"],
    },
  ],
  UI_Viewpoint_Rename: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpointList.tsx"],
    },
  ],
  UI_Viewpoint_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetViewpointButton.tsx",
        "v2-console/src/map/widget/viewpoint/MapWidgetViewpointSuspender.tsx",
      ],
    },
  ],
  UI_Viewpoint_Toggle: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpointList.tsx"],
    },
  ],
  UI_Viewpoint_Update: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewpoint/MapWidgetViewpointList.tsx"],
    },
  ],
  UI_Viewpoint_ZoomTo: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/viewpoint/map.widget.viewpoint.text.ts",
      ],
    },
  ],
  UI_Viewshed_AngleDefault: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/viewshed.utils.ts"],
    },
  ],
  UI_Viewshed_AngleFullCircle: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/viewshed.utils.ts"],
    },
  ],
  UI_Viewshed_AngleHalfCircle: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/viewshed.utils.ts"],
    },
  ],
  UI_Viewshed_Cancel: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedActions.tsx"],
    },
  ],
  UI_Viewshed_Create: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedActions.tsx"],
    },
  ],
  UI_Viewshed_Empty: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedlayerLists.tsx"],
    },
  ],
  UI_Viewshed_Header: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/widget/viewshed/MapWidgetViewshed.tsx"],
    },
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedlayerLists.tsx"],
    },
  ],
  UI_Viewshed_ListHeader: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedlayerLists.tsx"],
    },
  ],
  UI_Viewshed_ListItem_FieldOfViewDegrees: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedListItem.tsx"],
    },
  ],
  UI_Viewshed_Remove: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedListItem.tsx"],
    },
  ],
  UI_Viewshed_RemoveAll: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedlayerLists.tsx"],
    },
  ],
  UI_Viewshed_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/map/widget/MapWidgetViewGroupButton.tsx",
        "v2-console/src/map/widget/MapWidgetViewshedButton.tsx",
        "v2-console/src/map/widget/viewshed/MapWidgetViewshedSuspender.tsx",
      ],
    },
  ],
  UI_Viewshed_ZoomTo: [
    {
      label: "Viewshed",
      url: "https://app.placepoint.no/map",
      files: ["v2-console-ui/src/viewshed/ViewshedListItem.tsx"],
    },
  ],
  UI_Welcome_Chapter_Context: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.manifest.ts"],
    },
  ],
  UI_Welcome_Chapter_GetStarted: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.manifest.ts"],
    },
  ],
  UI_Welcome_Chapter_Letter: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.manifest.ts"],
    },
  ],
  UI_Welcome_Chapter_Portfolio: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.manifest.ts"],
    },
  ],
  UI_Welcome_Chapter_Prospect: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.manifest.ts"],
    },
  ],
  UI_Welcome_Chapter_Risk: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.manifest.ts"],
    },
  ],
  UI_Welcome_Chapter_Value: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.manifest.ts"],
    },
  ],
  UI_Welcome_Chapter_WhatWeDo: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.manifest.ts"],
    },
  ],
  UI_Welcome_Closing_Body: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeShippingSoonCard.tsx"],
    },
  ],
  UI_Welcome_Closing_ChatSub: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_Closing_ChatTitle: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_Closing_EnterCta: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeShippingSoonCard.tsx"],
    },
  ],
  UI_Welcome_Closing_Eyebrow: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeShippingSoonCard.tsx"],
    },
  ],
  UI_Welcome_Closing_Headline: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeShippingSoonCard.tsx"],
    },
  ],
  UI_Welcome_Closing_HelpdeskSub: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_Closing_HelpdeskTitle: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/welcome/WelcomeShippingSoonCard.tsx",
        "v2-console/src/welcome/welcome.constants.ts",
      ],
    },
  ],
  UI_Welcome_Closing_NewsSub: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_Closing_NewsTitle: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_Closing_RestartCta: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeShippingSoonCard.tsx"],
    },
  ],
  UI_Welcome_Letter_Cta: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Letter_Eyebrow: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Letter_P1: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Letter_P2: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Letter_P3: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Letter_ReadHint: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Letter_Signature: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Letter_SignatureRole: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Letter_Title: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeLetterCard.tsx"],
    },
  ],
  UI_Welcome_Shell_Back: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeShell.tsx"],
    },
  ],
  UI_Welcome_Shell_Beats: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeShell.tsx"],
    },
  ],
  UI_Welcome_UseCaseContext_Headline: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCaseContext_Sub: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCasePortfolio_Headline: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCasePortfolio_Sub: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCaseProspect_Headline: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCaseProspect_Sub: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCaseRisk_Headline: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCaseRisk_Sub: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCaseValue_Headline: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCaseValue_Sub: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCase_Cta: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_UseCase_CtaLast: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/welcome.constants.ts"],
    },
  ],
  UI_Welcome_WhatWeDo_Body: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeWhatWeDoCard.tsx"],
    },
  ],
  UI_Welcome_WhatWeDo_Body2: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeWhatWeDoCard.tsx"],
    },
  ],
  UI_Welcome_WhatWeDo_Cta: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeWhatWeDoCard.tsx"],
    },
  ],
  UI_Welcome_WhatWeDo_Eyebrow: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeWhatWeDoCard.tsx"],
    },
  ],
  UI_Welcome_WhatWeDo_Headline: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeWhatWeDoCard.tsx"],
    },
  ],
  UI_Welcome_WhatWeDo_StatCompanies: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeWhatWeDoCard.tsx"],
    },
  ],
  UI_Welcome_WhatWeDo_StatProperties: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeWhatWeDoCard.tsx"],
    },
  ],
  UI_Welcome_WhatWeDo_StatSources: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/welcome/WelcomeWhatWeDoCard.tsx"],
    },
  ],
  UI_Welcome_WhatWeDo_Stem: [
    {
      label: "Welcome",
      url: "https://app.placepoint.no/map",
      files: [
        "v2-console/src/welcome/WelcomeStatementCard.tsx",
        "v2-console/src/welcome/WelcomeWhatWeDoCard.tsx",
      ],
    },
  ],
  UI_ZoomIn_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/toolbar/MapToolbarItemZoom.tsx"],
    },
  ],
  UI_ZoomOut_Root: [
    {
      label: "Map",
      url: "https://app.placepoint.no/map",
      files: ["v2-console/src/map/toolbar/MapToolbarItemZoom.tsx"],
    },
  ],
}
